import React, { useEffect, useState, useCallback, useRef } from 'react';
import './App.css';
import { Task, Health, AgentStatus, User, PlanWithTask, DbApproval, S3Doc, S3DocContent, MigrationJob, getTasks, getTask, getTaskLog, getTaskPlans, getAllPlans, getPlanMarkdown, getHealth, getAgentStatus, executeTask, stopTask, getMe, updateMe, getUsers, updateUserRole, deactivateUser, activateUser, updateGithubUsername, getDbApprovals, getDocs, syncDocs, getDocContent, getDocDownloadUrl, deleteDoc, clearToken, uploadImage, getStores, getMigrationJobs, createMigrationJob, migrationInsertDev, migrationRequestLive, migrationInsertLive, migrationApprove, migrationReject, getMigrationJob, getDocProjects, getDocTypes, CouponType, getCouponTypes, addCouponType, getStoreBilling, StoreBillingInfo, issueCoupon, updateClaudeToken, deleteClaudeToken, TelemetrySummary, getTelemetrySummary, getTelemetryHourly, getTelemetryDaily, TelemetryHourly, TelemetryDaily, MessagePricing, getMessagePricing, updateMessagePricing, KpiSummary, KpiScore, KpiTask, KpiReview, getKpiSummary, getKpiScores, getKpiTasks, getKpiReviews, evaluateKpi, SyncProposal, getSyncProposals, approveSyncProposal, rejectSyncProposal, updateTaskComplexity, requestPasswordReset, confirmPasswordReset, toggleReviewResolved, KakaoTemplate, getKakaoTemplates, ActiveUsers, ActiveUsersTrend, getActiveUsers, getActiveUsersTrend, StoreDetail, getStoresDetail, updateStoreVisibility, MessagingMonthSummary, SmsTrendItem, AlimtalkTrendItem, AlimtalkTemplateStatsItem, getMessagingSummary, getSmsTrend, getAlimtalkTrend, getAlimtalkTemplateStats, StoreStatusDTO, StoreStatusSummary, BillingSummaryDTO, BillingTrendItem, CouponExpiringDTO, SignupStatsDTO, getStoreStatusSummary, getBillingSummary, getBillingTrend, getCouponExpiring, getSignupStats, UserDailyStat, getUserDailyStats, terminateSubscription, reactivateSubscription, deleteStore, HubMember, HubMemberDetail, getHubMembers, getHubMemberDetail, getPasskeyRegisterOptions, verifyPasskeyRegister, getPasskeys, deletePasskey, WithdrawalRequest, getWithdrawalRequests, PayoutSellerListItem, PayoutSellerDetail, getPayoutSellers, getPayoutSellerDetail, PayoutSettlementSummary, getPayoutSettlementSummary, rejectPayoutSeller, reapprovePayoutSeller, createMemberAccount, requestWithdrawal, cancelWithdrawal, processWithdrawal, StoreMember, getStoreMemberList, SMSCountry, getSMSCountryList, SubAccount, SUB_ACCOUNT_ROLES, PasswordResetResult, SecondPasswordResetResult, getSubAccounts, createSubAccount, modifySubAccount, deleteSubAccount, resetStorePassword, resetSubAccountPassword, resetStoreSecondPassword, SubscriptionPlan, getSubscriptionPlans, saveSubscriptionPlan, modifySubscriptionPlan, toggleSubscriptionPlan, deleteSubscriptionPlan, changeStorePlan, InfraOverview, getInfraOverview, getInfraTraffic, extendBillingDate, DevEc2Status, getDevEc2Status, controlDevEc2, DevServicesStatus, getDevServices, controlDevService, restartAllDevServices, DevRdsStatus, getDevRdsStatus, controlDevRds, AdminSmsSendResult, AdminVerifiedCodeSendResult, AdminMessageSendItem, AdminSendHistoryResponse, sendAdminSms, sendAdminVerifiedCode, getAdminSendHistory, RegistrationFailedMember, RegistrationFailedMembersResponse, getRegistrationFailedMembers, deleteCoach, LlmStatus, getLlmStatus, startLlm, stopLlm, SenderNumberSummary, SenderNumberDetail, getSenderNumberApplications, getSenderNumberApplication, updateSenderNumberStatus, downloadSenderNumberDocument, SenderDocType, EventOrganizer, getEventList, createEventer, updateTournamentDisplay, updateTournamentOrder, EventInspection, inspectTournament, getLatestInspection, approveTournament, EventDetail, EventSouvenir, getTournamentDetail, saveTournament, saveTournamentDate, TournamentSavePayload, TournamentDatePayload, AiLogSummary, AiLogList, AiLogItem, getAiLogSummary, getAiLogList, FleetLogEvent, FleetLogSearchResult, getFleetList, searchFleetLogs } from './api';
import { LineChart, Line, BarChart, Bar, ComposedChart, PieChart, Pie, Cell, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Login from './pages/Login';
import Invite from './pages/Invite';
import SharedDoc from './pages/SharedDoc';
import PushTemplateTab from './pages/messaging/PushTemplateTab';

const STATUS_FILTERS = ['all', 'running', 'completed', 'failed', 'pending', 'approved', 'rejected', 'revision_requested'];

const Skeleton = ({ h = 16, w = '100%' }: { h?: number; w?: string | number }) => (
  <div style={{ height: h, width: w, background: 'linear-gradient(90deg, #1a1a2e 25%, #2a2a4a 50%, #1a1a2e 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.5s infinite', borderRadius: 4 }} />
);

function AiLogsPage() {
  const fmtDate = (d: Date) => {
    const local = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
    return local.toISOString().slice(0, 10);
  };
  const [days, setDays] = useState(30);
  const [tab, setTab] = useState<'agent' | 'sms'>('agent');
  const [summary, setSummary] = useState<AiLogSummary | null>(null);
  const [list, setList] = useState<AiLogList | null>(null);
  const [listPage, setListPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [expanded, setExpanded] = useState<number | null>(null);

  const range = (() => {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - (days - 1));
    return { startDate: fmtDate(start), endDate: fmtDate(end) };
  })();

  useEffect(() => {
    setError(null);
    getAiLogSummary(range.startDate, range.endDate)
      .then(setSummary)
      .catch((e: any) => setError(e?.message || '집계 조회 실패'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [days]);

  useEffect(() => { setListPage(0); }, [tab, days]);

  useEffect(() => {
    setLoading(true);
    getAiLogList({ category: tab, startDate: range.startDate, endDate: range.endDate, page: listPage, size: 20 })
      .then(setList)
      .catch((e: any) => setError(e?.message || '목록 조회 실패'))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, days, listPage]);

  const stat = summary?.categories[tab];
  const accent = tab === 'agent' ? '#6dd49e' : '#ff8b48';
  const nf = (n?: number | null) => (n ?? 0).toLocaleString();
  const trendData = (summary?.dailyTrend || []).map(d => ({
    label: d.date.slice(5),
    calls: tab === 'agent' ? d.agentCalls : d.smsCalls,
    tokens: tab === 'agent' ? d.agentTokens : d.smsTokens,
  }));

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16, flexWrap: 'wrap', gap: 12 }}>
        <h2 style={{ margin: 0, fontSize: 18 }}>AI 사용 로그</h2>
        <div style={{ display: 'flex', gap: 4 }}>
          {[7, 30, 90].map(d => (
            <button key={d} className={`admin-tab-sm ${days === d ? 'active' : ''}`} onClick={() => setDays(d)}>{d}일</button>
          ))}
        </div>
      </div>

      <div style={{ fontSize: 12, color: '#777', marginBottom: 12 }}>
        {range.startDate} ~ {range.endDate} · 분류 기준: <span style={{ color: '#aaa' }}>ai_response.call_type</span> (sms_bulk/sms_individual = 문자추천)
      </div>

      {/* 카테고리 토글 */}
      <div className="admin-tabs" style={{ marginBottom: 16 }}>
        <button className={`admin-tab ${tab === 'agent' ? 'active' : ''}`} onClick={() => setTab('agent')}>에이전트 챗봇</button>
        <button className={`admin-tab ${tab === 'sms' ? 'active' : ''}`} onClick={() => setTab('sms')}>문자문구 추천</button>
      </div>

      {error && <div style={{ color: '#ff6b6b', fontSize: 13, marginBottom: 12 }}>{error}</div>}

      {/* 지표 카드 */}
      <div className="cards">
        <div className="card"><div className="label">LLM 호출</div><div className="value" style={{ color: accent }}>{nf(stat?.callCount)}</div></div>
        <div className="card"><div className="label">대화 수</div><div className="value">{nf(stat?.conversationCount)}</div></div>
        <div className="card"><div className="label">총 토큰</div><div className="value">{nf(stat?.totalTokens)}</div></div>
        <div className="card"><div className="label">에러</div><div className="value" style={{ color: (stat?.errorCount || 0) > 0 ? '#ff6b6b' : undefined }}>{nf(stat?.errorCount)}</div></div>
        <div className="card"><div className="label">평균 응답</div><div className="value">{nf(stat?.avgElapsedMs)}<span style={{ fontSize: 12, color: '#777' }}> ms</span></div></div>
      </div>

      {/* 추이 차트 */}
      <div style={{ marginTop: 24 }}>
        <h3 style={{ fontSize: 14, color: '#aaa', marginBottom: 8 }}>일별 호출 추이</h3>
        <ResponsiveContainer width="100%" height={240}>
          <LineChart data={trendData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
            <XAxis dataKey="label" stroke="#666" fontSize={11} />
            <YAxis stroke="#666" fontSize={11} />
            <Tooltip contentStyle={{ background: '#1a1a2e', border: '1px solid #333', borderRadius: 8, fontSize: 12, color: '#e0e0e0' }} labelStyle={{ color: '#aaa' }} itemStyle={{ color: '#e0e0e0' }} formatter={(v: any) => Number(v).toLocaleString()} />
            <Line type="monotone" dataKey="calls" name="호출" stroke={accent} strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* 로그 목록 */}
      <div style={{ marginTop: 24 }}>
        <h3 style={{ fontSize: 14, color: '#aaa', marginBottom: 8 }}>
          로그 목록 {list ? <span style={{ color: '#777', fontWeight: 400 }}>· 총 {nf(list.totalElements)}건</span> : ''}
        </h3>
        <div className="admin-table-wrap">
          <table>
            <thead>
              <tr>
                <th>시각</th>
                <th>업체</th>
                <th>사용자</th>
                <th>{tab === 'agent' ? '질문' : '추천 문구'}</th>
                {tab === 'agent' && <th>의도</th>}
                <th>유형</th>
                <th>토큰</th>
                <th>응답(ms)</th>
                <th>상태</th>
              </tr>
            </thead>
            <tbody>
              {loading && (!list || list.items.length === 0) ? (
                <tr><td colSpan={tab === 'agent' ? 9 : 8} style={{ color: '#777', textAlign: 'center', padding: 20 }}>불러오는 중…</td></tr>
              ) : list && list.items.length > 0 ? (
                list.items.map((it: AiLogItem) => {
                  const content = tab === 'agent' ? it.requestMessage : it.generatedContent;
                  const isOpen = expanded === it.id;
                  return (
                    <tr key={it.id} style={{ cursor: 'pointer' }} onClick={() => setExpanded(isOpen ? null : it.id)}>
                      <td style={{ whiteSpace: 'nowrap', fontSize: 12 }}>{it.createdDate?.slice(0, 16).replace('T', ' ')}</td>
                      <td style={{ fontSize: 12 }}>{it.storeId ?? '-'}</td>
                      <td style={{ fontSize: 12 }}>{it.userId ?? '-'}</td>
                      <td style={{ maxWidth: 360, fontSize: 12, color: '#ccc', whiteSpace: isOpen ? 'pre-wrap' : 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{content || '-'}</td>
                      {tab === 'agent' && <td style={{ fontSize: 12, color: '#999' }}>{it.intention || '-'}</td>}
                      <td style={{ fontSize: 11, color: '#999' }}>{it.callType}</td>
                      <td style={{ fontSize: 12, textAlign: 'right' }}>{nf(it.totalTokens)}</td>
                      <td style={{ fontSize: 12, textAlign: 'right' }}>{nf(it.elapsedMs)}</td>
                      <td>{it.error ? <span style={{ color: '#ff6b6b', fontSize: 11 }}>에러</span> : <span style={{ color: '#6dd49e', fontSize: 11 }}>정상</span>}</td>
                    </tr>
                  );
                })
              ) : (
                <tr><td colSpan={tab === 'agent' ? 9 : 8} style={{ color: '#777', textAlign: 'center', padding: 20 }}>데이터가 없습니다</td></tr>
              )}
            </tbody>
          </table>
        </div>
        {list && list.totalPages > 1 && (
          <div style={{ display: 'flex', gap: 6, marginTop: 12, justifyContent: 'center', alignItems: 'center' }}>
            <button onClick={() => setListPage(p => Math.max(0, p - 1))} disabled={listPage === 0} style={{ padding: '4px 10px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, color: listPage === 0 ? '#444' : '#aaa', fontSize: 12, cursor: listPage === 0 ? 'default' : 'pointer' }}>&lt;</button>
            <span style={{ fontSize: 12, color: '#888' }}>{listPage + 1} / {list.totalPages}</span>
            <button onClick={() => setListPage(p => Math.min(list.totalPages - 1, p + 1))} disabled={listPage >= list.totalPages - 1} style={{ padding: '4px 10px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, color: listPage >= list.totalPages - 1 ? '#444' : '#aaa', fontSize: 12, cursor: listPage >= list.totalPages - 1 ? 'default' : 'pointer' }}>&gt;</button>
          </div>
        )}
      </div>
    </div>
  );
}

const LOG_LEVELS = ['ERROR', 'WARN', 'INFO', 'DEBUG'];
const LEVEL_COLOR: Record<string, string> = { ERROR: '#ff6b6b', WARN: '#ffb347', INFO: '#6dd49e', DEBUG: '#7a9bd4' };
const RANGE_PRESETS: { key: string; label: string; ms: number }[] = [
  { key: '15m', label: '15분', ms: 15 * 60 * 1000 },
  { key: '1h', label: '1시간', ms: 60 * 60 * 1000 },
  { key: '3h', label: '3시간', ms: 3 * 60 * 60 * 1000 },
  { key: '24h', label: '24시간', ms: 24 * 60 * 60 * 1000 },
];
const PAGE_SIZE = 100;

function fmtKst(ts: number, withDate = true) {
  return new Date(ts).toLocaleString('ko-KR', {
    timeZone: 'Asia/Seoul', hour12: false,
    ...(withDate ? { month: '2-digit', day: '2-digit' } : {}),
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });
}
// datetime-local(로컬시각) 문자열 ↔ ms
function toLocalInput(ms: number) {
  const d = new Date(ms - new Date().getTimezoneOffset() * 60000);
  return d.toISOString().slice(0, 16);
}

function FleetLogsPage() {
  const [fleets, setFleets] = useState<string[]>([]);
  const [fleet, setFleet] = useState<string>('');
  const [preset, setPreset] = useState<string>('1h');
  const [customStart, setCustomStart] = useState<string>(toLocalInput(Date.now() - 3600000));
  const [customEnd, setCustomEnd] = useState<string>(toLocalInput(Date.now()));
  const [query, setQuery] = useState('');
  const [useRegex, setUseRegex] = useState(false);
  const [levels, setLevels] = useState<string[]>([]);
  const [className, setClassName] = useState('');
  const [thread, setThread] = useState('');
  const [sort, setSort] = useState<'asc' | 'desc'>('desc');

  const [result, setResult] = useState<FleetLogSearchResult | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [offset, setOffset] = useState(0);
  const [expanded, setExpanded] = useState<Set<number>>(new Set());

  useEffect(() => {
    getFleetList().then(r => {
      setFleets(r.fleets);
      if (r.fleets.length) setFleet(r.fleets[0]);
    }).catch(() => setError('Fleet 목록을 불러오지 못했습니다'));
  }, []);

  const computeRange = (): { start: number; end: number } => {
    if (preset === 'custom') {
      return { start: new Date(customStart).getTime(), end: new Date(customEnd).getTime() };
    }
    const p = RANGE_PRESETS.find(x => x.key === preset)!;
    const end = Date.now();
    return { start: end - p.ms, end };
  };

  const runSearch = (nextOffset = 0, sortOverride?: 'asc' | 'desc') => {
    if (!fleet) return;
    const { start, end } = computeRange();
    if (!(end > start)) { setError('종료 시각이 시작보다 뒤여야 합니다'); return; }
    setLoading(true); setError(null); setOffset(nextOffset); setExpanded(new Set());
    searchFleetLogs({
      fleet, start, end,
      q: query.trim() || undefined, regex: useRegex,
      levels: levels.length ? levels : undefined,
      className: className || undefined, thread: thread || undefined,
      sort: sortOverride ?? sort,
      limit: PAGE_SIZE, offset: nextOffset,
    })
      .then(setResult)
      .catch((e: any) => setError(e?.message || '검색 실패'))
      .finally(() => setLoading(false));
  };

  const toggleLevel = (lv: string) =>
    setLevels(cur => cur.includes(lv) ? cur.filter(x => x !== lv) : [...cur, lv]);
  const toggleRow = (i: number) =>
    setExpanded(cur => { const n = new Set(cur); n.has(i) ? n.delete(i) : n.add(i); return n; });

  const totalPages = result ? Math.ceil(result.total / PAGE_SIZE) : 0;
  const curPage = Math.floor(offset / PAGE_SIZE);
  const histoData = (result?.histogram || []).map(h => ({ t: h.t, label: fmtKst(h.t, false), count: h.count }));

  const inputStyle: React.CSSProperties = { background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, color: '#ddd', fontSize: 12, padding: '5px 8px' };

  return (
    <div style={{ padding: 24, maxWidth: 1280 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ margin: 0, fontSize: 18 }}>로그 검색</h2>
        <span style={{ fontSize: 12, color: '#777' }}>ECS Fleet 앱 로그 (S3)</span>
      </div>

      {/* 컨트롤 */}
      <div style={{ background: '#141428', border: '1px solid #2a2a4a', borderRadius: 8, padding: 14, marginBottom: 16 }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'center', marginBottom: 10 }}>
          <select value={fleet} onChange={e => setFleet(e.target.value)} style={{ ...inputStyle, minWidth: 120 }}>
            {fleets.length === 0 && <option value="">불러오는 중…</option>}
            {fleets.map(f => <option key={f} value={f}>{f}</option>)}
          </select>
          <div style={{ display: 'flex', gap: 4 }}>
            {RANGE_PRESETS.map(p => (
              <button key={p.key} className={`admin-tab-sm ${preset === p.key ? 'active' : ''}`} onClick={() => setPreset(p.key)}>{p.label}</button>
            ))}
            <button className={`admin-tab-sm ${preset === 'custom' ? 'active' : ''}`} onClick={() => setPreset('custom')}>직접</button>
          </div>
          {preset === 'custom' && (
            <>
              <input type="datetime-local" step="1" value={customStart} onChange={e => setCustomStart(e.target.value)} style={inputStyle} />
              <span style={{ color: '#777', fontSize: 12 }}>~</span>
              <input type="datetime-local" step="1" value={customEnd} onChange={e => setCustomEnd(e.target.value)} style={inputStyle} />
            </>
          )}
        </div>
        <div style={{ marginBottom: 10 }}>
          <textarea
            placeholder={useRegex
              ? '정규식 (예: error|timeout\\s+5\\d\\d) · 입력 전체가 하나의 정규식으로 매칭\n⌘/Ctrl+Enter 로 검색'
              : '검색어: 공백=AND, -단어=제외, "따옴표"=구절 (예: payment timeout -healthcheck)\n대소문자 무시 · 여러 줄 가능 · ⌘/Ctrl+Enter 로 검색'}
            value={query} onChange={e => setQuery(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) { e.preventDefault(); runSearch(0); } }}
            spellCheck={false}
            style={{ ...inputStyle, width: '100%', boxSizing: 'border-box', minHeight: 110, resize: 'vertical', fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, monospace', fontSize: 13, lineHeight: 1.6, padding: '12px 14px', tabSize: 2 }}
          />
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 8 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: '#aaa', cursor: 'pointer' }}>
              <input type="checkbox" checked={useRegex} onChange={e => setUseRegex(e.target.checked)} /> 정규식
            </label>
            <button onClick={() => { const ns = sort === 'desc' ? 'asc' : 'desc'; setSort(ns); if (result) runSearch(0, ns); }}
              title="결과 정렬 순서"
              style={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, color: '#aaa', fontSize: 11, padding: '4px 10px', cursor: 'pointer' }}>
              {sort === 'desc' ? '↓ 최신순' : '↑ 오래된순'}
            </button>
            <span style={{ fontSize: 11, color: '#666' }}>⌘/Ctrl + Enter 로 검색 · Enter 는 줄바꿈</span>
            <button onClick={() => runSearch(0)} disabled={loading || !fleet}
              style={{ marginLeft: 'auto', background: '#6dd49e', color: '#0a0a1a', border: 'none', borderRadius: 4, fontSize: 13, fontWeight: 600, padding: '8px 26px', cursor: loading ? 'default' : 'pointer', opacity: loading || !fleet ? 0.5 : 1 }}>
              {loading ? '검색 중…' : '검색'}
            </button>
          </div>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'center' }}>
          <span style={{ fontSize: 12, color: '#777' }}>레벨</span>
          {LOG_LEVELS.map(lv => (
            <button key={lv} onClick={() => toggleLevel(lv)}
              style={{ background: levels.includes(lv) ? LEVEL_COLOR[lv] : '#1a1a2e', color: levels.includes(lv) ? '#0a0a1a' : '#888', border: `1px solid ${levels.includes(lv) ? LEVEL_COLOR[lv] : '#2a2a4a'}`, borderRadius: 4, fontSize: 11, fontWeight: 600, padding: '3px 10px', cursor: 'pointer' }}>{lv}</button>
          ))}
          <input placeholder="클래스 필터" value={className} onChange={e => setClassName(e.target.value)} style={{ ...inputStyle, width: 160 }} />
          <input placeholder="스레드 필터" value={thread} onChange={e => setThread(e.target.value)} style={{ ...inputStyle, width: 140 }} />
        </div>
      </div>

      {error && <div style={{ background: '#3a1a1a', border: '1px solid #6b3030', borderRadius: 6, color: '#ff9b9b', fontSize: 13, padding: '10px 14px', marginBottom: 16 }}>{error}</div>}
      {result?.note && <div style={{ background: '#3a331a', border: '1px solid #6b5e30', borderRadius: 6, color: '#ffd88b', fontSize: 12, padding: '8px 14px', marginBottom: 16 }}>⚠ {result.note}</div>}

      {result && (
        <>
          <div style={{ display: 'flex', gap: 20, fontSize: 12, color: '#999', marginBottom: 10 }}>
            <span>매치 <b style={{ color: '#ddd' }}>{result.total.toLocaleString()}{result.capped ? '+' : ''}</b>건</span>
            <span>스캔 파일 <b style={{ color: '#ddd' }}>{result.scannedFiles}</b>개</span>
          </div>

          {/* 히스토그램 */}
          <div style={{ background: '#141428', border: '1px solid #2a2a4a', borderRadius: 8, padding: '12px 12px 4px', marginBottom: 16 }}>
            <ResponsiveContainer width="100%" height={140}>
              <BarChart data={histoData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#242440" vertical={false} />
                <XAxis dataKey="label" tick={{ fill: '#777', fontSize: 10 }} interval="preserveStartEnd" minTickGap={40} />
                <YAxis tick={{ fill: '#777', fontSize: 10 }} allowDecimals={false} width={32} />
                <Tooltip contentStyle={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, fontSize: 12 }} labelStyle={{ color: '#aaa' }} />
                <Bar dataKey="count" fill="#6dd49e" />
              </BarChart>
            </ResponsiveContainer>
          </div>

          {/* 결과 테이블 */}
          <div className="admin-table-wrap">
            <table>
              <thead>
                <tr>
                  <th style={{ width: 130 }}>시각(KST)</th>
                  <th style={{ width: 60 }}>레벨</th>
                  <th style={{ width: 170 }}>클래스</th>
                  <th style={{ width: 130 }}>스레드</th>
                  <th>메시지</th>
                </tr>
              </thead>
              <tbody>
                {result.results.length === 0 && (
                  <tr><td colSpan={5} style={{ color: '#777', textAlign: 'center', padding: 20 }}>결과가 없습니다</td></tr>
                )}
                {result.results.map((ev: FleetLogEvent, i: number) => (
                  <tr
                    key={i}
                    onClick={() => { if (!expanded.has(i)) toggleRow(i); }}
                    style={{ cursor: expanded.has(i) ? 'text' : 'pointer', verticalAlign: 'top' }}
                  >
                    <td style={{ fontSize: 11, color: '#999', whiteSpace: 'nowrap' }}>{fmtKst(ev.ts)}</td>
                    <td><span style={{ color: LEVEL_COLOR[ev.level] || '#888', fontSize: 11, fontWeight: 600 }}>{ev.level || '-'}</span></td>
                    <td style={{ fontSize: 11, color: '#8ab', wordBreak: 'break-all' }}>{ev.className || '-'}</td>
                    <td style={{ fontSize: 11, color: '#999', wordBreak: 'break-all' }}>{ev.thread || '-'}</td>
                    <td style={{ fontSize: 12, color: '#ccc', fontFamily: 'monospace', whiteSpace: expanded.has(i) ? 'pre-wrap' : 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: expanded.has(i) ? undefined : 600, wordBreak: 'break-all' }}>
                      {expanded.has(i) ? (
                        <div style={{ position: 'relative', paddingRight: 44, userSelect: 'text' }}>
                          <button
                            onClick={e => { e.stopPropagation(); toggleRow(i); }}
                            style={{ position: 'absolute', top: 0, right: 0, padding: '2px 7px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, color: '#888', fontSize: 10, cursor: 'pointer' }}
                          >
                            접기
                          </button>
                          {ev.raw}
                        </div>
                      ) : ev.message}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div style={{ display: 'flex', gap: 8, justifyContent: 'center', alignItems: 'center', marginTop: 12 }}>
              <button onClick={() => runSearch(Math.max(0, offset - PAGE_SIZE))} disabled={curPage === 0}
                style={{ padding: '4px 10px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, color: curPage === 0 ? '#444' : '#aaa', fontSize: 12, cursor: curPage === 0 ? 'default' : 'pointer' }}>&lt;</button>
              <span style={{ fontSize: 12, color: '#888' }}>{curPage + 1} / {totalPages}</span>
              <button onClick={() => runSearch(offset + PAGE_SIZE)} disabled={curPage >= totalPages - 1}
                style={{ padding: '4px 10px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, color: curPage >= totalPages - 1 ? '#444' : '#aaa', fontSize: 12, cursor: curPage >= totalPages - 1 ? 'default' : 'pointer' }}>&gt;</button>
            </div>
          )}
        </>
      )}

      {!result && !loading && !error && (
        <div style={{ color: '#777', fontSize: 13, textAlign: 'center', padding: 40 }}>Fleet·시간범위·검색어를 지정하고 [검색]을 누르세요</div>
      )}
    </div>
  );
}

function ServerPage() {
  const [infra, setInfra] = useState<InfraOverview | null>(null);
  const [trafficData, setTrafficData] = useState<{ time: string;[k: string]: any }[]>([]);
  const [latencyData, setLatencyData] = useState<{ time: string;[k: string]: any }[]>([]);
  const [errorData, setErrorData] = useState<{ time: string;[k: string]: any }[]>([]);
  const [svcResData, setSvcResData] = useState<{ time: string;[k: string]: any }[]>([]);
  const [svcMemData, setSvcMemData] = useState<{ time: string;[k: string]: any }[]>([]);
  const [dbCpuData, setDbCpuData] = useState<{ time: string;[k: string]: any }[]>([]);
  const [dbConnData, setDbConnData] = useState<{ time: string;[k: string]: any }[]>([]);
  const [infraLoading, setInfraLoading] = useState(true);
  const [trafficLoading, setTrafficLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);
  const [rpsMode, setRpsMode] = useState<'rps' | 'rpm'>('rps');
  const [latencyMode, setLatencyMode] = useState<'trend' | 'now'>('trend');
  const [errorMode, setErrorMode] = useState<'trend' | 'now'>('trend');
  const [svcResMode, setSvcResMode] = useState<'trend' | 'now'>('trend');
  const [dbResMode, setDbResMode] = useState<'trend' | 'now'>('trend');
  const [collapsed, setCollapsed] = useState<Record<string, boolean>>({ services: false, db: false, ecs: true, local: true });
  const [devEc2, setDevEc2] = useState<DevEc2Status | null>(null);
  const [devEc2Acting, setDevEc2Acting] = useState(false);
  const [devServices, setDevServices] = useState<DevServicesStatus | null>(null);
  const [devServiceActing, setDevServiceActing] = useState<string | null>(null);
  const [devEc2RestartAt, setDevEc2RestartAt] = useState<number | null>(null);
  const [devRds, setDevRds] = useState<DevRdsStatus | null>(null);
  const [devRdsActing, setDevRdsActing] = useState(false);
  const [llm, setLlm] = useState<LlmStatus | null>(null);
  const [llmActing, setLlmActing] = useState(false);
  const toDisplay = (rps: number) => rpsMode === 'rpm' ? Math.round(rps * 60) : rps;
  const rateLabel = rpsMode === 'rps' ? 'RPS' : 'RPM';

  useEffect(() => {
    getDevEc2Status().then(setDevEc2).catch(() => {});
    getDevServices().then(setDevServices).catch(() => {});
    getDevRdsStatus().then(setDevRds).catch(() => {});
    getLlmStatus().then(setLlm).catch(() => {});
  }, [refreshKey]);

  // dev RDS 전이 상태(starting/stopping)면 5초마다 재조회 (RDS 부팅 5-10분)
  useEffect(() => {
    if (!devRds) return;
    const transient = ['starting', 'stopping', 'rebooting', 'backing-up'].includes(devRds.state);
    if (!transient) return;
    const t = setTimeout(() => { getDevRdsStatus().then(setDevRds).catch(() => {}); }, 5000);
    return () => clearTimeout(t);
  }, [devRds]);

  const handleDevRds = async (action: 'up' | 'down') => {
    const label = action === 'up' ? '켜기' : '끄기';
    if (!window.confirm(`dev DB(link-dev)를 ${label} 하시겠습니까? RDS 부팅에 5-10분 걸립니다.`)) return;
    setDevRdsActing(true);
    try {
      await controlDevRds(action);
      const s = await getDevRdsStatus();
      setDevRds(s);
    } catch (e: any) {
      window.alert(`${label} 실패: ${e?.message || e}`);
    } finally {
      setDevRdsActing(false);
    }
  };

  // 전이 상태(pending/stopping)면 3초마다 재조회
  // 재부팅(stop --force → start)은 running → stopping → stopped → pending → running 순이라
  // 전이 상태가 아닌 stopped 구간과 중지가 반영되기 전 잠깐의 running 구간에서도 폴링을 이어간다.
  useEffect(() => {
    if (!devEc2) return;
    const transient = ['pending', 'stopping', 'shutting-down'].includes(devEc2.state);
    const restarting = devEc2RestartAt !== null && (devEc2.state !== 'running' || Date.now() - devEc2RestartAt < 30000);
    if (!transient && !restarting) {
      if (devEc2RestartAt !== null) {
        // 재부팅 완료 — 컨테이너 상태도 한 번 갱신
        setDevEc2RestartAt(null);
        getDevServices().then(setDevServices).catch(() => {});
      }
      return;
    }
    const t = setTimeout(() => { getDevEc2Status().then(setDevEc2).catch(() => {}); }, 3000);
    return () => clearTimeout(t);
  }, [devEc2, devEc2RestartAt]);

  const handleDevEc2 = async (action: 'up' | 'down') => {
    const label = action === 'up' ? '켜기' : '끄기';
    if (!window.confirm(`dev EC2를 ${label} 하시겠습니까?`)) return;
    setDevEc2Acting(true);
    try {
      await controlDevEc2(action);
      const s = await getDevEc2Status();
      setDevEc2(s);
    } catch (e: any) {
      window.alert(`${label} 실패: ${e?.message || e}`);
    } finally {
      setDevEc2Acting(false);
    }
  };

  const handleDevService = async (name: string, action: 'up' | 'down' | 'restart') => {
    if (devEc2 && devEc2.state !== 'running') {
      window.alert('서버가 켜져있지 않습니다. 먼저 dev EC2를 켜주세요.');
      return;
    }
    const label = action === 'up' ? '켜기 (최신 이미지)' : action === 'restart' ? '재부팅 (최신 이미지)' : '끄기';
    if (!window.confirm(`${name} 서비스를 ${label} 하시겠습니까?`)) return;
    setDevServiceActing(`${name}:${action}`);
    try {
      const r = await controlDevService(name, action);
      if (!r.ok) throw new Error(r.error || 'unknown');
      const s = await getDevServices();
      setDevServices(s);
    } catch (e: any) {
      window.alert(`${name} ${action} 실패: ${e?.message || e}`);
    } finally {
      setDevServiceActing(null);
    }
  };

  const handleRestartAllDevServices = async () => {
    if (devEc2 && devEc2.state !== 'running') {
      window.alert('서버가 켜져있지 않습니다. 먼저 dev EC2를 켜주세요.');
      return;
    }
    if (!window.confirm('dev EC2를 재부팅(강제 중지 후 시작) 하시겠습니까?\n약 1분 걸리며, 부팅 시 최신 이미지로 zone/coach/exercise 가 자동 기동됩니다.')) return;
    setDevServiceActing('*:restart-all');
    try {
      const r = await restartAllDevServices();
      if (!r.ok) throw new Error(r.error || 'unknown');
      // EC2 API 호출이라 즉시 반환된다 — 이후 진행은 상태 폴링이 이어받는다
      setDevEc2RestartAt(Date.now());
      const s = await getDevEc2Status();
      setDevEc2(s);
    } catch (e: any) {
      window.alert(`전체 재부팅 실패: ${e?.message || e}`);
    } finally {
      setDevServiceActing(null);
    }
  };

  const handleLlm = async (action: 'up' | 'down') => {
    const label = action === 'up' ? '켜기' : '끄기';
    if (!window.confirm(`로컬 LLM(Ollama)을 ${label} 하시겠습니까?`)) return;
    setLlmActing(true);
    try {
      if (action === 'up') await startLlm(); else await stopLlm();
      const s = await getLlmStatus();
      setLlm(s);
    } catch (e: any) {
      window.alert(`${label} 실패: ${e?.message || e}`);
    } finally {
      setLlmActing(false);
    }
  };

  useEffect(() => {
    setInfraLoading(true);
    setTrafficLoading(true);
    getInfraOverview().then(setInfra).catch(() => {}).finally(() => setInfraLoading(false));
    getInfraTraffic().then(tr => {
      if (tr?.traffic) {
        // ISO 시간 → 표시용 라벨 (24h 이내면 HH:MM, 넘으면 MM/DD HH시)
        const toLabel = (iso: string) => {
          const d = new Date(iso);
          const h = String(d.getHours()).padStart(2, '0');
          const m = String(d.getMinutes()).padStart(2, '0');
          const now = new Date();
          if (now.getTime() - d.getTime() > 25 * 3600000) return `${d.getMonth() + 1}/${d.getDate()} ${h}시`;
          return `${h}:${m}`;
        };

        // 모든 시간을 ISO 원본으로 수집 (중복 방지)
        const allTimesSet = new Set<string>();
        for (const pts of Object.values(tr.traffic)) for (const p of pts) allTimesSet.add(p.time);
        if (tr.latency) for (const pts of Object.values(tr.latency)) for (const p of pts) allTimesSet.add(p.time);
        if (tr.errors) for (const pts of Object.values(tr.errors)) for (const p of pts) allTimesSet.add(p.time);
        if (tr.serviceResources) for (const d of Object.values(tr.serviceResources)) { for (const p of d.cpu) allTimesSet.add(p.time); for (const p of d.mem) allTimesSet.add(p.time); }
        if (tr.dbResources) for (const d of Object.values(tr.dbResources)) { for (const p of d.cpu) allTimesSet.add(p.time); for (const p of d.conn) allTimesSet.add(p.time); }
        const sortedIsos = Array.from(allTimesSet).sort();

        // ISO → 라벨 매핑 (O(1) lookup용)
        const isoToLabel = new Map<string, string>();
        for (const iso of sortedIsos) isoToLabel.set(iso, toLabel(iso));
        const sortedLabels = sortedIsos.map(iso => isoToLabel.get(iso)!);

        const findVal = (pts: any[], iso: string, key: string) => { const m = pts.find(p => p.time === iso); return m ? (m[key] ?? null) : null; };

        // 트래픽 데이터
        setTrafficData(sortedIsos.map((iso, i) => {
          const row: any = { time: sortedLabels[i] };
          for (const [svc, pts] of Object.entries(tr.traffic)) { const v = findVal(pts, iso, 'requests'); row[svc] = v != null ? Math.round(v / 3600 * 10) / 10 : 0; }
          return row;
        }));

        // 응답시간 데이터
        if (tr.latency) {
          setLatencyData(sortedIsos.map((iso, i) => {
            const row: any = { time: sortedLabels[i] };
            for (const [svc, pts] of Object.entries(tr.latency)) row[svc] = findVal(pts, iso, 'value');
            return row;
          }));
        }

        // 에러 데이터
        if (tr.errors) {
          setErrorData(sortedIsos.map((iso, i) => {
            const row: any = { time: sortedLabels[i] };
            for (const [svc, pts] of Object.entries(tr.errors)) {
              const m = pts.find(p => p.time === iso);
              row[`${svc}_5xx`] = m ? m.err5xx : 0;
              row[`${svc}_4xx`] = m ? m.err4xx : 0;
            }
            return row;
          }));
        }

        // 서비스 리소스 시계열
        if (tr.serviceResources) {
          setSvcResData(sortedIsos.map((iso, i) => {
            const row: any = { time: sortedLabels[i] };
            for (const [svc, d] of Object.entries(tr.serviceResources)) row[svc] = findVal(d.cpu, iso, 'value');
            return row;
          }));
          setSvcMemData(sortedIsos.map((iso, i) => {
            const row: any = { time: sortedLabels[i] };
            for (const [svc, d] of Object.entries(tr.serviceResources)) row[svc] = findVal(d.mem, iso, 'value');
            return row;
          }));
        }

        // DB 리소스 시계열
        if (tr.dbResources) {
          setDbCpuData(sortedIsos.map((iso, i) => {
            const row: any = { time: sortedLabels[i] };
            for (const [db, d] of Object.entries(tr.dbResources)) row[db.replace(/^link-/, '')] = findVal(d.cpu, iso, 'value');
            return row;
          }));
          setDbConnData(sortedIsos.map((iso, i) => {
            const row: any = { time: sortedLabels[i] };
            for (const [db, d] of Object.entries(tr.dbResources)) row[db.replace(/^link-/, '')] = findVal(d.conn, iso, 'value');
            return row;
          }));
        }
      }
    }).catch(() => {}).finally(() => setTrafficLoading(false));
  }, [refreshKey]);


  const warn = (v: number | null, t: number) => v !== null && v > t ? '#ff4444' : '#e0e0e0';
  const warnLow = (v: number | null, t: number) => v !== null && v < t ? '#ff8844' : '#e0e0e0';
  const tColors: Record<string, string> = { Zone: '#4dabf7', Coach: '#00b894', Event: '#fdcb6e', Exercise: '#e17055', Scheduler: '#a29bfe' };
  const sec = { background: '#0f0f1a', border: '1px solid #1a1a2e', borderRadius: 10, padding: '16px 20px', marginBottom: 16 };
  const chartTooltip = { backgroundColor: '#141428', border: '1px solid #2a2a5a', borderRadius: 10, fontSize: 12, color: '#e0e0e0', boxShadow: '0 8px 32px rgba(0,0,0,0.6)' };
  const statusColor = (v: number | null, warn: number, danger: number) => v === null ? '#888' : v >= danger ? '#ff4444' : v >= warn ? '#ff8844' : '#00cc6a';

  const toggleCollapse = (key: string) => setCollapsed(prev => ({ ...prev, [key]: !prev[key] }));
  const CollapseHeader = ({ id, title, count }: { id: string; title: string; count?: number }) => (
    <div style={{ fontSize: 14, fontWeight: 600, color: '#e0e0e0', marginBottom: collapsed[id] ? 0 : 12, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }} onClick={() => toggleCollapse(id)}>
      <span style={{ fontSize: 10, color: '#888', transition: 'transform 0.2s', display: 'inline-block', transform: collapsed[id] ? 'rotate(-90deg)' : 'rotate(0deg)' }}>▼</span>
      {title}{count !== undefined && <span style={{ fontSize: 11, color: '#666', fontWeight: 400 }}>({count})</span>}
    </div>
  );

  // 서비스 리소스 바차트 데이터
  const resourceData = infra?.services.map(s => ({
    name: s.name,
    CPU: s.cpuPercent ?? 0,
    메모리: (s as any).memPercent ?? 0,
  })) || [];

  // DB 바차트 데이터
  const dbChartData = infra?.databases.map(d => ({
    name: d.name.replace(/^link-/, ''),
    CPU: d.cpuPercent ?? 0,
    접속: d.connections ?? 0,
  })) || [];

  return (
    <div>
      <style>{`@keyframes shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }`}</style>

      {/* 헤더 */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 8, marginBottom: 12 }}>
        {infra && <span style={{ fontSize: 11, color: '#444' }}>조회: {new Date(infra.timestamp).toLocaleTimeString()}</span>}
        <button onClick={() => setRefreshKey(k => k + 1)} disabled={infraLoading && !infra} style={{ fontSize: 11, padding: '3px 10px', borderRadius: 4, border: '1px solid #2a2a4a', background: 'transparent', color: !infra ? '#444' : '#888', cursor: !infra ? 'default' : 'pointer' }}>{infraLoading && infra ? '갱신 중...' : '새로고침'}</button>
      </div>

      {/* dev RDS 제어 (평일 9-20시 자동 cron, 그 외 수동) */}
      {(() => {
        if (!devRds) return null;
        const state = devRds.state;
        const dotColor = state === 'available' ? '#00cc6a'
          : state === 'stopped' ? '#666'
          : state === 'starting' ? '#ffaa00'
          : state === 'stopping' ? '#ff8844'
          : '#888';
        const stateLabel: Record<string, string> = {
          available: 'available', stopped: 'stopped',
          starting: '시작 중...', stopping: '중지 중...', rebooting: '재부팅 중...',
        };
        const transient = ['starting', 'stopping', 'rebooting', 'backing-up'].includes(state);
        const canUp = state === 'stopped';
        const canDown = state === 'available';
        const fmtLast = (iso: string) => {
          const d = new Date(iso);
          return `${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
        };
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '8px 12px', marginBottom: 12, border: '1px solid #2a2a4a', borderRadius: 6, background: '#0f0f1e', fontSize: 12 }}>
            <span style={{ color: '#888', fontWeight: 600 }}>dev DB</span>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: dotColor, display: 'inline-block' }} />
              <span style={{ color: '#ccc' }}>{stateLabel[state] || state}</span>
            </span>
            {devRds.endpoint && (
              <span
                style={{ color: '#555', fontFamily: 'monospace', fontSize: 10, maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                title={devRds.endpoint}
              >{devRds.endpoint.split('.')[0]}</span>
            )}
            {devRds.lastAction && (
              <span style={{ color: '#555', fontSize: 11 }}>
                마지막: {fmtLast(devRds.lastAction.at)} {devRds.lastAction.action} by {devRds.lastAction.user}
              </span>
            )}
            <span style={{ flex: 1 }} />
            <button
              onClick={() => handleDevRds('up')}
              disabled={devRdsActing || transient || !canUp}
              style={{ fontSize: 11, padding: '4px 12px', borderRadius: 4, border: '1px solid #00cc6a55', background: canUp && !devRdsActing ? '#00cc6a15' : 'transparent', color: canUp && !devRdsActing ? '#00cc6a' : '#444', cursor: canUp && !devRdsActing ? 'pointer' : 'default' }}
            >켜기</button>
            <button
              onClick={() => handleDevRds('down')}
              disabled={devRdsActing || transient || !canDown}
              style={{ fontSize: 11, padding: '4px 12px', borderRadius: 4, border: '1px solid #ff444455', background: canDown && !devRdsActing ? '#ff444415' : 'transparent', color: canDown && !devRdsActing ? '#ff4444' : '#444', cursor: canDown && !devRdsActing ? 'pointer' : 'default' }}
            >끄기</button>
          </div>
        );
      })()}

      {/* dev EC2 제어 (평일 9-20시 자동 cron, 그 외 수동) */}
      {(() => {
        if (!devEc2) return null;
        const state = devEc2.state;
        const dotColor = state === 'running' ? '#00cc6a'
          : state === 'stopped' ? '#666'
          : state === 'pending' ? '#ffaa00'
          : state === 'stopping' || state === 'shutting-down' ? '#ff8844'
          : '#888';
        const stateLabel: Record<string, string> = {
          running: 'running', stopped: 'stopped',
          pending: '시작 중...', stopping: '중지 중...', 'shutting-down': '종료 중...',
        };
        const transient = ['pending', 'stopping', 'shutting-down'].includes(state);
        const canUp = state === 'stopped';
        const canDown = state === 'running';
        const restartAllActing = devServiceActing === '*:restart-all' || devEc2RestartAt !== null;
        const restartAllDisabled = devEc2Acting || transient || devServiceActing !== null || devEc2RestartAt !== null || state !== 'running';
        const fmtLast = (iso: string) => {
          const d = new Date(iso);
          return `${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
        };
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '8px 12px', marginBottom: 12, border: '1px solid #2a2a4a', borderRadius: 6, background: '#0f0f1e', fontSize: 12 }}>
            <span style={{ color: '#888', fontWeight: 600 }}>dev EC2</span>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: dotColor, display: 'inline-block' }} />
              <span style={{ color: '#ccc' }}>{stateLabel[state] || state}</span>
            </span>
            {devEc2.ip && <span style={{ color: '#888', fontFamily: 'monospace' }}>{devEc2.ip}</span>}
            {devEc2.lastAction && (
              <span style={{ color: '#555', fontSize: 11 }}>
                마지막: {fmtLast(devEc2.lastAction.at)} {devEc2.lastAction.action} by {devEc2.lastAction.user}
              </span>
            )}
            <span style={{ flex: 1 }} />
            <button
              onClick={handleRestartAllDevServices}
              disabled={restartAllDisabled}
              title="dev EC2 강제 재부팅(중지 후 시작, 약 1분). 부팅 시 zone/coach/exercise 가 최신 이미지로 자동 기동된다"
              style={{ fontSize: 11, padding: '4px 12px', borderRadius: 4, border: '1px solid #ffa50055', background: !restartAllDisabled ? '#ffa50015' : 'transparent', color: !restartAllDisabled ? '#ffa500' : '#444', cursor: !restartAllDisabled ? 'pointer' : 'default' }}
            >{restartAllActing ? '재부팅 중...' : '재부팅'}</button>
            <button
              onClick={() => handleDevEc2('up')}
              disabled={devEc2Acting || transient || !canUp}
              style={{ fontSize: 11, padding: '4px 12px', borderRadius: 4, border: '1px solid #00cc6a55', background: canUp && !devEc2Acting ? '#00cc6a15' : 'transparent', color: canUp && !devEc2Acting ? '#00cc6a' : '#444', cursor: canUp && !devEc2Acting ? 'pointer' : 'default' }}
            >켜기</button>
            <button
              onClick={() => handleDevEc2('down')}
              disabled={devEc2Acting || transient || !canDown}
              style={{ fontSize: 11, padding: '4px 12px', borderRadius: 4, border: '1px solid #ff444455', background: canDown && !devEc2Acting ? '#ff444415' : 'transparent', color: canDown && !devEc2Acting ? '#ff4444' : '#444', cursor: canDown && !devEc2Acting ? 'pointer' : 'default' }}
            >끄기</button>
          </div>
        );
      })()}

      {/* dev EC2 안 docker 서비스 (zone/coach/exercise) */}
      {(() => {
        if (!devServices) return null;
        const ec2Running = devServices.ec2.state === 'running';
        if (!ec2Running) {
          return (
            <div style={{ padding: '8px 12px', marginBottom: 12, border: '1px dashed #2a2a4a', borderRadius: 6, background: '#0a0a14', fontSize: 11, color: '#666' }}>
              서버가 켜져있지 않습니다. 먼저 dev EC2를 켜야 서비스 상태/제어가 가능합니다.
            </div>
          );
        }
        return (
          <div style={{ marginBottom: 12, border: '1px solid #2a2a4a', borderRadius: 6, background: '#0f0f1e', fontSize: 12 }}>
            {devServices.services.map((svc, i) => {
              const dotColor = !svc.deployed ? '#555'
                : svc.running ? '#00cc6a'
                : '#666';
              const stateLabel = !svc.deployed ? '미배포'
                : svc.running ? `running · ${svc.uptime || ''}`
                : (svc.state || 'stopped');
              const upActing = devServiceActing === `${svc.name}:up`;
              const downActing = devServiceActing === `${svc.name}:down`;
              const restartActing = devServiceActing === `${svc.name}:restart`;
              const anyActing = devServiceActing !== null;
              const canUp = svc.deployed && !svc.running;
              const canDown = svc.deployed && svc.running;
              const canRestart = svc.deployed && svc.running;
              return (
                <div key={svc.name} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '8px 12px', borderTop: i === 0 ? 'none' : '1px solid #2a2a4a' }}>
                  <span style={{ color: '#888', fontWeight: 600, width: 70 }}>{svc.name}</span>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                    <span style={{ width: 8, height: 8, borderRadius: '50%', background: dotColor, display: 'inline-block' }} />
                    <span style={{ color: '#ccc' }}>{stateLabel}</span>
                  </span>
                  {svc.image && <span style={{ color: '#555', fontSize: 10, fontFamily: 'monospace' }}>{svc.image.split('/').pop()}</span>}
                  <span style={{ flex: 1 }} />
                  <button
                    onClick={() => handleDevService(svc.name, 'restart')}
                    disabled={anyActing || !canRestart}
                    title="최신 이미지 pull 후 강제 재생성(재부팅)"
                    style={{ fontSize: 11, padding: '4px 12px', borderRadius: 4, border: '1px solid #ffa50055', background: canRestart && !anyActing ? '#ffa50015' : 'transparent', color: canRestart && !anyActing ? '#ffa500' : '#444', cursor: canRestart && !anyActing ? 'pointer' : 'default' }}
                  >{restartActing ? '재부팅 중...' : '재부팅'}</button>
                  <button
                    onClick={() => handleDevService(svc.name, 'up')}
                    disabled={anyActing || !canUp}
                    title={svc.deployed ? '최신 이미지 pull 후 시작' : 'compose 미배포 — backend 작업 필요'}
                    style={{ fontSize: 11, padding: '4px 12px', borderRadius: 4, border: '1px solid #00cc6a55', background: canUp && !anyActing ? '#00cc6a15' : 'transparent', color: canUp && !anyActing ? '#00cc6a' : '#444', cursor: canUp && !anyActing ? 'pointer' : 'default' }}
                  >{upActing ? '시작 중...' : '켜기'}</button>
                  <button
                    onClick={() => handleDevService(svc.name, 'down')}
                    disabled={anyActing || !canDown}
                    style={{ fontSize: 11, padding: '4px 12px', borderRadius: 4, border: '1px solid #ff444455', background: canDown && !anyActing ? '#ff444415' : 'transparent', color: canDown && !anyActing ? '#ff4444' : '#444', cursor: canDown && !anyActing ? 'pointer' : 'default' }}
                  >{downActing ? '중지 중...' : '끄기'}</button>
                </div>
              );
            })}
          </div>
        );
      })()}

      {/* 요약 카드 (5개) */}
      <div className="cards" style={{ marginBottom: 16 }}>
        {!infra ? [1,2,3,4,5].map(i => <div key={i} className="card"><Skeleton h={20} w={60} /><Skeleton h={32} w={80} /></div>) : (() => {
          const sm = infra.summary;
          return <>
            <div className="card" style={{ cursor: 'pointer' }} onClick={() => setRpsMode(m => m === 'rps' ? 'rpm' : 'rps')}>
              <div className="label">총 {rateLabel}</div>
              <div className="value">{toDisplay(sm.totalRps)}</div>
            </div>
            <div className="card">
              <div className="label">평균 응답</div>
              <div className="value" style={{ color: statusColor(sm.avgLatencyMs, 300, 1000) }}>{sm.avgLatencyMs != null ? `${sm.avgLatencyMs}ms` : '-'}</div>
            </div>
            <div className="card">
              <div className="label">5xx (1h)</div>
              <div className="value" style={{ color: sm.total5xx > 0 ? '#ff4444' : '#00cc6a' }}>{sm.total5xx.toLocaleString()}</div>
            </div>
            <div className="card">
              <div className="label">CPU 최고</div>
              <div className="value" style={{ color: statusColor(sm.maxCpuPercent, 70, 90) }}>{sm.maxCpuPercent != null ? `${sm.maxCpuPercent}%` : '-'}</div>
            </div>
            <div className="card">
              <div className="label">DB 접속</div>
              <div className="value">{sm.totalDbConnections}</div>
            </div>
          </>;
        })()}
      </div>

      {/* 차트 영역 */}
      {/* 1행: 트래픽 추이 (전폭) */}
      <div style={sec}>
        <div style={{ fontSize: 14, fontWeight: 600, color: '#e0e0e0', marginBottom: 12, cursor: 'pointer' }} onClick={() => setRpsMode(m => m === 'rps' ? 'rpm' : 'rps')}>트래픽 추이 (24h · {rateLabel})</div>
        {trafficLoading ? <Skeleton h={200} /> : trafficData.length > 0 ? (
          <ResponsiveContainer width="100%" height={200}>
            <AreaChart data={rpsMode === 'rpm' ? trafficData.map(d => { const r: any = { time: d.time }; for (const k of Object.keys(d)) if (k !== 'time') r[k] = Math.round(d[k] * 60); return r; }) : trafficData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
              <XAxis dataKey="time" tick={{ fill: '#888', fontSize: 10 }} />
              <YAxis tick={{ fill: '#888', fontSize: 10 }} />
              <Tooltip contentStyle={chartTooltip} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
              {Object.keys(tColors).filter(k => trafficData.some(d => d[k] > 0)).map(svc => (
                <Area key={svc} type="monotone" dataKey={svc} name={svc} stroke={tColors[svc]} fill={tColors[svc]} fillOpacity={0.15} strokeWidth={2} dot={false} />
              ))}
            </AreaChart>
          </ResponsiveContainer>
        ) : <div style={{ color: '#666', fontSize: 13, padding: 20, textAlign: 'center' }}>트래픽 데이터 없음</div>}
      </div>

      {/* 2행: 응답시간 + 에러 (2열) */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
        {/* 응답시간 (토글: 추이/현재) */}
        <div style={sec}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#e0e0e0' }}>응답시간 (ms)</div>
            <div style={{ display: 'flex', gap: 4 }}>
              {(['trend', 'now'] as const).map(m => (
                <button key={m} onClick={() => setLatencyMode(m)} style={{ fontSize: 10, padding: '2px 8px', borderRadius: 4, border: `1px solid ${latencyMode === m ? '#00ff8866' : '#2a2a4a'}`, background: latencyMode === m ? '#00ff8815' : 'transparent', color: latencyMode === m ? '#00ff88' : '#888', cursor: 'pointer' }}>{m === 'trend' ? '24h 추이' : '현재'}</button>
              ))}
            </div>
          </div>
          {latencyMode === 'now' ? (
            !infra ? <Skeleton h={200} /> : (
              <ResponsiveContainer width="100%" height={200}>
                <BarChart data={infra.services.filter(s => s.latencyMs != null).map(s => ({ name: s.name, 응답시간: s.latencyMs }))} layout="vertical">
                  <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
                  <XAxis type="number" tick={{ fill: '#888', fontSize: 10 }} unit="ms" />
                  <YAxis type="category" dataKey="name" tick={{ fill: '#ccc', fontSize: 11 }} width={70} />
                  <Tooltip contentStyle={chartTooltip} formatter={(v: any) => `${v}ms`} cursor={false} />
                  <Bar dataKey="응답시간" fill="#4dabf7" barSize={14} radius={[0, 4, 4, 0]} />
                </BarChart>
              </ResponsiveContainer>
            )
          ) : (
            trafficLoading ? <Skeleton h={200} /> : latencyData.length > 0 ? (
              <ResponsiveContainer width="100%" height={200}>
                <LineChart data={latencyData}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
                  <XAxis dataKey="time" tick={{ fill: '#888', fontSize: 10 }} />
                  <YAxis tick={{ fill: '#888', fontSize: 10 }} unit="ms" />
                  <Tooltip contentStyle={chartTooltip} formatter={(v: any) => v != null ? `${v}ms` : '-'} />
                  <Legend wrapperStyle={{ fontSize: 11 }} />
                  {Object.keys(tColors).filter(k => latencyData.some(d => d[k] != null && d[k] > 0)).map(svc => (
                    <Line key={svc} type="monotone" dataKey={svc} name={svc} stroke={tColors[svc]} strokeWidth={2} dot={false} connectNulls />
                  ))}
                </LineChart>
              </ResponsiveContainer>
            ) : <div style={{ color: '#666', fontSize: 13, padding: 20, textAlign: 'center' }}>데이터 없음</div>
          )}
        </div>

        {/* 에러 (토글: 추이/현재) */}
        <div style={sec}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#e0e0e0' }}>에러 (5xx/4xx)</div>
            <div style={{ display: 'flex', gap: 4 }}>
              {(['trend', 'now'] as const).map(m => (
                <button key={m} onClick={() => setErrorMode(m)} style={{ fontSize: 10, padding: '2px 8px', borderRadius: 4, border: `1px solid ${errorMode === m ? '#00ff8866' : '#2a2a4a'}`, background: errorMode === m ? '#00ff8815' : 'transparent', color: errorMode === m ? '#00ff88' : '#888', cursor: 'pointer' }}>{m === 'trend' ? '24h 추이' : '현재'}</button>
              ))}
            </div>
          </div>
          {errorMode === 'now' ? (
            !infra ? <Skeleton h={200} /> : (
              <ResponsiveContainer width="100%" height={200}>
                <BarChart data={infra.services.map(s => ({ name: s.name, '5xx': s.err5xx, '4xx': s.err4xx }))} layout="vertical">
                  <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
                  <XAxis type="number" tick={{ fill: '#888', fontSize: 10 }} />
                  <YAxis type="category" dataKey="name" tick={{ fill: '#ccc', fontSize: 11 }} width={70} />
                  <Tooltip contentStyle={chartTooltip} cursor={false} />
                  <Legend wrapperStyle={{ fontSize: 11 }} />
                  <Bar dataKey="5xx" fill="#ff4444" barSize={10} radius={[0, 4, 4, 0]} />
                  <Bar dataKey="4xx" fill="#ff8844" barSize={10} radius={[0, 4, 4, 0]} />
                </BarChart>
              </ResponsiveContainer>
            )
          ) : (
            trafficLoading ? <Skeleton h={200} /> : errorData.length > 0 ? (
              <ResponsiveContainer width="100%" height={200}>
                <AreaChart data={errorData}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
                  <XAxis dataKey="time" tick={{ fill: '#888', fontSize: 10 }} />
                  <YAxis tick={{ fill: '#888', fontSize: 10 }} />
                  <Tooltip contentStyle={chartTooltip} formatter={(v: any) => v != null ? `${v}` : '-'} />
                  <Legend wrapperStyle={{ fontSize: 11 }} />
                  {Object.keys(tColors).filter(k => errorData.some(d => (d[`${k}_5xx`] || 0) > 0)).map(svc => (
                    <Area key={`${svc}_5xx`} type="monotone" dataKey={`${svc}_5xx`} name={`${svc} 5xx`} stroke="#ff4444" fill="#ff4444" fillOpacity={0.2} strokeWidth={1.5} dot={false} stackId="5xx" />
                  ))}
                  {Object.keys(tColors).filter(k => errorData.some(d => (d[`${k}_4xx`] || 0) > 0)).map(svc => (
                    <Area key={`${svc}_4xx`} type="monotone" dataKey={`${svc}_4xx`} name={`${svc} 4xx`} stroke="#ff8844" fill="#ff8844" fillOpacity={0.15} strokeWidth={1.5} dot={false} stackId="4xx" />
                  ))}
                </AreaChart>
              </ResponsiveContainer>
            ) : <div style={{ color: '#666', fontSize: 13, padding: 20, textAlign: 'center' }}>데이터 없음</div>
          )}
        </div>
      </div>

      {/* 3행: 서비스 리소스 + DB 리소스 (2열) */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
        {/* 서비스 리소스 (토글: 추이/현재) */}
        <div style={sec}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#e0e0e0' }}>서비스 리소스</div>
            <div style={{ display: 'flex', gap: 4 }}>
              {(['trend', 'now'] as const).map(m => (
                <button key={m} onClick={() => setSvcResMode(m)} style={{ fontSize: 10, padding: '2px 8px', borderRadius: 4, border: `1px solid ${svcResMode === m ? '#00ff8866' : '#2a2a4a'}`, background: svcResMode === m ? '#00ff8815' : 'transparent', color: svcResMode === m ? '#00ff88' : '#888', cursor: 'pointer' }}>{m === 'trend' ? '24h 추이' : '현재'}</button>
              ))}
            </div>
          </div>
          {svcResMode === 'now' ? (
            !infra ? <Skeleton h={200} /> : resourceData.length > 0 ? (
              <ResponsiveContainer width="100%" height={200}>
                <BarChart data={resourceData} layout="vertical">
                  <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
                  <XAxis type="number" tick={{ fill: '#888', fontSize: 10 }} domain={[0, 100]} unit="%" />
                  <YAxis type="category" dataKey="name" tick={{ fill: '#ccc', fontSize: 11 }} width={70} />
                  <Tooltip contentStyle={chartTooltip} formatter={(v: any) => `${v}%`} cursor={false} />
                  <Legend wrapperStyle={{ fontSize: 11 }} />
                  <Bar dataKey="CPU" fill="#4dabf7" barSize={12} radius={[0, 4, 4, 0]} />
                  <Bar dataKey="메모리" fill="#a29bfe" barSize={12} radius={[0, 4, 4, 0]} />
                </BarChart>
              </ResponsiveContainer>
            ) : <div style={{ color: '#666', fontSize: 13, padding: 20, textAlign: 'center' }}>데이터 없음</div>
          ) : (
            trafficLoading ? <Skeleton h={200} /> : svcResData.length > 0 ? (
              <div>
                <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>CPU (%)</div>
                <ResponsiveContainer width="100%" height={90}>
                  <LineChart data={svcResData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
                    <XAxis dataKey="time" tick={{ fill: '#888', fontSize: 9 }} />
                    <YAxis tick={{ fill: '#888', fontSize: 9 }} domain={[0, 'auto']} />
                    <Tooltip contentStyle={chartTooltip} formatter={(v: any) => v != null ? `${v}%` : '-'} />
                    {Object.keys(tColors).filter(k => svcResData.some(d => d[k] != null)).map(svc => (
                      <Line key={svc} type="monotone" dataKey={svc} stroke={tColors[svc]} strokeWidth={1.5} dot={false} connectNulls />
                    ))}
                  </LineChart>
                </ResponsiveContainer>
                <div style={{ fontSize: 11, color: '#888', marginBottom: 4, marginTop: 8 }}>메모리 (%)</div>
                <ResponsiveContainer width="100%" height={90}>
                  <LineChart data={svcMemData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
                    <XAxis dataKey="time" tick={{ fill: '#888', fontSize: 9 }} />
                    <YAxis tick={{ fill: '#888', fontSize: 9 }} domain={[0, 'auto']} />
                    <Tooltip contentStyle={chartTooltip} formatter={(v: any) => v != null ? `${v}%` : '-'} />
                    {Object.keys(tColors).filter(k => svcMemData.some(d => d[k] != null)).map(svc => (
                      <Line key={svc} type="monotone" dataKey={svc} stroke={tColors[svc]} strokeWidth={1.5} dot={false} connectNulls />
                    ))}
                  </LineChart>
                </ResponsiveContainer>
              </div>
            ) : <div style={{ color: '#666', fontSize: 13, padding: 20, textAlign: 'center' }}>데이터 없음</div>
          )}
        </div>

        {/* DB 리소스 (토글: 추이/현재) */}
        <div style={sec}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#e0e0e0' }}>DB 리소스</div>
            <div style={{ display: 'flex', gap: 4 }}>
              {(['trend', 'now'] as const).map(m => (
                <button key={m} onClick={() => setDbResMode(m)} style={{ fontSize: 10, padding: '2px 8px', borderRadius: 4, border: `1px solid ${dbResMode === m ? '#00ff8866' : '#2a2a4a'}`, background: dbResMode === m ? '#00ff8815' : 'transparent', color: dbResMode === m ? '#00ff88' : '#888', cursor: 'pointer' }}>{m === 'trend' ? '24h 추이' : '현재'}</button>
              ))}
            </div>
          </div>
          {dbResMode === 'now' ? (
            !infra ? <Skeleton h={200} /> : dbChartData.length > 0 ? (
              <ResponsiveContainer width="100%" height={200}>
                <BarChart data={dbChartData} layout="vertical">
                  <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
                  <XAxis type="number" tick={{ fill: '#888', fontSize: 10 }} />
                  <YAxis type="category" dataKey="name" tick={{ fill: '#ccc', fontSize: 11 }} width={80} />
                  <Tooltip contentStyle={chartTooltip} cursor={false} />
                  <Legend wrapperStyle={{ fontSize: 11 }} />
                  <Bar dataKey="CPU" fill="#00b894" barSize={12} radius={[0, 4, 4, 0]} />
                  <Bar dataKey="접속" fill="#fdcb6e" barSize={12} radius={[0, 4, 4, 0]} />
                </BarChart>
              </ResponsiveContainer>
            ) : <div style={{ color: '#666', fontSize: 13, padding: 20, textAlign: 'center' }}>데이터 없음</div>
          ) : (
            trafficLoading ? <Skeleton h={200} /> : dbCpuData.length > 0 ? (
              <div>
                <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>CPU (%)</div>
                <ResponsiveContainer width="100%" height={90}>
                  <LineChart data={dbCpuData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
                    <XAxis dataKey="time" tick={{ fill: '#888', fontSize: 9 }} />
                    <YAxis tick={{ fill: '#888', fontSize: 9 }} domain={[0, 'auto']} />
                    <Tooltip contentStyle={chartTooltip} formatter={(v: any) => v != null ? `${v}%` : '-'} />
                    {Object.keys(dbCpuData[0] || {}).filter(k => k !== 'time').map((db, i) => (
                      <Line key={db} type="monotone" dataKey={db} stroke={Object.values(tColors)[i % Object.values(tColors).length]} strokeWidth={1.5} dot={false} connectNulls />
                    ))}
                  </LineChart>
                </ResponsiveContainer>
                <div style={{ fontSize: 11, color: '#888', marginBottom: 4, marginTop: 8 }}>접속 수</div>
                <ResponsiveContainer width="100%" height={90}>
                  <LineChart data={dbConnData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
                    <XAxis dataKey="time" tick={{ fill: '#888', fontSize: 9 }} />
                    <YAxis tick={{ fill: '#888', fontSize: 9 }} domain={[0, 'auto']} />
                    <Tooltip contentStyle={chartTooltip} />
                    {Object.keys(dbConnData[0] || {}).filter(k => k !== 'time').map((db, i) => (
                      <Line key={db} type="monotone" dataKey={db} stroke={Object.values(tColors)[i % Object.values(tColors).length]} strokeWidth={1.5} dot={false} connectNulls />
                    ))}
                  </LineChart>
                </ResponsiveContainer>
              </div>
            ) : <div style={{ color: '#666', fontSize: 13, padding: 20, textAlign: 'center' }}>데이터 없음</div>
          )}
        </div>
      </div>

      {/* 접이식 테이블: 서비스 */}
      <div style={sec}>
        <CollapseHeader id="services" title="서비스 상세" count={infra?.services.length} />
        {!collapsed.services && (
          !infra ? <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>{[1,2,3,4,5].map(i => <Skeleton key={i} h={24} />)}</div> : (
          <table><thead><tr><th>서비스</th><th style={{ cursor: 'pointer' }} onClick={() => setRpsMode(m => m === 'rps' ? 'rpm' : 'rps')}>{rateLabel}</th><th>응답</th><th>5xx</th><th>4xx</th><th>CPU</th><th>메모리</th></tr></thead>
          <tbody>{infra.services.sort((a, b) => b.rps - a.rps).map(svc => (
            <tr key={svc.name}>
              <td style={{ fontWeight: 600 }}>{svc.name}</td>
              <td>{toDisplay(svc.rps)}</td>
              <td>{svc.latencyMs != null ? `${svc.latencyMs}ms` : '-'}</td>
              <td style={{ color: warn(svc.err5xx, 0) }}>{svc.err5xx.toLocaleString()}</td>
              <td style={{ color: svc.err4xx > 100 ? '#ff8844' : '#e0e0e0' }}>{svc.err4xx.toLocaleString()}</td>
              <td style={{ color: warn(svc.cpuPercent, 80) }}>{svc.cpuPercent != null ? `${svc.cpuPercent}%` : '-'}</td>
              <td style={{ color: warn((svc as any).memPercent, 80) }}>{(svc as any).memPercent != null ? `${(svc as any).memPercent}%` : '-'}</td>
            </tr>
          ))}</tbody></table>
        ))}
      </div>

      {/* 접이식 테이블: DB */}
      <div style={sec}>
        <CollapseHeader id="db" title="데이터베이스 상세" count={infra?.databases.length} />
        {!collapsed.db && (
          !infra ? <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>{[1,2,3,4,5].map(i => <Skeleton key={i} h={24} />)}</div> : (
          <table><thead><tr><th>DB</th><th>상태</th><th>CPU</th><th>접속</th><th>메모리</th><th>스토리지</th><th>Swap</th><th>클래스</th></tr></thead>
          <tbody>{infra.databases.map(db => (
            <tr key={db.name}>
              <td style={{ fontWeight: 600 }}>{db.name}</td>
              <td style={{ color: db.status === 'available' ? '#00cc6a' : '#ff4444' }}>{db.status}</td>
              <td style={{ color: warn(db.cpuPercent, 80) }}>{db.cpuPercent != null ? `${db.cpuPercent}%` : '-'}</td>
              <td>{db.connections ?? '-'}</td>
              <td style={{ color: warnLow(db.freeMemoryMB, 500) }}>{db.freeMemoryMB != null ? `${db.freeMemoryMB}MB` : '-'}</td>
              <td style={{ color: warnLow(db.freeStorageGB, 5) }}>{db.freeStorageGB != null ? `${db.freeStorageGB}GB` : '-'}</td>
              <td>{db.swapUsageMB != null ? `${db.swapUsageMB}MB` : '-'}</td>
              <td style={{ fontSize: 11, color: '#888' }}>{db.class}</td>
            </tr>
          ))}</tbody></table>
        ))}
      </div>

      {/* 접이식: ECS */}
      {infra && infra.ecs && infra.ecs.length > 0 && (
      <div style={sec}>
        <CollapseHeader id="ecs" title="ECS 서비스" count={infra.ecs.length} />
        {!collapsed.ecs && (
        <table><thead><tr><th>클러스터</th><th>서비스</th><th>EC2 타입</th><th>CPU</th><th>메모리</th></tr></thead>
        <tbody>{infra.ecs.map(e => (
          <tr key={e.cluster}>
            <td style={{ fontWeight: 600 }}>{e.cluster}</td>
            <td>{e.service}</td>
            <td style={{ fontSize: 11, color: '#888' }}>{e.ec2Type || '-'}</td>
            <td style={{ color: warn(e.cpuPercent, 80) }}>{e.cpuPercent != null ? `${e.cpuPercent}%` : '-'}</td>
            <td style={{ color: warn(e.memPercent, 80) }}>{e.memPercent != null ? `${e.memPercent}%` : '-'}</td>
          </tr>
        ))}</tbody></table>
        )}
      </div>
      )}

      {/* 접이식: 로컬 서버 */}
      {infra?.local && (
        <div style={sec}>
          <CollapseHeader id="local" title="로컬 (Mac Mini)" />
          {!collapsed.local && (
          <>
          <div style={{ display: 'flex', gap: 20, fontSize: 13, color: '#ccc', flexWrap: 'wrap' }}>
            <span>uptime: {infra.local.uptime}</span>
            <span>CPU: {infra.local.cpu}</span>
            <span>RAM: {infra.local.memory?.percent}</span>
            <span>Node: {infra.local.node}</span>
            <span>DB: <span style={{ color: infra.local.db === 'connected' ? '#00cc6a' : '#ff4444' }}>{infra.local.db}</span></span>
          </div>
          {llm && (
          <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 12, fontSize: 13, color: '#ccc', flexWrap: 'wrap' }}>
            <span>로컬 LLM ({llm.model}):
              <span style={{ marginLeft: 6, color: llm.running ? '#00cc6a' : '#666' }}>{llm.running ? '켜짐' : '꺼짐'}</span>
            </span>
            {llm.running && llm.loadedModels.length > 0 && (
              <span style={{ color: '#888' }}>모델 로드 {llm.loadedModels[0].sizeGB}GB</span>
            )}
            {llm.memory && <span style={{ color: '#888' }}>가용 {llm.memory.availableGB}GB</span>}
            <button
              onClick={() => handleLlm(llm.running ? 'down' : 'up')}
              disabled={llmActing}
              style={{ fontSize: 11, padding: '3px 10px', borderRadius: 4, border: `1px solid ${llm.running ? '#ff444466' : '#00ff8866'}`, background: llm.running ? '#ff444415' : '#00ff8815', color: llmActing ? '#888' : llm.running ? '#ff6666' : '#00ff88', cursor: llmActing ? 'default' : 'pointer' }}
            >
              {llmActing ? '처리 중...' : llm.running ? '끄기' : '켜기'}
            </button>
          </div>
          )}
          </>
          )}
        </div>
      )}

    </div>
  );
}

const AGENT_MODEL_MAP: Record<string, string> = {
  'master': 'Opus',
  'research': 'Haiku',
  'plan': 'Sonnet',
  'frontend-web': 'Opus',
  'frontend-app': 'Opus',
  'backend': 'Opus',
  'backend-crawler': 'Opus',
  'backend-agent': 'Opus',
  'verify': 'Sonnet',
  'cs': 'Haiku',
};

function AutoScrollPre({ children, className }: { children: React.ReactNode; className?: string }) {
  const ref = useRef<HTMLPreElement>(null);
  const userScrolling = useRef(false);
  const scrollTimer = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const onScroll = () => {
      const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 30;
      userScrolling.current = !atBottom;
      clearTimeout(scrollTimer.current);
      scrollTimer.current = setTimeout(() => { userScrolling.current = !atBottom; }, 1000);
    };
    el.addEventListener('scroll', onScroll);
    return () => el.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const el = ref.current;
    if (el && !userScrolling.current) {
      el.scrollTop = el.scrollHeight;
    }
  }, [children]);

  return <pre ref={ref} className={className}>{children}</pre>;
}

function escapeHtmlCodeBlocks(md: string): string {
  return md.replace(/```html\n/g, '```text\n');
}

function formatTime(iso: string | null, short?: boolean) {
  if (!iso) return '-';
  const d = new Date(iso);
  const y = String(d.getFullYear()).slice(2);
  const M = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  if (short) return `${y}.${M}.${dd}`;
  const h = String(d.getHours()).padStart(2, '0');
  const m = String(d.getMinutes()).padStart(2, '0');
  const s = String(d.getSeconds()).padStart(2, '0');
  return `${y}.${M}.${dd} ${h}:${m}:${s}`;
}

function getCreatedDate(filename: string): string | null {
  const m = filename.match(/^(\d{4}-\d{2}-\d{2})/);
  return m ? m[1] : null;
}

// AI 원본 압축본은 수십~수백 MB 라 KB 로만 찍으면 읽기 어렵다
function formatDocSize(size: number): string {
  if (!size) return '-';
  return size >= 1024 * 1024 ? `${(size / 1024 / 1024).toFixed(1)}MB` : `${(size / 1024).toFixed(1)}KB`;
}

// 마크다운이 아닌 문서(AI 원본 압축본 등)는 본문 대신 다운로드로 연다
function isDownloadOnlyDoc(d: S3Doc): boolean {
  return !d.s3_key.endsWith('.md');
}

async function downloadDoc(key: string) {
  try {
    const { url } = await getDocDownloadUrl(key);
    window.location.href = url;
  } catch (err: any) {
    alert(err.message || '다운로드 실패');
  }
}

function formatCreatedDate(filename: string, lastModified: string | null): string {
  const date = getCreatedDate(filename);
  if (!date) return formatTime(lastModified, true);
  const [y, M, dd] = date.split('-');
  return `${y.slice(2)}.${M}.${dd}`;
}

function elapsed(iso: string | null) {
  if (!iso) return '-';
  const sec = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (sec < 60) return `${sec}초`;
  if (sec < 3600) return `${Math.floor(sec / 60)}분 ${sec % 60}초`;
  return `${Math.floor(sec / 3600)}시간 ${Math.floor((sec % 3600) / 60)}분`;
}

function App() {
  const [user, setUser] = useState<User | null>(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [health, setHealth] = useState<Health | null>(null);
  const [tasks, setTasks] = useState<Task[]>([]);
  const [filter, setFilter] = useState('all');
  const [selected, setSelected] = useState<Task | null>(null);
  const [log, setLog] = useState<string | null>(null);
  const [plans, setPlans] = useState<any[]>([]);
  const [subTasks, setSubTasks] = useState<Task[]>([]);
  const [, setPlanTab] = useState<'combined' | string>('combined');
  const [previewDoc, setPreviewDoc] = useState<any>(null);
  const [previewMarkdown, setPreviewMarkdown] = useState<string | null>(null);
  const [, setAllPlans] = useState<PlanWithTask[]>([]);
  const [prompt, setPrompt] = useState('');
  const [executing, setExecuting] = useState(false);
  const [useTokenOf, setUseTokenOf] = useState('');
  const [tokenUsers, setTokenUsers] = useState<{ slack_user_id: string; name: string }[]>([]);
  const [agentStatus, setAgentStatus] = useState<AgentStatus | null>(null);
  const [dbApprovals, setDbApprovals] = useState<DbApproval[]>([]);
  const [approvalFilter, setApprovalFilter] = useState('all');
  const [selectedApproval, setSelectedApproval] = useState<DbApproval | null>(null);
  const [docs, setDocs] = useState<S3Doc[]>([]);
  const [docProjects, setDocProjects] = useState<string[]>([]);
  const [docTypes, setDocTypes] = useState<string[]>([]);
  const [docFilter, setDocFilter] = useState<{ project: string; type: string }>({ project: '', type: '' });
  const [selectedDoc2, setSelectedDoc2] = useState<S3Doc | null>(null);
  const [docContent, setDocContent] = useState<S3DocContent | null>(null);
  const [syncing, setSyncing] = useState(false);
  const [docPage, setDocPage] = useState(1);
  const [docSort, setDocSort] = useState<{ key: string; asc: boolean }>({ key: 'created_at', asc: false });
  const [deleteTarget, setDeleteTarget] = useState<S3Doc | null>(null);
  const pageFromPath = (): 'dashboard' | 'ai' | 'server' | 'logs' | 'workspace' | 'workspace-detail' | 'docs' | 'approvals' | 'migration' | 'coupon' | 'event' | 'msg-pricing' | 'mypage' | 'admin' => {
    const p = window.location.pathname.replace(/^\//, '') || 'dashboard';
    if (p === 'kpi') return 'admin';
    const valid = ['dashboard', 'ai', 'server', 'workspace', 'workspace-detail', 'docs', 'approvals', 'migration', 'coupon', 'event', 'msg-pricing', 'mypage', 'admin'];
    return valid.includes(p) ? p as any : 'dashboard';
  };
  const [page, _setPage] = useState<'dashboard' | 'ai' | 'server' | 'logs' | 'workspace' | 'workspace-detail' | 'docs' | 'approvals' | 'migration' | 'coupon' | 'event' | 'msg-pricing' | 'mypage' | 'admin'>(pageFromPath);
  const setPage = useCallback((p: typeof page) => {
    _setPage(p);
    window.history.pushState({ page: p }, '', `/${p === 'dashboard' ? '' : p}`);
    // 워크스페이스로 돌아올 때 로딩 카드 정리
    if (p === 'workspace') setSubmittedTaskId(null);
  }, []);
  const [taskPage, setTaskPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [submittedTaskId, setSubmittedTaskId] = useState<number | null>(null);
  const [selectedTaskGroup, setSelectedTaskGroup] = useState<number | null>(null);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [, setTick] = useState(0);
  const [attachedImages, setAttachedImages] = useState<{ file: File; preview: string }[]>([]);
  const [uploading, setUploading] = useState(false);
  const [activeUsers, setActiveUsers] = useState<ActiveUsers | null>(null);
  const [activeUsersTrend, setActiveUsersTrend] = useState<ActiveUsersTrend | null>(null);
  const [dauChartTab, setDauChartTab] = useState<'dau' | 'mau'>('dau');
  const [userDailyStats, setUserDailyStats] = useState<UserDailyStat[]>([]);
  const [totalUsers, setTotalUsers] = useState<number | null>(null);
  const [refreshing, setRefreshing] = useState(false);

  // 태스크 + 에이전트 상태 — 스스로 바뀌는 데이터 (작업 실행 중일 때만 폴링)
  const loadLive = useCallback(async () => {
    try {
      const params = [`page=${taskPage}`, `limit=20`];
      if (filter !== 'all') params.push(`status=${filter}`);
      const [t, a] = await Promise.all([
        getTasks(params.join('&')),
        getAgentStatus(),
      ]);
      setTasks(t.tasks || []);
      setTotalPages(t.totalPages || 1);
      setAgentStatus(a);
    } catch {}
  }, [filter, taskPage]);

  // health + hub 위젯 — 스스로 바뀌지 않는 데이터 (진입/새로고침 시에만, hub는 owner/admin 전용)
  const loadStatic = useCallback(async () => {
    try { setHealth(await getHealth()); } catch {}
    if (!user || !['owner', 'admin'].includes(user.role)) return;
    try {
      const today = new Date().toISOString().slice(0, 10);
      const [au, trend, udsResp] = await Promise.all([getActiveUsers(), getActiveUsersTrend(), getUserDailyStats(today).catch(() => null)]);
      if (au?.zoneDau !== undefined) setActiveUsers(au);
      if (trend?.zoneDauTrend) setActiveUsersTrend(trend);
      if (udsResp) {
        if (Array.isArray(udsResp.dailyStats)) setUserDailyStats(udsResp.dailyStats);
        if (udsResp.totalSignupCount !== undefined) setTotalUsers(udsResp.totalSignupCount);
      }
    } catch {}
  }, [user]);

  // 수동 새로고침 (전체)
  const loadData = useCallback(async () => {
    await Promise.all([loadStatic(), loadLive()]);
  }, [loadStatic, loadLive]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      getMe().then(u => { setUser(u); setAuthLoading(false); }).catch(() => { clearToken(); setAuthLoading(false); });
    } else {
      setAuthLoading(false);
    }
  }, []);

  // 브라우저 뒤로가기/앞으로가기 처리
  useEffect(() => {
    const handler = (e: PopStateEvent) => {
      const p = e.state?.page || pageFromPath();
      _setPage(p);
    };
    window.addEventListener('popstate', handler);
    if (!window.location.pathname.startsWith('/invite/') && !window.location.pathname.startsWith('/shared/')) {
      window.history.replaceState({ page }, '', `/${page === 'dashboard' ? '' : page}`);
    }
    return () => window.removeEventListener('popstate', handler);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // 로그인 시 전체 1회 로드 + 토큰 유저 목록
  useEffect(() => {
    if (!user) return;
    loadStatic();
    loadLive();
    if (['owner', 'admin'].includes(user.role)) {
      getUsers().then((users: any[]) => {
        setTokenUsers(users.filter((u: any) => u.has_claude_token).map((u: any) => ({ slack_user_id: u.slack_user_id, name: u.name })));
      }).catch(() => {});
    }
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  // 필터/페이지 변경 시 태스크 목록만 갱신
  useEffect(() => {
    if (user) loadLive();
  }, [filter, taskPage]); // eslint-disable-line react-hooks/exhaustive-deps

  // 작업 실행 중일 때만 태스크/에이전트 폴링 (유휴 시 정지)
  const hasActiveWork = (agentStatus?.agentWindows ?? 0) > 0 || tasks.some(t => t.status === 'running');
  useEffect(() => {
    if (!user || !hasActiveWork) return;
    const interval = setInterval(loadLive, 5000);
    return () => clearInterval(interval);
  }, [user, hasActiveWork, loadLive]);

  // 경과 시간 업데이트 (1초마다)
  useEffect(() => {
    const t = setInterval(() => setTick(n => n + 1), 1000);
    return () => clearInterval(t);
  }, []);

  const loadDocs = useCallback(() => {
    getDocs(docFilter.project || undefined, docFilter.type || undefined).then(setDocs).catch(() => {});
  }, [docFilter]);

  useEffect(() => {
    if (page === 'docs' && user) {
      loadDocs();
      getDocProjects().then(setDocProjects).catch(() => {});
      getDocTypes().then(setDocTypes).catch(() => {});
    }
  }, [page, user, loadDocs]);

  useEffect(() => {
    if (page === 'approvals' && user) {
      getDbApprovals(approvalFilter).then(setDbApprovals).catch(() => {});
    }
  }, [page, user, approvalFilter]);

  // 모달 열릴 때 배경 스크롤 방지
  useEffect(() => {
    const hasModal = !!(selected || selectedApproval || selectedDoc2);
    document.body.classList.toggle('modal-open', hasModal);
    return () => { document.body.classList.remove('modal-open'); };
  }, [selected, selectedApproval, selectedDoc2]);

  const handleSelect = async (task: Task) => {
    try {
      const detail = await getTask(task.id);
      setSelected(detail);
      setLog(null);
      setPlans([]);
      setSubTasks([]);
      setPlanTab('combined');
      try {
        const logData = await getTaskLog(task.id);
        setLog(logData.log);
      } catch {}
      try {
        const planData = await getTaskPlans(task.id);
        setPlans(planData.plans);
        setSubTasks(planData.subTasks || []);
      } catch {}
    } catch {}
  };

  const handleExecute = async () => {
    if (!prompt.trim() && attachedImages.length === 0) return;
    setExecuting(true);
    setSubmittedTaskId(null);
    try {
      // 첨부 이미지 S3 업로드
      let fullPrompt = prompt.trim();
      if (attachedImages.length > 0) {
        setUploading(true);
        const imageLinks: string[] = [];
        for (const img of attachedImages) {
          const res = await uploadImage(img.file);
          imageLinks.push(res.markdown);
        }
        setUploading(false);
        fullPrompt += '\n\n' + imageLinks.join('\n');
      }
      const result = await executeTask(fullPrompt.substring(0, 200), fullPrompt, useTokenOf || undefined);
      setSubmittedTaskId(result.taskId);
      setPrompt('');
      setAttachedImages([]);
      loadData();
    } catch (e: any) {
      setUploading(false);
      alert('실행 실패: ' + e.message);
    }
    setExecuting(false);
  };

  const online = health?.status === 'ok';

  // 공유 문서 페이지 확인
  const path = window.location.pathname;
  const sharedMatch = path.match(/^\/shared\/([a-f0-9]+)$/);
  if (sharedMatch) {
    return <SharedDoc token={sharedMatch[1]} />;
  }

  // 초대 페이지 확인
  const inviteMatch = path.match(/^\/invite\/([a-f0-9]+)$/);
  if (inviteMatch) {
    return <Invite code={inviteMatch[1]} onRegister={(u) => { setUser(u); window.history.pushState({}, '', '/'); }} />;
  }

  // 비밀번호 재설정 페이지
  if (path === '/reset-password') {
    return <ResetPasswordPage />;
  }

  if (authLoading) return null;
  if (!user) return <Login onLogin={setUser} />;

  const canExecute = ['owner', 'admin', 'engineer'].includes(user.role);

  return (
    <div className="app-layout">
      <aside className={`sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-top">
          <h1>
            <img src="/logo-linko.svg" alt="Linko" width="24" height="24" />
            {!sidebarCollapsed && <span>Agent LINKO</span>}
          </h1>
          <button className="sidebar-toggle" onClick={() => setSidebarCollapsed(!sidebarCollapsed)} title={sidebarCollapsed ? '펼치기' : '접기'}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#666" strokeWidth="1.5" strokeLinecap="round">
              {sidebarCollapsed
                ? <><line x1="4" y1="4" x2="4" y2="12"/><polyline points="8,5 12,8 8,11"/></>
                : <><line x1="12" y1="4" x2="12" y2="12"/><polyline points="8,5 4,8 8,11"/></>
              }
            </svg>
          </button>
        </div>
        <nav>
          <button className={page === 'dashboard' ? 'active' : ''} onClick={() => setPage('dashboard')} title="대시보드">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="2" width="5" height="5" rx="1"/><rect x="9" y="2" width="5" height="5" rx="1"/><rect x="2" y="9" width="5" height="5" rx="1"/><rect x="9" y="9" width="5" height="5" rx="1"/>
            </svg>
            {!sidebarCollapsed && <span>대시보드</span>}
          </button>
          {['owner', 'admin', 'engineer'].includes(user.role) && (
          <button className={page === 'ai' ? 'active' : ''} onClick={() => setPage('ai')} title="AI">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="8" cy="8" r="3"/><path d="M8,1 v2 M8,13 v2 M1,8 h2 M13,8 h2 M3.2,3.2 l1.4,1.4 M11.4,11.4 l1.4,1.4 M12.8,3.2 l-1.4,1.4 M4.6,11.4 l-1.4,1.4"/>
            </svg>
            {!sidebarCollapsed && <span>AI</span>}
          </button>
          )}
          {['owner', 'admin', 'engineer'].includes(user.role) && (
          <button className={page === 'server' ? 'active' : ''} onClick={() => setPage('server')} title="서버">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="2" width="12" height="4" rx="1"/><rect x="2" y="10" width="12" height="4" rx="1"/><circle cx="5" cy="4" r="0.5" fill="currentColor"/><circle cx="5" cy="12" r="0.5" fill="currentColor"/><line x1="8" y1="6" x2="8" y2="10"/>
            </svg>
            {!sidebarCollapsed && <span>서버</span>}
          </button>
          )}
          {['owner', 'admin', 'engineer'].includes(user.role) && (
          <button className={page === 'logs' ? 'active' : ''} onClick={() => setPage('logs')} title="로그">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 2h7l3 3v9H3z"/><line x1="5.5" y1="6" x2="10.5" y2="6"/><line x1="5.5" y1="8.5" x2="10.5" y2="8.5"/><line x1="5.5" y1="11" x2="8.5" y2="11"/>
            </svg>
            {!sidebarCollapsed && <span>로그</span>}
          </button>
          )}
          <button className={page === 'workspace' || page === 'workspace-detail' ? 'active' : ''} onClick={() => setPage('workspace')} title="워크스페이스">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="4,11 7,6 4,1"/><line x1="8" y1="13" x2="14" y2="13"/>
            </svg>
            {!sidebarCollapsed && <span>워크스페이스 {agentStatus && agentStatus.taskGroups.length > 0 ? `(${agentStatus.taskGroups.length})` : ''}</span>}
          </button>
          <button className={page === 'docs' ? 'active' : ''} onClick={() => setPage('docs')} title="문서">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4,2 h6 l3,3 v9 h-9 z"/><polyline points="10,2 10,5 13,5"/><line x1="5" y1="8" x2="11" y2="8"/><line x1="5" y1="10.5" x2="11" y2="10.5"/>
            </svg>
            {!sidebarCollapsed && <span>문서</span>}
          </button>
          {['owner', 'admin'].includes(user.role) && (
          <button className={page === 'approvals' ? 'active' : ''} onClick={() => setPage('approvals')} title="DB권한 승인">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="3" width="12" height="10" rx="1.5"/><path d="M5,8 l2,2 l4,-4"/>
            </svg>
            {!sidebarCollapsed && <span>DB권한 승인</span>}
          </button>
          )}
          {['owner', 'admin'].includes(user.role) && (
          <button className={page === 'migration' ? 'active' : ''} onClick={() => setPage('migration')} title="데이터 이전">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M2,5 h12 M2,11 h12"/><polyline points="10,2 13,5 10,8"/><polyline points="6,8 3,11 6,14"/>
            </svg>
            {!sidebarCollapsed && <span>데이터 이전</span>}
          </button>
          )}
          {(user.role === 'owner' || user.role === 'admin') && (
          <button className={page === 'coupon' ? 'active' : ''} onClick={() => setPage('coupon')} title="서비스 관리">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M2,2 h12 v12 H2 z"/><path d="M2,6 h12"/><path d="M6,6 v8"/>
            </svg>
            {!sidebarCollapsed && <span>서비스 관리</span>}
          </button>
          )}
          {['owner', 'admin', 'engineer'].includes(user.role) && (
          <button className={page === 'event' ? 'active' : ''} onClick={() => setPage('event')} title="이벤트 관리">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="3" width="12" height="11" rx="1.5"/><path d="M2,6 h12 M5,1.5 v3 M11,1.5 v3"/>
            </svg>
            {!sidebarCollapsed && <span>이벤트 관리</span>}
          </button>
          )}
          {['owner', 'admin', 'engineer'].includes(user.role) && (
          <button className={page === 'msg-pricing' ? 'active' : ''} onClick={() => setPage('msg-pricing')} title="문자">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M2,3 h12 v10 H2 z"/><path d="M5,7 h6 M5,10 h4"/>
            </svg>
            {!sidebarCollapsed && <span>문자</span>}
          </button>
          )}
          {['owner', 'admin'].includes(user.role) && (
            <button className={page === 'admin' ? 'active' : ''} onClick={() => setPage('admin')} title="팀">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="8" cy="5" r="3"/><path d="M2,14 c0,-3.3 2.7,-6 6,-6 s6,2.7 6,6"/>
              </svg>
              {!sidebarCollapsed && <span>팀</span>}
            </button>
          )}
        </nav>
        <div className="sidebar-bottom">
          <button className={`sidebar-profile ${page === 'mypage' ? 'active' : ''}`} onClick={() => setPage('mypage')} title="마이페이지">
            {user.profile_image
              ? <img src={user.profile_image} alt="" className="sidebar-avatar" />
              : <div className="sidebar-avatar-placeholder">{user.name?.charAt(0).toUpperCase()}</div>
            }
            {!sidebarCollapsed && <span>{user.name}</span>}
          </button>
          <button className="logout-btn" onClick={() => { clearToken(); setUser(null); }} title="로그아웃">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6,2 h-3 v12 h3"/><polyline points="10,5 13,8 10,11"/><line x1="6" y1="8" x2="13" y2="8"/>
            </svg>
            {!sidebarCollapsed && <span>로그아웃</span>}
          </button>
        </div>
      </aside>
      <main className={`main-content ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>

      {page === 'server' && ['owner', 'admin', 'engineer'].includes(user.role) && <ServerPage />}

      {page === 'ai' && ['owner', 'admin', 'engineer'].includes(user.role) && <AiLogsPage />}
      {page === 'logs' && ['owner', 'admin', 'engineer'].includes(user.role) && <FleetLogsPage />}

      {page === 'dashboard' && health && (
        <div className="cards">
          <div className="card">
            <div className="label">Status</div>
            <div className="value">
              <span style={{ color: online ? '#00ff88' : '#ff4444' }}>{online ? 'Online' : 'Offline'}</span>
              <span style={{ color: '#333', margin: '0 8px' }}>|</span>
              <span style={{ fontSize: 13, color: health.db === 'connected' ? '#00ff88' : '#ff4444' }}>DB {health.db === 'connected' ? 'Connected' : 'Disconnected'}</span>
            </div>
          </div>
          <div className="card">
            <div className="label">CPU</div>
            <div className="value">{health.cpu || '-'}</div>
          </div>
          <div className="card">
            <div className="label">GPU</div>
            <div className="value">{health.gpu || '-'}</div>
          </div>
          <div className="card">
            <div className="label">Memory</div>
            <div className="value">{health.memory.percent} ({health.memory.free} / {health.memory.total})</div>
          </div>
        </div>
      )}

      {page === 'dashboard' && activeUsers?.zoneDau !== undefined && (
        <div className="cards" style={{ marginTop: 16 }}>
          <div className="card">
            <div className="label"><span style={{ color: '#ff8b48' }}>MAU</span> (Zone)</div>
            <div className="value">{activeUsers.zoneMau.toLocaleString()}</div>
          </div>
          <div className="card">
            <div className="label"><span style={{ color: '#6dd49e' }}>MAU</span> (Coach)</div>
            <div className="value">{activeUsers.coachMau.toLocaleString()}</div>
          </div>
          <div className="card">
            <div className="label"><span style={{ color: '#ff8b48' }}>DAU</span> (Zone)</div>
            <div className="value">{activeUsers.zoneDau.toLocaleString()}</div>
          </div>
          <div className="card">
            <div className="label"><span style={{ color: '#6dd49e' }}>DAU</span> (Coach)</div>
            <div className="value">{activeUsers.coachDau.toLocaleString()}</div>
          </div>
        </div>
      )}

      {page === 'dashboard' && activeUsersTrend?.zoneDauTrend && (
        <div style={{ marginTop: 24 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
            <div style={{ display: 'flex', gap: 4 }}>
              <button className={`admin-tab-sm ${dauChartTab === 'dau' ? 'active' : ''}`} onClick={() => setDauChartTab('dau')}>DAU (일별)</button>
              <button className={`admin-tab-sm ${dauChartTab === 'mau' ? 'active' : ''}`} onClick={() => setDauChartTab('mau')}>MAU (월별)</button>
            </div>
          </div>
          {dauChartTab === 'dau' ? (
            <div style={{ marginBottom: 24 }}>
              <h3 style={{ fontSize: 14, color: '#aaa', marginBottom: 8 }}>일별 활성 사용자 (DAU)</h3>
              <ResponsiveContainer width="100%" height={280}>
                <LineChart data={(() => {
                  const allDates = new Set<string>();
                  activeUsersTrend.zoneDauTrend.forEach(d => allDates.add(d.date));
                  activeUsersTrend.coachDauTrend.forEach(d => allDates.add(d.date));
                  const zoneMap = Object.fromEntries(activeUsersTrend.zoneDauTrend.map(d => [d.date, d.count]));
                  const coachMap = Object.fromEntries(activeUsersTrend.coachDauTrend.map(d => [d.date, d.count]));
                  return Array.from(allDates).sort().map(date => ({
                    label: date.slice(5),
                    Zone: zoneMap[date] || 0,
                    Coach: coachMap[date] || 0,
                  }));
                })()}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
                  <XAxis dataKey="label" stroke="#666" fontSize={11} />
                  <YAxis stroke="#666" fontSize={11} tickFormatter={(v: number) => v >= 1000 ? `${(v/1000).toFixed(0)}K` : String(v)} />
                  <Tooltip contentStyle={{ background: '#1a1a2e', border: '1px solid #333', borderRadius: 8, fontSize: 12, color: '#e0e0e0' }} labelStyle={{ color: '#aaa' }} itemStyle={{ color: '#e0e0e0' }} formatter={(v: any) => Number(v).toLocaleString()} />
                  <Legend />
                  <Line type="monotone" dataKey="Zone" stroke="#ff8b48" strokeWidth={2} dot={false} />
                  <Line type="monotone" dataKey="Coach" stroke="#6dd49e" strokeWidth={2} dot={false} />
                </LineChart>
              </ResponsiveContainer>
            </div>
          ) : (
            <div style={{ marginBottom: 24 }}>
              <h3 style={{ fontSize: 14, color: '#aaa', marginBottom: 8 }}>월별 활성 사용자 (MAU)</h3>
              <ResponsiveContainer width="100%" height={280}>
                <BarChart data={(() => {
                  const allMonths = new Set<string>();
                  activeUsersTrend.zoneMauTrend.forEach(d => allMonths.add(d.month));
                  activeUsersTrend.coachMauTrend.forEach(d => allMonths.add(d.month));
                  const zoneMap = Object.fromEntries(activeUsersTrend.zoneMauTrend.map(d => [d.month, d.count]));
                  const coachMap = Object.fromEntries(activeUsersTrend.coachMauTrend.map(d => [d.month, d.count]));
                  return Array.from(allMonths).sort().map(month => ({
                    label: month,
                    Zone: zoneMap[month] || 0,
                    Coach: coachMap[month] || 0,
                  }));
                })()}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
                  <XAxis dataKey="label" stroke="#666" fontSize={11} />
                  <YAxis stroke="#666" fontSize={11} tickFormatter={(v: number) => v >= 1000 ? `${(v/1000).toFixed(0)}K` : String(v)} />
                  <Tooltip cursor={{ fill: 'rgba(255,255,255,0.05)' }} contentStyle={{ background: '#1a1a2e', border: '1px solid #333', borderRadius: 8, fontSize: 12, color: '#e0e0e0' }} labelStyle={{ color: '#aaa' }} itemStyle={{ color: '#e0e0e0' }} formatter={(v: any) => Number(v).toLocaleString()} />
                  <Legend />
                  <Bar dataKey="Zone" fill="#ff8b48" radius={[4, 4, 0, 0]} maxBarSize={48} />
                  <Bar dataKey="Coach" fill="#6dd49e" radius={[4, 4, 0, 0]} maxBarSize={48} />
                </BarChart>
              </ResponsiveContainer>
            </div>
          )}
        </div>
      )}

      {page === 'dashboard' && (() => {
        const todayStat = userDailyStats.find(d => d.date === new Date().toISOString().slice(0, 10));
        return (
          <>
            <div className="cards" style={{ marginTop: 16 }}>
              <div className="card">
                <div className="label"><span style={{ color: '#4dabf7' }}>총 가입자</span></div>
                <div className="value">{totalUsers !== null ? totalUsers.toLocaleString() : '-'}<span style={{ fontSize: 12, color: '#666' }}>명</span></div>
              </div>
              <div className="card">
                <div className="label"><span style={{ color: '#00b894' }}>오늘 가입</span></div>
                <div className="value">{todayStat?.signupCount ?? '-'}<span style={{ fontSize: 12, color: '#666' }}>명</span></div>
              </div>
              <div className="card">
                <div className="label"><span style={{ color: '#fdcb6e' }}>탈퇴 신청</span></div>
                <div className="value">{todayStat?.withdrawRequestCount ?? '-'}<span style={{ fontSize: 12, color: '#666' }}>명</span></div>
              </div>
              <div className="card">
                <div className="label"><span style={{ color: '#e17055' }}>탈퇴 처리</span></div>
                <div className="value">{todayStat?.withdrawProcessedCount ?? '-'}<span style={{ fontSize: 12, color: '#666' }}>명</span></div>
              </div>
            </div>
            {userDailyStats.length > 0 && (
              <div style={{ marginTop: 24, background: '#0f0f1a', borderRadius: 12, padding: 20, border: '1px solid #1a1a2e' }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: '#e0e0e0', marginBottom: 16 }}>앱 사용자 가입/탈퇴 추이 (30일)</div>
                <ResponsiveContainer width="100%" height={260}>
                  <LineChart data={userDailyStats.map(d => ({ ...d, date: d.date.slice(5) }))}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
                    <XAxis dataKey="date" tick={{ fill: '#888', fontSize: 11 }} />
                    <YAxis tick={{ fill: '#888', fontSize: 11 }} />
                    <Tooltip contentStyle={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 8, fontSize: 12 }} />
                    <Legend wrapperStyle={{ fontSize: 11 }} />
                    <Line type="monotone" dataKey="signupCount" name="가입" stroke="#00b894" strokeWidth={2} dot={{ r: 3 }} />
                    <Line type="monotone" dataKey="withdrawRequestCount" name="탈퇴 신청" stroke="#fdcb6e" strokeWidth={2} dot={{ r: 3 }} />
                    <Line type="monotone" dataKey="withdrawProcessedCount" name="탈퇴 처리" stroke="#e17055" strokeWidth={2} dot={{ r: 3 }} />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            )}
          </>
        );
      })()}

      {/* 워크스페이스 */}
      {page === 'workspace' && (
        <div>
          {/* 작업 요청 입력 (권한 있는 사용자만) */}
          {canExecute && (<>
            <div className="workspace-input">
              <textarea
                placeholder="요청사항을 입력하세요 (Shift+Enter: 줄바꿈)"
                value={prompt}
                onChange={(e) => {
                  setPrompt(e.target.value);
                  e.target.style.height = '44px';
                  e.target.style.height = Math.min(e.target.scrollHeight, 200) + 'px';
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && e.shiftKey) {
                    e.preventDefault();
                    const ta = e.target as HTMLTextAreaElement;
                    const start = ta.selectionStart;
                    const end = ta.selectionEnd;
                    const val = prompt.slice(0, start) + '\n' + prompt.slice(end);
                    setPrompt(val);
                    setTimeout(() => { ta.selectionStart = ta.selectionEnd = start + 1; ta.style.height = '44px'; ta.style.height = Math.min(ta.scrollHeight, 200) + 'px'; }, 0);
                    return;
                  }
                  if (e.key === 'Enter') { e.preventDefault(); handleExecute(); }
                }}
                rows={1}
              />
              <input
                type="file"
                accept="image/png,image/jpeg,image/gif,image/webp"
                multiple
                id="workspace-image-input"
                style={{ display: 'none' }}
                onChange={(e) => {
                  const files = Array.from(e.target.files || []);
                  const newImages = files.map(f => ({ file: f, preview: URL.createObjectURL(f) }));
                  setAttachedImages(prev => [...prev, ...newImages]);
                  e.target.value = '';
                }}
              />
              <button
                className="attach-btn"
                onClick={() => document.getElementById('workspace-image-input')?.click()}
                title="이미지 첨부"
                disabled={executing}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                  <circle cx="8.5" cy="8.5" r="1.5" />
                  <polyline points="21 15 16 10 5 21" />
                </svg>
              </button>
              {user && ['owner', 'admin'].includes(user.role) && tokenUsers.length > 0 && (
                <select
                  value={useTokenOf}
                  onChange={(e) => setUseTokenOf(e.target.value)}
                  style={{ padding: '6px 8px', borderRadius: 6, background: '#1a1a2e', color: '#ccc', border: '1px solid #333', fontSize: 12, maxWidth: 120 }}
                  title="사용할 토큰 선택"
                >
                  <option value="">내 토큰</option>
                  {tokenUsers.map(u => (
                    <option key={u.slack_user_id} value={u.slack_user_id}>{u.name}</option>
                  ))}
                </select>
              )}
              <button onClick={handleExecute} disabled={executing || (!prompt.trim() && attachedImages.length === 0)}>
                {uploading ? '업로드 중...' : executing ? '요청 중...' : '요청'}
              </button>
            </div>
            {attachedImages.length > 0 && (
              <div className="attached-images">
                {attachedImages.map((img, i) => (
                  <div key={i} className="attached-image-item">
                    <img src={img.preview} alt="" />
                    <button className="remove-image" onClick={() => {
                      URL.revokeObjectURL(img.preview);
                      setAttachedImages(prev => prev.filter((_, idx) => idx !== i));
                    }}>×</button>
                  </div>
                ))}
              </div>
            )}
          </>)}

          {/* 방금 요청한 태스크 로딩 카드 */}
          {submittedTaskId && !agentStatus?.taskGroups.find(g => g.taskId === submittedTaskId) && (
            <div className="task-group-grid" style={{ marginBottom: 16 }}>
              <div className="task-group-card submitted-loading">
                <div className="loading-spinner" />
                <div className="task-group-title" style={{ marginTop: 12 }}>에이전트 배정 중...</div>
                <div className="task-group-meta">Task #{submittedTaskId}</div>
              </div>
            </div>
          )}

          {/* 실행 중인 태스크 카드 */}
          {agentStatus && agentStatus.taskGroups.length > 0 ? (
            <div className="task-group-grid">
              {agentStatus.taskGroups.map((g) => (
                <div
                  key={g.taskId}
                  className="task-group-card"
                  onClick={() => { setSelectedTaskGroup(g.taskId); setPage('workspace-detail'); }}
                >
                  <div className="task-group-elapsed">{elapsed(g.startedAt)}</div>
                  <div className="task-group-title">{g.title}</div>
                  <div className="task-group-meta">
                    {g.requestedBy && <span>요청자: {g.requestedBy}</span>}
                  </div>
                  <div className="task-group-terminals">
                    {g.agents.map((a) => (
                      <span key={a.window} className="terminal-icon" title={a.window}>
                        <span className="terminal-icon-box">
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#00ff88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="4 17 10 11 4 5" />
                            <line x1="12" y1="19" x2="20" y2="19" />
                          </svg>
                        </span>
                        <span className="terminal-icon-label">{a.window.replace(/-\d+$/, '')}</span>
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            !submittedTaskId && <div className="empty">실행 중인 작업이 없습니다</div>
          )}

          <div className="task-section" style={{ marginTop: 24 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <h2 style={{ margin: 0 }}>태스크 목록 <span>{tasks.length}건</span></h2>
              {hasActiveWork && <span style={{ fontSize: 11, color: '#00ff88' }} title="실행 중인 작업이 있어 자동 갱신 중">● 실시간</span>}
              <button
                onClick={async () => { setRefreshing(true); await loadData(); setRefreshing(false); }}
                disabled={refreshing}
                title="새로고침"
                style={{ marginLeft: 'auto', padding: '4px 12px', fontSize: 12, borderRadius: 4, border: '1px solid #2a2a4a', background: '#1a1a2e', color: refreshing ? '#555' : '#aaa', cursor: refreshing ? 'default' : 'pointer' }}
              >{refreshing ? '새로고침 중…' : '↻ 새로고침'}</button>
            </div>
            <div className="filters">
              {STATUS_FILTERS.map((s) => (
                <button key={s} className={filter === s ? 'active' : ''} onClick={() => { setFilter(s); setTaskPage(1); }}>
                  {s === 'all' ? '전체' : s}
                </button>
              ))}
            </div>
            {tasks.length > 0 ? (
              <table>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>상태</th>
                    <th>에이전트</th>
                    <th>타입</th>
                    <th>제목</th>
                    <th>생성일</th>
                  </tr>
                </thead>
                <tbody>
                  {tasks.map((t) => (
                    <tr key={t.id} onClick={() => handleSelect(t)}>
                      <td>#{t.id}</td>
                      <td><span className={`status ${t.status}`}>{t.status}</span></td>
                      <td>{t.agent_name || '-'}</td>
                      <td>{t.type || '-'}</td>
                      <td>{t.title || '-'}</td>
                      <td>{formatTime(t.created_at, true)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="empty">태스크가 없습니다</div>
            )}
            {totalPages > 1 && (
              <div className="pagination">
                <button disabled={taskPage <= 1} onClick={() => setTaskPage(taskPage - 1)}>이전</button>
                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  .filter(p => p === 1 || p === totalPages || Math.abs(p - taskPage) <= 2)
                  .reduce<(number | string)[]>((acc, p, i, arr) => {
                    if (i > 0 && p - (arr[i - 1] as number) > 1) acc.push('...');
                    acc.push(p);
                    return acc;
                  }, [])
                  .map((p, i) =>
                    typeof p === 'string'
                      ? <span key={`dot-${i}`} className="pagination-dots">...</span>
                      : <button key={p} className={taskPage === p ? 'active' : ''} onClick={() => setTaskPage(p)}>{p}</button>
                  )}
                <button disabled={taskPage >= totalPages} onClick={() => setTaskPage(taskPage + 1)}>다음</button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* 워크스페이스 상세: 콘솔 출력 */}
      {page === 'workspace-detail' && (() => {
        const group = agentStatus?.taskGroups.find(g => g.taskId === selectedTaskGroup);
        if (!group) return <div className="empty" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 24 }}>
          <div>태스크를 찾을 수 없습니다</div>
          <button onClick={() => setPage('workspace')} style={{ color: '#00ff88', background: 'none', border: '1px solid #00ff8844', borderRadius: 8, cursor: 'pointer', padding: '8px 20px', fontSize: 13 }}>돌아가기</button>
        </div>;
        return (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
              <button onClick={() => setPage('workspace')} style={{ background: 'none', border: '1px solid #2a2a4a', borderRadius: 6, color: '#888', padding: '6px 12px', cursor: 'pointer', fontSize: 13 }}>← 목록</button>
              <h2 style={{ fontSize: 15, color: '#ccc', margin: 0, flex: 1 }}>Task #{group.taskId} <span style={{ color: '#00ff88', fontWeight: 'normal', marginLeft: 6 }}>{elapsed(group.startedAt)}</span></h2>
              {canExecute && (
                <button
                  className="stop-btn"
                  onClick={async () => { if (window.confirm('이 태스크를 중지하시겠습니까?')) { await stopTask(group.taskId); loadData(); setPage('workspace'); } }}
                  title="중지"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="#ff4444">
                    <rect x="2" y="2" width="12" height="12" rx="2" />
                  </svg>
                </button>
              )}
            </div>
            <div style={{ fontSize: 14, color: '#ddd', marginBottom: 8 }}>{group.title}</div>
            {group.requestedBy && <div style={{ fontSize: 12, color: '#888', marginBottom: 16 }}>요청자: {group.requestedBy}</div>}
            <div className="agent-detail-grid">
              {group.agents.map((a) => (
                <div key={a.window} className="agent-detail-card">
                  <div className="agent-detail-header">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span className="agent-window-name">{a.window}</span>
                      {a.task?.agent_name && <span style={{ fontSize: 10, color: '#888' }}>{(a.task as any).model || AGENT_MODEL_MAP[a.task.agent_name] || a.task.agent_name}</span>}
                    </div>
                    {a.task && <span className={`status ${a.task.status}`}>{a.task.status}</span>}
                  </div>
                  {a.task && (
                    <div className="agent-task-info">
                      <span>Task #{a.task.id}</span>
                      <span>{a.task.title}</span>
                    </div>
                  )}
                  <AutoScrollPre className="agent-detail-output">{a.lastOutput || '출력 없음'}</AutoScrollPre>
                </div>
              ))}
            </div>
          </div>
        );
      })()}

      {page === 'docs' && (
        <div className="task-section">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
            <div style={{ display: 'flex', gap: 8 }}>
              <select value={docFilter.project} onChange={(e) => { setDocFilter(f => ({ ...f, project: e.target.value })); setDocPage(1); }} style={{ background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#ccc', padding: '6px 10px', fontSize: 13 }}>
                <option value="">전체 프로젝트</option>
                {docProjects.map((p) => (
                  <option key={p} value={p}>{p}</option>
                ))}
              </select>
              <select value={docFilter.type} onChange={(e) => { setDocFilter(f => ({ ...f, type: e.target.value })); setDocPage(1); }} style={{ background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#ccc', padding: '6px 10px', fontSize: 13 }}>
                <option value="">전체 유형</option>
                {docTypes.map((t) => (
                  <option key={t} value={t}>{t}</option>
                ))}
              </select>
            </div>
            <button
              onClick={async () => {
                setSyncing(true);
                try {
                  await syncDocs();
                  loadDocs();
                } catch {}
                setSyncing(false);
              }}
              disabled={syncing}
              style={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 6, color: syncing ? '#555' : '#00ff88', padding: '6px 14px', fontSize: 13, cursor: syncing ? 'default' : 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}
            >
              <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" style={syncing ? { animation: 'spin 1s linear infinite' } : {}}>
                <path d="M2,8 a6,6 0 0,1 10.3,-4.2 M14,8 a6,6 0 0,1 -10.3,4.2" /><polyline points="2,3 2,8 7,8" /><polyline points="14,13 14,8 9,8" />
              </svg>
              {syncing ? '동기화 중...' : '새로고침'}
            </button>
          </div>
          {(() => {
            const dateKeys = ['last_modified', 'synced_at', 'created_at'];
            const toggleSort = (key: string) => {
              setDocSort(prev => {
                if (prev.key !== key) return { key, asc: dateKeys.includes(key) ? false : true };
                if (dateKeys.includes(key)) {
                  if (!prev.asc) return { key, asc: true };
                  return { key: '', asc: true };
                }
                if (prev.asc) return { key, asc: false };
                return { key: '', asc: true };
              });
              setDocPage(1);
            };
            const sortIcon = (key: string) => docSort.key === key ? (docSort.asc ? ' ▲' : ' ▼') : '';
            const sorted = docSort.key ? [...docs].sort((a: any, b: any) => {
              const av = a[docSort.key] || '';
              const bv = b[docSort.key] || '';
              const cmp = typeof av === 'number' ? av - bv : String(av).localeCompare(String(bv));
              return docSort.asc ? cmp : -cmp;
            }) : docs;
            const docPerPage = 20;
            const docTotalPages = Math.max(1, Math.ceil(sorted.length / docPerPage));
            const pagedDocs = sorted.slice((docPage - 1) * docPerPage, docPage * docPerPage);
            return <>
              <h2>문서 <span>{docs.length}건</span></h2>
              {docs.length > 0 ? (
                <>
                  <table style={{ tableLayout: 'fixed' }}>
                    <thead>
                      <tr>
                        <th style={{ width: '13%', cursor: 'pointer' }} onClick={() => toggleSort('project')}>프로젝트{sortIcon('project')}</th>
                        <th style={{ width: '8%' }}>유형</th>
                        <th style={{ width: '37%', cursor: 'pointer' }} onClick={() => toggleSort('filename')}>파일명{sortIcon('filename')}</th>
                        <th style={{ width: '11%', cursor: 'pointer' }} onClick={() => toggleSort('author')}>작성자{sortIcon('author')}</th>
                        <th style={{ width: '7%' }}>크기</th>
                        <th style={{ width: '8%', cursor: 'pointer' }} onClick={() => toggleSort('last_modified')}>생성일{sortIcon('last_modified')}</th>
                        {user && ['owner', 'admin', 'engineer'].includes(user.role) && <th style={{ width: '5%' }}></th>}
                      </tr>
                    </thead>
                    <tbody>
                      {pagedDocs.map((d) => (
                        <tr key={d.id} onClick={() => {
                          setSelectedDoc2(d);
                          setDocContent(null);
                          if (!isDownloadOnlyDoc(d)) getDocContent(d.s3_key).then(setDocContent).catch(() => {});
                        }}>
                          <td style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.project}</td>
                          <td style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.doc_type || '-'}</td>
                          <td style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.filename}</td>
                          <td>{d.author || '-'}</td>
                          <td>{formatDocSize(d.size)}</td>
                          <td>{formatCreatedDate(d.filename, d.last_modified)}</td>
                          {user && ['owner', 'admin', 'engineer'].includes(user.role) && (
                            <td style={{ textAlign: 'center' }}>
                              {(user.role === 'owner' || user.role === 'admin' || (user.github_username && d.author === user.github_username)) && (
                                <button
                                  className="doc-delete-btn"
                                  onClick={(e) => { e.stopPropagation(); setDeleteTarget(d); }}
                                  title="삭제"
                                ><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg></button>
                              )}
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {docTotalPages > 1 && (
                    <div className="pagination">
                      <button disabled={docPage <= 1} onClick={() => setDocPage(docPage - 1)}>이전</button>
                      {Array.from({ length: docTotalPages }, (_, i) => i + 1)
                        .filter(p => p === 1 || p === docTotalPages || Math.abs(p - docPage) <= 2)
                        .reduce<(number | string)[]>((acc, p, i, arr) => {
                          if (i > 0 && p - (arr[i - 1] as number) > 1) acc.push('...');
                          acc.push(p);
                          return acc;
                        }, [])
                        .map((p, i) =>
                          typeof p === 'string'
                            ? <span key={`dot-${i}`} className="pagination-dots">...</span>
                            : <button key={p} className={docPage === p ? 'active' : ''} onClick={() => setDocPage(p)}>{p}</button>
                        )}
                      <button disabled={docPage >= docTotalPages} onClick={() => setDocPage(docPage + 1)}>다음</button>
                    </div>
                  )}
                </>
              ) : (
                <div className="empty">문서가 없습니다. 우측 상단 새로고침 버튼으로 S3 동기화하세요.</div>
              )}
            </>;
          })()}

          {deleteTarget && (
            <div className="modal-overlay" onClick={() => setDeleteTarget(null)}>
              <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 420 }}>
                <div className="modal-header">
                  <h2>문서 삭제</h2>
                  <button className="close" onClick={() => setDeleteTarget(null)}>&times;</button>
                </div>
                <div className="modal-body" style={{ padding: '20px 24px' }}>
                  <p style={{ color: '#ccc', fontSize: 14, margin: '0 0 8px' }}>다음 문서를 삭제하시겠습니까?</p>
                  <p style={{ color: '#fff', fontSize: 14, fontWeight: 600, margin: '0 0 4px' }}>{deleteTarget.filename}</p>
                  <p style={{ color: '#888', fontSize: 12, margin: 0 }}>{deleteTarget.project} / {deleteTarget.doc_type || '-'}</p>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 20 }}>
                    <button
                      style={{ background: '#2a2a4a', color: '#ccc', border: 'none', borderRadius: 6, padding: '8px 16px', fontSize: 13, cursor: 'pointer' }}
                      onClick={() => setDeleteTarget(null)}
                    >취소</button>
                    <button
                      style={{ background: '#ff4444', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 16px', fontSize: 13, cursor: 'pointer' }}
                      onClick={async () => {
                        try {
                          await deleteDoc(deleteTarget.s3_key);
                          setDeleteTarget(null);
                          loadDocs();
                        } catch (err: any) {
                          alert(err.message || '삭제 실패');
                        }
                      }}
                    >삭제</button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {selectedDoc2 && (
            <div className="modal-overlay" onClick={() => setSelectedDoc2(null)}>
              <div className="modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                  <h2>{selectedDoc2.filename}</h2>
                  <button className="close" onClick={() => setSelectedDoc2(null)}>&times;</button>
                </div>
                <div className="modal-body">
                  <div className="detail-row"><div className="dl">프로젝트</div><div className="dv">{selectedDoc2.project}</div></div>
                  <div className="detail-row"><div className="dl">유형</div><div className="dv">{selectedDoc2.doc_type || '-'}</div></div>
                  <div className="detail-row"><div className="dl">작성자</div><div className="dv">{docContent?.author || selectedDoc2.author || '-'}</div></div>
                  <div className="detail-row"><div className="dl">생성일</div><div className="dv">{formatCreatedDate(selectedDoc2.filename, selectedDoc2.last_modified)}</div></div>
                  <div className="detail-row"><div className="dl">크기</div><div className="dv">{formatDocSize(selectedDoc2.size)}</div></div>
                  {isDownloadOnlyDoc(selectedDoc2) ? (
                    <div style={{ padding: 16, textAlign: 'center' }}>
                      <button
                        onClick={() => downloadDoc(selectedDoc2.s3_key)}
                        style={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 6, color: '#00ff88', padding: '8px 16px', fontSize: 13, cursor: 'pointer' }}
                      >다운로드</button>
                    </div>
                  ) : docContent?.markdown ? (
                    <div className="markdown-body"><ReactMarkdown remarkPlugins={[remarkGfm]}>{escapeHtmlCodeBlocks(docContent.markdown)}</ReactMarkdown></div>
                  ) : (
                    <div style={{ color: '#666', fontSize: 13, padding: 16, textAlign: 'center' }}>문서 로딩 중...</div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {page === 'approvals' && (
        <div className="task-section">
          <h2>DB권한 승인 요청 <span>{dbApprovals.length}건</span></h2>
          <div className="filters">
            {['all', 'pending', 'approved', 'rejected', 'completed'].map((s) => (
              <button key={s} className={approvalFilter === s ? 'active' : ''} onClick={() => setApprovalFilter(s)}>
                {s === 'all' ? '전체' : s === 'pending' ? '대기' : s === 'approved' ? '승인' : s === 'rejected' ? '거부' : '완료'}
              </button>
            ))}
          </div>
          {dbApprovals.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>상태</th>
                  <th>유형</th>
                  <th>제목</th>
                  <th>대상 DB</th>
                  <th>요청자</th>
                  <th>요청일</th>
                </tr>
              </thead>
              <tbody>
                {dbApprovals.map((a) => (
                  <tr key={a.id} onClick={() => setSelectedApproval(a)}>
                    <td>#{a.id}</td>
                    <td><span className={`status ${a.status}`}>{a.status}</span></td>
                    <td>{a.type === 'cs' ? 'CS' : a.type === 'crawl' ? '크롤링' : a.type === 'migration' ? '마이그레이션' : a.type}</td>
                    <td>{a.title}</td>
                    <td>{a.target_db || '-'}</td>
                    <td>{a.requested_by || '-'}</td>
                    <td>{formatTime(a.requested_at, true)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="empty">승인 요청이 없습니다</div>
          )}
        </div>
      )}

      {selectedApproval && (
        <div className="modal-overlay" onClick={() => setSelectedApproval(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>DB권한 승인 #{selectedApproval.id}</h2>
              <button className="close" onClick={() => setSelectedApproval(null)}>&times;</button>
            </div>
            <div className="modal-body">
              <div className="detail-row"><div className="dl">상태</div><div className="dv"><span className={`status ${selectedApproval.status}`}>{selectedApproval.status}</span></div></div>
              <div className="detail-row"><div className="dl">유형</div><div className="dv">{selectedApproval.type === 'cs' ? 'CS 데이터 수정' : selectedApproval.type === 'crawl' ? '크롤링 적재' : selectedApproval.type === 'migration' ? '마이그레이션' : selectedApproval.type}</div></div>
              <div className="detail-row"><div className="dl">제목</div><div className="dv">{selectedApproval.title}</div></div>
              {selectedApproval.target_db && <div className="detail-row"><div className="dl">대상 DB</div><div className="dv">{selectedApproval.target_db}</div></div>}
              {selectedApproval.target_table && <div className="detail-row"><div className="dl">대상 테이블</div><div className="dv">{selectedApproval.target_table}</div></div>}
              {selectedApproval.record_count && <div className="detail-row"><div className="dl">건수</div><div className="dv">{selectedApproval.record_count}건</div></div>}
              {selectedApproval.task_id && <div className="detail-row"><div className="dl">연결 태스크</div><div className="dv">#{selectedApproval.task_id} {selectedApproval.task_title || ''}</div></div>}
              <div className="detail-row"><div className="dl">요청자</div><div className="dv">{selectedApproval.requested_by || '-'}</div></div>
              <div className="detail-row"><div className="dl">요청일</div><div className="dv">{formatTime(selectedApproval.requested_at)}</div></div>
              {selectedApproval.approved_by && <div className="detail-row"><div className="dl">승인자</div><div className="dv">{selectedApproval.approved_by}</div></div>}
              {selectedApproval.approved_at && <div className="detail-row"><div className="dl">승인일</div><div className="dv">{formatTime(selectedApproval.approved_at)}</div></div>}
              {selectedApproval.executed_at && <div className="detail-row"><div className="dl">실행일</div><div className="dv">{formatTime(selectedApproval.executed_at)}</div></div>}
              {selectedApproval.execution_result && <div className="detail-row"><div className="dl">실행 결과</div><div className="dv">{selectedApproval.execution_result}</div></div>}
              {selectedApproval.detail && (
                <>
                  <h2 style={{ marginTop: 16 }}>상세</h2>
                  <pre>{selectedApproval.detail}</pre>
                </>
              )}
            </div>
          </div>
        </div>
      )}


      {selected && (
        <div className="modal-overlay" onClick={() => { setSelected(null); setPreviewDoc(null); }}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            {previewDoc ? (
              <>
                <div className="modal-header">
                  <button className="back-btn" onClick={() => setPreviewDoc(null)} style={{ marginRight: 8 }}>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="9,2 4,7 9,12"/></svg>
                  </button>
                  <h2>{previewDoc.agent_name}</h2>
                  <button className="close" onClick={() => { setSelected(null); setPreviewDoc(null); }}>&times;</button>
                </div>
                <div className="modal-body">
                {previewDoc.task_title && <div className="detail-row"><div className="dl">태스크</div><div className="dv">{previewDoc.task_title}</div></div>}
                <div className="detail-row"><div className="dl">에이전트</div><div className="dv">{previewDoc.agent_name}</div></div>
                <div className="detail-row"><div className="dl">생성일</div><div className="dv">{formatTime(previewDoc.created_at)}</div></div>
                <h2 style={{ marginTop: 16, fontSize: 14 }}>요약</h2>
                <div style={{ fontSize: 13, color: '#ccc', padding: '8px 0' }}>{previewDoc.summary}</div>
                {previewDoc.s3_key ? (
                  previewMarkdown ? (
                    <div className="markdown-body"><ReactMarkdown remarkPlugins={[remarkGfm]}>{escapeHtmlCodeBlocks(previewMarkdown)}</ReactMarkdown></div>
                  ) : (
                    <div style={{ color: '#666', fontSize: 13, padding: 16, textAlign: 'center' }}>문서 로딩 중...</div>
                  )
                ) : previewDoc.detail ? (
                  <>
                    <h2 style={{ marginTop: 16, fontSize: 14 }}>상세</h2>
                    <pre>{previewDoc.detail}</pre>
                  </>
                ) : null}
                </div>
              </>
            ) : (
            <>
            <div className="modal-header">
              <h2>Task #{selected.id}</h2>
              <button className="close" onClick={() => setSelected(null)}>&times;</button>
            </div>
            <div className="modal-body">
            <div className="detail-row"><div className="dl">상태</div><div className="dv"><span className={`status ${selected.status}`}>{selected.status}</span></div></div>
            <div className="detail-row"><div className="dl">에이전트</div><div className="dv">{selected.agent_name}</div></div>
            <div className="detail-row"><div className="dl">타입</div><div className="dv">{selected.type}</div></div>
            <div className="detail-row"><div className="dl">제목</div><div className="dv">{selected.title}</div></div>
            {selected.prompt && <div className="detail-row"><div className="dl">프롬프트</div><div className="dv">{selected.prompt}</div></div>}
            {selected.result && <div className="detail-row"><div className="dl">결과</div><div className="dv">{selected.result}</div></div>}
            {selected.error && <div className="detail-row"><div className="dl">에러</div><div className="dv" style={{ color: '#ff4444' }}>{selected.error}</div></div>}
            {selected.branch && <div className="detail-row"><div className="dl">브랜치</div><div className="dv">{selected.branch}</div></div>}
            <div className="detail-row"><div className="dl">생성</div><div className="dv">{formatTime(selected.created_at)}</div></div>
            <div className="detail-row"><div className="dl">시작</div><div className="dv">{formatTime(selected.started_at)}</div></div>
            <div className="detail-row"><div className="dl">완료</div><div className="dv">{formatTime(selected.completed_at)}</div></div>

            {/* 하위 에이전트 */}
            {subTasks.length > 0 && (
              <>
                <h2 style={{ marginTop: 16 }}>하위 에이전트 <span style={{ color: '#00ff88', fontWeight: 'normal', fontSize: 13 }}>{subTasks.length}건</span></h2>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  {subTasks.map((st) => {
                    const isRunning = st.status === 'running';
                    return (
                    <div
                      key={st.id}
                      className={`subtask-row ${isRunning ? 'clickable' : ''}`}
                      onClick={isRunning ? () => {
                        const parentGroup = agentStatus?.taskGroups.find(g => g.taskId === selected!.id || g.taskId === selected!.parent_task_id);
                        if (parentGroup) {
                          setSelected(null);
                          setPreviewDoc(null);
                          setSelectedTaskGroup(parentGroup.taskId);
                          setPage('workspace-detail');
                        }
                      } : undefined}
                    >
                      <span className={`status ${st.status}`}>{st.status}</span>
                      <span style={{ color: '#00ff88', fontWeight: 600 }}>{st.agent_name}</span>
                      <span style={{ color: '#aaa', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{st.title}</span>
                      <span style={{ color: '#555', fontSize: 11 }}>{formatTime(st.created_at, true)}</span>
                      {isRunning && <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="#00ff88" strokeWidth="1.5" strokeLinecap="round"><polyline points="4,2 8,6 4,10"/></svg>}
                    </div>
                    );
                  })}
                </div>
              </>
            )}

            {/* 설계 문서 & 리서치 */}
            {plans.length > 0 && (
              <>
                <h2 style={{ marginTop: 16 }}>설계 문서 <span style={{ color: '#00ff88', fontWeight: 'normal', fontSize: 13 }}>{plans.length}건</span></h2>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  {plans.map((p) => (
                    <div
                      key={p.id}
                      className="doc-link-row"
                      onClick={() => {
                        setPreviewDoc(p);
                        setPreviewMarkdown(null);
                        if (p.s3_key) {
                          getPlanMarkdown(p.id).then(r => setPreviewMarkdown(r.markdown)).catch(() => {});
                        }
                      }}
                    >
                      <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="#00ff88" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M4,2 h6 l3,3 v9 h-9 z"/><polyline points="10,2 10,5 13,5"/>
                      </svg>
                      <span className="doc-link-agent">{p.agent_name}</span>
                      <span className="doc-link-summary">{p.summary?.substring(0, 50)}{p.summary?.length > 50 ? '...' : ''}</span>
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="#555" strokeWidth="1.5" strokeLinecap="round">
                        <polyline points="4,2 8,6 4,10"/>
                      </svg>
                    </div>
                  ))}
                </div>
                <div
                  className="doc-goto-link"
                  onClick={() => {
                    setSelected(null);
                    setPreviewDoc(null);
                    setPage('docs');
                    getAllPlans().then(setAllPlans).catch(() => {});
                  }}
                >
                  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4,2 h6 l3,3 v9 h-9 z"/><polyline points="10,2 10,5 13,5"/><line x1="5" y1="8" x2="11" y2="8"/><line x1="5" y1="10.5" x2="11" y2="10.5"/>
                  </svg>
                  문서 페이지에서 전체 보기
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                    <polyline points="4,2 8,6 4,10"/>
                  </svg>
                </div>
              </>
            )}
            {log && (
              <>
                <h2 style={{ marginTop: 16 }}>실행 로그</h2>
                <pre>{log}</pre>
              </>
            )}
            </div>
            </>
            )}
          </div>
        </div>
      )}
      {/* KPI는 팀 페이지 내 탭으로 이동 */}
      {page === 'migration' && ['owner', 'admin'].includes(user.role) && <MigrationPage />}
      {page === 'coupon' && (user.role === 'owner' || user.role === 'admin') && <CouponPage user={user} />}
      {page === 'event' && ['owner', 'admin', 'engineer'].includes(user.role) && <EventPage />}
      {page === 'msg-pricing' && ['owner', 'admin', 'engineer'].includes(user.role) && <MessagePricingPage user={user} />}
      {page === 'mypage' && <MyPage user={user} onUpdate={(u) => setUser(u)} />}
      {page === 'admin' && ['owner', 'admin'].includes(user.role) && <AdminPage currentUser={user} />}
      </main>
    </div>
  );
}

const DONUT_COLORS = ['#6c5ce7', '#00b894', '#fdcb6e', '#e17055', '#74b9ff', '#a29bfe'];

function MessagingOverviewTab() {
  const [summaryMonths, setSummaryMonths] = useState<MessagingMonthSummary[]>([]);
  const [smsTrend, setSmsTrend] = useState<SmsTrendItem[]>([]);
  const [alimtalkTrend, setAlimtalkTrend] = useState<AlimtalkTrendItem[]>([]);
  const [templateStats, setTemplateStats] = useState<AlimtalkTemplateStatsItem[]>([]);
  const [loading, setLoading] = useState(true);

  const now = new Date();
  const currentMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  const sixMonthsAgo = (() => {
    const d = new Date(now);
    d.setMonth(d.getMonth() - 5);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
  })();

  useEffect(() => {
    setLoading(true);
    Promise.all([
      getMessagingSummary(sixMonthsAgo, currentMonth).catch(() => ({ months: [] })),
      getSmsTrend(currentMonth, currentMonth, 'daily').catch(() => []),
      getAlimtalkTrend(currentMonth, currentMonth, 'daily').catch(() => []),
      getAlimtalkTemplateStats(currentMonth).catch(() => ({ templates: [] })),
    ]).then(([summary, sms, alimtalk, tplStats]) => {
      setSummaryMonths(summary.months || []);
      setSmsTrend(Array.isArray(sms) ? sms : []);
      setAlimtalkTrend(Array.isArray(alimtalk) ? alimtalk : []);
      setTemplateStats(tplStats.templates || []);
    }).finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const current = summaryMonths.find(m => m.month === currentMonth);
  const prevIdx = summaryMonths.findIndex(m => m.month === currentMonth) + 1;
  const prev = prevIdx < summaryMonths.length ? summaryMonths[prevIdx] : null;

  const smsDiff = current && prev && prev.sms.total > 0 ? Math.round(((current.sms.total - prev.sms.total) / prev.sms.total) * 100) : 0;
  const alimDiff = current && prev && prev.alimtalk.sent > 0 ? Math.round(((current.alimtalk.sent - prev.alimtalk.sent) / prev.alimtalk.sent) * 100) : 0;
  const costDiff = current && prev && prev.costBreakdown.total > 0 ? Math.round(((current.costBreakdown.total - prev.costBreakdown.total) / prev.costBreakdown.total) * 100) : 0;

  const monthlyTrend = summaryMonths.slice().reverse().map(m => ({
    month: m.month.slice(5) + '월',
    sms: m.sms.sms,
    lms: m.sms.lms,
    alimtalk: m.alimtalk.sent,
  }));

  const cardStyle: React.CSSProperties = { flex: 1, minWidth: 160, background: '#16162a', borderRadius: 10, padding: '16px 20px', border: '1px solid #2a2a4a' };
  const labelStyle: React.CSSProperties = { fontSize: 11, color: '#888', marginBottom: 4 };
  const valueStyle: React.CSSProperties = { fontSize: 22, fontWeight: 700, color: '#e0e0e0' };
  const diffStyle = (v: number): React.CSSProperties => ({ fontSize: 11, marginTop: 4, color: v > 0 ? '#00b894' : v < 0 ? '#e17055' : '#888' });
  const sectionTitle: React.CSSProperties = { fontSize: 14, fontWeight: 600, color: '#e0e0e0', marginBottom: 12 };
  const chartBox: React.CSSProperties = { background: '#16162a', borderRadius: 10, padding: 20, border: '1px solid #2a2a4a', marginBottom: 20 };

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#888' }}>로딩 중...</div>;

  return (
    <div style={{ padding: '0 8px' }}>
      {/* 요약 카드 */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
        <div style={cardStyle}>
          <div style={labelStyle}>문자 (SMS + LMS)</div>
          <div style={valueStyle}>{(current?.sms.total || 0).toLocaleString()}건</div>
          <div style={diffStyle(smsDiff)}>{smsDiff > 0 ? '▲' : '▼'} {Math.abs(smsDiff)}% vs 전월</div>
        </div>
        <div style={cardStyle}>
          <div style={labelStyle}>카카오 알림톡</div>
          <div style={valueStyle}>{(current?.alimtalk.sent || 0).toLocaleString()}건</div>
          <div style={diffStyle(alimDiff)}>{alimDiff > 0 ? '▲' : '▼'} {Math.abs(alimDiff)}% vs 전월</div>
        </div>
        <div style={cardStyle}>
          <div style={labelStyle}>이번 달 총 비용</div>
          <div style={valueStyle}>₩{(current?.costBreakdown.total || 0).toLocaleString()}</div>
          <div style={diffStyle(costDiff)}>{costDiff > 0 ? '▲' : '▼'} {Math.abs(costDiff)}% vs 전월</div>
          <div style={{ marginTop: 8, fontSize: 11, color: '#888', lineHeight: 1.6 }}>
            SMS ₩{(current?.costBreakdown.sms || 0).toLocaleString()}<br />
            LMS ₩{(current?.costBreakdown.lms || 0).toLocaleString()}<br />
            알림톡 ₩{(current?.costBreakdown.alimtalk || 0).toLocaleString()}
          </div>
        </div>
      </div>

      {/* 통합 추이 차트 */}
      <div style={chartBox}>
        <div style={sectionTitle}>채널별 월간 추이</div>
        <ResponsiveContainer width="100%" height={260}>
          <LineChart data={monthlyTrend}>
            <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
            <XAxis dataKey="month" tick={{ fill: '#888', fontSize: 11 }} />
            <YAxis tick={{ fill: '#888', fontSize: 11 }} />
            <Tooltip contentStyle={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 8, fontSize: 12 }} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Line type="monotone" dataKey="sms" name="SMS" stroke="#6c5ce7" strokeWidth={2} dot={{ r: 3 }} />
            <Line type="monotone" dataKey="lms" name="LMS" stroke="#a29bfe" strokeWidth={2} dot={{ r: 3 }} />
            <Line type="monotone" dataKey="alimtalk" name="알림톡" stroke="#00b894" strokeWidth={2} dot={{ r: 3 }} />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* 하단 2컬럼: 문자 상세 + 알림톡 상세 */}
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 20 }}>
        {/* 문자 상세 */}
        <div style={{ ...chartBox, flex: 1, minWidth: 320, marginBottom: 0 }}>
          <div style={sectionTitle}>문자 발송 추이 (일별)</div>
          <ResponsiveContainer width="100%" height={220}>
            <LineChart data={smsTrend.map(d => ({ ...d, date: d.date.slice(5) }))}>
              <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
              <XAxis dataKey="date" tick={{ fill: '#888', fontSize: 11 }} />
              <YAxis tick={{ fill: '#888', fontSize: 11 }} />
              <Tooltip contentStyle={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 8, fontSize: 12 }} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
              <Line type="monotone" dataKey="sms" name="SMS" stroke="#6c5ce7" strokeWidth={2} dot={{ r: 3 }} />
              <Line type="monotone" dataKey="lms" name="LMS" stroke="#a29bfe" strokeWidth={2} dot={{ r: 3 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>

        {/* 알림톡 상세 */}
        <div style={{ ...chartBox, flex: 1, minWidth: 320, marginBottom: 0 }}>
          <div style={sectionTitle}>알림톡 발송 추이 (일별)</div>
          <ResponsiveContainer width="100%" height={220}>
            <LineChart data={alimtalkTrend.map(d => ({ ...d, date: d.date.slice(5) }))}>
              <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
              <XAxis dataKey="date" tick={{ fill: '#888', fontSize: 11 }} />
              <YAxis tick={{ fill: '#888', fontSize: 11 }} />
              <Tooltip contentStyle={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 8, fontSize: 12 }} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
              <Line type="monotone" dataKey="success" name="성공" stroke="#00b894" strokeWidth={2} dot={{ r: 3 }} />
              <Line type="monotone" dataKey="failed" name="실패" stroke="#e17055" strokeWidth={2} dot={{ r: 3 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* 도넛차트: 알림톡 템플릿별 발송 비율 */}
      <div style={chartBox}>
        <div style={sectionTitle}>알림톡 템플릿별 발송 비율</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 32, flexWrap: 'wrap' }}>
          <ResponsiveContainer width={280} height={280}>
            <PieChart>
              <Pie
                data={templateStats}
                dataKey="sent"
                nameKey="templateCode"
                cx="50%"
                cy="50%"
                innerRadius={70}
                outerRadius={110}
                paddingAngle={3}
                stroke="none"
              >
                {templateStats.map((_entry, idx) => (
                  <Cell key={idx} fill={DONUT_COLORS[idx % DONUT_COLORS.length]} />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 8, fontSize: 12 }}
                formatter={(value: any, name: any) => [`${Number(value).toLocaleString()}건`, name]}
              />
            </PieChart>
          </ResponsiveContainer>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {templateStats.map((t, idx) => (
              <div key={t.templateCode} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{ width: 12, height: 12, borderRadius: 3, background: DONUT_COLORS[idx % DONUT_COLORS.length], flexShrink: 0 }} />
                <span style={{ fontSize: 13, color: '#e0e0e0', minWidth: 100 }}>{t.templateCode}</span>
                <span style={{ fontSize: 13, color: '#888' }}>{t.sent.toLocaleString()}건</span>
                <span style={{ fontSize: 12, color: '#6c5ce7', fontWeight: 600 }}>{t.ratio}%</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function MessagePricingPage({ user }: { user: User }) {
  const canViewOverview = ['owner', 'admin'].includes(user.role);
  const [msgTab, setMsgTab] = useState<'overview' | 'push' | 'kakao' | 'sender' | 'pricing'>(canViewOverview ? 'overview' : 'push');
  const [pricing, setPricing] = useState<MessagePricing[]>([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState<number | null>(null);
  const [editPrice, setEditPrice] = useState('');
  const [editDesc, setEditDesc] = useState('');
  const [saving, setSaving] = useState(false);

  // Kakao templates state
  const [kakaoTemplates, setKakaoTemplates] = useState<KakaoTemplate[]>([]);
  const [kakaoLoading, setKakaoLoading] = useState(true);
  const [kakaoFilterProject, setKakaoFilterProject] = useState('');
  const [kakaoDetailTarget, setKakaoDetailTarget] = useState<KakaoTemplate | null>(null);

  // 발신번호 현황 — 상세/상태변경 모달 (신청 관리 큐/모달 재사용, 읽기전용 현황 + 상태 변경)
  const [senderModalId, setSenderModalId] = useState<number | null>(null);
  const [senderRefreshTick, setSenderRefreshTick] = useState(0);
  // 전역 1초 타이머 리렌더에도 참조가 바뀌지 않도록 안정화 — 모달/큐 깜빡임 방지
  const openSenderModal = useCallback((id: number) => setSenderModalId(id), []);
  const closeSenderModal = useCallback(() => setSenderModalId(null), []);
  const onSenderChanged = useCallback(() => { setSenderModalId(null); setSenderRefreshTick(t => t + 1); }, []);

  const load = () => {
    setLoading(true);
    getMessagePricing().then(setPricing).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const loadKakaoTemplates = useCallback(() => {
    setKakaoLoading(true);
    getKakaoTemplates(kakaoFilterProject || undefined)
      .then(setKakaoTemplates)
      .catch(() => setKakaoTemplates([]))
      .finally(() => setKakaoLoading(false));
  }, [kakaoFilterProject]);
  useEffect(() => { loadKakaoTemplates(); }, [loadKakaoTemplates]);

  const kakaoProjects = Array.from(new Set(kakaoTemplates.map(t => t.project))).sort();

  const startEdit = (p: MessagePricing) => {
    setEditing(p.id);
    setEditPrice(String(p.unitPrice));
    setEditDesc(p.description || '');
  };

  const cancelEdit = () => { setEditing(null); };

  const saveEdit = async (messageType: string) => {
    const price = parseInt(editPrice);
    if (!price || price <= 0) { alert('금액은 1원 이상이어야 합니다.'); return; }
    setSaving(true);
    try {
      await updateMessagePricing({ messageType, unitPrice: price, description: editDesc });
      setEditing(null);
      load();
    } catch (err: any) {
      alert(err.message || '수정 실패');
    } finally {
      setSaving(false);
    }
  };

  const typeLabel: Record<string, string> = { ALIMTALK: '알림톡', SMS: '단문 (SMS)', LMS: '장문 (LMS)' };

  return (
    <div className="admin-page">
      {/* 탭 */}
      <div className="admin-tabs">
        {canViewOverview && <button className={`admin-tab ${msgTab === 'overview' ? 'active' : ''}`} onClick={() => setMsgTab('overview')}>현황</button>}
        <button className={`admin-tab ${msgTab === 'push' ? 'active' : ''}`} onClick={() => setMsgTab('push')}>푸시 알림</button>
        <button className={`admin-tab ${msgTab === 'kakao' ? 'active' : ''}`} onClick={() => setMsgTab('kakao')}>카카오 알림톡</button>
        <button className={`admin-tab ${msgTab === 'sender' ? 'active' : ''}`} onClick={() => setMsgTab('sender')}>발신 번호</button>
        <button className={`admin-tab ${msgTab === 'pricing' ? 'active' : ''}`} onClick={() => setMsgTab('pricing')}>금액 설정</button>
      </div>

      {/* 현황 */}
      {msgTab === 'overview' && canViewOverview && <MessagingOverviewTab />}

      {/* 푸시 알림 */}
      {msgTab === 'push' && <PushTemplateTab />}

      {/* 카카오 알림톡 */}
      {msgTab === 'kakao' && (
        <div style={{ padding: '0 8px' }}>
          <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap', alignItems: 'center' }}>
            <select value={kakaoFilterProject} onChange={e => setKakaoFilterProject(e.target.value)} style={{ height: 32, padding: '0 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 12 }}>
              <option value="">전체 프로젝트</option>
              {kakaoProjects.map(p => <option key={p} value={p}>{p}</option>)}
            </select>
            <span style={{ fontSize: 12, color: '#666' }}>{kakaoTemplates.length}건</span>
          </div>

          {kakaoLoading ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#666', fontSize: 13 }}>로딩중...</div>
          ) : kakaoTemplates.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#666', fontSize: 13 }}>템플릿이 없습니다.</div>
          ) : (
            <div className="admin-table-wrap">
              <table><thead><tr>
                <th style={{ width: 100 }}>프로젝트</th>
                <th style={{ width: 120 }}>카카오 코드</th>
                <th style={{ width: 80 }}>제목</th>
                <th>본문</th>
                <th style={{ width: 45 }}>과금</th>
              </tr></thead><tbody>
                {kakaoTemplates.map(t => (
                  <tr key={t.id} onClick={() => setKakaoDetailTarget(t)} style={{ cursor: 'pointer' }}>
                    <td style={{ fontSize: 11, color: '#aaa' }}>{t.project}</td>
                    <td style={{ fontSize: 11, fontFamily: 'monospace' }}>{t.kakaoTemplateCode}</td>
                    <td>{t.title}</td>
                    <td style={{ maxWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 12, color: '#ccc' }}>{t.body}</td>
                    <td style={{ textAlign: 'center' }}>{t.isBillable ? <span style={{ color: '#f59e0b', fontSize: 11 }}>과금</span> : <span style={{ color: '#666', fontSize: 11 }}>-</span>}</td>
                  </tr>
                ))}
              </tbody></table>
            </div>
          )}

          {kakaoDetailTarget && (
            <div className="modal-overlay" onClick={() => setKakaoDetailTarget(null)}>
              <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 640 }}>
                <div className="modal-header">
                  <h2>알림톡 템플릿 상세</h2>
                  <button className="close" onClick={() => setKakaoDetailTarget(null)}>&times;</button>
                </div>
                <div className="modal-body" style={{ padding: '16px 24px' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px 16px' }}>
                    <div className="migration-field">
                      <label>내부 코드</label>
                      <input type="text" value={kakaoDetailTarget.templateCode} disabled style={{ color: '#aaa', fontFamily: 'monospace' }} />
                    </div>
                    <div className="migration-field">
                      <label>카카오 코드</label>
                      <input type="text" value={kakaoDetailTarget.kakaoTemplateCode} disabled style={{ color: '#aaa', fontFamily: 'monospace' }} />
                    </div>
                    <div className="migration-field">
                      <label>프로젝트</label>
                      <input type="text" value={kakaoDetailTarget.project} disabled style={{ color: '#666' }} />
                    </div>
                    <div className="migration-field">
                      <label>카테고리</label>
                      <input type="text" value={kakaoDetailTarget.category} disabled style={{ color: '#666' }} />
                    </div>
                    <div className="migration-field">
                      <label>division</label>
                      <input type="text" value={kakaoDetailTarget.division} disabled style={{ color: '#666' }} />
                    </div>
                    <div className="migration-field">
                      <label>과금</label>
                      <div style={{ padding: '6px 0', fontSize: 12 }}>
                        <span>{kakaoDetailTarget.isBillable ? '과금 대상' : '무료'}</span>
                      </div>
                    </div>
                    <div className="migration-field" style={{ gridColumn: 'span 2' }}>
                      <label>제목</label>
                      <input type="text" value={kakaoDetailTarget.title} disabled style={{ color: '#e0e0e0' }} />
                    </div>
                    <div className="migration-field" style={{ gridColumn: 'span 2' }}>
                      <label>본문</label>
                      <textarea value={kakaoDetailTarget.body} disabled rows={5} style={{ width: '100%', boxSizing: 'border-box', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', padding: '8px 12px', fontSize: 13, resize: 'vertical', fontFamily: 'inherit' }} />
                    </div>
                    {kakaoDetailTarget.availableVariables && (
                      <div className="migration-field" style={{ gridColumn: 'span 2' }}>
                        <label>사용 변수</label>
                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', padding: '4px 0' }}>
                          {kakaoDetailTarget.availableVariables.split(',').map(v => (
                            <span key={v} style={{ display: 'inline-block', padding: '2px 8px', borderRadius: 4, fontSize: 11, fontFamily: 'monospace', background: '#1a1a2e', border: '1px solid #2a2a4a', color: '#8b8bdb' }}>{v.trim()}</span>
                          ))}
                        </div>
                      </div>
                    )}
                    {kakaoDetailTarget.buttonName && (
                      <>
                        <div className="migration-field" style={{ gridColumn: 'span 2' }}>
                          <label>버튼</label>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 16px', padding: '4px 0' }}>
                            <div><span style={{ fontSize: 11, color: '#666' }}>텍스트: </span><span style={{ fontSize: 12, color: '#e0e0e0' }}>{kakaoDetailTarget.buttonName}</span></div>
                            <div><span style={{ fontSize: 11, color: '#666' }}>타입: </span><span style={{ fontSize: 12, color: '#e0e0e0' }}>{kakaoDetailTarget.buttonType || '-'}</span></div>
                            {kakaoDetailTarget.buttonSchemeAndroid && <div><span style={{ fontSize: 11, color: '#666' }}>Android: </span><span style={{ fontSize: 11, color: '#aaa', fontFamily: 'monospace' }}>{kakaoDetailTarget.buttonSchemeAndroid}</span></div>}
                            {kakaoDetailTarget.buttonSchemeIos && <div><span style={{ fontSize: 11, color: '#666' }}>iOS: </span><span style={{ fontSize: 11, color: '#aaa', fontFamily: 'monospace' }}>{kakaoDetailTarget.buttonSchemeIos}</span></div>}
                            {kakaoDetailTarget.buttonUrlMobile && <div><span style={{ fontSize: 11, color: '#666' }}>모바일: </span><span style={{ fontSize: 11, color: '#aaa', fontFamily: 'monospace', wordBreak: 'break-all' }}>{kakaoDetailTarget.buttonUrlMobile}</span></div>}
                            {kakaoDetailTarget.buttonUrlPc && <div><span style={{ fontSize: 11, color: '#666' }}>PC: </span><span style={{ fontSize: 11, color: '#aaa', fontFamily: 'monospace', wordBreak: 'break-all' }}>{kakaoDetailTarget.buttonUrlPc}</span></div>}
                          </div>
                        </div>
                      </>
                    )}
                    {kakaoDetailTarget.description && (
                      <div className="migration-field" style={{ gridColumn: 'span 2' }}>
                        <label>설명</label>
                        <input type="text" value={kakaoDetailTarget.description} disabled style={{ color: '#666' }} />
                      </div>
                    )}
                  </div>
                  <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
                    <button onClick={() => setKakaoDetailTarget(null)} style={{ height: 36, padding: '0 14px', background: 'transparent', border: '1px solid #2a2a4a', borderRadius: 6, color: '#aaa', fontSize: 13, cursor: 'pointer' }}>닫기</button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* 발신 번호 현황 (신청 승인/반려 관리는 쿠폰 페이지, 여기선 현황 조회 + 상태 변경) */}
      {msgTab === 'sender' && (
        <div style={{ padding: '0 8px' }}>
          <SenderNumberQueue refreshTick={senderRefreshTick} onOpen={openSenderModal} />
        </div>
      )}

      {/* 금액 설정 */}
      {msgTab === 'pricing' && (
      <div style={{ padding: '0 8px' }}>
      {loading ? (
        <div style={{ color: '#666', padding: 24, textAlign: 'center' }}>로딩 중...</div>
      ) : pricing.length === 0 ? (
        <div style={{ color: '#666', padding: 24, textAlign: 'center' }}>데이터가 없습니다</div>
      ) : (
        <div className="admin-table-wrap">
          <table>
            <thead>
              <tr>
                <th>유형</th>
                <th>단가 (원)</th>
                <th>설명</th>
                <th style={{ width: 100 }}></th>
              </tr>
            </thead>
            <tbody>
              {pricing.map(p => (
                <tr key={p.id}>
                  <td style={{ fontWeight: 600 }}>{typeLabel[p.messageType] || p.messageType}</td>
                  {editing === p.id ? (
                    <>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                          <div className="migration-field" style={{ width: 80, marginBottom: 0 }}>
                            <input type="text" inputMode="numeric" value={editPrice} onChange={e => { if (/^\d*$/.test(e.target.value)) setEditPrice(e.target.value); }} />
                          </div>
                          <span style={{ color: '#666', fontSize: 12 }}>원</span>
                        </div>
                      </td>
                      <td>
                        <div className="migration-field" style={{ width: 160, marginBottom: 0 }}>
                          <input type="text" value={editDesc} onChange={e => setEditDesc(e.target.value)} placeholder="설명" />
                        </div>
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: 4 }}>
                          <button
                            onClick={() => saveEdit(p.messageType)}
                            disabled={saving}
                            style={{ height: 36, padding: '0 14px', background: saving ? '#2a2a4a' : '#00cc6a', border: 'none', borderRadius: 6, color: saving ? '#888' : '#fff', fontSize: 13, fontWeight: 600, cursor: saving ? 'not-allowed' : 'pointer', transition: 'all 0.15s', whiteSpace: 'nowrap' }}
                          >{saving ? '...' : '저장'}</button>
                          <button
                            onClick={cancelEdit}
                            style={{ height: 36, padding: '0 14px', background: 'transparent', border: '1px solid #2a2a4a', borderRadius: 6, color: '#aaa', fontSize: 13, cursor: 'pointer', transition: 'all 0.15s', whiteSpace: 'nowrap' }}
                          >취소</button>
                        </div>
                      </td>
                    </>
                  ) : (
                    <>
                      <td style={{ fontSize: 15, fontWeight: 600, color: '#00ff88' }}>{p.unitPrice.toLocaleString()}원</td>
                      <td style={{ color: '#aaa', fontSize: 13 }}>{p.description || '-'}</td>
                      <td>
                        <button
                          onClick={() => startEdit(p)}
                          style={{ background: '#2a2a4a', color: '#ccc', border: 'none', borderRadius: 4, padding: '4px 10px', fontSize: 12, cursor: 'pointer' }}
                        >수정</button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      </div>
      )}

      {/* 발신번호 현황 상세/상태변경 모달 */}
      {senderModalId != null && (
        <SenderNumberDetailModal
          id={senderModalId}
          onClose={closeSenderModal}
          onChanged={onSenderChanged}
        />
      )}
    </div>
  );
}

// 지급대행(링코페이 정산) 셀러 상태 관리 — 관리자 뷰
// 상태 라벨은 백엔드(statusLabel) 제공값 그대로 표시. 색상만 code로 매핑
const PAYOUT_STATUS_COLOR: Record<string, string> = {
  NOT_APPLIED: '#888',
  APPLIED: '#4dabf7',
  PENDING: '#ffa94d',
  APPROVED: '#00ff88',
  REJECTED: '#ff6b6b', // 향후 관리자 반려
};
const payoutColor = (status: string) => PAYOUT_STATUS_COLOR[status] || '#888';
// 진행 스텝: 신청 → 대기 → 승인
const PAYOUT_STEPS: { code: string; label: string }[] = [
  { code: 'APPLIED', label: '신청' },
  { code: 'PENDING', label: '대기' },
  { code: 'APPROVED', label: '승인' },
];
// 상태 필터 칩 (서버 status 쿼리로 전달)
const PAYOUT_FILTERS: { key: string; label: string }[] = [
  { key: '', label: '전체' },
  { key: 'APPLIED', label: '신청' },
  { key: 'PENDING', label: '대기' },
  { key: 'APPROVED', label: '승인' },
  { key: 'REJECTED', label: '반려' },
  { key: 'NOT_APPLIED', label: '미신청' },
];
const PAYOUT_PAGE_SIZE = 20;

function PayoutStatusBadge({ status, label }: { status: string; label: string }) {
  const c = payoutColor(status);
  return (
    <span style={{ display: 'inline-block', padding: '2px 10px', borderRadius: 10, fontSize: 12, color: c, background: `${c}1a`, border: `1px solid ${c}55` }}>
      ● {label}
    </span>
  );
}

// 발신번호 신청 상태 라벨/색상 (REVIEWING 포함 — PAYOUT_STATUS_COLOR 재사용 금지)
const SENDER_STATUS_LABEL: Record<string, string> = { APPLIED: '신청', REVIEWING: '검수중', APPROVED: '승인', REJECTED: '반려' };
const SENDER_STATUS_COLOR: Record<string, string> = { APPLIED: '#4dabf7', REVIEWING: '#ffa94d', APPROVED: '#00ff88', REJECTED: '#ff6b6b' };
function SenderStatusBadge({ status }: { status: string }) {
  const c = SENDER_STATUS_COLOR[status] || '#888';
  const label = SENDER_STATUS_LABEL[status] || status;
  return (
    <span style={{ display: 'inline-block', padding: '2px 10px', borderRadius: 10, fontSize: 12, color: c, background: `${c}1a`, border: `1px solid ${c}55` }}>
      ● {label}
    </span>
  );
}

// 발신번호 반려 항목 키 (Link_Dev_Back SenderNumberField) — 관리자 웹이 해당 단계 · 입력칸을 빨간색으로 표시
const SENDER_REJECT_FIELDS: { key: string; step: string; label: string }[] = [
  { key: 'HOLDER_NAME', step: '01 정보', label: '명의자 실명' },
  { key: 'PHONE_NUMBER', step: '01 정보', label: '발신번호 · 국가번호' },
  { key: 'BUSINESS_NUMBER', step: '01 정보', label: '사업자등록번호' },
  { key: 'BUSINESS_REGISTRATION', step: '02 서류', label: '사업자등록증' },
  { key: 'TELECOM_CERTIFICATE', step: '02 서류', label: '통신서비스 이용증명원' },
  { key: 'ID_CARD', step: '02 서류', label: '신분증 사본' },
  { key: 'SEAL_CERTIFICATE', step: '02 서류', label: '인감 증명서' },
  { key: 'EMPLOYMENT_CERTIFICATE', step: '02 서류', label: '재직증명서 (법인)' },
  { key: 'ADDRESS', step: '04 서명', label: '주소' },
  { key: 'STAMP', step: '04 서명', label: '도장 이미지' },
];
const SENDER_REJECT_FIELD_LABEL: Record<string, string> = Object.fromEntries(SENDER_REJECT_FIELDS.map(f => [f.key, f.label]));
const SENDER_REJECT_STEPS = Array.from(new Set(SENDER_REJECT_FIELDS.map(f => f.step)));
const SENDER_APPLICANT_TYPE_LABEL: Record<string, string> = { INDIVIDUAL: '개인', CORPORATION: '법인' };

function PayoutTab() {
  const [items, setItems] = useState<PayoutSellerListItem[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0); // 0-base (서버 규격)
  const [statusFilter, setStatusFilter] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [keyword, setKeyword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const searchTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const [detail, setDetail] = useState<PayoutSellerDetail | null>(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [showSettlements, setShowSettlements] = useState(false);

  // 심사 반려/재승인 — 반려는 사유 필수(1~255자)라 확정 전 입력칸을 펼친다
  const [showReject, setShowReject] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [reloadKey, setReloadKey] = useState(0); // 반려/재승인 후 목록 상태 뱃지 갱신용

  // 정산 집계 (총금액/월별) — 상세 모달 내
  const [summary, setSummary] = useState<PayoutSettlementSummary | null>(null);
  const [summaryMode, setSummaryMode] = useState<'total' | 'month'>('total');
  const [summaryLoading, setSummaryLoading] = useState(false);

  // 목록 로딩 — 정렬은 서버 기본(등록일 DESC). 서버 정렬 파라미터 추가 시 컬럼 소팅 연결 예정
  useEffect(() => {
    setLoading(true);
    setError(false);
    getPayoutSellers(statusFilter || undefined, keyword || undefined, page, PAYOUT_PAGE_SIZE)
      .then(data => { setItems(data.items || []); setTotalCount(data.totalCount || 0); })
      .catch(() => { setItems([]); setTotalCount(0); setError(true); })
      .finally(() => setLoading(false));
  }, [statusFilter, keyword, page, reloadKey]);

  useEffect(() => {
    document.body.style.overflow = (detail || detailLoading) ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [detail, detailLoading]);

  const openDetail = (storeId: number) => {
    setDetailLoading(true);
    setShowSettlements(false);
    setSummary(null);
    setSummaryMode('total');
    setShowReject(false);
    setRejectReason('');
    getPayoutSellerDetail(storeId)
      .then(setDetail)
      .catch(() => { setDetail(null); alert('셀러 상세를 불러오지 못했습니다.'); })
      .finally(() => setDetailLoading(false));
  };
  const closeDetail = () => { setDetail(null); setDetailLoading(false); setSummary(null); setShowReject(false); setRejectReason(''); };

  // 반려/재승인 공용 — 성공하면 상세를 다시 읽어 상태·사유를 갱신하고 목록도 새로 부른다 //
  const runSellerAction = async (action: () => Promise<unknown>, storeId: number, doneMsg: string) => {
    setSubmitting(true);
    try {
      await action();
      const refreshed = await getPayoutSellerDetail(storeId);
      setDetail(refreshed);
      setShowReject(false);
      setRejectReason('');
      setReloadKey(k => k + 1);
      alert(doneMsg);
    } catch (e: any) {
      // 프록시가 백엔드 문구를 그대로 넘긴다 (사유 필수 / 이미 반려됨 / 신청 내역 없음)
      alert(e?.message || '처리에 실패했습니다');
    } finally {
      setSubmitting(false);
    }
  };
  const rejectSeller = (storeId: number) => {
    const reason = rejectReason.trim();
    if (!reason) { alert('반려 사유를 입력해주세요'); return; }
    runSellerAction(() => rejectPayoutSeller(storeId, reason), storeId, '반려되었습니다');
  };
  const reapproveSeller = (storeId: number) => {
    runSellerAction(() => reapprovePayoutSeller(storeId), storeId, '재승인되었습니다');
  };

  // 정산 집계 로딩 (상세 진입 + 모드 토글 시)
  useEffect(() => {
    if (!detail) return;
    const storeId = detail.storeId;
    setSummaryLoading(true);
    getPayoutSettlementSummary(storeId, summaryMode)
      .then(setSummary)
      .catch(() => setSummary(null))
      .finally(() => setSummaryLoading(false));
  }, [detail, summaryMode]);

  const totalPages = Math.max(1, Math.ceil(totalCount / PAYOUT_PAGE_SIZE));
  const stepIndex = (code: string) => PAYOUT_STEPS.findIndex(s => s.code === code);
  // 'YYYY-MM-DD...' → 'MM.DD'
  const fmtMD = (s?: string) => {
    if (!s) return '-';
    const m = s.match(/\d{4}-(\d{2})-(\d{2})/);
    return m ? `${m[1]}.${m[2]}` : s;
  };

  return (
    <div className="payout-tab">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, marginBottom: 16 }}>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {PAYOUT_FILTERS.map(f => (
            <button key={f.key || 'all'} className={`admin-tab-sm ${statusFilter === f.key ? 'active' : ''}`} onClick={() => { setStatusFilter(f.key); setPage(0); }}>{f.label}</button>
          ))}
        </div>
        <input
          type="text"
          placeholder="업체명 / 사업자번호 검색"
          value={searchInput}
          onChange={(e) => {
            const v = e.target.value;
            setSearchInput(v);
            if (searchTimer.current) clearTimeout(searchTimer.current);
            searchTimer.current = setTimeout(() => { setKeyword(v.trim()); setPage(0); }, 300);
          }}
          style={{ padding: '6px 12px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, color: '#ccc', fontSize: 13, minWidth: 220 }}
        />
      </div>

      <div className="admin-table-wrap">
        <table>
          <thead><tr>
            <th>업체명</th><th>사업자번호</th><th>대표자</th><th>상태</th><th>정산주기</th><th>등록일</th>
          </tr></thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} style={{ textAlign: 'center', color: '#888', padding: '40px 0' }}>불러오는 중...</td></tr>
            ) : error ? (
              <tr><td colSpan={6} style={{ textAlign: 'center', color: '#ff6b6b', padding: '40px 0' }}>목록을 불러오지 못했습니다. (백엔드 미배포 시 정상)</td></tr>
            ) : items.length === 0 ? (
              <tr><td colSpan={6} style={{ textAlign: 'center', color: '#888', padding: '40px 0' }}>해당 조건의 업체가 없습니다.</td></tr>
            ) : items.map(r => (
              <tr key={r.storeId} style={{ cursor: 'pointer' }} onClick={() => openDetail(r.storeId)}>
                <td>{r.storeName}</td>
                <td>{r.businessNumber}</td>
                <td>{r.representative}</td>
                <td><PayoutStatusBadge status={r.status} label={r.statusLabel} /></td>
                <td>{r.settlementCycle}</td>
                <td>{fmtMD(r.registeredAt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalCount > PAYOUT_PAGE_SIZE && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 12 }}>
          <button disabled={page <= 0} onClick={() => setPage(p => p - 1)} style={{ padding: '4px 12px', fontSize: 12, borderRadius: 4, border: '1px solid #2a2a4a', background: 'transparent', color: '#888', cursor: page <= 0 ? 'default' : 'pointer' }}>이전</button>
          <span style={{ padding: '4px 12px', fontSize: 12, color: '#888' }}>{page + 1} / {totalPages}</span>
          <button disabled={page >= totalPages - 1} onClick={() => setPage(p => p + 1)} style={{ padding: '4px 12px', fontSize: 12, borderRadius: 4, border: '1px solid #2a2a4a', background: 'transparent', color: '#888', cursor: page >= totalPages - 1 ? 'default' : 'pointer' }}>다음</button>
        </div>
      )}

      {(detail || detailLoading) && (
        <div className="modal-overlay" onClick={closeDetail}>
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 560 }}>
            {(detailLoading || !detail) ? (
              <div style={{ padding: '60px 0', textAlign: 'center', color: '#888' }}>불러오는 중...</div>
            ) : (
              <>
                <div className="modal-header">
                  <h2>{detail.storeName} · 셀러 상세</h2>
                  <button className="close" onClick={closeDetail}>×</button>
                </div>
                <div className="modal-body" style={{ padding: '20px 24px' }}>
                  {/* 진행 스텝 */}
                  {detail.status === 'NOT_APPLIED' ? (
                    <div style={{ marginBottom: 20, color: '#888', fontSize: 13 }}>● 미신청 — 셀러 등록 전</div>
                  ) : stepIndex(detail.status) < 0 ? (
                    <div style={{ marginBottom: 20, color: payoutColor(detail.status), fontSize: 13 }}>● {detail.statusLabel}</div>
                  ) : (
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
                      {PAYOUT_STEPS.map((step, i) => {
                        const done = i <= stepIndex(detail.status);
                        return (
                          <React.Fragment key={step.code}>
                            {i > 0 && <div style={{ flex: 1, height: 2, background: done ? '#00ff88' : '#2a2a4a' }} />}
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                              <div style={{ width: 10, height: 10, borderRadius: '50%', background: done ? '#00ff88' : '#2a2a4a' }} />
                              <span style={{ fontSize: 12, color: done ? '#00ff88' : '#888' }}>{step.label}</span>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                  )}

                  {detail.status === 'REJECTED' && (
                    <div className="detail-row"><div className="dl">반려 사유</div><div className="dv" style={{ color: '#ff8888' }}>{detail.rejectReason || '-'}</div></div>
                  )}
                  <div className="detail-row"><div className="dl">상호명</div><div className="dv">{detail.storeName}</div></div>
                  <div className="detail-row"><div className="dl">사업자 등록 번호</div><div className="dv">{detail.businessNumber}</div></div>
                  <div className="detail-row"><div className="dl">사업자 등록증</div><div className="dv">{detail.businessLicenseUrl ? <a href={detail.businessLicenseUrl} target="_blank" rel="noreferrer" style={{ color: '#4dabf7' }}>파일 보기</a> : <span style={{ color: '#666' }}>없음</span>}</div></div>
                  <div className="detail-row"><div className="dl">대표자 이름</div><div className="dv">{detail.representative}</div></div>
                  <div className="detail-row"><div className="dl">사업자 계좌</div><div className="dv">{detail.account ? `${detail.account.bankName} ${detail.account.accountNumber} (${detail.account.holderName})` : '-'}</div></div>
                  <div className="detail-row"><div className="dl">연락 가능 이메일</div><div className="dv">{detail.email}</div></div>
                  <div className="detail-row"><div className="dl">연락 가능 연락처</div><div className="dv">{detail.phone}</div></div>
                  <div className="detail-row"><div className="dl">정산 주기</div><div className="dv">{detail.settlementCycle}</div></div>

                  {/* 정산 집계 (총금액 / 월별) */}
                  <div style={{ marginTop: 16, borderTop: '1px solid #2a2a4a', paddingTop: 12 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                      <span style={{ fontSize: 13, color: '#e0e0e0', fontWeight: 600 }}>정산 집계</span>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button className={`admin-tab-sm ${summaryMode === 'total' ? 'active' : ''}`} onClick={() => setSummaryMode('total')}>총금액</button>
                        <button className={`admin-tab-sm ${summaryMode === 'month' ? 'active' : ''}`} onClick={() => setSummaryMode('month')}>월별</button>
                      </div>
                    </div>
                    {summaryLoading ? (
                      <div style={{ color: '#888', fontSize: 13 }}>불러오는 중…</div>
                    ) : !summary ? (
                      <div style={{ color: '#888', fontSize: 13 }}>집계를 불러오지 못했습니다.</div>
                    ) : (
                      <>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px 28px', marginBottom: summaryMode === 'month' ? 12 : 0 }}>
                          <div>
                            <div style={{ fontSize: 11, color: '#888', marginBottom: 2 }}>총 지급완료액</div>
                            <div style={{ fontSize: 18, color: '#00ff88', fontWeight: 700 }}>{summary.totalAmount.toLocaleString()}원</div>
                          </div>
                          <div>
                            <div style={{ fontSize: 11, color: '#888', marginBottom: 2 }}>완료 건수</div>
                            <div style={{ fontSize: 18, color: '#e0e0e0', fontWeight: 700 }}>{summary.totalCount.toLocaleString()}건</div>
                          </div>
                        </div>
                        {summaryMode === 'month' && (
                          (summary.buckets?.length || 0) > 0 ? (
                            <div className="modal-table-scroll">
                              <table style={{ width: '100%', minWidth: 480 }}>
                                <thead><tr><th style={{ textAlign: 'left' }}>월</th><th style={{ textAlign: 'right' }}>지급완료</th><th style={{ textAlign: 'right' }}>시도총액</th><th style={{ textAlign: 'right' }}>건수</th><th style={{ textAlign: 'right' }}>실패</th></tr></thead>
                                <tbody>
                                  {summary.buckets!.map(b => (
                                    <tr key={b.period}>
                                      <td>{b.period}</td>
                                      <td style={{ textAlign: 'right', color: '#00ff88' }}>{b.completedAmount.toLocaleString()}원</td>
                                      <td style={{ textAlign: 'right', color: '#ccc' }}>{b.amount.toLocaleString()}원</td>
                                      <td style={{ textAlign: 'right' }}>{b.count.toLocaleString()}</td>
                                      <td style={{ textAlign: 'right', color: b.failedCount ? '#ff6b6b' : '#666' }}>{b.failedCount.toLocaleString()}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <div style={{ color: '#888', fontSize: 13 }}>월별 정산 내역이 없습니다.</div>
                          )
                        )}
                      </>
                    )}
                  </div>

                  {/* 정산 내역 (부가, 접이식) */}
                  <div style={{ marginTop: 16, borderTop: '1px solid #2a2a4a', paddingTop: 12 }}>
                    <button className="admin-tab-sm" onClick={() => setShowSettlements(v => !v)}>
                      정산 내역 {showSettlements ? '▾' : '▸'} ({detail.settlements?.length || 0})
                    </button>
                    {showSettlements && (
                      (detail.settlements?.length || 0) > 0 ? (
                        <div className="modal-table-scroll" style={{ marginTop: 10 }}>
                          <table style={{ width: '100%', minWidth: 420 }}>
                            <thead><tr><th>정산일</th><th>기간</th><th>금액</th><th>상태</th></tr></thead>
                            <tbody>
                              {detail.settlements.map((s, i) => (
                                <tr key={i}>
                                  <td>{fmtMD(s.settledDate)}</td>
                                  <td>{fmtMD(s.startAt)} ~ {fmtMD(s.endAt)}</td>
                                  <td>{s.settlementAmount?.toLocaleString()}원</td>
                                  <td style={{ color: (s.type === 'FAILED' || s.status === 'FAILED') ? '#ff6b6b' : '#ccc' }}>{s.statusLabel}{s.errorCode ? ` (${s.errorCode})` : ''}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div style={{ marginTop: 10, color: '#888', fontSize: 13 }}>정산 내역이 없습니다.</div>
                      )
                    )}
                  </div>

                  {/* 반려 사유 입력 — [반려] 를 누른 뒤에만 펼친다 */}
                  {showReject && (
                    <div style={{ marginTop: 16, borderTop: '1px solid #2a2a4a', paddingTop: 12 }}>
                      <div style={{ fontSize: 12, color: '#888', marginBottom: 6 }}>반려 사유 (필수, 최대 255자)</div>
                      <textarea
                        value={rejectReason}
                        onChange={(e) => setRejectReason(e.target.value)}
                        maxLength={255}
                        rows={3}
                        placeholder="반려 사유를 입력해주세요"
                        style={{ width: '100%', padding: 10, fontSize: 13, borderRadius: 6, border: '1px solid #2a2a4a', background: '#0f0f23', color: '#e0e0e0', resize: 'vertical', boxSizing: 'border-box' }}
                      />
                      <div style={{ textAlign: 'right', fontSize: 11, color: '#666', marginTop: 4 }}>{rejectReason.length} / 255</div>
                    </div>
                  )}

                  {/* 관리자 액션 — 셀러 등록·상태 동기화는 백엔드 API 가 없어 노출하지 않는다 */}
                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 20 }}>
                    <button className="admin-tab-sm" onClick={closeDetail}>닫기</button>
                    {detail.status === 'REJECTED' ? (
                      <button className="admin-tab-sm active" disabled={submitting} onClick={() => reapproveSeller(detail.storeId)}>
                        {submitting ? '처리 중...' : '재승인'}
                      </button>
                    ) : detail.status !== 'NOT_APPLIED' && (
                      showReject ? (
                        <>
                          <button className="admin-tab-sm" disabled={submitting} onClick={() => { setShowReject(false); setRejectReason(''); }}>취소</button>
                          <button
                            disabled={submitting || !rejectReason.trim()}
                            onClick={() => rejectSeller(detail.storeId)}
                            style={{ padding: '8px 16px', fontSize: 13, borderRadius: 6, border: '1px solid #ff6b6b55', background: 'rgba(255,107,107,0.08)', color: '#ff8888', cursor: (submitting || !rejectReason.trim()) ? 'default' : 'pointer', opacity: (submitting || !rejectReason.trim()) ? 0.5 : 1 }}
                          >
                            {submitting ? '처리 중...' : '반려 확정'}
                          </button>
                        </>
                      ) : (
                        <button
                          onClick={() => setShowReject(true)}
                          style={{ padding: '8px 18px', fontSize: 13, borderRadius: 6, border: '1px solid #ff6b6b55', background: 'rgba(255,107,107,0.08)', color: '#ff8888', cursor: 'pointer' }}
                        >
                          반려
                        </button>
                      )
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function StoreOverviewTab() {
  const [billingSummary, setBillingSummary] = useState<BillingSummaryDTO | null>(null);
  const [billingTrend, setBillingTrend] = useState<BillingTrendItem[]>([]);
  const [couponExpiring, setCouponExpiring] = useState<CouponExpiringDTO[]>([]);
  const [statusSummary, setStatusSummary] = useState<StoreStatusSummary | null>(null);
  const [signupStats, setSignupStats] = useState<SignupStatsDTO | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      getBillingSummary(6).catch(() => null),
      getBillingTrend(new Date().toISOString().slice(0, 10)).catch(() => []),
      getCouponExpiring(30).catch(() => []),
      getStoreStatusSummary().catch(() => null),
      getSignupStats(6).catch(() => null),
    ]).then(([billing, trend, expiring, status, signup]) => {
      setBillingSummary(billing);
      setBillingTrend(Array.isArray(trend) ? trend : []);
      setCouponExpiring(Array.isArray(expiring) ? expiring : []);
      setStatusSummary(status);
      setSignupStats(signup);
    }).finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cardStyle: React.CSSProperties = { flex: 1, minWidth: 160, background: '#16162a', borderRadius: 10, padding: '16px 20px', border: '1px solid #2a2a4a' };
  const labelStyle: React.CSSProperties = { fontSize: 11, color: '#888', marginBottom: 4 };
  const valueStyle: React.CSSProperties = { fontSize: 22, fontWeight: 700, color: '#e0e0e0' };
  const diffStyle = (v: number): React.CSSProperties => ({ fontSize: 11, marginTop: 4, color: v > 0 ? '#00b894' : v < 0 ? '#e17055' : '#888' });
  const sectionTitle: React.CSSProperties = { fontSize: 14, fontWeight: 600, color: '#e0e0e0', marginBottom: 12 };
  const chartBox: React.CSSProperties = { background: '#16162a', borderRadius: 10, padding: 20, border: '1px solid #2a2a4a', marginBottom: 20 };

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#888' }}>로딩 중...</div>;

  const bs = billingSummary;
  const billedDiff = bs && bs.prevMonthBilled > 0 ? Math.round(((bs.currentMonthBilled - bs.prevMonthBilled) / bs.prevMonthBilled) * 100) : 0;
  const subDiff = bs && bs.prevMonthSubscribe > 0 ? Math.round(((bs.currentMonthSubscribe - bs.prevMonthSubscribe) / bs.prevMonthSubscribe) * 100) : 0;
  const notiDiff = bs && bs.prevMonthNotification > 0 ? Math.round(((bs.currentMonthNotification - bs.prevMonthNotification) / bs.prevMonthNotification) * 100) : 0;

  const monthlyTrend = (bs?.monthlyTrend || []).map(m => ({
    month: m.month.slice(5) + '월',
    subscribe: m.subscribe,
    notification: m.notification,
    total: m.total,
  }));

  const statusData = statusSummary ? [
    { name: '결제중', value: statusSummary.billingCount, color: '#00b894' },
    { name: '쿠폰', value: statusSummary.couponCount, color: '#4dabf7' },
    { name: '만료임박', value: statusSummary.expiringCount, color: '#fdcb6e' },
    { name: '없음', value: statusSummary.noneCount, color: '#636e72' },
  ].filter(d => d.value > 0) : [];

  return (
    <div style={{ padding: '0 8px' }}>
      {/* 요약 카드 */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
        <div style={cardStyle}>
          <div style={labelStyle}>이번달 결제금액</div>
          <div style={valueStyle}>{bs ? `₩${bs.currentMonthBilled.toLocaleString()}` : '-'}</div>
          <div style={diffStyle(billedDiff)}>{billedDiff > 0 ? '▲' : billedDiff < 0 ? '▼' : '-'} {Math.abs(billedDiff)}% vs 전월</div>
        </div>
        <div style={cardStyle}>
          <div style={labelStyle}>예정 결제금액</div>
          <div style={valueStyle}>{bs ? `₩${bs.currentMonthPending.toLocaleString()}` : '-'}</div>
          <div style={{ fontSize: 11, marginTop: 4, color: '#888' }}>미결제 건 합계</div>
        </div>
        <div style={cardStyle}>
          <div style={labelStyle}>활성 업체</div>
          <div style={valueStyle}>{bs ? `${bs.activeStoreCount}` : '-'}<span style={{ fontSize: 13, fontWeight: 400, color: '#888' }}> / {bs?.totalStoreCount || '-'}</span></div>
          <div style={{ fontSize: 11, marginTop: 4, color: '#888' }}>결제 + 쿠폰 업체</div>
        </div>
        <div style={cardStyle}>
          <div style={labelStyle}>쿠폰 만료 예정</div>
          <div style={valueStyle}>{couponExpiring.length}<span style={{ fontSize: 13, fontWeight: 400, color: '#888' }}>개 업체</span></div>
          <div style={{ fontSize: 11, marginTop: 4, color: '#888' }}>30일 이내</div>
        </div>
        <div style={cardStyle}>
          <div style={labelStyle}>이번달 신규 가입</div>
          <div style={valueStyle}>{signupStats ? signupStats.currentMonth.signupCount : '-'}<span style={{ fontSize: 13, fontWeight: 400, color: '#888' }}>개 업체</span></div>
          <div style={diffStyle(signupStats && signupStats.prevMonth.signupCount > 0 ? Math.round(((signupStats.currentMonth.signupCount - signupStats.prevMonth.signupCount) / signupStats.prevMonth.signupCount) * 100) : 0)}>
            {(() => { const d = signupStats && signupStats.prevMonth.signupCount > 0 ? Math.round(((signupStats.currentMonth.signupCount - signupStats.prevMonth.signupCount) / signupStats.prevMonth.signupCount) * 100) : 0; return `${d > 0 ? '▲' : d < 0 ? '▼' : '-'} ${Math.abs(d)}% vs 전월`; })()}
          </div>
          <div style={{ fontSize: 11, marginTop: 4, color: '#888' }}>전환율 <strong style={{ color: '#6c5ce7' }}>{signupStats ? `${signupStats.currentMonth.conversionRate}%` : '-'}</strong></div>
        </div>
      </div>

      {/* 가입 현황 */}
      <>
        {/* 가입 퍼널 */}
        <div style={chartBox}>
          <div style={sectionTitle}>가입 퍼널 (전체 누적)</div>
          {(() => {
            const funnel = signupStats?.funnelTotal || { signup: 0, cardRegistered: 0, couponUsed: 0, paidConverted: 0 };
            const steps = [
              { label: '가입', value: funnel.signup, color: '#4dabf7' },
              { label: '카드 등록', value: funnel.cardRegistered, color: '#6c5ce7' },
              { label: '쿠폰 사용', value: funnel.couponUsed, color: '#a29bfe' },
              { label: '유료 전환', value: funnel.paidConverted, color: '#00b894' },
            ];
            const max = funnel.signup || 1;
            return (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {steps.map((s, i) => (
                  <div key={s.label} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <span style={{ fontSize: 12, color: '#888', width: 70, textAlign: 'right', flexShrink: 0 }}>{s.label}</span>
                    <div style={{ flex: 1, height: 28, background: '#0f0f1a', borderRadius: 6, overflow: 'hidden', position: 'relative' }}>
                      <div style={{ width: `${(s.value / max) * 100}%`, height: '100%', background: s.color, borderRadius: 6, transition: 'width 0.5s', minWidth: s.value > 0 ? 40 : 0, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', paddingRight: 8 }}>
                        <span style={{ fontSize: 11, color: '#fff', fontWeight: 600 }}>{s.value.toLocaleString()}</span>
                      </div>
                    </div>
                    <span style={{ fontSize: 11, color: '#888', width: 45, flexShrink: 0 }}>{i === 0 ? '100%' : `${max > 0 ? Math.round((s.value / max) * 100) : 0}%`}</span>
                  </div>
                ))}
              </div>
            );
          })()}
        </div>

        {/* 월별 가입 + 전환 추이 */}
        {(signupStats?.monthlySignups?.length || 0) > 0 && (
        <div style={chartBox}>
          <div style={sectionTitle}>월별 가입 / 전환 추이</div>
          <ResponsiveContainer width="100%" height={260}>
            <ComposedChart data={(signupStats?.monthlySignups || []).map(m => ({ ...m, month: m.month.slice(5) + '월' }))}>
              <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
              <XAxis dataKey="month" tick={{ fill: '#888', fontSize: 11 }} />
              <YAxis yAxisId="left" tick={{ fill: '#888', fontSize: 11 }} />
              <YAxis yAxisId="right" orientation="right" tick={{ fill: '#888', fontSize: 11 }} unit="%" domain={[0, 100]} />
              <Tooltip contentStyle={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 8, fontSize: 12 }} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
              <Bar yAxisId="left" dataKey="signupCount" name="가입" fill="#4dabf7" radius={[4, 4, 0, 0]} />
              <Bar yAxisId="left" dataKey="cardRegistered" name="카드등록" fill="#6c5ce7" radius={[4, 4, 0, 0]} />
              <Bar yAxisId="left" dataKey="paidConverted" name="유료전환" fill="#00b894" radius={[4, 4, 0, 0]} />
              <Line yAxisId="right" type="monotone" dataKey="conversionRate" name="전환율(%)" stroke="#fdcb6e" strokeWidth={2} dot={{ r: 3 }} />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
        )}
      </>

      {/* 월간 추이 라인 차트 */}
      {monthlyTrend.length > 0 && (
        <div style={chartBox}>
          <div style={sectionTitle}>월별 매출 추이</div>
          <ResponsiveContainer width="100%" height={260}>
            <LineChart data={monthlyTrend}>
              <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
              <XAxis dataKey="month" tick={{ fill: '#888', fontSize: 11 }} />
              <YAxis tick={{ fill: '#888', fontSize: 11 }} tickFormatter={(v: number) => `₩${(v / 10000).toFixed(0)}만`} />
              <Tooltip contentStyle={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 8, fontSize: 12 }} formatter={(value: any) => [`₩${Number(value).toLocaleString()}`, '']} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
              <Line type="monotone" dataKey="subscribe" name="구독" stroke="#6c5ce7" strokeWidth={2} dot={{ r: 3 }} />
              <Line type="monotone" dataKey="notification" name="문자" stroke="#00b894" strokeWidth={2} dot={{ r: 3 }} />
              <Line type="monotone" dataKey="total" name="합계" stroke="#4dabf7" strokeWidth={2} dot={{ r: 3 }} strokeDasharray="5 5" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}

      {/* 하단 2컬럼: 구독 월별 + 문자 월별 */}
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 20 }}>
        <div style={{ ...chartBox, flex: 1, minWidth: 320, marginBottom: 0 }}>
          <div style={sectionTitle}>구독 결제 추이 (월별)</div>
          <div style={{ display: 'flex', gap: 16, marginBottom: 12, fontSize: 12 }}>
            <span style={{ color: '#888' }}>이번달 <strong style={{ color: '#6c5ce7' }}>₩{bs?.currentMonthSubscribe.toLocaleString()}</strong></span>
            <span style={diffStyle(subDiff)}>{subDiff > 0 ? '▲' : '▼'} {Math.abs(subDiff)}% vs 전월</span>
          </div>
          <ResponsiveContainer width="100%" height={220}>
            <LineChart data={billingTrend.map(d => ({ ...d, date: d.date.slice(5) }))}>
              <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
              <XAxis dataKey="date" tick={{ fill: '#888', fontSize: 11 }} />
              <YAxis tick={{ fill: '#888', fontSize: 11 }} tickFormatter={(v: number) => v >= 10000 ? `${(v / 10000).toFixed(0)}만` : `${v}`} />
              <Tooltip contentStyle={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 8, fontSize: 12 }} formatter={(value: any) => [`₩${Number(value).toLocaleString()}`, '']} />
              <Line type="monotone" dataKey="subscribe" name="구독" stroke="#6c5ce7" strokeWidth={2} dot={{ r: 3 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>

        <div style={{ ...chartBox, flex: 1, minWidth: 320, marginBottom: 0 }}>
          <div style={sectionTitle}>문자 결제 추이 (월별)</div>
          <div style={{ display: 'flex', gap: 16, marginBottom: 12, fontSize: 12 }}>
            <span style={{ color: '#888' }}>이번달 <strong style={{ color: '#00b894' }}>₩{bs?.currentMonthNotification.toLocaleString()}</strong></span>
            <span style={diffStyle(notiDiff)}>{notiDiff > 0 ? '▲' : '▼'} {Math.abs(notiDiff)}% vs 전월</span>
          </div>
          <ResponsiveContainer width="100%" height={220}>
            <LineChart data={billingTrend.map(d => ({ ...d, date: d.date.slice(5) }))}>
              <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
              <XAxis dataKey="date" tick={{ fill: '#888', fontSize: 11 }} />
              <YAxis tick={{ fill: '#888', fontSize: 11 }} tickFormatter={(v: number) => v >= 10000 ? `${(v / 10000).toFixed(0)}만` : `${v}`} />
              <Tooltip contentStyle={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 8, fontSize: 12 }} formatter={(value: any) => [`₩${Number(value).toLocaleString()}`, '']} />
              <Line type="monotone" dataKey="notification" name="문자" stroke="#00b894" strokeWidth={2} dot={{ r: 3 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* 하단 2컬럼: 업체 상태 분포 + 쿠폰 만료 예정 */}
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 20 }}>
        {/* 업체 상태 분포 도넛 */}
        {statusData.length > 0 && (
          <div style={{ ...chartBox, flex: 1, minWidth: 300, marginBottom: 0 }}>
            <div style={sectionTitle}>업체 상태 분포</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 32, flexWrap: 'wrap' }}>
              <ResponsiveContainer width={220} height={220}>
                <PieChart>
                  <Pie data={statusData} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={55} outerRadius={85} paddingAngle={3} stroke="none">
                    {statusData.map((d, idx) => <Cell key={idx} fill={d.color} />)}
                  </Pie>
                  <Tooltip contentStyle={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 8, fontSize: 12 }} formatter={(value: any, name: any) => [`${Number(value).toLocaleString()}개`, name]} />
                </PieChart>
              </ResponsiveContainer>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {statusData.map(d => (
                  <div key={d.name} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ width: 12, height: 12, borderRadius: 3, background: d.color, flexShrink: 0 }} />
                    <span style={{ fontSize: 13, color: '#e0e0e0', minWidth: 60 }}>{d.name}</span>
                    <span style={{ fontSize: 13, color: '#888' }}>{d.value.toLocaleString()}개</span>
                    <span style={{ fontSize: 12, color: d.color, fontWeight: 600 }}>{statusSummary ? Math.round((d.value / statusSummary.total) * 100) : 0}%</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* 쿠폰 만료 예정 리스트 */}
        <div style={{ ...chartBox, flex: 1, minWidth: 320, marginBottom: 0 }}>
          <div style={sectionTitle}>쿠폰 만료 예정 업체 (30일 이내)</div>
          {couponExpiring.length === 0 ? (
            <div style={{ padding: 24, textAlign: 'center', color: '#666', fontSize: 13 }}>만료 예정 업체가 없습니다.</div>
          ) : (
            <table style={{ tableLayout: 'auto', width: '100%' }}>
              <thead><tr>
                <th style={{ whiteSpace: 'nowrap' }}>업체명</th>
                <th style={{ whiteSpace: 'nowrap' }}>쿠폰명</th>
                <th style={{ whiteSpace: 'nowrap', width: 80 }}>종료일</th>
                <th style={{ whiteSpace: 'nowrap', width: 55 }}>남은일</th>
                <th style={{ whiteSpace: 'nowrap', width: 50 }}>결제</th>
              </tr></thead>
              <tbody>
                {couponExpiring.slice(0, 10).map(c => (
                  <tr key={`${c.storeId}-${c.endDate}`}>
                    <td>{c.storeName}</td>
                    <td>{c.couponName}</td>
                    <td>{c.endDate?.slice(0, 10)}</td>
                    <td><span style={{ color: c.daysLeft <= 7 ? '#e17055' : '#fdcb6e', fontWeight: 600 }}>{c.daysLeft}일</span></td>
                    <td><span className={`status-badge ${c.hasBilling ? 'completed' : 'failed'}`}>{c.hasBilling ? '있음' : '없음'}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

    </div>
  );
}

function EventPage() {
  const [list, setList] = useState<EventOrganizer[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [busyId, setBusyId] = useState<number | null>(null);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({ loginId: '', password: '', name: '', description: '', logo: '' });
  const [creating, setCreating] = useState(false);
  const [detailTarget, setDetailTarget] = useState<EventOrganizer | null>(null);
  const [detailData, setDetailData] = useState<EventDetail | null>(null);
  const [detailLoading, setDetailLoading] = useState(false);
  // 편집 폼 상태
  const [editBasic, setEditBasic] = useState<TournamentSavePayload | null>(null);
  const [editDates, setEditDates] = useState<TournamentDatePayload | null>(null);
  const [savingBasic, setSavingBasic] = useState(false);
  const [savingDates, setSavingDates] = useState(false);
  // 승인 검수
  const [inspectTarget, setInspectTarget] = useState<EventOrganizer | null>(null);
  const [inspection, setInspection] = useState<EventInspection | null>(null);
  const [inspecting, setInspecting] = useState(false);
  const [urlKeyInput, setUrlKeyInput] = useState('');
  const [approving, setApproving] = useState(false);
  const [inspectDetail, setInspectDetail] = useState<EventDetail | null>(null);  // 승인 보정 프리뷰용 상세
  // 표출 종목 텍스트 함축/원본 선택 (기본=원본 유지, 운영자가 명시적으로 함축 선택)
  const [etChoice, setEtChoice] = useState<'original' | 'condensed'>('original');
  const [etKo, setEtKo] = useState('');
  const [etEn, setEtEn] = useState('');

  const load = useCallback(() => {
    setLoading(true);
    getEventList()
      .then((rows) => { setList(rows || []); setError(null); })
      .catch((e) => setError(e.message || '목록 조회 실패'))
      .finally(() => setLoading(false));
  }, []);
  // 로딩 표시 없이 조용히 갱신 — 표가 안 사라져 스크롤 위치 유지 (순서변경/토글용)
  const reloadSilent = useCallback(() =>
    getEventList().then((rows) => setList(rows || [])).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  // 상세 로드/변경 시 표출 종목 텍스트를 원본으로 시드 (기본=원본)
  useEffect(() => {
    setEtChoice('original');
    setEtKo(inspectDetail?.eventText || '');
    setEtEn(inspectDetail?.eventTextEn || '');
  }, [inspectDetail]);
  // 원본/함축 라디오 전환 — 선택값으로 편집 입력 채움 (이후 직접 수정 가능)
  const applyEtChoice = (c: 'original' | 'condensed') => {
    setEtChoice(c);
    if (c === 'condensed') {
      setEtKo(inspection?.suggested_event_text || '');
      setEtEn(inspection?.suggested_event_text_en || inspection?.suggested_event_text || '');
    } else {
      setEtKo(inspectDetail?.eventText || '');
      setEtEn(inspectDetail?.eventTextEn || '');
    }
  };

  // 자세히 모달 열릴 때 단일 대회 상세(편집용 전체 필드 + 통계) 조회 → 편집 폼 시드
  const seedEditForms = useCallback((d: EventDetail) => {
    setEditBasic({
      organizerId: d.organizerId,
      title: d.title || '', mainPicture: d.mainPicture || '', bannerPicture: d.bannerPicture || '',
      souvenirPicture: d.souvenirPicture || '', content: d.content || '', period: d.period || '',
      place: d.place || '', subjectivity: d.subjectivity || '', sponsor: d.sponsor || '',
      support: d.support || '', columnText: d.columnText || '', eventText: d.eventText || '', eventTextEn: d.eventTextEn || '',
    });
    setEditDates({
      organizerId: d.organizerId,
      startDate: toLocalInput(d.startDate), endDate: toLocalInput(d.endDate),
      applicationStartDate: toLocalInput(d.applicationStartDate), applicationEndDate: toLocalInput(d.applicationEndDate),
      availableModifyDate: toLocalInput(d.availableModifyDate), availableDeleteDate: toLocalInput(d.availableDeleteDate),
      myEventOpenDate: toLocalInput(d.myEventOpenDate),
    });
  }, []);
  useEffect(() => {
    if (!detailTarget) { setDetailData(null); setEditBasic(null); setEditDates(null); return; }
    let alive = true;
    setDetailLoading(true);
    getTournamentDetail(detailTarget.organizerId)
      .then((d) => { if (alive) { setDetailData(d); seedEditForms(d); } })
      .catch(() => { if (alive) setDetailData(null); })
      .finally(() => { if (alive) setDetailLoading(false); });
    return () => { alive = false; };
  }, [detailTarget, seedEditForms]);

  const fmtWon = (n: number) => (n || 0).toLocaleString('ko-KR');
  // "2026-07-27T00:00:00" → "2026-07-27T00:00" (datetime-local), null → ''
  function toLocalInput(d: string | null | undefined): string { return d ? d.slice(0, 16) : ''; }

  // 파일 → base64 dataURL (이미지 교체용)
  const fileToDataUrl = (file: File): Promise<string> => new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result as string);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
  const onPickImage = async (key: 'mainPicture' | 'bannerPicture' | 'souvenirPicture', file: File | undefined) => {
    if (!file || !editBasic) return;
    try { const url = await fileToDataUrl(file); setEditBasic({ ...editBasic, [key]: url }); }
    catch { alert('이미지 읽기 실패'); }
  };

  const saveBasic = async () => {
    if (!editBasic || !detailTarget) return;
    setSavingBasic(true);
    try {
      const updated = await saveTournament(editBasic);
      if (updated) { setDetailData(updated); seedEditForms(updated); }
      reloadSilent();
      alert('기본정보를 저장했습니다.');
    } catch (e: any) { alert(e.message || '기본정보 저장 실패'); }
    finally { setSavingBasic(false); }
  };
  const saveDates = async () => {
    if (!editDates) return;
    const req = [editDates.startDate, editDates.endDate, editDates.applicationStartDate, editDates.applicationEndDate, editDates.availableModifyDate, editDates.availableDeleteDate, editDates.myEventOpenDate];
    if (req.some((v) => !v)) { alert('날짜 7종을 모두 입력하세요.'); return; }
    setSavingDates(true);
    try {
      await saveTournamentDate(editDates);
      const d = await getTournamentDetail(editDates.organizerId);
      setDetailData(d); seedEditForms(d);
      reloadSilent();
      alert('날짜를 저장했습니다.');
    } catch (e: any) { alert(e.message || '날짜 저장 실패 (시작일이 종료일보다 늦을 수 없습니다)'); }
    finally { setSavingDates(false); }
  };

  const toggleDisplay = async (o: EventOrganizer) => {
    const next = !o.isDisplay;
    setBusyId(o.organizerId);
    try {
      await updateTournamentDisplay(o.organizerId, next);
      if (next) await updateTournamentOrder(o.organizerId, 1);   // 표출 ON → 맨 앞으로, 백엔드가 나머지 한 칸씩 밀어 재번호
      await reloadSilent();
    }
    catch (e: any) { alert(e.message || '표출 변경 실패'); }
    finally { setBusyId(null); }
  };
  // 위/아래 이동 — 같은 섹션(표출) 내 인접 항목의 viewOrder 위치로 1회 이동 (백엔드가 나머지 shift·재번호 처리)
  const moveOrder = async (arr: EventOrganizer[], idx: number, dir: 'up' | 'down') => {
    const j = dir === 'up' ? idx - 1 : idx + 1;
    if (j < 0 || j >= arr.length) return;
    const a = arr[idx], b = arr[j];
    setBusyId(a.organizerId);
    try {
      await updateTournamentOrder(a.organizerId, b.viewOrder);
      await reloadSilent();
    } catch (e: any) { alert(e.message || '순서 변경 실패'); }
    finally { setBusyId(null); }
  };
  const submitCreate = async () => {
    if (!form.loginId || !form.password || !form.name) { alert('아이디·비밀번호·이름은 필수입니다.'); return; }
    setCreating(true);
    try {
      await createEventer({ loginId: form.loginId, password: form.password, name: form.name, description: form.description, logo: form.logo });
      setForm({ loginId: '', password: '', name: '', description: '', logo: '' });
      setShowCreate(false);
      load();
    } catch (e: any) { alert(e.message || '계정 생성 실패'); }
    finally { setCreating(false); }
  };

  // 검수 모달 열기 + 최신 검수결과 로드
  const openInspect = async (o: EventOrganizer) => {
    setInspectTarget(o);
    setInspection(null);
    setUrlKeyInput('');
    setInspectDetail(null);
    getTournamentDetail(o.organizerId).then(setInspectDetail).catch(() => { /* 상세 없음 — 보정 프리뷰 생략 */ });
    try {
      const latest = await getLatestInspection(o.organizerId);
      setInspection(latest);
      if (latest?.suggested_url_key) setUrlKeyInput(latest.suggested_url_key);
      if (latest && (latest.status === 'inspecting' || latest.task_status === 'running')) setInspecting(true);
    } catch { /* 이력 없음 */ }
  };
  const startInspect = async () => {
    if (!inspectTarget) return;
    setInspecting(true);
    setInspection(null);
    try { await inspectTournament(inspectTarget.organizerId); }
    catch (e: any) { alert(e.message || '검수 시작 실패'); setInspecting(false); }
  };
  // 검수 진행 중이면 폴링
  useEffect(() => {
    if (!inspecting || !inspectTarget) return;
    const id = setInterval(async () => {
      try {
        const latest = await getLatestInspection(inspectTarget.organizerId);
        if (latest) {
          setInspection(latest);
          if (latest.status === 'inspected' || latest.status === 'approved' || latest.status === 'failed' || latest.task_status === 'failed') {
            setInspecting(false);
            if (latest.suggested_url_key && !urlKeyInput) setUrlKeyInput(latest.suggested_url_key);
          }
        }
      } catch { /* ignore */ }
    }, 4000);
    return () => clearInterval(id);
  }, [inspecting, inspectTarget, urlKeyInput]);

  const confirmApprove = async () => {
    if (!inspectTarget) return;
    if (!urlKeyInput.trim()) { alert('url_key를 입력하세요.'); return; }
    setApproving(true);
    try {
      // 표출 종목 텍스트가 원본과 달라졌으면(함축 선택/직접수정) 승인 전 '메인 표출 종목명' 저장
      if (inspectDetail && (etKo !== (inspectDetail.eventText || '') || etEn !== (inspectDetail.eventTextEn || ''))) {
        await saveTournament({
          organizerId: inspectDetail.organizerId,
          title: inspectDetail.title || '', mainPicture: inspectDetail.mainPicture || '', bannerPicture: inspectDetail.bannerPicture || '',
          souvenirPicture: inspectDetail.souvenirPicture || '', content: inspectDetail.content || '', period: inspectDetail.period || '',
          place: inspectDetail.place || '', subjectivity: inspectDetail.subjectivity || '', sponsor: inspectDetail.sponsor || '',
          support: inspectDetail.support || '', columnText: inspectDetail.columnText || '', eventText: etKo, eventTextEn: etEn,
        });
      }
      await approveTournament(inspectTarget.organizerId, urlKeyInput.trim(), inspection?.id);
      setInspectTarget(null);
      load();
    } catch (e: any) { alert(e.message || '승인 실패 (url_key 중복/형식 확인)'); }
    finally { setApproving(false); }
  };

  const inputStyle: React.CSSProperties = { width: '100%', padding: '6px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13, boxSizing: 'border-box' };
  const tag = (on: boolean, label: string) => (
    <span style={{ fontSize: 12, fontWeight: 600, color: on ? '#00ff88' : '#666' }}>{on ? `● ${label}` : `○ ${label}`}</span>
  );

  // 승인 확정 시 백엔드가 자동 보정하는 빈 항목 프리뷰 (eventProfile←메인사진, eventText←종목명, 있으면 유지)
  const inspTickets = Array.from(new Set((inspectDetail?.tickets || []).map((t) => (t.name || '').trim()).filter(Boolean)));
  const inspTicketText = inspTickets.join(', ');
  const inspCi = inspectDetail?.completeInfo;
  const fixProfile = !!inspectDetail && !inspCi?.eventProfile;
  const fixEventText = !!inspectDetail && (!inspCi?.eventText || !inspectDetail.eventText);
  const hasAutoFix = fixProfile || fixEventText;
  // USD(priceUsd) 미설정 가격옵션 — 유료(KRW>0)인데 USD=0인 것만 경고 (무료옵션은 정상). 승인 시 백엔드가 당시 환율로 자동 기입
  const usdMissing = (inspectDetail?.tickets || []).flatMap((t) =>
    (t.priceOptions || [])
      .filter((p) => (p.price || 0) > 0 && !p.priceUsd)
      .map((p) => ({ ticket: t.name || '(종목)', option: p.name || '기본', price: p.price }))
  );
  // 기념품 사진(tournament_organizer_info)과 기념품 설정(souvenir_info)은 서로 참조가 없어 따로 논다
  // → 사진만 올리고 공통기념품을 안 만들면 신청 화면에 기념품 선택 항목이 아예 안 뜬다
  const souvenirPic = (inspectDetail?.souvenirPicture || '').trim();
  const hasSouvenirPic = !!souvenirPic && souvenirPic !== 'None';
  const souvenirLoaded = Array.isArray(inspectDetail?.souvenirs);   // 구버전 백엔드는 필드 자체가 없음 → 오탐 방지
  const commonSouvenirs = (inspectDetail?.souvenirs || []).filter((s) => s.division === 'Common');
  const additionalCount = (inspectDetail?.souvenirs || []).length - commonSouvenirs.length;
  const souvenirMissing = !!inspectDetail && souvenirLoaded && hasSouvenirPic && commonSouvenirs.length === 0;
  // 사이즈 축 — isUseOption=false 면 sizes, true 면 options(옵션명이 사이즈이거나 옵션 하위 sizes)
  const souvenirAxis = (s: EventSouvenir): string[] =>
    s.isUseOption
      ? (s.options || []).map((o) => (o.sizes && o.sizes.length ? `${o.name} (${o.sizes.join(' / ')})` : o.name || '')).filter(Boolean)
      : (s.sizes || []);

  return (
    <div className="admin-page">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
        <h2 style={{ fontSize: 16, color: '#e0e0e0', margin: 0 }}>이벤트 관리 <span style={{ fontSize: 13, color: '#888', fontWeight: 400 }}>{list.length}건</span></h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={load} style={{ height: 34, padding: '0 14px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 6, color: '#aaa', fontSize: 13, cursor: 'pointer' }}>새로고침</button>
          <button onClick={() => setShowCreate((v) => !v)} style={{ height: 34, padding: '0 16px', background: '#00cc6a', border: 'none', borderRadius: 6, color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>{showCreate ? '취소' : '+ 이벤터 계정 생성'}</button>
        </div>
      </div>

      {showCreate && (
        <div style={{ padding: 16, background: '#0a0a18', border: '1px solid #2a2a4a', borderRadius: 8, marginBottom: 16 }}>
          <div style={{ fontSize: 13, color: '#e0e0e0', fontWeight: 600, marginBottom: 12 }}>새 이벤터 계정</div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
            <div style={{ flex: 1, minWidth: 160 }}>
              <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>로그인 아이디 *</div>
              <input value={form.loginId} onChange={(e) => setForm({ ...form, loginId: e.target.value })} style={inputStyle} />
            </div>
            <div style={{ flex: 1, minWidth: 160 }}>
              <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>비밀번호 *</div>
              <input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} style={inputStyle} />
            </div>
            <div style={{ flex: 1, minWidth: 160 }}>
              <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>주최자명 *</div>
              <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} style={inputStyle} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 12 }}>
            <div style={{ flex: 2, minWidth: 220 }}>
              <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>설명</div>
              <input value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} style={inputStyle} />
            </div>
            <div style={{ flex: 1, minWidth: 160 }}>
              <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>로고 URL</div>
              <input value={form.logo} onChange={(e) => setForm({ ...form, logo: e.target.value })} style={inputStyle} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button onClick={() => setShowCreate(false)} style={{ height: 32, padding: '0 14px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 6, color: '#888', fontSize: 13, cursor: 'pointer' }}>취소</button>
            <button disabled={creating} onClick={submitCreate} style={{ height: 32, padding: '0 18px', background: '#00cc6a', border: 'none', borderRadius: 6, color: '#fff', fontSize: 13, fontWeight: 600, cursor: creating ? 'not-allowed' : 'pointer' }}>{creating ? '생성중...' : '생성'}</button>
          </div>
        </div>
      )}

      {error && <div style={{ padding: 12, background: '#2a0a0a', border: '1px solid #5a2a2a', borderRadius: 6, color: '#ff8888', fontSize: 13, marginBottom: 12 }}>{error}</div>}

      {loading ? (
        <div style={{ padding: 30, textAlign: 'center', color: '#888', fontSize: 13 }}>불러오는 중...</div>
      ) : list.length === 0 ? (
        <div style={{ padding: 30, textAlign: 'center', color: '#888', fontSize: 13 }}>등록된 이벤트가 없습니다.</div>
      ) : (() => {
        // 표출/비표출 분리 — list 는 백엔드에서 view_order asc 정렬됨(표출 상대순서 = Dev 동일)
        const shown = list.filter((o) => o.isDisplay);
        const hidden = list.filter((o) => !o.isDisplay);
        const renderRow = (o: EventOrganizer, idx: number, arr: EventOrganizer[], withMove: boolean) => (
          <tr key={o.organizerId} style={{ borderBottom: '1px solid #1a1a2e', opacity: busyId === o.organizerId ? 0.5 : 1 }}>
            <td onClick={() => setDetailTarget(o)} title="자세히 보기" style={{ padding: '8px 10px', color: '#e0e0e0', cursor: 'pointer' }}>{o.title}{o.isSeminar ? <span style={{ marginLeft: 6, fontSize: 11, color: '#88aaff' }}>세미나</span> : null}</td>
            <td style={{ padding: '8px 10px', textAlign: 'center', whiteSpace: 'nowrap' }}>
              <span style={{ marginRight: 10 }}>{tag(o.isSubmit, '승인')}</span>
              <span>{tag(o.isDisplay, '표출')}</span>
            </td>
            <td style={{ padding: '8px 10px', textAlign: 'center', whiteSpace: 'nowrap' }}>
              {withMove ? (() => {
                const canUp = idx > 0;
                const canDown = idx < arr.length - 1;
                return (<>
                  <span style={{ display: 'inline-block', minWidth: 22, color: '#ccc', fontSize: 13, marginRight: 8 }}>{idx + 1}</span>
                  <button disabled={busyId !== null || !canUp} onClick={() => moveOrder(arr, idx, 'up')} title="위로" style={{ width: 26, height: 26, background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 6, color: !canUp ? '#444' : '#aaa', fontSize: 12, cursor: !canUp ? 'default' : 'pointer' }}>▲</button>
                  <button disabled={busyId !== null || !canDown} onClick={() => moveOrder(arr, idx, 'down')} title="아래로" style={{ width: 26, height: 26, marginLeft: 6, background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 6, color: !canDown ? '#444' : '#aaa', fontSize: 12, cursor: !canDown ? 'default' : 'pointer' }}>▼</button>
                </>);
              })() : <span style={{ color: '#555', fontSize: 12 }}>—</span>}
            </td>
          </tr>
        );
        const thead = (
          <thead>
            <tr style={{ color: '#888', textAlign: 'left', borderBottom: '1px solid #2a2a4a' }}>
              <th style={{ padding: '8px 10px' }}>대회명</th>
              <th style={{ padding: '8px 10px', textAlign: 'center', width: 150 }}>상태</th>
              <th style={{ padding: '8px 10px', textAlign: 'center', width: 90 }}>순서</th>
            </tr>
          </thead>
        );
        return (
          <>
            {/* 표출 중 — view_order asc (앱 노출 순서, Dev 와 동일). ▲▼ 로 순서변경 */}
            <div style={{ fontSize: 13, color: '#00ff88', fontWeight: 700, margin: '4px 0 8px' }}>표출 중 <span style={{ color: '#888', fontWeight: 400 }}>{shown.length}건 · 앱 노출 순서</span></div>
            {shown.length === 0 ? (
              <div style={{ padding: 14, textAlign: 'center', color: '#666', fontSize: 13 }}>표출 중인 이벤트가 없습니다.</div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, marginBottom: 22 }}>
                {thead}
                <tbody>{shown.map((o, idx) => renderRow(o, idx, shown, true))}</tbody>
              </table>
            )}

            {/* 비표출 — 앱 미노출. 순서 무의미해 ▲▼ 없음 */}
            <div style={{ fontSize: 13, color: '#888', fontWeight: 700, margin: '4px 0 8px' }}>비표출 <span style={{ fontWeight: 400 }}>{hidden.length}건 · 앱에 안 보임</span></div>
            {hidden.length === 0 ? (
              <div style={{ padding: 14, textAlign: 'center', color: '#666', fontSize: 13 }}>비표출 이벤트가 없습니다.</div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, opacity: 0.78 }}>
                {thead}
                <tbody>{hidden.map((o, idx) => renderRow(o, idx, hidden, false))}</tbody>
              </table>
            )}
          </>
        );
      })()}

      {detailTarget && (() => {
        const o = detailTarget;
        // 표출/승인 상태는 항상 최신 목록에서 — 토글 직후 reloadSilent 결과가 모달에도 즉시 반영됨
        const live = list.find((x) => x.organizerId === o.organizerId) || o;
        const labelStyle: React.CSSProperties = { fontSize: 11, color: '#888', marginBottom: 4 };
        const taStyle: React.CSSProperties = { ...inputStyle, minHeight: 64, resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.5 };
        const sectionTitle: React.CSSProperties = { fontSize: 13, color: '#e0e0e0', fontWeight: 700, margin: '20px 0 10px', borderBottom: '1px solid #2a2a4a', paddingBottom: 6 };
        const field = (label: string, node: React.ReactNode) => (
          <div style={{ marginBottom: 10 }}><div style={labelStyle}>{label}</div>{node}</div>
        );
        const bInput = (label: string, key: keyof TournamentSavePayload) => field(label,
          <input value={(editBasic?.[key] as string) ?? ''} onChange={(e) => editBasic && setEditBasic({ ...editBasic, [key]: e.target.value })} style={inputStyle} />
        );
        const bArea = (label: string, key: keyof TournamentSavePayload) => field(label,
          <textarea value={(editBasic?.[key] as string) ?? ''} onChange={(e) => editBasic && setEditBasic({ ...editBasic, [key]: e.target.value })} style={taStyle} />
        );
        const dInput = (label: string, key: keyof TournamentDatePayload) => field(label,
          <input type="datetime-local" value={(editDates?.[key] as string) ?? ''} onChange={(e) => editDates && setEditDates({ ...editDates, [key]: e.target.value })} style={inputStyle} />
        );
        const imgField = (label: string, key: 'mainPicture' | 'bannerPicture' | 'souvenirPicture') => {
          const v = editBasic?.[key] || '';
          return field(label, (
            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              {v ? <img src={v} alt={label} style={{ width: 56, height: 56, objectFit: 'cover', borderRadius: 6, border: '1px solid #2a2a4a', flexShrink: 0 }} /> : <div style={{ width: 56, height: 56, borderRadius: 6, border: '1px dashed #2a2a4a', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#555', fontSize: 11 }}>없음</div>}
              <input type="file" accept="image/*" onChange={(e) => onPickImage(key, e.target.files?.[0])} style={{ fontSize: 12, color: '#aaa' }} />
              {v && editBasic && <button onClick={() => setEditBasic({ ...editBasic, [key]: '' })} style={{ height: 26, padding: '0 10px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 6, color: '#888', fontSize: 12, cursor: 'pointer' }}>제거</button>}
            </div>
          ));
        };
        const statBox = (k: string, v: React.ReactNode) => (
          <div style={{ flex: 1, minWidth: 90, background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, padding: '8px 10px' }}>
            <div style={{ fontSize: 11, color: '#888' }}>{k}</div>
            <div style={{ fontSize: 14, color: '#ddd', fontWeight: 600, marginTop: 2 }}>{v}</div>
          </div>
        );
        return (
          <div onClick={() => setDetailTarget(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 1000, overflowY: 'auto', padding: '40px 16px' }}>
            <div onClick={(e) => e.stopPropagation()} style={{ width: 'min(720px, 100%)', background: '#0a0a18', border: '1px solid #2a2a4a', borderRadius: 10, padding: 20 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                <h3 style={{ fontSize: 15, color: '#e0e0e0', margin: 0 }}>{o.title}{o.isSeminar ? <span style={{ marginLeft: 6, fontSize: 11, color: '#88aaff' }}>세미나</span> : null}</h3>
                <button onClick={() => setDetailTarget(null)} style={{ background: 'none', border: 'none', color: '#888', fontSize: 18, cursor: 'pointer' }}>✕</button>
              </div>

              {/* 통계·상태 */}
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 4 }}>
                {statBox('주최자', o.userId)}
                {statBox('이벤트수', detailLoading ? '…' : `${detailData?.eventCount ?? 0}개`)}
                {statBox('참가자수', detailLoading ? '…' : `${detailData?.totalParticipantCount ?? 0}명`)}
                {statBox('매출', detailLoading ? '…' : `${fmtWon(detailData?.totalSalesAmount ?? 0)}원`)}
                {statBox('승인', tag(live.isSubmit, live.isSubmit ? '승인' : '미승인'))}
                {statBox('표출', <button disabled={busyId === live.organizerId} onClick={() => toggleDisplay(live)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>{tag(live.isDisplay, live.isDisplay ? 'ON' : 'OFF')}</button>)}
              </div>

              {(detailLoading || !editBasic || !editDates) ? (
                <div style={{ padding: 30, textAlign: 'center', color: '#888', fontSize: 13 }}>불러오는 중...</div>
              ) : (
                <>
                  {/* 기본정보 편집 */}
                  <div style={sectionTitle}>기본정보</div>
                  {bInput('대회명', 'title')}
                  <div style={{ display: 'flex', gap: 10 }}>
                    <div style={{ flex: 1 }}>{bInput('메인 표출 종목명 (한)', 'eventText')}</div>
                    <div style={{ flex: 1 }}>{bInput('메인 표출 종목명 (영)', 'eventTextEn')}</div>
                  </div>
                  {bArea('소개 (content)', 'content')}
                  {bArea('기간 안내문 (period)', 'period')}
                  <div style={{ display: 'flex', gap: 10 }}>
                    <div style={{ flex: 1 }}>{bInput('장소', 'place')}</div>
                    <div style={{ flex: 1 }}>{bInput('칼럼 텍스트', 'columnText')}</div>
                  </div>
                  <div style={{ display: 'flex', gap: 10 }}>
                    <div style={{ flex: 1 }}>{bInput('주관', 'subjectivity')}</div>
                    <div style={{ flex: 1 }}>{bInput('스폰서', 'sponsor')}</div>
                    <div style={{ flex: 1 }}>{bInput('후원', 'support')}</div>
                  </div>
                  {imgField('메인 사진', 'mainPicture')}
                  {imgField('배너 사진 (저장 시 계정로고·완료화면 동기화)', 'bannerPicture')}
                  {imgField('기념품 사진', 'souvenirPicture')}
                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 4 }}>
                    <button disabled={savingBasic} onClick={saveBasic} style={{ height: 34, padding: '0 18px', background: '#00cc6a', border: 'none', borderRadius: 6, color: '#fff', fontSize: 13, fontWeight: 600, cursor: savingBasic ? 'not-allowed' : 'pointer' }}>{savingBasic ? '저장 중...' : '기본정보 저장'}</button>
                  </div>

                  {/* 날짜 편집 */}
                  <div style={sectionTitle}>날짜 <span style={{ fontSize: 11, color: '#888', fontWeight: 400 }}>(7종 모두 필수 · 시작 ≤ 종료)</span></div>
                  <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                    <div style={{ flex: 1, minWidth: 200 }}>{dInput('대회 시작일', 'startDate')}</div>
                    <div style={{ flex: 1, minWidth: 200 }}>{dInput('대회 종료일', 'endDate')}</div>
                  </div>
                  <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                    <div style={{ flex: 1, minWidth: 200 }}>{dInput('신청 시작일', 'applicationStartDate')}</div>
                    <div style={{ flex: 1, minWidth: 200 }}>{dInput('신청 종료일', 'applicationEndDate')}</div>
                  </div>
                  <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                    <div style={{ flex: 1, minWidth: 200 }}>{dInput('신청정보 수정 시작일', 'availableModifyDate')}</div>
                    <div style={{ flex: 1, minWidth: 200 }}>{dInput('신청정보 수정/삭제 종료일', 'availableDeleteDate')}</div>
                  </div>
                  {dInput('나의 이벤트 오픈일', 'myEventOpenDate')}
                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 4 }}>
                    <button disabled={savingDates} onClick={saveDates} style={{ height: 34, padding: '0 18px', background: '#00cc6a', border: 'none', borderRadius: 6, color: '#fff', fontSize: 13, fontWeight: 600, cursor: savingDates ? 'not-allowed' : 'pointer' }}>{savingDates ? '저장 중...' : '날짜 저장'}</button>
                  </div>

                  {/* 종목 (읽기전용) */}
                  <div style={sectionTitle}>종목 <span style={{ fontSize: 11, color: '#888', fontWeight: 400 }}>(읽기전용 — {detailData?.tickets?.length ?? 0}개)</span></div>
                  {(detailData?.tickets ?? []).length === 0 ? (
                    <div style={{ fontSize: 12, color: '#666' }}>등록된 종목이 없습니다.</div>
                  ) : (detailData!.tickets.map((t) => (
                    <div key={t.eventId} style={{ background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, padding: 10, marginBottom: 8, fontSize: 12.5 }}>
                      <div style={{ color: '#ddd', fontWeight: 600 }}>{t.name} {t.isTeamFight ? <span style={{ color: '#88aaff', fontSize: 11 }}>팀전 {t.teamMemberCount}인</span> : <span style={{ color: '#888', fontSize: 11 }}>개인전</span>}</div>
                      <div style={{ color: '#999', marginTop: 4 }}>참가비 {fmtWon(t.participationFee ?? 0)}원
                        {t.priceOptions?.length > 0 && <span> · 가격옵션 {t.priceOptions.map((p) => `${p.name || '기본'} ${fmtWon(p.price)}원`).join(', ')}</span>}
                      </div>
                      {t.entryQualification && <div style={{ color: '#777', marginTop: 2 }}>자격: {t.entryQualification}</div>}
                    </div>
                  )))}

                  {/* 약관 (읽기전용) */}
                  <div style={sectionTitle}>약관 <span style={{ fontSize: 11, color: '#888', fontWeight: 400 }}>(읽기전용 — {detailData?.terms?.length ?? 0}개)</span></div>
                  {(detailData?.terms ?? []).length === 0 ? (
                    <div style={{ fontSize: 12, color: '#666' }}>등록된 약관이 없습니다.</div>
                  ) : (detailData!.terms.map((tm) => (
                    <div key={tm.termsId} style={{ fontSize: 12.5, color: '#bbb', padding: '4px 0', borderBottom: '1px solid #1a1a2e' }}>
                      {tm.isEssential ? <span style={{ color: '#ff6666', marginRight: 4 }}>[필수]</span> : <span style={{ color: '#888', marginRight: 4 }}>[선택]</span>}{tm.termsTitle || '(제목 없음)'}
                    </div>
                  )))}
                </>
              )}

              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 18, borderTop: '1px solid #2a2a4a', paddingTop: 14 }}>
                <button onClick={() => { setDetailTarget(null); openInspect(o); }} style={{ height: 34, padding: '0 18px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 6, color: '#00cc6a', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>승인 검수</button>
              </div>
            </div>
          </div>
        );
      })()}

      {inspectTarget && (
        <div onClick={() => !inspecting && setInspectTarget(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 1000, overflowY: 'auto', padding: '40px 16px' }}>
          <div onClick={(e) => e.stopPropagation()} style={{ width: 'min(820px, 100%)', background: '#0a0a18', border: '1px solid #2a2a4a', borderRadius: 10, padding: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
              <h3 style={{ fontSize: 15, color: '#e0e0e0', margin: 0 }}>승인 검수 — {inspectTarget.title}</h3>
              <button onClick={() => !inspecting && setInspectTarget(null)} style={{ background: 'none', border: 'none', color: '#888', fontSize: 18, cursor: inspecting ? 'not-allowed' : 'pointer' }}>✕</button>
            </div>

            {!inspection && !inspecting && (
              <div style={{ textAlign: 'center', padding: '24px 0' }}>
                <div style={{ color: '#888', fontSize: 13, marginBottom: 16 }}>Claude 에이전트가 사진·날짜·종목명 정합·가격·complete_info 등을 ARENA 2026 기준으로 검수합니다.</div>
                <button onClick={startInspect} style={{ height: 38, padding: '0 22px', background: '#00cc6a', border: 'none', borderRadius: 6, color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>검수 시작</button>
              </div>
            )}

            {inspecting && (
              <div style={{ textAlign: 'center', padding: '28px 0', color: '#88aaff', fontSize: 14 }}>
                🔍 검수 중입니다… <span style={{ color: '#666', fontSize: 12 }}>(에이전트 실행, 수십 초~1분 소요)</span>
              </div>
            )}

            {inspection && (inspection.status === 'inspected' || inspection.status === 'approved') && (
              <div>
                <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 14 }}>
                  <span style={{ fontSize: 14, fontWeight: 700, color: inspection.ready ? '#00ff88' : '#ffaa44' }}>
                    {inspection.ready ? '✓ 오픈 가능 (Critical 통과)' : '⚠ 확인 필요'}
                  </span>
                  {inspection.score != null && <span style={{ color: '#888', fontSize: 13 }}>점수 {inspection.score}/100</span>}
                </div>

                {Array.isArray(inspection.verdict) && inspection.verdict.length > 0 && (
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12.5, marginBottom: 16 }}>
                    <thead>
                      <tr style={{ color: '#888', textAlign: 'left', borderBottom: '1px solid #2a2a4a' }}>
                        <th style={{ padding: '6px 8px' }}>항목</th>
                        <th style={{ padding: '6px 8px', textAlign: 'center', width: 56 }}>판정</th>
                        <th style={{ padding: '6px 8px' }}>현재값</th>
                        <th style={{ padding: '6px 8px' }}>코멘트</th>
                      </tr>
                    </thead>
                    <tbody>
                      {inspection.verdict.map((c, i) => (
                        <tr key={c.key || i} style={{ borderBottom: '1px solid #1a1a2e' }}>
                          <td style={{ padding: '6px 8px', color: '#ccc' }}>{c.label}{c.grade === 'critical' && <span style={{ color: '#ff6666', marginLeft: 4 }}>*</span>}</td>
                          <td style={{ padding: '6px 8px', textAlign: 'center', fontWeight: 700, color: c.pass ? '#00ff88' : (c.grade === 'warning' ? '#ffaa44' : '#ff5555') }}>{c.pass ? 'PASS' : (c.grade === 'warning' ? 'WARN' : 'FAIL')}</td>
                          <td style={{ padding: '6px 8px', color: '#999' }}>{c.current || '-'}</td>
                          <td style={{ padding: '6px 8px', color: '#aaa' }}>{c.comment || ''}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}

                {inspection.report_md && (
                  <details style={{ marginBottom: 16 }}>
                    <summary style={{ cursor: 'pointer', color: '#88aaff', fontSize: 13 }}>검수 리포트 전문</summary>
                    <pre style={{ whiteSpace: 'pre-wrap', fontSize: 12, color: '#bbb', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, padding: 12, marginTop: 8, maxHeight: 280, overflowY: 'auto' }}>{inspection.report_md}</pre>
                  </details>
                )}

                {inspectDetail && inspection.status !== 'approved' && hasAutoFix && (
                  <div style={{ marginBottom: 16, padding: 12, background: '#10241a', border: '1px solid #1f5c3a', borderRadius: 6 }}>
                    <div style={{ fontSize: 12.5, fontWeight: 700, color: '#00ff88', marginBottom: 8 }}>🛠 승인 확정 시 자동 보정 (빈 항목만)</div>
                    {fixProfile && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6, fontSize: 12.5, color: '#ccc' }}>
                        <span>신청완료 이미지 ← 메인 정사각형 사진</span>
                        {inspectDetail.mainPicture && <img src={inspectDetail.mainPicture} alt="main" style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 4, border: '1px solid #2a2a4a' }} />}
                      </div>
                    )}
                    {fixEventText && (
                      <div style={{ fontSize: 12.5, color: '#ccc' }}>
                        표출 종목 텍스트 ← <span style={{ color: '#fff' }}>{inspTicketText || '(종목 없음)'}</span>
                      </div>
                    )}
                    <div style={{ fontSize: 11, color: '#6a9a7a', marginTop: 8 }}>* 이미 값이 있는 항목은 그대로 유지됩니다.</div>
                  </div>
                )}

                {inspectDetail && inspection.status !== 'approved' && usdMissing.length > 0 && (
                  <div style={{ marginBottom: 16, padding: 12, background: '#241a10', border: '1px solid #5c3a1f', borderRadius: 6 }}>
                    <div style={{ fontSize: 12.5, fontWeight: 700, color: '#ffb454', marginBottom: 8 }}>⚠ USD 미설정 가격옵션 {usdMissing.length}건 — 승인 시 당시 환율로 자동 기입</div>
                    {usdMissing.map((u, i) => (
                      <div key={i} style={{ fontSize: 12.5, color: '#ccc', marginBottom: 4 }}>
                        {u.ticket} · {u.option} <span style={{ color: '#888' }}>{fmtWon(u.price)}원</span> → <span style={{ color: '#ff6b6b' }}>USD 0 (미설정)</span>
                      </div>
                    ))}
                    <div style={{ fontSize: 11, color: '#8a6a4a', marginTop: 8 }}>* 승인 확정 시 KRW 금액을 당시 환율로 환산해 자동 기입됩니다. (이미 설정된 값은 유지 · 무료옵션 제외)</div>
                  </div>
                )}

                {inspectDetail && inspection.status !== 'approved' && souvenirMissing && (
                  <div style={{ marginBottom: 16, padding: 12, background: '#2a1418', border: '1px solid #6b2a35', borderRadius: 6 }}>
                    <div style={{ fontSize: 12.5, fontWeight: 700, color: '#ff6b6b', marginBottom: 8 }}>⚠ 기념품 사진만 등록 — 공통기념품 설정 0건</div>
                    <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                      <img src={souvenirPic} alt="souvenir" style={{ width: 56, height: 56, objectFit: 'cover', borderRadius: 4, border: '1px solid #2a2a4a' }} />
                      <div style={{ fontSize: 12.5, color: '#ccc', lineHeight: 1.6 }}>
                        상세 화면에는 기념품 이미지가 뜨지만 <b style={{ color: '#ff9a9a' }}>신청 화면에 기념품 선택 항목이 표출되지 않습니다.</b>
                        {additionalCount > 0 && <span style={{ color: '#888' }}> (추가기념품 {additionalCount}건은 설정됨)</span>}
                        <div style={{ fontSize: 11, color: '#8a6a6a', marginTop: 4 }}>* 주최자가 기념품 관리에서 공통기념품(이름·사이즈)을 등록해야 합니다.</div>
                      </div>
                    </div>
                  </div>
                )}

                {inspectDetail && inspection.status !== 'approved' && hasSouvenirPic && commonSouvenirs.length > 0 && (
                  <div style={{ marginBottom: 16, padding: 12, background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6 }}>
                    <div style={{ fontSize: 12.5, fontWeight: 700, color: '#aaa', marginBottom: 8 }}>🎁 기념품 사진 ↔ 설정 사이즈 대조</div>
                    <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                      <a href={souvenirPic} target="_blank" rel="noreferrer">
                        <img src={souvenirPic} alt="souvenir" style={{ width: 72, height: 72, objectFit: 'cover', borderRadius: 4, border: '1px solid #2a2a4a' }} />
                      </a>
                      <div style={{ fontSize: 12.5, color: '#ccc', lineHeight: 1.6, flex: 1 }}>
                        {commonSouvenirs.map((s) => (
                          <div key={s.souvenirId} style={{ marginBottom: 4 }}>
                            <span style={{ color: '#e0e0e0' }}>{s.name || '(이름없음)'}</span>
                            <span style={{ color: '#888' }}> — {souvenirAxis(s).length > 0 ? souvenirAxis(s).join(', ') : '사이즈 미설정'}</span>
                          </div>
                        ))}
                        <div style={{ fontSize: 11, color: '#666', marginTop: 4 }}>* 사진 속 사이즈표와 위 목록이 같은지 확인하세요 (XXL≡2XL 등 표기 차이는 정상).</div>
                      </div>
                    </div>
                  </div>
                )}

                {inspectDetail && inspection.status !== 'approved' && inspection.suggested_event_text && (
                  <div style={{ marginBottom: 16, padding: 12, background: '#241a10', border: '1px solid #5c3a1f', borderRadius: 6 }}>
                    <div style={{ fontSize: 12.5, fontWeight: 700, color: '#ffb454', marginBottom: 8 }}>✂ 표출 종목 텍스트 — 길면 깨질 수 있어 함축안 제안</div>
                    <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 6, cursor: 'pointer' }}>
                      <input type="radio" name="etChoice" checked={etChoice === 'original'} onChange={() => applyEtChoice('original')} style={{ marginTop: 3 }} />
                      <span style={{ fontSize: 12, color: '#bbb' }}><b style={{ color: '#888' }}>원본</b> {inspectDetail.eventText || '(없음)'}</span>
                    </label>
                    <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 8, cursor: 'pointer' }}>
                      <input type="radio" name="etChoice" checked={etChoice === 'condensed'} onChange={() => applyEtChoice('condensed')} style={{ marginTop: 3 }} />
                      <span style={{ fontSize: 12, color: '#ffd9a0' }}><b style={{ color: '#ffb454' }}>함축</b> {inspection.suggested_event_text}</span>
                    </label>
                    <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>적용값 (직접 수정 가능) — 한 / 영</div>
                    <input value={etKo} onChange={(e) => setEtKo(e.target.value)} placeholder="메인 표출 종목명 (한)" style={{ ...inputStyle, marginBottom: 6 }} />
                    <input value={etEn} onChange={(e) => setEtEn(e.target.value)} placeholder="메인 표출 종목명 (영)" style={inputStyle} />
                    <div style={{ fontSize: 11, color: '#8a6a4a', marginTop: 8 }}>* 원본과 다르면 승인 확정 시 '메인 표출 종목명'을 이 값으로 저장한 뒤 승인합니다.</div>
                  </div>
                )}

                <div style={{ borderTop: '1px solid #2a2a4a', paddingTop: 14 }}>
                  {inspection.status === 'approved' ? (
                    <div style={{ color: '#00ff88', fontSize: 13 }}>✓ 승인 완료됨</div>
                  ) : (
                    <>
                      <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>url_key (제안값 — 확인/수정 후 승인)</div>
                      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                        <input value={urlKeyInput} onChange={(e) => setUrlKeyInput(e.target.value)} placeholder="2026_..." style={{ flex: 1, minWidth: 200, ...inputStyle }} />
                        <button onClick={startInspect} style={{ height: 34, padding: '0 14px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 6, color: '#aaa', fontSize: 13, cursor: 'pointer' }}>재검수</button>
                        <button disabled={approving} onClick={confirmApprove} style={{ height: 34, padding: '0 20px', background: '#00cc6a', border: 'none', borderRadius: 6, color: '#fff', fontSize: 13, fontWeight: 600, cursor: approving ? 'not-allowed' : 'pointer' }}>{approving ? '승인 중...' : '승인 확정'}</button>
                      </div>
                      <div style={{ fontSize: 11, color: '#666', marginTop: 8 }}>* 최종 승인은 검수 결과를 확인한 운영자가 직접 확정합니다.</div>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// ─── 국가코드 선택 (coach DB sms_country 원본) ────────────────────────────────
// 앱/웹(Link_Dev_Front CountryCodeSelectBox)과 똑같은 목록·표기를 쓰기 위해
// 하드코딩 대신 /hub/sms-country 프록시로 전체 국가를 받아온다.

// 조회 실패 시 폴백 — 종전 하드코딩 목록과 동일하게 최소한의 선택지는 남긴다
const COUNTRY_FALLBACK: SMSCountry[] = [
  { countryNameKR: '대한민국', countryNameEN: 'Korea, South', countryCode: '+82', countryIso: 'KR', isAvailable: true, flagUrl: '' },
  { countryNameKR: '미국', countryNameEN: 'United States of America', countryCode: '+1', countryIso: 'US', isAvailable: true, flagUrl: '' },
  { countryNameKR: '영국', countryNameEN: 'United Kingdom', countryCode: '+44', countryIso: 'GB', isAvailable: true, flagUrl: '' },
  { countryNameKR: '일본', countryNameEN: 'Japan', countryCode: '+81', countryIso: 'JP', isAvailable: true, flagUrl: '' },
  { countryNameKR: '중국', countryNameEN: 'China', countryCode: '+86', countryIso: 'CN', isAvailable: true, flagUrl: '' },
];

// 국가 목록은 사실상 고정값 — 모듈 스코프에서 한 번만 받아 모든 인스턴스가 공유한다
let countryListPromise: Promise<SMSCountry[]> | null = null;
function loadCountryList(): Promise<SMSCountry[]> {
  if (!countryListPromise) {
    countryListPromise = getSMSCountryList()
      .then(list => (list && list.length ? list : COUNTRY_FALLBACK))
      .catch(() => { countryListPromise = null; return COUNTRY_FALLBACK; });  // 실패는 캐싱하지 않아 다음 열람 때 재시도
  }
  return countryListPromise;
}

// countryCode 는 국가 간 중복이 있어(+1 US/CA, +61 3곳 등) iso 까지 합쳐야 고유해진다
const countryKey = (c: SMSCountry) => `${c.countryIso}-${c.countryCode}`;

function findCountry(list: SMSCountry[], code: string, iso?: string): SMSCountry | null {
  if (!code) return null;
  if (iso) {
    const exact = list.find(c => c.countryCode === code && c.countryIso === iso);
    if (exact) return exact;
  }
  return list.find(c => c.countryCode === code) || null;
}

function CountryCodeSelect({ code, iso, onChange, disabled, width = '100%', height = 38 }: {
  code: string;
  iso?: string;
  onChange: (c: SMSCountry) => void;
  disabled?: boolean;
  width?: number | string;
  height?: number;
}) {
  const [list, setList] = useState<SMSCountry[]>([]);
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const boxRef = useRef<HTMLDivElement>(null);
  const searchRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    let alive = true;
    loadCountryList().then(l => { if (alive) setList(l); });
    return () => { alive = false; };
  }, []);

  useEffect(() => {
    if (!open) return;
    searchRef.current?.focus();
    const onPointerDown = (e: PointerEvent) => {
      if (boxRef.current && !boxRef.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('pointerdown', onPointerDown);
    return () => document.removeEventListener('pointerdown', onPointerDown);
  }, [open]);

  const selected = findCountry(list, code, iso);

  const q = query.trim().toLowerCase();
  const qDigits = q.replace(/\D/g, '');
  const filtered = !q ? list : list.filter(c =>
    c.countryNameKR.toLowerCase().includes(q)
    || c.countryNameEN.toLowerCase().includes(q)
    || c.countryIso.toLowerCase().includes(q)
    || (!!qDigits && c.countryCode.replace(/\D/g, '').startsWith(qDigits))
  );

  const pick = (c: SMSCountry) => { onChange(c); setOpen(false); setQuery(''); };

  return (
    <div ref={boxRef} style={{ position: 'relative', width }}>
      <div
        onClick={() => { if (!disabled) { setOpen(o => !o); setQuery(''); } }}
        style={{
          display: 'flex', alignItems: 'center', gap: 6, height, boxSizing: 'border-box',
          padding: '0 8px', background: '#0f0f1a', border: `1px solid ${open ? '#00cc6a' : '#2a2a4a'}`,
          borderRadius: 6, color: '#e0e0e0', fontSize: 13,
          cursor: disabled ? 'default' : 'pointer', opacity: disabled ? 0.5 : 1,
        }}
      >
        <CountryFlag country={selected} />
        <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{code || '-'}</span>
        <span style={{ color: '#555', fontSize: 9 }}>{open ? '▲' : '▼'}</span>
      </div>
      {open && !disabled && (
        <div style={{ position: 'absolute', top: 'calc(100% + 4px)', left: 0, width: 260, background: '#0a0a15', border: '1px solid #2a2a4a', borderRadius: 6, zIndex: 30, boxShadow: '0 6px 20px rgba(0,0,0,0.5)' }}>
          <div style={{ padding: 6, borderBottom: '1px solid #1a1a2e' }}>
            <input
              ref={searchRef}
              type="text"
              value={query}
              onChange={e => setQuery(e.target.value)}
              onKeyDown={e => {
                if (e.key === 'Escape') { e.stopPropagation(); setOpen(false); }
                if (e.key === 'Enter' && filtered.length > 0) { e.preventDefault(); pick(filtered[0]); }
              }}
              placeholder="국가명 / 코드 검색 (예: 미국, US, 82)"
              style={{ width: '100%', boxSizing: 'border-box', padding: '6px 8px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, color: '#e0e0e0', fontSize: 12 }}
            />
          </div>
          <div style={{ maxHeight: 260, overflowY: 'auto' }}>
            {list.length === 0 && <div style={{ padding: '8px 10px', fontSize: 11, color: '#555' }}>국가 목록 불러오는 중...</div>}
            {list.length > 0 && filtered.length === 0 && <div style={{ padding: '8px 10px', fontSize: 11, color: '#555' }}>검색 결과 없음</div>}
            {filtered.map(c => {
              const isSel = !!selected && countryKey(selected) === countryKey(c);
              return (
                <div
                  key={countryKey(c)}
                  onClick={() => pick(c)}
                  style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 10px', cursor: 'pointer', fontSize: 12, color: isSel ? '#00cc6a' : '#ccc', background: isSel ? '#00cc6a11' : 'transparent', borderBottom: '1px solid #12121f' }}
                >
                  <CountryFlag country={c} />
                  <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.countryNameKR}</span>
                  <span style={{ color: isSel ? '#00cc6a' : '#666', fontFamily: 'SF Mono, Menlo, monospace' }}>{c.countryCode}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

function CountryFlag({ country }: { country: SMSCountry | null }) {
  const [broken, setBroken] = useState(false);
  useEffect(() => { setBroken(false); }, [country?.flagUrl]);
  if (!country?.flagUrl || broken) {
    // 국기 미제공/로드 실패 시에도 폭을 유지해 목록이 흔들리지 않게 한다
    return <span style={{ width: 20, height: 14, flex: 'none', borderRadius: 2, background: '#2a2a4a' }} />;
  }
  return (
    <img
      src={country.flagUrl}
      alt=""
      loading="lazy"
      onError={() => setBroken(true)}
      style={{ width: 20, height: 14, flex: 'none', borderRadius: 2, objectFit: 'cover' }}
    />
  );
}

function CouponPage({ user }: { user: User }) {
  const [couponPageTab, setCouponPageTab] = useState<'overview' | 'stores' | 'members' | 'withdrawal' | 'sms-send' | 'verified-code' | 'plans' | 'payout' | 'sender'>(user.role === 'owner' ? 'overview' : 'stores');
  const [couponGroup, setCouponGroup] = useState<'store' | 'member' | 'tool'>('store');
  // 회원목록 상태
  const [members, setMembers] = useState<HubMember[]>([]);
  const [memberTotalCount, setMemberTotalCount] = useState(0);
  const [memberPage, setMemberPage] = useState(1);
  const [memberSearch, setMemberSearch] = useState('');
  const [memberSearchInput, setMemberSearchInput] = useState('');
  const [memberLoading, setMemberLoading] = useState(false);
  const [memberDetail, setMemberDetail] = useState<HubMemberDetail | null>(null);
  const [memberDetailSource, setMemberDetailSource] = useState<'members' | 'withdrawal'>('members');
  const [showAddMember, setShowAddMember] = useState(false);
  const [newMember, setNewMember] = useState({ userId: '', password: '', name: '', nickName: '', phone: '', countryCode: '+82', countryIso: 'KR', gender: '', birthDate: '', isForeigner: false, memberId: undefined as number | undefined });
  const [addMemberStoreId, setAddMemberStoreId] = useState<number | ''>('');
  const [addMemberStoreSearch, setAddMemberStoreSearch] = useState('');
  const [addMemberStoreOpen, setAddMemberStoreOpen] = useState(false);
  const [addMemberStoreMembers, setAddMemberStoreMembers] = useState<StoreMember[]>([]);
  const [addMemberMemberSearch, setAddMemberMemberSearch] = useState('');
  const [addMemberMemberOpen, setAddMemberMemberOpen] = useState(false);
  const [addMemberSelectedMember, setAddMemberSelectedMember] = useState<StoreMember | null>(null);
  const [addMemberMembersLoading, setAddMemberMembersLoading] = useState(false);
  const addMemberStoreRef = useRef<HTMLDivElement>(null);
  const addMemberMemberRef = useRef<HTMLDivElement>(null);
  const memberSearchTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  // 탈퇴 신청 상태
  const [withdrawalRequests, setWithdrawalRequests] = useState<WithdrawalRequest[]>([]);
  const [withdrawalLoading, setWithdrawalLoading] = useState(false);
  const [withdrawalPage, setWithdrawalPage] = useState(1);
  const [withdrawalTotalCount, setWithdrawalTotalCount] = useState(0);
  const [withdrawalSearch, setWithdrawalSearch] = useState('');
  const [withdrawalSearchInput, setWithdrawalSearchInput] = useState('');
  const withdrawalSearchTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [storeStatusSummary, setStoreStatusSummary] = useState<StoreStatusSummary | null>(null);
  const [statusFilter, setStatusFilter] = useState<'ALL' | 'BILLING' | 'COUPON' | 'EXPIRING' | 'NONE'>('ALL');
  const [stores, setStores] = useState<StoreDetail[]>([]);
  const [storeSearch, setStoreSearch] = useState('');
  const [storePage, setStorePage] = useState(1);
  const storePageSize = 30;
  const [couponTypes, setCouponTypes] = useState<CouponType[]>([]);
  const [selectedCouponTypeId, setSelectedCouponTypeId] = useState('');
  const [modalStore, setModalStore] = useState<StoreDetail | null>(null);
  // 발신번호 신청 상세 모달 (큐 탭 / 업체 모달 탭 공용)
  const [senderModalId, setSenderModalId] = useState<number | null>(null);
  // 발신번호 큐/탭 새로고침 트리거 (상태 변경 후 목록 재조회)
  const [senderRefreshTick, setSenderRefreshTick] = useState(0);
  // 전역 1초 타이머(App setTick) 리렌더에도 참조가 바뀌지 않도록 안정화 — 모달/큐 깜빡임 방지
  const openSenderModal = useCallback((id: number) => setSenderModalId(id), []);
  const closeSenderModal = useCallback(() => setSenderModalId(null), []);
  const onSenderChanged = useCallback(() => { setSenderModalId(null); setSenderRefreshTick(t => t + 1); }, []);

  useEffect(() => {
    document.body.style.overflow = modalStore ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [modalStore]);

  const [billingInfo, setBillingInfo] = useState<StoreBillingInfo | null>(null);
  const [extendDays, setExtendDays] = useState('');
  const [extendLoading, setExtendLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [couponPage, setCouponPage] = useState(1);
  const [billingPage, setBillingPage] = useState(1);
  const [billingFilter, setBillingFilter] = useState<'all' | 'subscribe' | 'notification'>('all');
  const [historyTab, setHistoryTab] = useState<'coupon' | 'billing' | 'coaches' | 'subaccount' | 'sender'>('billing');
  const [showAddForm, setShowAddForm] = useState(false);
  const [newCoupon, setNewCoupon] = useState({ couponName: '', validity: '', couponCategory: 'GENERAL', isActive: true });
  const [couponSort, setCouponSort] = useState<{ key: string; asc: boolean }>({ key: '', asc: true });
  const [billingSort, setBillingSort] = useState<{ key: string; asc: boolean }>({ key: '', asc: true });
  // 부계정(서브어카운트)
  const [subAccounts, setSubAccounts] = useState<SubAccount[]>([]);
  const [subLoading, setSubLoading] = useState(false);
  const [subForm, setSubForm] = useState<{ id: number | null; account: string; password: string; name: string; phone: string; role: string[]; isBilling: boolean } | null>(null);
  const [subSaving, setSubSaving] = useState(false);
  const [pwReset, setPwReset] = useState<PasswordResetResult | null>(null);
  const [secondPwReset, setSecondPwReset] = useState<SecondPasswordResetResult | null>(null);
  // 구독권(subscription-plan)
  const [plans, setPlans] = useState<SubscriptionPlan[]>([]);
  const [planForm, setPlanForm] = useState<{ id: number | null; planName: string; price: string; validityDays: string; description: string; sortOrder: string } | null>(null);
  const [planSaving, setPlanSaving] = useState(false);
  const [planChangeSel, setPlanChangeSel] = useState<string>('');
  const [planChanging, setPlanChanging] = useState(false);

  useEffect(() => {
    getStoresDetail().then(setStores).catch(() => {});
    getCouponTypes().then(setCouponTypes).catch(() => {});
    getStoreStatusSummary().then(setStoreStatusSummary).catch(() => {});
    getSubscriptionPlans().then(setPlans).catch(() => {});
  }, []);

  const reloadPlans = () => { getSubscriptionPlans().then(setPlans).catch(() => {}); };

  // 회원목록 로딩
  useEffect(() => {
    if (couponPageTab !== 'members') return;
    setMemberLoading(true);
    getHubMembers(memberPage, 30, memberSearch || undefined)
      .then(data => { setMembers(data.members || []); setMemberTotalCount(data.totalCount || 0); })
      .catch(() => { setMembers([]); setMemberTotalCount(0); })
      .finally(() => setMemberLoading(false));
  }, [couponPageTab, memberPage, memberSearch]);

  // 셀렉트 외부 클릭 닫기
  useEffect(() => {
    if (!addMemberStoreOpen && !addMemberMemberOpen) return;
    const handler = (e: MouseEvent) => {
      if (addMemberStoreOpen && addMemberStoreRef.current && !addMemberStoreRef.current.contains(e.target as Node)) setAddMemberStoreOpen(false);
      if (addMemberMemberOpen && addMemberMemberRef.current && !addMemberMemberRef.current.contains(e.target as Node)) setAddMemberMemberOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [addMemberStoreOpen, addMemberMemberOpen]);

  // 탈퇴 신청 로딩
  useEffect(() => {
    if (couponPageTab !== 'withdrawal') return;
    setWithdrawalLoading(true);
    getWithdrawalRequests(withdrawalPage, 20, withdrawalSearch || undefined)
      .then(data => {
        setWithdrawalRequests(data.members || []);
        setWithdrawalTotalCount(data.totalCount || 0);
      })
      .catch(() => { setWithdrawalRequests([]); setWithdrawalTotalCount(0); })
      .finally(() => setWithdrawalLoading(false));
  }, [couponPageTab, withdrawalPage, withdrawalSearch]);

  // 상태 맵 생성 (storeStatusSummary 기반)
  const storeStatusMap = new Map<number, StoreStatusDTO>();
  if (storeStatusSummary) {
    storeStatusSummary.stores.forEach(s => storeStatusMap.set(s.storeId, s));
  }

  const filtered = stores.filter(s => {
    if (storeSearch) {
      const q = storeSearch.toLowerCase();
      if (!(s.name.toLowerCase().includes(q) || String(s.id).includes(q) || (s.ownerName || '').toLowerCase().includes(q) || (s.phone || '').includes(q))) return false;
    }
    if (statusFilter !== 'ALL') {
      const st = storeStatusMap.get(s.id);
      if (!st) return statusFilter === 'NONE';
      return st.status === statusFilter;
    }
    return true;
  });
  const storeTotalPages = Math.ceil(filtered.length / storePageSize);
  const visible = filtered.slice((storePage - 1) * storePageSize, storePage * storePageSize);

  useEffect(() => {
    setStorePage(1);
  }, [storeSearch, statusFilter]);

  // 모달 열릴 때 billing 조회
  useEffect(() => {
    if (!modalStore) { setBillingInfo(null); setSubAccounts([]); setSubForm(null); setPwReset(null); setSecondPwReset(null); setPlanChangeSel(''); return; }
    setCouponPage(1); setBillingPage(1); setBillingFilter('all');
    setSelectedCouponTypeId('');
    setSubForm(null); setPwReset(null); setSecondPwReset(null); setPlanChangeSel('');
    getStoreBilling(modalStore.id).then(setBillingInfo).catch(() => setBillingInfo(null));
    setSubLoading(true);
    getSubAccounts(modalStore.id).then(setSubAccounts).catch(() => setSubAccounts([])).finally(() => setSubLoading(false));
  }, [modalStore]);

  const selectedCouponType = couponTypes.find(c => c.id === Number(selectedCouponTypeId));

  const handleIssue = async () => {
    if (!modalStore || !selectedCouponTypeId) return alert('쿠폰을 선택해주세요.');
    if (!window.confirm(`${modalStore.name}에 "${selectedCouponType?.couponName}" 쿠폰을 발급하시겠습니까?`)) return;
    setLoading(true);
    try {
      await issueCoupon({ storeId: modalStore.id, couponTypeId: Number(selectedCouponTypeId), userId: user.name });
      alert('쿠폰 지급 완료');
      getStoreBilling(modalStore.id).then(setBillingInfo).catch(() => {});
    } catch (e: any) {
      alert('발급 실패: ' + e.message);
    }
    setLoading(false);
  };

  const handleAddCouponType = async () => {
    if (!newCoupon.couponName || !newCoupon.validity) return alert('쿠폰명과 유효일수를 입력해주세요.');
    try {
      await addCouponType({ ...newCoupon, validity: Number(newCoupon.validity), isActive: newCoupon.isActive });
      alert('쿠폰 종류 추가 완료');
      setCouponTypes(await getCouponTypes());
      setNewCoupon({ couponName: '', validity: '', couponCategory: 'GENERAL', isActive: true });
      setShowAddForm(false);
    } catch (e: any) {
      alert('추가 실패: ' + e.message);
    }
  };

  const reloadSubAccounts = () => {
    if (!modalStore) return;
    setSubLoading(true);
    getSubAccounts(modalStore.id).then(setSubAccounts).catch(() => setSubAccounts([])).finally(() => setSubLoading(false));
  };

  const handleSubSave = async () => {
    if (!modalStore || !subForm) return;
    const f = subForm;
    if (!f.name.trim() || !f.phone.trim()) return alert('이름과 전화번호는 필수입니다.');
    if (f.id === null && (!f.account.trim() || !f.password.trim())) return alert('계정과 비밀번호는 필수입니다.');
    setSubSaving(true);
    try {
      if (f.id === null) {
        await createSubAccount({ storeId: modalStore.id, account: f.account.trim(), password: f.password, name: f.name.trim(), phone: f.phone.trim(), role: f.role, isBilling: f.isBilling });
        alert('부계정 생성 완료');
      } else {
        await modifySubAccount({ storeId: modalStore.id, subAccountId: f.id, name: f.name.trim(), phone: f.phone.trim(), role: f.role, isBilling: f.isBilling });
        alert('부계정 수정 완료');
      }
      setSubForm(null);
      reloadSubAccounts();
    } catch (e: any) {
      alert((f.id === null ? '생성' : '수정') + ' 실패: ' + e.message);
    }
    setSubSaving(false);
  };

  const handleSubDelete = async (sa: SubAccount) => {
    if (!modalStore) return;
    if (!window.confirm(`부계정 "${sa.name}(${sa.account})"을(를) 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다.`)) return;
    try {
      await deleteSubAccount(modalStore.id, sa.id);
      reloadSubAccounts();
    } catch (e: any) {
      alert('삭제 실패: ' + e.message);
    }
  };

  const handlePwReset = async (sa: SubAccount | null) => {
    if (!modalStore) return;
    const target = sa ? `부계정 "${sa.name}(${sa.account})"` : `점주`;
    if (!window.confirm(`${target}의 비밀번호를 초기화하시겠습니까?\n임시 비밀번호가 발급되고 등록된 번호로 SMS가 발송됩니다.`)) return;
    try {
      const result = sa ? await resetSubAccountPassword(modalStore.id, sa.id) : await resetStorePassword(modalStore.id);
      setPwReset(result);
    } catch (e: any) {
      alert('비밀번호 초기화 실패: ' + e.message);
    }
  };

  const handleSecondPwReset = async () => {
    if (!modalStore) return;
    if (!window.confirm(`${modalStore.name}의 2차 비밀번호를 초기화하시겠습니까?\n기본값 "0000"으로 되돌아갑니다.`)) return;
    try {
      const result = await resetStoreSecondPassword(modalStore.id);
      setSecondPwReset(result);
    } catch (e: any) {
      alert('2차 비밀번호 초기화 실패: ' + e.message);
    }
  };

  // 업체 사용중 구독권 변경
  const handleChangeStorePlan = async () => {
    if (!modalStore || !planChangeSel) return;
    const plan = plans.find(p => p.id === Number(planChangeSel));
    if (!plan) return;
    if (!window.confirm(`${modalStore.name}의 구독권을 "${plan.planName}"(으)로 변경하시겠습니까?\n다음 결제분부터 ${plan.price.toLocaleString()}원 / ${plan.validityDays}일 기준으로 적용됩니다.`)) return;
    setPlanChanging(true);
    try {
      await changeStorePlan(modalStore.id, plan.id);
      const info = await getStoreBilling(modalStore.id);
      setBillingInfo(info);
      setPlanChangeSel('');
      alert('구독권 변경 완료');
    } catch (e: any) {
      alert('구독권 변경 실패: ' + e.message);
    }
    setPlanChanging(false);
  };

  // 구독권 마스터 생성/수정
  const handlePlanSave = async () => {
    if (!planForm) return;
    const f = planForm;
    if (!f.planName.trim()) return alert('플랜명은 필수입니다.');
    if (f.price === '' || Number(f.price) < 0) return alert('결제 금액을 올바르게 입력해주세요.');
    if (f.validityDays === '' || Number(f.validityDays) <= 0) return alert('유효 일수를 올바르게 입력해주세요.');
    setPlanSaving(true);
    try {
      if (f.id === null) {
        await saveSubscriptionPlan({ planName: f.planName.trim(), price: Number(f.price), validityDays: Number(f.validityDays), description: f.description.trim() || undefined, sortOrder: f.sortOrder === '' ? undefined : Number(f.sortOrder) });
        alert('구독권 생성 완료');
      } else {
        await modifySubscriptionPlan({ id: f.id, planName: f.planName.trim(), price: Number(f.price), validityDays: Number(f.validityDays), description: f.description.trim(), sortOrder: f.sortOrder === '' ? undefined : Number(f.sortOrder) });
        alert('구독권 수정 완료');
      }
      setPlanForm(null);
      reloadPlans();
    } catch (e: any) {
      alert((f.id === null ? '생성' : '수정') + ' 실패: ' + e.message);
    }
    setPlanSaving(false);
  };

  const handlePlanToggle = async (p: SubscriptionPlan) => {
    if (!window.confirm(`"${p.planName}" 플랜을 ${p.isActive ? '비활성화' : '활성화'}하시겠습니까?`)) return;
    try {
      await toggleSubscriptionPlan(p.id);
      reloadPlans();
    } catch (e: any) {
      alert('상태 변경 실패: ' + e.message);
    }
  };

  const handlePlanDelete = async (p: SubscriptionPlan) => {
    if (!window.confirm(`"${p.planName}" 플랜을 삭제하시겠습니까?\n진행중인 구독이 있으면 삭제할 수 없습니다.`)) return;
    try {
      await deleteSubscriptionPlan(p.id);
      reloadPlans();
    } catch (e: any) {
      alert('삭제 실패: ' + e.message);
    }
  };

  const statusBadge = (storeId: number) => {
    const st = storeStatusMap.get(storeId);
    if (!st) return null;
    const cfg: Record<string, { label: string; bg: string; color: string }> = {
      BILLING: { label: '결제중', bg: '#00b89420', color: '#00b894' },
      COUPON: { label: '쿠폰', bg: '#4dabf720', color: '#4dabf7' },
      EXPIRING: { label: '만료임박', bg: '#fdcb6e20', color: '#fdcb6e' },
      NONE: { label: '없음', bg: '#636e7220', color: '#636e72' },
    };
    const c = cfg[st.status] || cfg.NONE;
    return <span style={{ fontSize: 10, padding: '1px 6px', borderRadius: 4, background: c.bg, color: c.color, fontWeight: 600, marginLeft: 6 }}>{c.label}</span>;
  };

  const filterButtons = () => {
    const ss = storeStatusSummary;
    const items: { key: typeof statusFilter; label: string; count: number }[] = [
      { key: 'ALL', label: '전체', count: ss?.total || stores.length },
      { key: 'BILLING', label: '결제중', count: ss?.billingCount || 0 },
      { key: 'COUPON', label: '쿠폰', count: ss?.couponCount || 0 },
      { key: 'EXPIRING', label: '만료임박', count: ss?.expiringCount || 0 },
      { key: 'NONE', label: '없음', count: ss?.noneCount || 0 },
    ];
    return (
      <div style={{ display: 'flex', gap: 6, marginBottom: 12, flexWrap: 'wrap' }}>
        {items.map(f => (
          <button key={f.key} onClick={() => { setStatusFilter(f.key); setStorePage(1); }}
            style={{ padding: '5px 14px', fontSize: 12, borderRadius: 6, border: statusFilter === f.key ? '1px solid #4dabf7' : '1px solid #2a2a4a', background: statusFilter === f.key ? '#4dabf720' : 'transparent', color: statusFilter === f.key ? '#4dabf7' : '#888', cursor: 'pointer', fontWeight: statusFilter === f.key ? 600 : 400 }}>
            {f.label} <span style={{ opacity: 0.7 }}>({f.count})</span>
          </button>
        ))}
      </div>
    );
  };

  const storeList = (onClickStore: (s: StoreDetail) => void) => (
    <>
      {filterButtons()}
      <div style={{ marginBottom: 16 }}>
        <input
          type="text"
          placeholder="업체명, 대표자명, ID, 연락처로 검색"
          value={storeSearch}
          onChange={(e) => setStoreSearch(e.target.value)}
          style={{ width: '100%', maxWidth: 400, boxSizing: 'border-box', padding: '8px 12px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13 }}
        />
        <span style={{ marginLeft: 12, fontSize: 12, color: '#666' }}>{filtered.length}개 업체</span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 12 }}>
        {visible.map(s => (
          <div
            key={s.id}
            onClick={() => onClickStore(s)}
            style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 8, cursor: 'pointer', transition: 'border-color 0.15s', opacity: s.isView ? 1 : 0.5 }}
            onMouseEnter={(e) => (e.currentTarget.style.borderColor = '#4dabf7')}
            onMouseLeave={(e) => (e.currentTarget.style.borderColor = '#2a2a4a')}
          >
            {s.logo ? (
              <img src={s.logo} alt="" loading="lazy" style={{ width: 40, height: 40, borderRadius: 8, objectFit: 'cover', flexShrink: 0, background: '#1a1a2e' }} />
            ) : (
              <div style={{ width: 40, height: 40, borderRadius: 8, background: '#1a1a2e', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: 16, color: '#333' }}>
                <svg width="20" height="20" viewBox="0 0 16 16" fill="none" stroke="#444" strokeWidth="1.5"><rect x="2" y="2" width="12" height="12" rx="2"/><path d="M2,6 h12"/><path d="M6,6 v8"/></svg>
              </div>
            )}
            <div style={{ overflow: 'hidden', flex: 1 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#e0e0e0', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {s.name}
                {statusBadge(s.id)}
                {!s.isView && <span style={{ fontSize: 10, color: '#ff4444', marginLeft: 6 }}>숨김</span>}
              </div>
              <div style={{ fontSize: 11, color: '#666', marginTop: 2 }}>
                <span>#{s.id}</span>
                {s.ownerName && <span style={{ marginLeft: 8 }}>{s.ownerName}</span>}
                {s.phone && <span style={{ marginLeft: 8 }}>{s.phone}</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
      {visible.length === 0 && <div style={{ padding: 40, textAlign: 'center', color: '#666', fontSize: 13 }}>검색 결과가 없습니다.</div>}
      {storeTotalPages > 1 && (
        <div className="pagination" style={{ marginTop: 12 }}>
          <button disabled={storePage <= 1} onClick={() => setStorePage(storePage - 1)}>이전</button>
          {Array.from({ length: storeTotalPages }, (_, i) => i + 1)
            .filter(p => p === 1 || p === storeTotalPages || Math.abs(p - storePage) <= 2)
            .reduce<(number | string)[]>((acc, p, i, arr) => {
              if (i > 0 && p - (arr[i - 1] as number) > 1) acc.push('...');
              acc.push(p);
              return acc;
            }, [])
            .map((p, i) =>
              typeof p === 'string'
                ? <span key={`dot-${i}`} className="pagination-dots">...</span>
                : <button key={p} className={storePage === p ? 'active' : ''} onClick={() => setStorePage(p)}>{p}</button>
            )}
          <button disabled={storePage >= storeTotalPages} onClick={() => setStorePage(storePage + 1)}>다음</button>
        </div>
      )}
    </>
  );

  // 서비스 관리 2단 탭: 상위 그룹(업체/회원/도구) ▸ 하위 탭
  type CouponTabKey = 'overview' | 'stores' | 'members' | 'withdrawal' | 'sms-send' | 'verified-code' | 'plans' | 'payout' | 'sender';
  const couponGroups: { key: 'store' | 'member' | 'tool'; label: string; tabs: { key: CouponTabKey; label: string; ownerOnly?: boolean }[] }[] = [
    { key: 'store', label: '업체', tabs: [
      { key: 'overview', label: '현황', ownerOnly: true },
      { key: 'stores', label: '업체목록' },
      { key: 'plans', label: '구독권 관리' },
      { key: 'payout', label: '지급대행' },
    ] },
    { key: 'member', label: '회원', tabs: [
      { key: 'members', label: '회원목록' },
      { key: 'withdrawal', label: '탈퇴 신청' },
    ] },
    { key: 'tool', label: '도구', tabs: [
      { key: 'sms-send', label: '문자 발송' },
      { key: 'verified-code', label: '인증번호 발급' },
      { key: 'sender', label: '발신번호 신청' },
    ] },
  ];
  const visibleTabs = (g: 'store' | 'member' | 'tool') =>
    (couponGroups.find(x => x.key === g)?.tabs ?? []).filter(t => !t.ownerOnly || user.role === 'owner');
  const selectGroup = (g: 'store' | 'member' | 'tool') => {
    setCouponGroup(g);
    const first = visibleTabs(g)[0];
    if (first) setCouponPageTab(first.key);
  };

  return (
    <div className="admin-page">
      {/* 1단: 그룹 탭 */}
      <div className="admin-tabs">
        {couponGroups.map(g => (
          <button key={g.key} className={`admin-tab ${couponGroup === g.key ? 'active' : ''}`} onClick={() => selectGroup(g.key)}>{g.label}</button>
        ))}
      </div>
      {/* 2단: 하위 탭 */}
      <div className="admin-subtabs">
        {visibleTabs(couponGroup).map(t => (
          <button key={t.key} className={`admin-tab-sm ${couponPageTab === t.key ? 'active' : ''}`} onClick={() => setCouponPageTab(t.key)}>{t.label}</button>
        ))}
      </div>

      {couponPageTab === 'sms-send' && <AdminSmsSendTab />}
      {couponPageTab === 'verified-code' && <AdminVerifiedCodeSendTab />}
      {couponPageTab === 'sender' && <SenderNumberQueue refreshTick={senderRefreshTick} onOpen={openSenderModal} />}

      {couponPageTab === 'plans' && (
        <div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
            <h2 style={{ fontSize: 16, color: '#e0e0e0', margin: 0 }}>구독권 관리 <span style={{ fontSize: 13, color: '#888', fontWeight: 400 }}>{plans.length}건</span></h2>
            <button
              onClick={() => setPlanForm(planForm && planForm.id === null ? null : { id: null, planName: '', price: '', validityDays: '', description: '', sortOrder: '' })}
              style={{ height: 34, padding: '0 16px', background: '#00cc6a', border: 'none', borderRadius: 6, color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}
            >{planForm && planForm.id === null ? '취소' : '+ 새 구독권'}</button>
          </div>

          {/* 생성/수정 폼 */}
          {planForm && (
            <div style={{ padding: '16px', background: '#0a0a18', border: '1px solid #2a2a4a', borderRadius: 8, marginBottom: 16 }}>
              <div style={{ fontSize: 13, color: '#e0e0e0', fontWeight: 600, marginBottom: 12 }}>{planForm.id === null ? '새 구독권 생성' : `구독권 수정 (#${planForm.id})`}</div>
              <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
                <div style={{ flex: 2, minWidth: 180 }}>
                  <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>플랜명 *</div>
                  <input value={planForm.planName} onChange={(e) => setPlanForm({ ...planForm, planName: e.target.value })} placeholder="Link Zone Pro" style={{ width: '100%', padding: '6px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13, boxSizing: 'border-box' }} />
                </div>
                <div style={{ flex: 1, minWidth: 110 }}>
                  <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>금액(원) *</div>
                  <input type="number" value={planForm.price} onChange={(e) => setPlanForm({ ...planForm, price: e.target.value })} placeholder="120000" style={{ width: '100%', padding: '6px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13, boxSizing: 'border-box' }} />
                </div>
                <div style={{ flex: 1, minWidth: 90 }}>
                  <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>유효일수 *</div>
                  <input type="number" value={planForm.validityDays} onChange={(e) => setPlanForm({ ...planForm, validityDays: e.target.value })} placeholder="30" style={{ width: '100%', padding: '6px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13, boxSizing: 'border-box' }} />
                </div>
                <div style={{ flex: 1, minWidth: 80 }}>
                  <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>노출순서</div>
                  <input type="number" value={planForm.sortOrder} onChange={(e) => setPlanForm({ ...planForm, sortOrder: e.target.value })} placeholder="1" style={{ width: '100%', padding: '6px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13, boxSizing: 'border-box' }} />
                </div>
              </div>
              <div style={{ marginBottom: 12 }}>
                <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>설명</div>
                <input value={planForm.description} onChange={(e) => setPlanForm({ ...planForm, description: e.target.value })} placeholder="Pro 월간 구독" style={{ width: '100%', padding: '6px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13, boxSizing: 'border-box' }} />
              </div>
              <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                <button onClick={() => setPlanForm(null)} style={{ height: 32, padding: '0 14px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 6, color: '#888', fontSize: 13, cursor: 'pointer' }}>취소</button>
                <button disabled={planSaving} onClick={handlePlanSave} style={{ height: 32, padding: '0 18px', background: '#00cc6a', border: 'none', borderRadius: 6, color: '#fff', fontSize: 13, fontWeight: 600, cursor: planSaving ? 'not-allowed' : 'pointer' }}>{planSaving ? '저장중...' : '저장'}</button>
              </div>
            </div>
          )}

          {/* 플랜 목록 */}
          {plans.length === 0 ? (
            <div style={{ padding: 30, textAlign: 'center', color: '#888', fontSize: 13 }}>등록된 구독권이 없습니다.</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ color: '#888', textAlign: 'left', borderBottom: '1px solid #2a2a4a' }}>
                  <th style={{ padding: '8px 10px', width: 50 }}>순서</th>
                  <th style={{ padding: '8px 10px' }}>플랜명</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right' }}>금액</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right' }}>유효일수</th>
                  <th style={{ padding: '8px 10px' }}>설명</th>
                  <th style={{ padding: '8px 10px', textAlign: 'center' }}>상태</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right' }}>관리</th>
                </tr>
              </thead>
              <tbody>
                {[...plans].sort((a, b) => a.sortOrder - b.sortOrder).map(p => (
                  <tr key={p.id} style={{ borderBottom: '1px solid #1a1a2e', color: '#e0e0e0', opacity: p.isActive ? 1 : 0.5 }}>
                    <td style={{ padding: '10px', color: '#888' }}>{p.sortOrder}</td>
                    <td style={{ padding: '10px', fontWeight: 600 }}>{p.planName}</td>
                    <td style={{ padding: '10px', textAlign: 'right' }}>{p.price.toLocaleString()}원</td>
                    <td style={{ padding: '10px', textAlign: 'right' }}>{p.validityDays}일</td>
                    <td style={{ padding: '10px', color: '#aaa', fontSize: 12 }}>{p.description || '-'}</td>
                    <td style={{ padding: '10px', textAlign: 'center' }}>
                      <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 11, background: p.isActive ? '#00cc6a22' : '#63636222', color: p.isActive ? '#00cc6a' : '#888' }}>{p.isActive ? '활성' : '비활성'}</span>
                    </td>
                    <td style={{ padding: '10px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                      <button onClick={() => setPlanForm({ id: p.id, planName: p.planName, price: String(p.price), validityDays: String(p.validityDays), description: p.description || '', sortOrder: String(p.sortOrder) })} style={{ padding: '4px 8px', background: 'none', border: '1px solid #2a2a4a', borderRadius: 4, color: '#aaa', fontSize: 11, cursor: 'pointer', marginRight: 4 }}>수정</button>
                      <button onClick={() => handlePlanToggle(p)} style={{ padding: '4px 8px', background: 'none', border: '1px solid #4dabf755', borderRadius: 4, color: '#4dabf7', fontSize: 11, cursor: 'pointer', marginRight: 4 }}>{p.isActive ? '비활성화' : '활성화'}</button>
                      <button onClick={() => handlePlanDelete(p)} style={{ padding: '4px 8px', background: 'none', border: '1px solid #ff444455', borderRadius: 4, color: '#ff4444', fontSize: 11, cursor: 'pointer' }}>삭제</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {couponPageTab === 'overview' && <StoreOverviewTab />}
      {couponPageTab === 'payout' && <PayoutTab />}
      {couponPageTab === 'stores' && storeList((s) => setModalStore(s))}
      {couponPageTab === 'members' && (
        <div>
          {/* 검색 */}
          <div style={{ marginBottom: 16 }}>
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <input
                type="text"
                placeholder="이름 또는 전화번호 검색"
                value={memberSearchInput}
                onChange={(e) => {
                  setMemberSearchInput(e.target.value);
                  if (memberSearchTimer.current) clearTimeout(memberSearchTimer.current);
                  memberSearchTimer.current = setTimeout(() => { setMemberSearch(e.target.value); setMemberPage(1); }, 300);
                }}
                style={{ width: 280, padding: '8px 32px 8px 12px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13 }}
              />
              {memberSearchInput && (
                <button
                  onClick={() => { setMemberSearchInput(''); setMemberSearch(''); setMemberPage(1); }}
                  style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: '#666', cursor: 'pointer', fontSize: 16, padding: 0, lineHeight: 1 }}
                >×</button>
              )}
            </div>
            <span style={{ fontSize: 12, color: '#666', marginLeft: 12 }}>{memberTotalCount.toLocaleString()}명</span>
            <button onClick={() => { setShowAddMember(true); setNewMember({ userId: '', password: '', name: '', nickName: '', phone: '', countryCode: '+82', countryIso: 'KR', gender: '', birthDate: '', isForeigner: false, memberId: undefined }); setAddMemberStoreId(''); setAddMemberStoreSearch(''); setAddMemberStoreMembers([]); setAddMemberSelectedMember(null); setAddMemberMemberSearch(''); }} style={{ marginLeft: 12, padding: '4px 12px', fontSize: 12, borderRadius: 4, border: '1px solid #00cc6a', background: 'transparent', color: '#00cc6a', cursor: 'pointer' }}>+ 계정 추가</button>
          </div>

          {/* 테이블 */}
          {memberLoading ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#888' }}>로딩 중...</div>
          ) : members.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>회원이 없습니다</div>
          ) : (
            <table>
              <thead><tr>
                <th>이름</th>
                <th>전화번호</th>
                <th>가입 방식</th>
                <th>가입일</th>
              </tr></thead>
              <tbody>
                {members.map(m => (
                  <tr key={m.userId} style={{ cursor: 'pointer' }} onClick={() => {
                    setMemberDetailSource('members');
                    getHubMemberDetail(m.userId).then(setMemberDetail).catch(() => alert('상세 조회 실패'));
                  }}>
                    <td style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      {m.profile ? <img src={m.profile.replace(/img_\d+x\d+/, 'img_110x110')} alt="" loading="lazy" width={24} height={24} style={{ width: 24, height: 24, borderRadius: '50%', objectFit: 'cover' }} /> : <div style={{ width: 24, height: 24, borderRadius: '50%', background: '#2a2a4a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, color: '#888' }}>{m.name?.charAt(0)}</div>}
                      {m.name}
                    </td>
                    <td>{m.phone}</td>
                    <td>{(() => {
                      const iconMap: Record<string, string> = { Kakao: '/icons/KakaoIcon.png', Naver: '/icons/NaverIcon.png', Google: '/icons/GoogleIcon.png', Apple: '/icons/AppleIcon.png' };
                      const icon = iconMap[m.signUpType];
                      return icon
                        ? <img src={icon} alt={m.signUpType} title={m.signUpType} style={{ width: 20, height: 20, borderRadius: 4 }} />
                        : <img src="/logo-linko.svg" alt="Linko" title="일반 가입" style={{ width: 20, height: 20, borderRadius: 4 }} />;
                    })()}</td>
                    <td>{m.createdDate?.slice(0, 10)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {/* 페이지네이션 */}
          {memberTotalCount > 30 && (
            <div style={{ display: 'flex', justifyContent: 'center', gap: 4, marginTop: 16 }}>
              <button disabled={memberPage <= 1} onClick={() => setMemberPage(p => p - 1)} style={{ padding: '4px 12px', fontSize: 12, borderRadius: 4, border: '1px solid #2a2a4a', background: 'transparent', color: '#888', cursor: memberPage <= 1 ? 'default' : 'pointer' }}>이전</button>
              <span style={{ padding: '4px 12px', fontSize: 12, color: '#888' }}>{memberPage} / {Math.ceil(memberTotalCount / 30)}</span>
              <button disabled={memberPage >= Math.ceil(memberTotalCount / 30)} onClick={() => setMemberPage(p => p + 1)} style={{ padding: '4px 12px', fontSize: 12, borderRadius: 4, border: '1px solid #2a2a4a', background: 'transparent', color: '#888', cursor: memberPage >= Math.ceil(memberTotalCount / 30) ? 'default' : 'pointer' }}>다음</button>
            </div>
          )}

        </div>
      )}

      {couponPageTab === 'withdrawal' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <span style={{ fontSize: 12, color: '#666' }}>총 {withdrawalTotalCount}건</span>
            <input
              type="text"
              placeholder="이름 또는 전화번호 검색"
              value={withdrawalSearchInput}
              onChange={(e) => {
                setWithdrawalSearchInput(e.target.value);
                if (withdrawalSearchTimer.current) clearTimeout(withdrawalSearchTimer.current);
                withdrawalSearchTimer.current = setTimeout(() => {
                  setWithdrawalSearch(e.target.value);
                  setWithdrawalPage(1);
                }, 300);
              }}
              style={{ width: 240, padding: '6px 10px', fontSize: 12, borderRadius: 4, border: '1px solid #2a2a4a', background: '#1a1a2e', color: '#ccc' }}
            />
          </div>
          {withdrawalLoading ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#888' }}>로딩 중...</div>
          ) : withdrawalRequests.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>탈퇴 신청이 없습니다</div>
          ) : (
            <table>
              <thead><tr>
                <th>회원</th>
                <th>전화번호</th>
                <th>가입 방식</th>
                <th>가입일</th>
                <th>탈퇴 신청일</th>
                <th>처리 예정일</th>
              </tr></thead>
              <tbody>
                {withdrawalRequests.map(w => (
                  <tr key={w.userId} style={{ cursor: 'pointer' }} onClick={() => {
                    setMemberDetailSource('withdrawal');
                    getHubMemberDetail(w.userId).then(setMemberDetail).catch(() => alert('상세 조회 실패'));
                  }}>
                    <td style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      {w.profile ? <img src={w.profile.replace(/img_\d+x\d+/, 'img_110x110')} alt="" loading="lazy" width={24} height={24} style={{ width: 24, height: 24, borderRadius: '50%', objectFit: 'cover' }} /> : <div style={{ width: 24, height: 24, borderRadius: '50%', background: '#2a2a4a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, color: '#888' }}>{w.name?.charAt(0)}</div>}
                      <div>
                        <div style={{ fontSize: 13 }}>{w.name}</div>
                        <div style={{ fontSize: 11, color: '#666' }}>{w.userId}</div>
                      </div>
                    </td>
                    <td>{w.phone}</td>
                    <td>{(() => {
                      const iconMap: Record<string, string> = { Kakao: '/icons/KakaoIcon.png', Naver: '/icons/NaverIcon.png', Google: '/icons/GoogleIcon.png', Apple: '/icons/AppleIcon.png' };
                      const icon = iconMap[w.signUpType];
                      return icon ? <img src={icon} alt={w.signUpType} title={w.signUpType} style={{ width: 20, height: 20, borderRadius: 4 }} /> : <span style={{ fontSize: 11, color: '#888' }}>{w.signUpType}</span>;
                    })()}</td>
                    <td>{w.createdDate?.slice(0, 10)}</td>
                    <td style={{ color: '#ff8844' }}>{w.withdrawalRequestDate?.slice(0, 10)}</td>
                    <td style={{ color: '#ff4444' }}>{w.withdrawalScheduledDate?.slice(0, 10)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          {withdrawalTotalCount > 20 && (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8, marginTop: 16 }}>
              <button disabled={withdrawalPage <= 1} onClick={() => setWithdrawalPage(p => p - 1)} style={{ padding: '4px 12px', fontSize: 12, borderRadius: 4, border: '1px solid #2a2a4a', background: 'transparent', color: withdrawalPage <= 1 ? '#444' : '#ccc', cursor: withdrawalPage <= 1 ? 'default' : 'pointer' }}>이전</button>
              <span style={{ fontSize: 12, color: '#888' }}>{withdrawalPage} / {Math.ceil(withdrawalTotalCount / 20)}</span>
              <button disabled={withdrawalPage >= Math.ceil(withdrawalTotalCount / 20)} onClick={() => setWithdrawalPage(p => p + 1)} style={{ padding: '4px 12px', fontSize: 12, borderRadius: 4, border: '1px solid #2a2a4a', background: 'transparent', color: withdrawalPage >= Math.ceil(withdrawalTotalCount / 20) ? '#444' : '#ccc', cursor: withdrawalPage >= Math.ceil(withdrawalTotalCount / 20) ? 'default' : 'pointer' }}>다음</button>
            </div>
          )}
        </div>
      )}

      {/* 회원 상세 모달 */}
      {memberDetail && (
        <div className="modal-overlay" onClick={() => setMemberDetail(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 500 }}>
            <div className="modal-header">
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                {memberDetail.profile ? <img src={memberDetail.profile.replace(/img_\d+x\d+/, 'img_110x110')} alt="" loading="lazy" width={36} height={36} style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover' }} /> : <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#2a2a4a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, color: '#888' }}>{memberDetail.name?.charAt(0)}</div>}
                <h2>{memberDetail.name}</h2>
              </div>
              <button className="close" onClick={() => setMemberDetail(null)}>&times;</button>
            </div>
            <div className="modal-body">
              <table style={{ tableLayout: 'auto', width: '100%' }}>
                <tbody>
                  {[
                    ['전화번호', memberDetail.phone],
                    ['가입 방식', memberDetail.signUpType],
                    ['성별', memberDetail.gender],
                    ['나이', memberDetail.age ? `${memberDetail.age}세` : null],
                    ['가입일', memberDetail.createdDate?.slice(0, 10)],
                    ['최근 접속', memberDetail.lastAccessDate?.slice(0, 10)],
                    ['OS / 버전', [memberDetail.os, memberDetail.appVersion || memberDetail.buildVersion].filter(Boolean).join(' / ') || null],
                    ['기기', memberDetail.deviceModel],
                    ['국가', [memberDetail.countryIso, memberDetail.countryCode].filter(Boolean).join(' ') || null],
                    ['푸시 알림', memberDetail.isAvailableNotification ? 'ON' : 'OFF'],
                    ['링코페이 카드', memberDetail.isCardRegistered ? '등록됨' : '미등록'],
                  ].filter(([, v]) => v != null).map(([label, value]) => (
                    <tr key={label as string}>
                      <td style={{ color: '#888', fontSize: 12, padding: '6px 12px 6px 0', whiteSpace: 'nowrap' }}>{label}</td>
                      <td style={{ fontSize: 13, padding: '6px 0' }}>{value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {memberDetail.registeredStores && memberDetail.registeredStores.length > 0 && (
                <div style={{ marginTop: 12 }}>
                  <div style={{ fontSize: 12, color: '#888', marginBottom: 6 }}>소속 체육관</div>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    {memberDetail.registeredStores.map((s, i) => (
                      <span key={i} style={{ fontSize: 11, padding: '3px 8px', borderRadius: 4, background: '#1a1a2e', border: '1px solid #2a2a4a', color: '#ccc', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                        {typeof s === 'string' ? s : (<>
                          {s.storeLogo && <img src={s.storeLogo.replace(/img_\d+x\d+/, 'img_110x110')} alt="" loading="lazy" width={16} height={16} style={{ width: 16, height: 16, borderRadius: 3, objectFit: 'cover' }} />}
                          {s.storeName}
                        </>)}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              {memberDetail.eventParticipations && memberDetail.eventParticipations.length > 0 && (
                <div style={{ marginTop: 12 }}>
                  <div style={{ fontSize: 12, color: '#888', marginBottom: 6 }}>이벤트 참여 ({memberDetail.eventParticipations.length}회)</div>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    {memberDetail.eventParticipations.map((e, i) => (
                      <span key={i} style={{ fontSize: 11, padding: '3px 8px', borderRadius: 4, background: '#1a1a2e', border: '1px solid #2a2a4a', color: '#ccc', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                        {e.eventLogo && <img src={e.eventLogo} alt="" style={{ width: 16, height: 16, borderRadius: 3, objectFit: 'cover' }} />}
                        {e.eventName || `이벤트 #${e.eventId}`}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {/* 탈퇴 관련 액션 버튼 */}
              <div style={{ marginTop: 16, paddingTop: 16, borderTop: '1px solid #2a2a4a', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                {memberDetailSource === 'members' && (
                  <button
                    onClick={async () => {
                      if (!window.confirm(`${memberDetail.name}님을 탈퇴 처리하시겠습니까?\n30일 후 데이터가 삭제됩니다.`)) return;
                      try {
                        await requestWithdrawal(memberDetail.userId, '관리자 요청에 의한 탈퇴 신청');
                        alert('탈퇴 신청 완료');
                        setMemberDetail(null);
                      } catch (e: any) { alert('탈퇴 실패: ' + e.message); }
                    }}
                    style={{ padding: '8px 16px', fontSize: 13, borderRadius: 6, border: '1px solid #ff4444', background: 'transparent', color: '#ff4444', cursor: 'pointer' }}
                  >회원 탈퇴</button>
                )}
                {memberDetailSource === 'withdrawal' && (<>
                  <button
                    onClick={async () => {
                      if (!window.confirm(`${memberDetail.name}님의 탈퇴를 철회하시겠습니까?`)) return;
                      try {
                        await cancelWithdrawal(memberDetail.userId);
                        alert('탈퇴 철회 완료');
                        setMemberDetail(null);
                        setWithdrawalRequests(prev => prev.filter(w => w.userId !== memberDetail.userId));
                        setWithdrawalTotalCount(prev => Math.max(0, prev - 1));
                      } catch (e: any) { alert('탈퇴 철회 실패: ' + e.message); }
                    }}
                    style={{ padding: '8px 16px', fontSize: 13, borderRadius: 6, border: '1px solid #00cc6a', background: 'transparent', color: '#00cc6a', cursor: 'pointer' }}
                  >탈퇴 철회</button>
                  <button
                    onClick={async () => {
                      if (!window.confirm(`${memberDetail.name}님의 탈퇴를 즉시 진행하시겠습니까?\n이 작업은 되돌릴 수 없습니다.`)) return;
                      try {
                        await processWithdrawal(memberDetail.userId);
                        alert('탈퇴 처리 완료');
                        setMemberDetail(null);
                        setWithdrawalRequests(prev => prev.filter(w => w.userId !== memberDetail.userId));
                        setWithdrawalTotalCount(prev => Math.max(0, prev - 1));
                      } catch (e: any) { alert('탈퇴 처리 실패: ' + e.message); }
                    }}
                    style={{ padding: '8px 16px', fontSize: 13, borderRadius: 6, border: 'none', background: '#ff4444', color: '#fff', cursor: 'pointer', fontWeight: 600 }}
                  >탈퇴 진행</button>
                </>)}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 계정 추가 모달 */}
      {showAddMember && (() => {
        const inputStyle = { width: '100%', padding: '8px 12px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13, height: 38, boxSizing: 'border-box' as const };
        const labelStyle = { fontSize: 11, color: '#888', display: 'block' as const, marginBottom: 4 };
        const canSubmit = newMember.userId && newMember.password && newMember.name && newMember.nickName;
        const filteredStores = stores.filter(s => !addMemberStoreSearch || s.name.toLowerCase().includes(addMemberStoreSearch.toLowerCase()) || String(s.id).includes(addMemberStoreSearch));
        return (
        <div className="modal-overlay" onClick={() => setShowAddMember(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 480 }}>
            <div className="modal-header">
              <h2>계정 추가</h2>
              <button className="close" onClick={() => setShowAddMember(false)}>&times;</button>
            </div>
            <div className="modal-body">
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div style={{ display: 'flex', gap: 8 }}>
                  <div style={{ flex: 1 }}>
                    <label style={labelStyle}>로그인 ID *</label>
                    <input type="text" value={newMember.userId} onChange={e => setNewMember(p => ({ ...p, userId: e.target.value }))} placeholder="user123" style={inputStyle} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={labelStyle}>임시 비밀번호 *</label>
                    <input type="text" value={newMember.password} onChange={e => setNewMember(p => ({ ...p, password: e.target.value }))} placeholder="temp1234!" style={inputStyle} />
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <div style={{ flex: 1 }}>
                    <label style={labelStyle}>이름 *</label>
                    <input type="text" value={newMember.name} onChange={e => setNewMember(p => ({ ...p, name: e.target.value }))} placeholder="홍길동" style={inputStyle} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={labelStyle}>닉네임 *</label>
                    <input type="text" value={newMember.nickName} onChange={e => setNewMember(p => ({ ...p, nickName: e.target.value }))} placeholder="hong" style={inputStyle} />
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <div style={{ width: 110 }}>
                    <label style={labelStyle}>국가코드</label>
                    <CountryCodeSelect
                      code={newMember.countryCode}
                      iso={newMember.countryIso}
                      onChange={c => setNewMember(p => ({ ...p, countryCode: c.countryCode, countryIso: c.countryIso, isForeigner: c.countryIso !== 'KR' }))}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={labelStyle}>전화번호</label>
                    <input type="text" value={newMember.phone} onChange={e => setNewMember(p => ({ ...p, phone: e.target.value.replace(/[^0-9]/g, '') }))} placeholder="미입력 시 자동생성" style={inputStyle} />
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <div style={{ flex: 1 }}>
                    <label style={labelStyle}>성별</label>
                    <select value={newMember.gender} onChange={e => setNewMember(p => ({ ...p, gender: e.target.value }))} style={inputStyle}>
                      <option value="">미선택</option>
                      <option value="Male">남성</option>
                      <option value="Female">여성</option>
                    </select>
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={labelStyle}>생년월일 (YYMMDD)</label>
                    <input type="text" value={newMember.birthDate} onChange={e => setNewMember(p => ({ ...p, birthDate: e.target.value.replace(/[^0-9]/g, '').slice(0, 6) }))} placeholder="850315" maxLength={6} style={inputStyle} />
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <div style={{ flex: 1, position: 'relative' }} ref={addMemberStoreRef}>
                    <label style={labelStyle}>소속 업체</label>
                    <input
                      type="text"
                      value={addMemberStoreOpen ? addMemberStoreSearch : (addMemberStoreId ? `${stores.find(s => s.id === addMemberStoreId)?.name || ''} #${addMemberStoreId}` : addMemberStoreSearch)}
                      onFocus={() => { setAddMemberStoreOpen(true); setAddMemberStoreSearch(''); }}
                      onChange={e => { setAddMemberStoreSearch(e.target.value); setAddMemberStoreOpen(true); if (addMemberStoreId) { setAddMemberStoreId(''); setAddMemberSelectedMember(null); setNewMember(p => ({ ...p, memberId: undefined })); } }}
                      placeholder="업체명 또는 ID 검색"
                      style={{ ...inputStyle, color: !addMemberStoreOpen && addMemberStoreId ? '#00cc6a' : '#e0e0e0' }}
                    />
                    {addMemberStoreOpen && (
                      <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, border: '1px solid #2a2a4a', borderRadius: 6, maxHeight: 150, overflowY: 'auto', marginTop: 2, background: '#0a0a15', zIndex: 10 }}>
                        {filteredStores.map(s => (
                          <div key={s.id} onClick={async () => {
                            setAddMemberStoreId(s.id);
                            setAddMemberStoreSearch('');
                            setAddMemberStoreOpen(false);
                            setAddMemberSelectedMember(null);
                            setNewMember(p => ({ ...p, memberId: undefined }));
                            setAddMemberMembersLoading(true);
                            try { const members = await getStoreMemberList(s.id); setAddMemberStoreMembers(members || []); } catch { setAddMemberStoreMembers([]); } finally { setAddMemberMembersLoading(false); }
                          }} style={{ padding: '6px 10px', cursor: 'pointer', fontSize: 12, color: addMemberStoreId === s.id ? '#00cc6a' : '#ccc', background: addMemberStoreId === s.id ? '#00cc6a11' : 'transparent', borderBottom: '1px solid #1a1a2e' }}>
                            {s.name} <span style={{ color: '#555' }}>#{s.id}</span>
                          </div>
                        ))}
                        {filteredStores.length === 0 && <div style={{ padding: '6px 10px', fontSize: 11, color: '#555' }}>검색 결과 없음</div>}
                      </div>
                    )}
                  </div>
                  <div style={{ flex: 1, position: 'relative' }} ref={addMemberMemberRef}>
                    <label style={labelStyle}>회원 연동</label>
                    <input
                      type="text"
                      value={addMemberMemberOpen ? addMemberMemberSearch : (addMemberSelectedMember ? `${addMemberSelectedMember.name} (${addMemberSelectedMember.phone})` : '')}
                      onFocus={() => { if (!addMemberStoreId) return; setAddMemberMemberOpen(true); setAddMemberMemberSearch(''); }}
                      onChange={e => { setAddMemberMemberSearch(e.target.value); setAddMemberMemberOpen(true); if (addMemberSelectedMember) { setAddMemberSelectedMember(null); setNewMember(p => ({ ...p, memberId: undefined })); } }}
                      placeholder={!addMemberStoreId ? '업체를 먼저 선택하세요' : (addMemberMembersLoading ? '회원 로딩 중...' : '미선택 (이름/전화번호 검색)')}
                      disabled={!addMemberStoreId || addMemberMembersLoading}
                      style={{ ...inputStyle, color: !addMemberMemberOpen && addMemberSelectedMember ? '#00cc6a' : '#e0e0e0' }}
                    />
                    {addMemberMemberOpen && addMemberStoreId && (
                      <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, border: '1px solid #2a2a4a', borderRadius: 6, maxHeight: 150, overflowY: 'auto', marginTop: 2, background: '#0a0a15', zIndex: 10 }}>
                        <div key="none" onClick={() => { setAddMemberSelectedMember(null); setAddMemberMemberSearch(''); setAddMemberMemberOpen(false); setNewMember(p => ({ ...p, memberId: undefined })); }} style={{ padding: '6px 10px', cursor: 'pointer', fontSize: 12, color: !addMemberSelectedMember ? '#ff8844' : '#888', background: !addMemberSelectedMember ? '#ff884411' : 'transparent', borderBottom: '1px solid #1a1a2e' }}>
                          미선택 (신규 계정)
                        </div>
                        {addMemberStoreMembers.filter(m => !addMemberMemberSearch || m.name.includes(addMemberMemberSearch) || m.phone.includes(addMemberMemberSearch)).map(m => (
                          <div key={m.id} onClick={() => {
                            setAddMemberSelectedMember(m);
                            setAddMemberMemberSearch('');
                            setAddMemberMemberOpen(false);
                            setNewMember(p => ({ ...p, memberId: m.id, name: p.name || m.name, phone: p.phone || m.phone }));
                          }} style={{ padding: '6px 10px', cursor: 'pointer', fontSize: 12, color: addMemberSelectedMember?.id === m.id ? '#00cc6a' : '#ccc', background: addMemberSelectedMember?.id === m.id ? '#00cc6a11' : 'transparent', borderBottom: '1px solid #1a1a2e' }}>
                            {m.name} <span style={{ color: '#555' }}>{m.phone}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div style={{ marginTop: 20, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                <button onClick={() => setShowAddMember(false)} style={{ padding: '8px 16px', fontSize: 13, borderRadius: 6, border: '1px solid #333', background: 'transparent', color: '#888', cursor: 'pointer', height: 38 }}>취소</button>
                <button
                  disabled={!canSubmit}
                  onClick={async () => {
                    try {
                      const payload = { ...newMember, memberId: addMemberSelectedMember?.id };
                      await createMemberAccount(payload);
                      alert('계정 생성 완료');
                      setShowAddMember(false);
                      setNewMember({ userId: '', password: '', name: '', nickName: '', phone: '', countryCode: '+82', countryIso: 'KR', gender: '', birthDate: '', isForeigner: false, memberId: undefined });
                      setAddMemberSelectedMember(null);
                      setAddMemberStoreId('');
                      getHubMembers(memberPage, 30, memberSearch || undefined)
                        .then(data => { setMembers(data.members || []); setMemberTotalCount(data.totalCount || 0); })
                        .catch(() => {});
                    } catch (e: any) { alert('생성 실패: ' + e.message); }
                  }}
                  style={{ padding: '8px 16px', fontSize: 13, borderRadius: 6, border: 'none', background: canSubmit ? '#00cc6a' : '#2a2a4a', color: canSubmit ? '#fff' : '#666', cursor: canSubmit ? 'pointer' : 'not-allowed', fontWeight: 600, height: 38 }}
                >계정 추가</button>
              </div>
            </div>
          </div>
        </div>
        );
      })()}

      {/* 업체 상세 모달 */}
      {modalStore && (
        <div className="modal-overlay" onClick={() => setModalStore(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 700 }}>
            <div className="modal-header">
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                {modalStore.logo && <img src={modalStore.logo.replace(/img_\d+x\d+/, 'img_110x110')} alt="" loading="lazy" width={32} height={32} style={{ width: 32, height: 32, borderRadius: 6, objectFit: 'cover' }} />}
                <h2>{modalStore.name} <span style={{ color: '#666', fontWeight: 'normal', fontSize: 13 }}>#{modalStore.id}</span></h2>
                {user.role === 'owner' && (
                  <button
                    title="업체 삭제"
                    onClick={async () => {
                      if (!window.confirm(`"${modalStore.name}" 업체를 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다.`)) return;
                      try {
                        await deleteStore(modalStore.id);
                        alert('업체가 삭제되었습니다.');
                        setModalStore(null);
                        setStores(prev => prev.filter(s => s.id !== modalStore.id));
                      } catch (e: any) { alert('삭제 실패: ' + e.message); }
                    }}
                    style={{ background: 'transparent', border: '1px solid #ff4444', cursor: 'pointer', fontSize: 11, color: '#ff4444', padding: '3px 8px', borderRadius: 4, fontWeight: 600 }}
                  >삭제</button>
                )}
              </div>
              <button className="close" onClick={() => setModalStore(null)}>&times;</button>
            </div>
            <div className="modal-body">

              {/* 검색노출 + 구독 상태 관리 */}
              <div style={{ display: 'flex', gap: 10, marginBottom: 14 }}>
                <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 14px', background: '#0a0a18', border: `1px solid ${modalStore.isView ? '#00cc6a33' : '#ff444433'}`, borderRadius: 8 }}>
                  <div>
                    <span style={{ fontSize: 13, color: '#e0e0e0' }}>검색노출</span>
                    <span style={{ fontSize: 11, color: modalStore.isView ? '#00cc6a' : '#ff4444', marginLeft: 8 }}>{modalStore.isView ? 'ON' : 'OFF'}</span>
                  </div>
                  <div
                    title={modalStore.isView ? '검색노출 OFF' : '검색노출 ON'}
                    onClick={async (e) => {
                      e.stopPropagation();
                      const next = !modalStore.isView;
                      if (!window.confirm(`${modalStore.name}을(를) 검색에서 ${next ? '노출' : '숨김'} 처리하시겠습니까?`)) return;
                      try {
                        await updateStoreVisibility(modalStore.id, next);
                        setModalStore({ ...modalStore, isView: next });
                        setStores(prev => prev.map(s => s.id === modalStore.id ? { ...s, isView: next } : s));
                      } catch (e: any) {
                        alert('변경 실패: ' + (e as Error).message);
                      }
                    }}
                    style={{ width: 36, height: 20, borderRadius: 10, background: modalStore.isView ? '#00cc6a' : '#444', cursor: 'pointer', position: 'relative', transition: 'background 0.2s', flexShrink: 0 }}
                  >
                    <div style={{ width: 16, height: 16, borderRadius: '50%', background: '#fff', position: 'absolute', top: 2, [modalStore.isView ? 'right' : 'left']: 2, transition: 'all 0.2s' }} />
                  </div>
                </div>
                {(() => {
                  const st = storeStatusMap.get(modalStore.id);
                  const sub = st?.subscribeStatus;
                  const isActive = sub === 1;     // 진행중
                  const isReserved = sub === 2;   // 해지예약 (결제일까지 유지, DB status와 동일)
                  const stColor = isActive ? '#00cc6a' : isReserved ? '#ffaa00' : '#ff4444';
                  const stLabel = isActive ? '진행중' : isReserved ? '해지예약' : '미구독';
                  const keepUntil = isReserved && st?.nextApprovalDate ? st.nextApprovalDate.slice(0, 10).replace(/-/g, '.') : null;
                  return (
                    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 14px', background: '#0a0a18', border: `1px solid ${stColor}33`, borderRadius: 8 }}>
                      <div>
                        <span style={{ fontSize: 13, color: '#e0e0e0' }}>구독 결제</span>
                        <span style={{ fontSize: 11, color: stColor, marginLeft: 8 }}>{stLabel}</span>
                        {keepUntil && <span style={{ fontSize: 11, color: '#888', marginLeft: 6 }}>~{keepUntil}까지 유지</span>}
                      </div>
                      <div
                        title={isActive ? '구독 끊기' : isReserved ? '해지예약 취소' : '구독 재개'}
                        onClick={async (e) => {
                          e.stopPropagation();
                          const confirmMsg = isActive
                            ? `${modalStore.name}의 구독을 종료하시겠습니까?\n(다음 결제일까지는 유지되며 이후 종료됩니다)`
                            : isReserved
                              ? `${modalStore.name}의 해지예약을 취소하고 구독을 재개하시겠습니까?`
                              : `${modalStore.name}의 구독을 재개하시겠습니까?`;
                          if (!window.confirm(confirmMsg)) return;
                          try {
                            if (isActive) {
                              await terminateSubscription(modalStore.id);
                            } else {
                              await reactivateSubscription(modalStore.id);
                            }
                            getStoreStatusSummary().then(setStoreStatusSummary).catch(() => {});
                          } catch (e: any) {
                            alert('변경 실패: ' + (e as Error).message);
                          }
                        }}
                        style={{ width: 36, height: 20, borderRadius: 10, background: isActive ? '#00cc6a' : isReserved ? '#ffaa00' : '#444', cursor: 'pointer', position: 'relative', transition: 'background 0.2s', flexShrink: 0 }}
                      >
                        <div style={{ width: 16, height: 16, borderRadius: '50%', background: '#fff', position: 'absolute', top: 2, [isActive ? 'right' : 'left']: 2, transition: 'all 0.2s' }} />
                      </div>
                    </div>
                  );
                })()}
              </div>

              {/* 현재 구독권 + 변경 */}
              <div style={{ padding: '12px 14px', background: '#0a0a18', border: '1px solid #2a2a4a', borderRadius: 8, marginBottom: 14 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                  <span style={{ fontSize: 13, color: '#e0e0e0' }}>현재 구독권</span>
                  {billingInfo?.currentPlanName ? (
                    <span style={{ fontSize: 13, color: '#00cc6a', fontWeight: 600 }}>
                      {billingInfo.currentPlanName}
                      {billingInfo.currentPrice != null && <span style={{ color: '#888', fontWeight: 400, marginLeft: 6 }}>{billingInfo.currentPrice.toLocaleString()}원{billingInfo.currentValidityDays != null && ` / ${billingInfo.currentValidityDays}일`}</span>}
                    </span>
                  ) : (
                    <span style={{ fontSize: 12, color: '#888' }}>{billingInfo?.currentItemName || '구독권 미연동'}</span>
                  )}
                </div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <select
                    value={planChangeSel}
                    onChange={(e) => setPlanChangeSel(e.target.value)}
                    style={{ flex: 1, padding: '6px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13 }}
                  >
                    <option value="">변경할 구독권 선택...</option>
                    {plans.filter(p => p.isActive).map(p => (
                      <option key={p.id} value={p.id} disabled={p.id === billingInfo?.currentPlanId}>
                        {p.planName} · {p.price.toLocaleString()}원 / {p.validityDays}일{p.id === billingInfo?.currentPlanId ? ' (현재)' : ''}
                      </option>
                    ))}
                  </select>
                  <button
                    disabled={!planChangeSel || planChanging}
                    onClick={handleChangeStorePlan}
                    style={{ padding: '6px 14px', background: planChangeSel ? '#00cc6a' : '#2a2a4a', border: 'none', borderRadius: 6, color: planChangeSel ? '#fff' : '#888', fontSize: 13, fontWeight: 600, cursor: planChangeSel && !planChanging ? 'pointer' : 'not-allowed', whiteSpace: 'nowrap' }}
                  >{planChanging ? '변경중...' : '변경'}</button>
                </div>
                <div style={{ fontSize: 11, color: '#666', marginTop: 6 }}>* 진행중인 구독이 있을 때만 변경되며, 다음 결제분부터 적용됩니다.</div>
              </div>

              {/* 다음 결제 예정일 */}
              {billingInfo?.nextApprovalDate && (
                <div style={{ padding: '12px 14px', background: '#0a0a18', border: '1px solid #2a2a4a', borderRadius: 8, marginBottom: 14 }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                    <span style={{ fontSize: 13, color: '#e0e0e0' }}>다음 결제 예정일</span>
                    <span style={{ fontSize: 14, color: '#00cc6a', fontWeight: 600 }}>{new Date(billingInfo.nextApprovalDate).toLocaleDateString('ko-KR')}</span>
                  </div>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <input
                      type="number"
                      placeholder="일수"
                      value={extendDays}
                      onChange={(e) => setExtendDays(e.target.value)}
                      style={{ width: 70, padding: '5px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13, boxSizing: 'border-box' }}
                    />
                    <span style={{ fontSize: 12, color: '#888' }}>일 연장</span>
                    {extendDays && Number(extendDays) !== 0 && (
                      <span style={{ fontSize: 12, color: '#fdcb6e', marginLeft: 4 }}>
                        → {new Date(new Date(billingInfo.nextApprovalDate).getTime() + Number(extendDays) * 86400000).toLocaleDateString('ko-KR')}
                      </span>
                    )}
                    <button
                      disabled={!extendDays || Number(extendDays) === 0 || extendLoading}
                      onClick={async () => {
                        if (!modalStore || !extendDays) return;
                        const days = Number(extendDays);
                        const newDate = new Date(new Date(billingInfo.nextApprovalDate!).getTime() + days * 86400000).toLocaleDateString('ko-KR');
                        if (!window.confirm(`${modalStore.name}의 결제 예정일을 ${days}일 ${days > 0 ? '연장' : '차감'}하시겠습니까?\n변경 후: ${newDate}`)) return;
                        setExtendLoading(true);
                        try {
                          await extendBillingDate(modalStore.id, days);
                          getStoreBilling(modalStore.id).then(setBillingInfo).catch(() => {});
                          setExtendDays('');
                        } catch (e: any) { alert('변경 실패: ' + e.message); }
                        setExtendLoading(false);
                      }}
                      style={{ marginLeft: 'auto', padding: '5px 12px', background: extendDays && Number(extendDays) !== 0 ? '#00cc6a' : '#2a2a4a', border: 'none', borderRadius: 6, color: extendDays && Number(extendDays) !== 0 ? '#fff' : '#888', fontSize: 12, fontWeight: 600, cursor: extendDays && Number(extendDays) !== 0 ? 'pointer' : 'not-allowed' }}
                    >{extendLoading ? '처리중...' : '적용'}</button>
                  </div>
                </div>
              )}

              {/* 비밀번호 초기화 — 탭과 무관하게 항상 노출 */}
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 12 }}>
                <button onClick={() => handlePwReset(null)} style={{ height: 32, padding: '0 12px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 6, color: '#fdcb6e', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>비밀번호 초기화</button>
                <button onClick={handleSecondPwReset} style={{ height: 32, padding: '0 12px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 6, color: '#74b9ff', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>2차 비밀번호 초기화</button>
              </div>

              {/* 1차 비밀번호 초기화 결과 배너 */}
              {pwReset && (
                <div style={{ padding: '12px 14px', background: '#0a0a18', border: '1px solid #fdcb6e55', borderRadius: 8, marginBottom: 12 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                    <span style={{ fontSize: 13, color: '#fdcb6e', fontWeight: 600 }}>임시 비밀번호 발급됨</span>
                    <button onClick={() => setPwReset(null)} style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', fontSize: 14 }}>&times;</button>
                  </div>
                  <div style={{ fontSize: 12, color: '#e0e0e0', lineHeight: 1.7 }}>
                    <div>대상: {pwReset.name ? `${pwReset.name} ` : ''}({pwReset.account}) · {pwReset.phone}</div>
                    <div>임시 비밀번호: <code style={{ background: '#1a1a2e', padding: '2px 8px', borderRadius: 4, color: '#00cc6a', fontWeight: 700, letterSpacing: 1 }}>{pwReset.tempPassword}</code></div>
                    <div>SMS 발송: <span style={{ color: pwReset.smsSuccess ? '#00cc6a' : '#ff4444' }}>{pwReset.smsSuccess ? '성공' : '실패'}</span>{pwReset.smsDescription ? ` — ${pwReset.smsDescription}` : ''}</div>
                  </div>
                </div>
              )}

              {/* 2차 비밀번호 초기화 결과 배너 */}
              {secondPwReset && (
                <div style={{ padding: '12px 14px', background: '#0a0a18', border: '1px solid #74b9ff55', borderRadius: 8, marginBottom: 12 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                    <span style={{ fontSize: 13, color: '#74b9ff', fontWeight: 600 }}>2차 비밀번호 초기화됨</span>
                    <button onClick={() => setSecondPwReset(null)} style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', fontSize: 14 }}>&times;</button>
                  </div>
                  <div style={{ fontSize: 12, color: '#e0e0e0', lineHeight: 1.7 }}>
                    <div>2차 비밀번호가 기본값 <code style={{ background: '#1a1a2e', padding: '2px 8px', borderRadius: 4, color: '#00cc6a', fontWeight: 700, letterSpacing: 1 }}>{secondPwReset.resetTo}</code>(으)로 초기화되었습니다.</div>
                    <div style={{ color: '#888' }}>{secondPwReset.alreadyDefault ? '이미 기본값 상태였습니다.' : '점주에게 로그인 후 2차 비밀번호 재설정을 안내해주세요.'}</div>
                  </div>
                </div>
              )}

              {/* 탭 바 — billingInfo 로딩과 무관하게 항상 렌더 (발신번호 탭은 billing 미연동) */}
              <div style={{ display: 'flex', gap: 4, marginBottom: 12 }}>
                <button className={`admin-tab-sm ${historyTab === 'billing' ? 'active' : ''}`} onClick={() => setHistoryTab('billing')}>결제 내역</button>
                <button className={`admin-tab-sm ${historyTab === 'coupon' ? 'active' : ''}`} onClick={() => setHistoryTab('coupon')}>쿠폰 내역</button>
                <button className={`admin-tab-sm ${historyTab === 'coaches' ? 'active' : ''}`} onClick={() => setHistoryTab('coaches')}>코치 정보</button>
                <button className={`admin-tab-sm ${historyTab === 'subaccount' ? 'active' : ''}`} onClick={() => setHistoryTab('subaccount')}>부계정 {subAccounts.length > 0 && `(${subAccounts.length})`}</button>
                <button className={`admin-tab-sm ${historyTab === 'sender' ? 'active' : ''}`} onClick={() => setHistoryTab('sender')}>발신번호</button>
              </div>

              {/* 발신번호 탭 — billingInfo 게이트 밖에서 렌더 */}
              {historyTab === 'sender' && (
                <StoreSenderNumberList storeId={modalStore.id} refreshTick={senderRefreshTick} onOpen={openSenderModal} />
              )}

              {/* 결제/쿠폰/코치/부계정 내역 (billingInfo 의존) */}
              {historyTab !== 'sender' && (billingInfo ? (
                <>
                  {historyTab === 'subaccount' && (<>
                    {/* 부계정 추가 */}
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 12 }}>
                      <button onClick={() => setSubForm(subForm && subForm.id === null ? null : { id: null, account: '', password: '', name: '', phone: '', role: [], isBilling: true })} style={{ marginLeft: 'auto', height: 32, padding: '0 14px', background: '#00cc6a', border: 'none', borderRadius: 6, color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>{subForm && subForm.id === null ? '취소' : '+ 부계정 추가'}</button>
                    </div>

                    {/* 추가/수정 폼 */}
                    {subForm && (
                      <div style={{ padding: '14px', background: '#0a0a18', border: '1px solid #2a2a4a', borderRadius: 8, marginBottom: 12 }}>
                        <div style={{ fontSize: 13, color: '#e0e0e0', fontWeight: 600, marginBottom: 10 }}>{subForm.id === null ? '부계정 추가' : '부계정 수정'}</div>
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>
                          {subForm.id === null && (<>
                            <input placeholder="계정(로그인 ID)" value={subForm.account} onChange={(e) => setSubForm({ ...subForm, account: e.target.value })} style={{ flex: 1, minWidth: 140, padding: '6px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13, boxSizing: 'border-box' }} />
                            <input placeholder="비밀번호" type="text" value={subForm.password} onChange={(e) => setSubForm({ ...subForm, password: e.target.value })} style={{ flex: 1, minWidth: 140, padding: '6px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13, boxSizing: 'border-box' }} />
                          </>)}
                          <input placeholder="이름" value={subForm.name} onChange={(e) => setSubForm({ ...subForm, name: e.target.value })} style={{ flex: 1, minWidth: 120, padding: '6px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13, boxSizing: 'border-box' }} />
                          <input placeholder="전화번호" value={subForm.phone} onChange={(e) => setSubForm({ ...subForm, phone: e.target.value })} style={{ flex: 1, minWidth: 120, padding: '6px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13, boxSizing: 'border-box' }} />
                        </div>
                        <div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>권한</div>
                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 10 }}>
                          {SUB_ACCOUNT_ROLES.map(r => {
                            const on = subForm.role.includes(r.code);
                            return (
                              <button key={r.code} onClick={() => setSubForm({ ...subForm, role: on ? subForm.role.filter(x => x !== r.code) : [...subForm.role, r.code] })} style={{ padding: '4px 10px', background: on ? '#00cc6a22' : '#0f0f1a', border: `1px solid ${on ? '#00cc6a' : '#2a2a4a'}`, borderRadius: 6, color: on ? '#00cc6a' : '#888', fontSize: 12, cursor: 'pointer' }}>{r.label}</button>
                            );
                          })}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#e0e0e0', cursor: 'pointer' }}>
                            <input type="checkbox" checked={subForm.isBilling} onChange={(e) => setSubForm({ ...subForm, isBilling: e.target.checked })} /> 과금 대상
                          </label>
                          <button disabled={subSaving} onClick={handleSubSave} style={{ marginLeft: 'auto', height: 32, padding: '0 16px', background: '#00cc6a', border: 'none', borderRadius: 6, color: '#fff', fontSize: 13, fontWeight: 600, cursor: subSaving ? 'not-allowed' : 'pointer' }}>{subSaving ? '저장중...' : '저장'}</button>
                          <button onClick={() => setSubForm(null)} style={{ height: 32, padding: '0 12px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 6, color: '#888', fontSize: 13, cursor: 'pointer' }}>취소</button>
                        </div>
                      </div>
                    )}

                    {/* 부계정 목록 */}
                    {subLoading ? (
                      <div style={{ padding: 20, textAlign: 'center', color: '#888', fontSize: 13 }}>불러오는 중...</div>
                    ) : subAccounts.length === 0 ? (
                      <div style={{ padding: 20, textAlign: 'center', color: '#888', fontSize: 13 }}>등록된 부계정이 없습니다.</div>
                    ) : (
                      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                        <thead>
                          <tr style={{ color: '#888', textAlign: 'left' }}>
                            <th style={{ padding: '6px 8px' }}>이름</th>
                            <th style={{ padding: '6px 8px' }}>계정</th>
                            <th style={{ padding: '6px 8px' }}>전화</th>
                            <th style={{ padding: '6px 8px' }}>권한</th>
                            <th style={{ padding: '6px 8px' }}>과금</th>
                            <th style={{ padding: '6px 8px', textAlign: 'right' }}>관리</th>
                          </tr>
                        </thead>
                        <tbody>
                          {subAccounts.map(sa => (
                            <tr key={sa.id} style={{ borderTop: '1px solid #1a1a2e', color: '#e0e0e0' }}>
                              <td style={{ padding: '8px' }}>{sa.name}{sa.teacherId && <span style={{ marginLeft: 6, fontSize: 10, color: '#4dabf7' }} title="코치 연동됨">●</span>}</td>
                              <td style={{ padding: '8px', color: '#aaa' }}>{sa.account}</td>
                              <td style={{ padding: '8px', color: '#aaa' }}>{sa.phone}</td>
                              <td style={{ padding: '8px' }}>
                                <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                                  {(sa.role ? sa.role.split(',').filter(Boolean) : []).map(code => {
                                    const r = SUB_ACCOUNT_ROLES.find(x => x.code === code);
                                    return <span key={code} style={{ padding: '2px 6px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 4, fontSize: 10, color: '#aaa' }}>{r ? r.label : code}</span>;
                                  })}
                                </div>
                              </td>
                              <td style={{ padding: '8px', color: sa.isBilling ? '#00cc6a' : '#888' }}>{sa.isBilling ? '과금' : '무료'}</td>
                              <td style={{ padding: '8px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                                <button onClick={() => setSubForm({ id: sa.id, account: sa.account, password: '', name: sa.name, phone: sa.phone, role: sa.role ? sa.role.split(',').filter(Boolean) : [], isBilling: sa.isBilling !== false })} style={{ padding: '4px 8px', background: 'none', border: '1px solid #2a2a4a', borderRadius: 4, color: '#aaa', fontSize: 11, cursor: 'pointer', marginRight: 4 }}>수정</button>
                                <button onClick={() => handlePwReset(sa)} style={{ padding: '4px 8px', background: 'none', border: '1px solid #fdcb6e55', borderRadius: 4, color: '#fdcb6e', fontSize: 11, cursor: 'pointer', marginRight: 4 }}>비번초기화</button>
                                <button onClick={() => handleSubDelete(sa)} style={{ padding: '4px 8px', background: 'none', border: '1px solid #ff444455', borderRadius: 4, color: '#ff4444', fontSize: 11, cursor: 'pointer' }}>삭제</button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </>)}
                  {historyTab === 'coupon' && (<>
                  {/* 쿠폰 지급 폼 */}
                  <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', flexWrap: 'wrap', marginBottom: 12 }}>
                    <div style={{ flex: 1, minWidth: 180 }}>
                      <label style={{ fontSize: 11, color: '#888', display: 'block', marginBottom: 4 }}>쿠폰 종류</label>
                      <select value={selectedCouponTypeId} onChange={(e) => setSelectedCouponTypeId(e.target.value)} style={{ width: '100%', padding: '6px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13 }}>
                        <option value="">선택하세요</option>
                        {couponTypes.map(c => (
                          <option key={c.id} value={c.id}>{c.couponName} ({c.validity}일) [{c.couponCategory === 'STARTING' ? '신규' : '일반'}]</option>
                        ))}
                      </select>
                    </div>
                    {(() => {
                      const ready = !!selectedCouponTypeId && !loading;
                      return <button onClick={handleIssue} disabled={!ready} style={{ height: 34, padding: '0 14px', background: ready ? '#00cc6a' : '#2a2a4a', border: ready ? 'none' : '1px solid #2a2a4a', borderRadius: 6, color: ready ? '#fff' : '#888', fontSize: 13, fontWeight: 600, cursor: ready ? 'pointer' : 'not-allowed' }}>
                        {loading ? '지급 중...' : '쿠폰 지급'}
                      </button>;
                    })()}
                    <button onClick={() => setShowAddForm(!showAddForm)} style={{ height: 34, padding: '0 14px', background: 'transparent', border: '1px solid #2a2a4a', borderRadius: 6, color: '#aaa', fontSize: 13, cursor: 'pointer' }}>+ 종류 추가</button>
                  </div>
                  {showAddForm && (
                    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', flexWrap: 'wrap', padding: '10px 12px', background: '#0a0a18', borderRadius: 8, border: '1px solid #00ff8830', marginBottom: 12 }}>
                      <div style={{ flex: 2, minWidth: 120 }}>
                        <label style={{ fontSize: 11, color: '#888', display: 'block', marginBottom: 4 }}>쿠폰명</label>
                        <input type="text" placeholder="7일 무료 체험권" value={newCoupon.couponName} onChange={(e) => setNewCoupon({ ...newCoupon, couponName: e.target.value })} style={{ width: '100%', padding: '6px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13, boxSizing: 'border-box' }} />
                      </div>
                      <div style={{ width: 60 }}>
                        <label style={{ fontSize: 11, color: '#888', display: 'block', marginBottom: 4 }}>일수</label>
                        <input type="number" placeholder="7" value={newCoupon.validity} onChange={(e) => setNewCoupon({ ...newCoupon, validity: e.target.value })} style={{ width: '100%', padding: '6px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13, boxSizing: 'border-box' }} />
                      </div>
                      <div style={{ width: 70 }}>
                        <label style={{ fontSize: 11, color: '#888', display: 'block', marginBottom: 4 }}>분류</label>
                        <select value={newCoupon.couponCategory} onChange={(e) => setNewCoupon({ ...newCoupon, couponCategory: e.target.value })} style={{ width: '100%', padding: '6px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13 }}>
                          <option value="GENERAL">일반</option>
                          <option value="STARTING">신규</option>
                        </select>
                      </div>
                      {(() => {
                        const ready = !!newCoupon.couponName && !!newCoupon.validity;
                        return <button onClick={handleAddCouponType} disabled={!ready} style={{ height: 34, padding: '0 12px', background: ready ? '#00cc6a' : '#2a2a4a', border: 'none', borderRadius: 6, color: ready ? '#fff' : '#888', fontSize: 13, fontWeight: 600, cursor: ready ? 'pointer' : 'not-allowed' }}>등록</button>;
                      })()}
                    </div>
                  )}
                  {(() => {
                    const toggleCouponSort = (key: string) => {
                      setCouponSort(prev => {
                        if (prev.key !== key) return { key, asc: true };
                        if (prev.asc) return { key, asc: false };
                        return { key: '', asc: true };
                      });
                      setCouponPage(1);
                    };
                    const cSortIcon = (key: string) => couponSort.key === key ? (couponSort.asc ? ' ▲' : ' ▼') : '';
                    const sorted = couponSort.key ? [...billingInfo.couponHistories].sort((a: any, b: any) => {
                      let av = couponSort.key === 'days' ? (a.startDate && a.endDate ? (new Date(a.endDate).getTime() - new Date(a.startDate).getTime()) : 0) : (a[couponSort.key] || '');
                      let bv = couponSort.key === 'days' ? (b.startDate && b.endDate ? (new Date(b.endDate).getTime() - new Date(b.startDate).getTime()) : 0) : (b[couponSort.key] || '');
                      const cmp = typeof av === 'number' ? av - bv : String(av).localeCompare(String(bv));
                      return couponSort.asc ? cmp : -cmp;
                    }) : billingInfo.couponHistories;
                    const total = sorted.length;
                    const totalPages = Math.ceil(total / 10);
                    const paged = sorted.slice((couponPage - 1) * 10, couponPage * 10);
                    return (
                    <>
                      <div style={{ fontSize: 12, color: '#666', marginBottom: 8 }}>{total}건</div>
                      {total === 0 ? (
                        <div style={{ padding: 16, textAlign: 'center', color: '#666', fontSize: 13, background: '#0f0f1a', borderRadius: 8 }}>쿠폰 지급내역이 없습니다.</div>
                      ) : (
                      <>
                      <table style={{ tableLayout: 'fixed', width: '100%' }}><thead><tr>
                        <th style={{ cursor: 'pointer' }} onClick={() => toggleCouponSort('couponName')}>쿠폰명{cSortIcon('couponName')}</th>
                        <th style={{ width: 65, cursor: 'pointer' }} onClick={() => toggleCouponSort('days')}>적용일수{cSortIcon('days')}</th>
                        <th style={{ width: 90, cursor: 'pointer' }} onClick={() => toggleCouponSort('startDate')}>시작일{cSortIcon('startDate')}</th>
                        <th style={{ width: 90, cursor: 'pointer' }} onClick={() => toggleCouponSort('endDate')}>종료일{cSortIcon('endDate')}</th>
                        <th style={{ width: 80, cursor: 'pointer' }} onClick={() => toggleCouponSort('requestedBy')}>요청자{cSortIcon('requestedBy')}</th>
                      </tr></thead><tbody>
                        {paged.map(c => {
                          const days = c.startDate && c.endDate ? Math.round((new Date(c.endDate).getTime() - new Date(c.startDate).getTime()) / (1000 * 60 * 60 * 24)) : '-';
                          const ct = c.couponTypeId ? couponTypes.find(t => t.id === c.couponTypeId) : null;
                          const isUnlimited = (ct && ct.validity >= 36500) || days >= 36500;
                          return (
                          <tr key={c.id}>
                            <td>{c.couponName}</td>
                            <td>{isUnlimited ? '∞' : `${days}일`}</td>
                            <td>{formatTime(c.startDate, true)}</td>
                            <td>{formatTime(c.endDate, true)}</td>
                            <td>{c.requestedBy || '-'}</td>
                          </tr>
                          );
                        })}
                      </tbody></table>
                      {totalPages > 1 && (
                        <div className="pagination" style={{ marginTop: 8 }}>
                          <button disabled={couponPage <= 1} onClick={() => setCouponPage(couponPage - 1)}>이전</button>
                          <span style={{ fontSize: 12, color: '#888' }}>{couponPage} / {totalPages}</span>
                          <button disabled={couponPage >= totalPages} onClick={() => setCouponPage(couponPage + 1)}>다음</button>
                        </div>
                      )}
                      </>
                      )}
                    </>
                    );
                  })()}
                  </>)}
                  {historyTab === 'coaches' && (
                    <div>
                      {billingInfo?.coaches && billingInfo.coaches.length > 0 ? (
                        <table>
                          <thead><tr>
                            <th>코치</th>
                            <th>전화번호</th>
                            <th style={{ textAlign: 'center' }}>회원 권한</th>
                            <th style={{ textAlign: 'center' }}>운동 권한</th>
                            <th style={{ textAlign: 'center' }}>매출 권한</th>
                            {user?.role === 'owner' && <th style={{ width: 50, textAlign: 'center' }}></th>}
                          </tr></thead>
                          <tbody>
                            {billingInfo.coaches.map((c, i) => (
                              <tr key={i}>
                                <td style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                  {c.profile ? <img src={c.profile.replace(/img_\d+x\d+/, 'img_110x110')} alt="" loading="lazy" width={28} height={28} style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover' }} /> : <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#2a2a4a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, color: '#888' }}>{c.name?.charAt(0)}</div>}
                                  <div>
                                    <div style={{ fontSize: 13 }}>{c.name}</div>
                                    <div style={{ fontSize: 11, color: '#666' }}>{c.linkCoachId}</div>
                                  </div>
                                </td>
                                <td>{c.phone}</td>
                                <td style={{ textAlign: 'center', color: c.isMemberAuth ? '#00cc6a' : '#666' }}>{c.isMemberAuth ? 'O' : '-'}</td>
                                <td style={{ textAlign: 'center', color: c.isExerciseAuth ? '#00cc6a' : '#666' }}>{c.isExerciseAuth ? 'O' : '-'}</td>
                                <td style={{ textAlign: 'center', color: c.isSalesAuth ? '#00cc6a' : '#666' }}>{c.isSalesAuth ? 'O' : '-'}</td>
                                {user?.role === 'owner' && (
                                  <td style={{ textAlign: 'center' }}>
                                    <button onClick={async () => {
                                      if (!window.confirm(`${c.name}(${c.phone}) 코치를 삭제하시겠습니까?\n\n이 코치의 레슨 배정도 함께 해제됩니다.`)) return;
                                      try {
                                        await deleteCoach(modalStore!.id, c.teacherId);
                                        getStoreBilling(modalStore!.id).then(setBillingInfo).catch(() => {});
                                      } catch (err: any) {
                                        alert(`삭제 실패: ${err.message}`);
                                      }
                                    }} style={{ padding: '2px 8px', fontSize: 11, background: 'transparent', border: '1px solid #ff4444', borderRadius: 4, color: '#ff4444', cursor: 'pointer' }}>삭제</button>
                                  </td>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                        <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>등록된 코치가 없습니다</div>
                      )}
                    </div>
                  )}
                  {historyTab === 'billing' && (() => {
                    const toggleBillingSort = (key: string) => {
                      setBillingSort(prev => {
                        if (prev.key !== key) return { key, asc: true };
                        if (prev.asc) return { key, asc: false };
                        return { key: '', asc: true };
                      });
                      setBillingPage(1);
                    };
                    const bSortIcon = (key: string) => billingSort.key === key ? (billingSort.asc ? ' ▲' : ' ▼') : '';
                    const filtered = billingInfo.billingHistories.filter(b => {
                      if (billingFilter === 'subscribe') return b.itemName?.includes('구독');
                      if (billingFilter === 'notification') return b.itemName?.includes('알림');
                      return true;
                    });
                    const sortedFiltered = billingSort.key ? [...filtered].sort((a: any, b: any) => {
                      const av = a[billingSort.key] || '';
                      const bv = b[billingSort.key] || '';
                      const cmp = typeof av === 'number' ? av - bv : String(av).localeCompare(String(bv));
                      return billingSort.asc ? cmp : -cmp;
                    }) : filtered;
                    const total = sortedFiltered.length;
                    const totalPages = Math.ceil(total / 10);
                    const safePage = Math.min(billingPage, totalPages || 1);
                    const paged = sortedFiltered.slice((safePage - 1) * 10, safePage * 10);
                    return (
                    <>
                      <div style={{ fontSize: 12, color: '#666', marginBottom: 8 }}>{total}건</div>
                      {(() => {
                        const all = billingInfo.billingHistories;
                        const totalAmt = all.reduce((s, b) => s + (b.price || 0), 0);
                        const subList = all.filter(b => b.itemName?.includes('구독'));
                        const notiList = all.filter(b => b.itemName?.includes('알림'));
                        const subAmt = subList.reduce((s, b) => s + (b.price || 0), 0);
                        const notiAmt = notiList.reduce((s, b) => s + (b.price || 0), 0);
                        return (
                          <div style={{ display: 'flex', gap: 16, marginBottom: 10, padding: '8px 12px', background: '#0f0f1a', borderRadius: 6, fontSize: 12 }}>
                            <span style={{ color: '#e0e0e0' }}>총 <strong style={{ color: '#4dabf7' }}>{totalAmt.toLocaleString()}원</strong></span>
                            <span style={{ color: '#888' }}>정기구독 <strong style={{ color: '#e0e0e0' }}>{subAmt.toLocaleString()}원</strong></span>
                            <span style={{ color: '#888' }}>알림 <strong style={{ color: '#e0e0e0' }}>{notiAmt.toLocaleString()}원</strong> <span style={{ color: '#666' }}>({(() => {
                              let kakao = 0, sms = 0, lms = 0;
                              notiList.forEach(b => {
                                const k = b.itemName?.match(/카카오 알림톡\((\d+)건\)/); if (k) kakao += Number(k[1]);
                                const s2 = b.itemName?.match(/SMS\((\d+)건\)/); if (s2) sms += Number(s2[1]);
                                const l = b.itemName?.match(/LMS\((\d+)건\)/); if (l) lms += Number(l[1]);
                              });
                              const parts: string[] = [];
                              if (kakao) parts.push(`카카오 ${kakao.toLocaleString()}건`);
                              if (sms) parts.push(`SMS ${sms.toLocaleString()}건`);
                              if (lms) parts.push(`LMS ${lms.toLocaleString()}건`);
                              return parts.length ? parts.join(', ') : `${notiList.length}건`;
                            })()})</span></span>
                          </div>
                        );
                      })()}
                      <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
                        {(['all', 'subscribe', 'notification'] as const).map(f => (
                          <button key={f} onClick={() => { setBillingFilter(f); setBillingPage(1); }}
                            style={{ padding: '4px 12px', fontSize: 12, borderRadius: 4, border: billingFilter === f ? '1px solid #4dabf7' : '1px solid #2a2a4a', background: billingFilter === f ? '#4dabf720' : 'transparent', color: billingFilter === f ? '#4dabf7' : '#888', cursor: 'pointer' }}>
                            {f === 'all' ? '전체' : f === 'subscribe' ? '정기구독권' : '문자'}
                          </button>
                        ))}
                      </div>
                      {total === 0 ? (
                        <div style={{ padding: 16, textAlign: 'center', color: '#666', fontSize: 13, background: '#0f0f1a', borderRadius: 8 }}>결제내역이 없습니다.</div>
                      ) : (
                      <>
                      <table style={{ tableLayout: 'fixed', width: '100%' }}><thead><tr>
                        <th>품목</th><th style={{ width: 80 }}>금액</th><th style={{ width: 110 }}>구매자</th><th style={{ width: 55 }}>상태</th>
                        <th style={{ width: 90, cursor: 'pointer' }} onClick={() => toggleBillingSort('approvalDate')}>결제일{bSortIcon('approvalDate')}</th>
                      </tr></thead><tbody>
                        {paged.map(b => (
                          <tr key={b.id}>
                            <td>{b.itemName}</td>
                            <td>{b.price?.toLocaleString()}원</td>
                            <td>{b.customerName}</td>
                            <td><span className={`status-badge ${b.status === 1 ? 'completed' : b.status === 4 ? 'failed' : b.status === 0 ? 'pending' : 'running'}`}>
                              {b.status === 0 ? '미결제' : b.status === 1 ? '성공' : b.status === 2 ? '에러' : b.status === 3 ? '환불신청' : b.status === 4 ? '환불' : b.status}
                            </span></td>
                            <td>{formatTime(b.approvalDate, true)}</td>
                          </tr>
                        ))}
                      </tbody></table>
                      {totalPages > 1 && (
                        <div className="pagination" style={{ marginTop: 8 }}>
                          <button disabled={safePage <= 1} onClick={() => setBillingPage(safePage - 1)}>이전</button>
                          <span style={{ fontSize: 12, color: '#888' }}>{safePage} / {totalPages}</span>
                          <button disabled={safePage >= totalPages} onClick={() => setBillingPage(safePage + 1)}>다음</button>
                        </div>
                      )}
                      </>
                      )}
                    </>
                    );
                  })()}

                </>
              ) : (
                <div style={{ padding: 24, textAlign: 'center', color: '#666', fontSize: 13 }}>내역 로딩 중...</div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* 발신번호 신청 상세/승인 모달 (큐 탭 + 업체 모달 탭 공용) */}
      {senderModalId != null && (
        <SenderNumberDetailModal
          id={senderModalId}
          onClose={closeSenderModal}
          onChanged={onSenderChanged}
        />
      )}
    </div>
  );
}

// ===== 발신번호 신청 큐 (도구 탭) =====
function SenderNumberQueue({ refreshTick, onOpen }: { refreshTick: number; onOpen: (id: number) => void }) {
  const [items, setItems] = useState<SenderNumberSummary[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(0); // 0-base (서버 page)
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  // 적용된 필터(조회 시점 확정)
  const [status, setStatus] = useState('');
  const [keyword, setKeyword] = useState('');
  // 입력 중인 키워드
  const [keywordInput, setKeywordInput] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    getSenderNumberApplications({ status: status || undefined, keyword: keyword || undefined, page, size: 20 })
      .then(res => {
        if (cancelled) return;
        setItems(res.content);
        setTotalCount(res.totalCount);
        setTotalPages(res.totalPages);
      })
      .catch(e => { if (!cancelled) setError(e?.message || '조회 실패'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [status, keyword, page, refreshTick]);

  const applyKeyword = () => { setKeyword(keywordInput.trim()); setPage(0); };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, gap: 8, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 12, color: '#666' }}>총 {totalCount}건</span>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <select
            value={status}
            onChange={(e) => { setStatus(e.target.value); setPage(0); }}
            style={{ padding: '6px 10px', fontSize: 12, borderRadius: 4, border: '1px solid #2a2a4a', background: '#1a1a2e', color: '#ccc' }}
          >
            <option value="">전체</option>
            <option value="APPLIED">신청</option>
            <option value="REVIEWING">검수중</option>
            <option value="APPROVED">승인</option>
            <option value="REJECTED">반려</option>
          </select>
          <input
            type="text"
            placeholder="별칭 또는 발신번호"
            value={keywordInput}
            onChange={(e) => setKeywordInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') applyKeyword(); }}
            style={{ width: 200, padding: '6px 10px', fontSize: 12, borderRadius: 4, border: '1px solid #2a2a4a', background: '#1a1a2e', color: '#ccc' }}
          />
          <button onClick={applyKeyword} style={{ padding: '6px 14px', fontSize: 12, borderRadius: 4, border: '1px solid #2a2a4a', background: 'transparent', color: '#ccc', cursor: 'pointer' }}>조회</button>
        </div>
      </div>
      {loading ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#888' }}>로딩 중...</div>
      ) : error ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#ff6b6b' }}>{error}</div>
      ) : items.length === 0 ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>신청 내역이 없습니다</div>
      ) : (
        <table>
          <thead><tr>
            <th>업체ID</th>
            <th>별칭</th>
            <th>발신번호</th>
            <th>상태</th>
            <th>신청일</th>
          </tr></thead>
          <tbody>
            {items.map(s => (
              <tr key={s.id} style={{ cursor: 'pointer' }} onClick={() => onOpen(s.id)}>
                <td>{s.storeId}</td>
                <td>{s.alias}</td>
                <td>{s.phoneNumber}</td>
                <td><SenderStatusBadge status={s.approvalStatus} /></td>
                <td>{formatTime(s.createdDate, true)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8, marginTop: 16 }}>
          <button disabled={page <= 0} onClick={() => setPage(p => p - 1)} style={{ padding: '4px 12px', fontSize: 12, borderRadius: 4, border: '1px solid #2a2a4a', background: 'transparent', color: page <= 0 ? '#444' : '#ccc', cursor: page <= 0 ? 'default' : 'pointer' }}>이전</button>
          <span style={{ fontSize: 12, color: '#888' }}>{page + 1} / {totalPages}</span>
          <button disabled={page >= totalPages - 1} onClick={() => setPage(p => p + 1)} style={{ padding: '4px 12px', fontSize: 12, borderRadius: 4, border: '1px solid #2a2a4a', background: 'transparent', color: page >= totalPages - 1 ? '#444' : '#ccc', cursor: page >= totalPages - 1 ? 'default' : 'pointer' }}>다음</button>
        </div>
      )}
    </div>
  );
}

// ===== 발신번호 신청 상세/승인 모달 (큐 + 업체 모달 공용) =====
function SenderNumberDetailModal({ id, onClose, onChanged }: { id: number; onClose: () => void; onChanged: () => void }) {
  const [detail, setDetail] = useState<SenderNumberDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [downloading, setDownloading] = useState<SenderDocType | null>(null);
  const [showReject, setShowReject] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const [rejectFields, setRejectFields] = useState<string[]>([]);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getSenderNumberApplication(id)
      .then(d => { if (!cancelled) setDetail(d); })
      .catch(() => { if (!cancelled) { alert('상세 조회 실패'); onClose(); } })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
    // onClose는 의존성에서 제외 — 포함 시 상위 1초 타이머 리렌더마다 재조회되어 모달이 깜빡임
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const approve = async () => {
    if (!window.confirm('이 발신번호 신청을 승인하시겠습니까?')) return;
    setSubmitting(true);
    try {
      await updateSenderNumberStatus(id, { status: 'APPROVED' });
      alert('승인되었습니다');
      onChanged();
    } catch (e: any) {
      alert(e?.message || '승인에 실패했습니다');
    } finally {
      setSubmitting(false);
    }
  };

  const reject = async () => {
    const reason = rejectReason.trim();
    if (!reason) { alert('반려 사유를 입력해주세요'); return; }
    setSubmitting(true);
    try {
      await updateSenderNumberStatus(id, { status: 'REJECTED', rejectionReason: reason, rejectedFields: rejectFields });
      alert('반려되었습니다');
      onChanged();
    } catch (e: any) {
      alert(e?.message || '반려에 실패했습니다');
    } finally {
      setSubmitting(false);
    }
  };

  const toggleRejectField = (key: string) =>
    setRejectFields(prev => prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]);

  const doDownload = async (type: SenderDocType, fileName: string | null) => {
    setDownloading(type);
    try {
      await downloadSenderNumberDocument(id, type, fileName || `sender-${id}-${type}`);
    } catch (e: any) {
      alert(e?.message || '다운로드에 실패했습니다');
    } finally {
      setDownloading(null);
    }
  };

  const canAct = detail && (detail.approvalStatus === 'APPLIED' || detail.approvalStatus === 'REVIEWING');
  const isCorporation = detail?.applicantType === 'CORPORATION';

  // 첨부 서류 목록 — 재직증명서는 법인만, 도장 원본 사진은 있을 때만 노출
  const docs: { label: string; url: string | null; fileName: string | null; type: SenderDocType }[] = detail ? [
    { label: '사업자등록증', url: detail.businessRegistrationUrl, fileName: detail.businessRegistrationFileName, type: 'business' },
    { label: '통신서비스 이용증명원', url: detail.telecomCertificateUrl, fileName: detail.telecomCertificateFileName, type: 'telecom' },
    { label: '신분증 사본', url: detail.idCardUrl, fileName: detail.idCardFileName, type: 'idCard' },
    { label: '인감 증명서', url: detail.sealCertificateUrl, fileName: detail.sealCertificateFileName, type: 'seal' },
    ...(isCorporation || detail.employmentCertificateUrl
      ? [{ label: '재직증명서', url: detail.employmentCertificateUrl, fileName: detail.employmentCertificateFileName, type: 'employment' as SenderDocType }]
      : []),
    { label: '위임장용 도장', url: detail.stampUrl, fileName: null, type: 'stamp' },
    ...(detail.stampOriginalUrl
      ? [{ label: '도장 원본 사진', url: detail.stampOriginalUrl, fileName: null, type: 'stampOriginal' as SenderDocType }]
      : []),
    { label: '위임장 PDF', url: detail.delegationUrl, fileName: null, type: 'delegation' },
  ] : [];

  const docRow = (label: string, url: string | null, fileName: string | null, type: SenderDocType) => (
    <div className="detail-row" key={type}>
      <div className="dl">{label}</div>
      <div className="dv">
        {fileName || url ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <span style={{ fontSize: 12, color: '#ccc' }}>{fileName || '첨부파일'}</span>
            {url && (
              <div
                onClick={() => window.open(url, '_blank')}
                title="클릭하면 원본 크기로 열립니다"
                style={{ position: 'relative', width: 220, height: 160, border: '1px solid #2a2a4a', borderRadius: 6, overflow: 'hidden', background: '#0a0a14', cursor: 'zoom-in' }}
              >
                <iframe
                  src={url}
                  title={label}
                  scrolling="no"
                  style={{ width: '100%', height: '100%', border: 'none', pointerEvents: 'none' }}
                />
              </div>
            )}
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
              {url && <button onClick={() => window.open(url, '_blank')} style={{ padding: '3px 10px', fontSize: 11, borderRadius: 4, border: '1px solid #2a2a4a', background: 'transparent', color: '#4dabf7', cursor: 'pointer' }}>크게 보기</button>}
              <button disabled={downloading === type} onClick={() => doDownload(type, fileName)} style={{ padding: '3px 10px', fontSize: 11, borderRadius: 4, border: '1px solid #2a2a4a', background: 'transparent', color: downloading === type ? '#666' : '#00ff88', cursor: downloading === type ? 'default' : 'pointer' }}>{downloading === type ? '다운로드 중...' : '다운로드'}</button>
            </div>
          </div>
        ) : <span style={{ fontSize: 12, color: '#666' }}>-</span>}
      </div>
    </div>
  );

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal sender-detail-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 520 }}>
        <div className="modal-header">
          <h2>발신번호 신청 #{id}</h2>
          <button className="close" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          {loading || !detail ? (
            <div style={{ padding: 24, textAlign: 'center', color: '#666', fontSize: 13 }}>로딩 중...</div>
          ) : (
            <>
              <div className="detail-row"><div className="dl">업체ID</div><div className="dv">{detail.storeId}</div></div>
              <div className="detail-row"><div className="dl">별칭</div><div className="dv">{detail.alias}</div></div>
              <div className="detail-row"><div className="dl">발신번호</div><div className="dv">{detail.countryCode ? `${detail.countryCode} ` : ''}{detail.phoneNumber}</div></div>
              <div className="detail-row"><div className="dl">사업자등록번호</div><div className="dv">{detail.businessNumber || '-'}</div></div>
              <div className="detail-row"><div className="dl">신청자 유형</div><div className="dv">{detail.applicantType ? SENDER_APPLICANT_TYPE_LABEL[detail.applicantType] || detail.applicantType : '-'}</div></div>
              <div className="detail-row"><div className="dl">주소</div><div className="dv">{detail.address || '-'}</div></div>
              <div className="detail-row"><div className="dl">약관동의일시</div><div className="dv">{formatTime(detail.agreedTermsAt)}</div></div>
              <div className="detail-row"><div className="dl">상태</div><div className="dv"><SenderStatusBadge status={detail.approvalStatus} /></div></div>
              <div className="detail-row"><div className="dl">신청일</div><div className="dv">{formatTime(detail.createdDate)}</div></div>
              <div className="detail-row"><div className="dl">만료일</div><div className="dv">{formatTime(detail.expiredDate)}</div></div>
              {detail.approvalStatus === 'REJECTED' && (
                <>
                  <div className="detail-row"><div className="dl">반려사유</div><div className="dv" style={{ color: '#ff8888' }}>{detail.rejectionReason || '-'}</div></div>
                  <div className="detail-row">
                    <div className="dl">반려항목</div>
                    <div className="dv">
                      {detail.rejectedFields?.length ? (
                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                          {detail.rejectedFields.map(k => (
                            <span key={k} style={{ padding: '2px 8px', fontSize: 11, borderRadius: 10, color: '#ff8888', background: 'rgba(255,107,107,0.08)', border: '1px solid #ff6b6b55' }}>{SENDER_REJECT_FIELD_LABEL[k] || k}</span>
                          ))}
                        </div>
                      ) : '-'}
                    </div>
                  </div>
                </>
              )}

              <h2 style={{ marginTop: 16, fontSize: 14 }}>첨부 서류</h2>
              {docs.map(d => docRow(d.label, d.url, d.fileName, d.type))}

              {canAct && (
                <div style={{ marginTop: 20, borderTop: '1px solid #23233a', paddingTop: 16 }}>
                  {!showReject ? (
                    <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                      <button disabled={submitting} onClick={() => setShowReject(true)} style={{ padding: '8px 18px', fontSize: 13, borderRadius: 6, border: '1px solid #ff6b6b55', background: 'rgba(255,107,107,0.08)', color: '#ff8888', cursor: submitting ? 'default' : 'pointer' }}>반려</button>
                      <button disabled={submitting} onClick={approve} style={{ padding: '8px 18px', fontSize: 13, borderRadius: 6, border: '1px solid #00ff8855', background: 'rgba(0,255,136,0.08)', color: '#00ff88', cursor: submitting ? 'default' : 'pointer' }}>{submitting ? '처리 중...' : '승인'}</button>
                    </div>
                  ) : (
                    <div>
                      <div style={{ fontSize: 12, color: '#888', marginBottom: 6 }}>반려 항목 (선택 — 신청 화면에서 빨간색으로 표시)</div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 12 }}>
                        {SENDER_REJECT_STEPS.map(step => (
                          <div key={step} style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                            <span style={{ fontSize: 11, color: '#666', width: 52, flexShrink: 0, paddingTop: 4 }}>{step}</span>
                            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                              {SENDER_REJECT_FIELDS.filter(f => f.step === step && (f.key !== 'EMPLOYMENT_CERTIFICATE' || isCorporation)).map(f => {
                                const on = rejectFields.includes(f.key);
                                return (
                                  <button
                                    key={f.key}
                                    type="button"
                                    disabled={submitting}
                                    onClick={() => toggleRejectField(f.key)}
                                    style={{ padding: '3px 10px', fontSize: 11, borderRadius: 12, border: `1px solid ${on ? '#ff6b6b' : '#2a2a4a'}`, background: on ? 'rgba(255,107,107,0.15)' : 'transparent', color: on ? '#ff8888' : '#aaa', cursor: submitting ? 'default' : 'pointer' }}
                                  >{f.label}</button>
                                );
                              })}
                            </div>
                          </div>
                        ))}
                      </div>
                      <div style={{ fontSize: 12, color: '#888', marginBottom: 6 }}>반려 사유 (필수)</div>
                      <textarea
                        value={rejectReason}
                        onChange={(e) => setRejectReason(e.target.value)}
                        rows={3}
                        placeholder="반려 사유를 입력해주세요"
                        style={{ width: '100%', padding: '8px 10px', fontSize: 13, borderRadius: 6, border: '1px solid #2a2a4a', background: '#0a0a14', color: '#e0e0e0', boxSizing: 'border-box', resize: 'vertical' }}
                      />
                      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8 }}>
                        <button disabled={submitting} onClick={() => { setShowReject(false); setRejectReason(''); setRejectFields([]); }} style={{ padding: '8px 16px', fontSize: 13, borderRadius: 6, border: '1px solid #2a2a4a', background: 'transparent', color: '#ccc', cursor: submitting ? 'default' : 'pointer' }}>취소</button>
                        <button disabled={submitting} onClick={reject} style={{ padding: '8px 16px', fontSize: 13, borderRadius: 6, border: '1px solid #ff6b6b55', background: 'rgba(255,107,107,0.08)', color: '#ff8888', cursor: submitting ? 'default' : 'pointer' }}>{submitting ? '처리 중...' : '반려 확정'}</button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// ===== 업체 모달 내 발신번호 신청 목록 =====
function StoreSenderNumberList({ storeId, refreshTick, onOpen }: { storeId: number; refreshTick: number; onOpen: (id: number) => void }) {
  const [items, setItems] = useState<SenderNumberSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    getSenderNumberApplications({ storeId, size: 50 })
      .then(res => { if (!cancelled) setItems(res.content); })
      .catch(e => { if (!cancelled) setError(e?.message || '조회 실패'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [storeId, refreshTick]);

  if (loading) return <div style={{ padding: 24, textAlign: 'center', color: '#666', fontSize: 13 }}>로딩 중...</div>;
  if (error) return <div style={{ padding: 24, textAlign: 'center', color: '#ff6b6b', fontSize: 13 }}>{error}</div>;
  if (items.length === 0) return <div style={{ padding: 24, textAlign: 'center', color: '#666', fontSize: 13 }}>신청 내역이 없습니다</div>;

  return (
    <table>
      <thead><tr>
        <th>별칭</th>
        <th>발신번호</th>
        <th>상태</th>
        <th style={{ width: 90 }}>신청일</th>
      </tr></thead>
      <tbody>
        {items.map(s => (
          <tr key={s.id} style={{ cursor: 'pointer' }} onClick={() => onOpen(s.id)}>
            <td>{s.alias}</td>
            <td>{s.phoneNumber}</td>
            <td><SenderStatusBadge status={s.approvalStatus} /></td>
            <td>{formatTime(s.createdDate, true)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// 어드민 메시징 탭 공통 스타일
const ADMIN_CARD_STYLE: React.CSSProperties = {
  background: 'linear-gradient(180deg, #11111c 0%, #0d0d18 100%)',
  border: '1px solid #1f1f33',
  borderRadius: 10,
  padding: 20,
  boxShadow: '0 2px 12px rgba(0,0,0,0.2)',
};

const ADMIN_INPUT_STYLE: React.CSSProperties = {
  width: '100%',
  padding: '9px 12px',
  background: '#0a0a14',
  border: '1px solid #23233a',
  borderRadius: 6,
  color: '#e0e0e0',
  fontSize: 13,
  boxSizing: 'border-box',
  outline: 'none',
  transition: 'border-color 120ms ease',
};

const ADMIN_ERROR_STYLE: React.CSSProperties = {
  padding: '8px 12px',
  marginBottom: 10,
  background: 'rgba(255,85,85,0.08)',
  border: '1px solid rgba(255,85,85,0.3)',
  borderRadius: 6,
  color: '#ff8888',
  fontSize: 12,
};

function primaryButtonStyle(loading: boolean, disabled: boolean): React.CSSProperties {
  const off = loading || disabled;
  return {
    width: '100%',
    padding: '11px',
    borderRadius: 6,
    border: off ? '1px solid #2a2a4a' : '1px solid #00cc6a',
    background: off ? 'transparent' : 'linear-gradient(180deg, #00d672, #00b85e)',
    color: off ? (loading ? '#00cc6a' : '#555') : '#001a0c',
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: '0.02em',
    cursor: loading ? 'wait' : (disabled ? 'not-allowed' : 'pointer'),
    transition: 'all 120ms ease',
    boxShadow: off ? 'none' : '0 2px 8px rgba(0,204,106,0.18)',
  };
}

function Field({ label, right, children }: { label: string; right?: React.ReactNode; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 5 }}>
        <label style={{ fontSize: 11, color: '#888', fontWeight: 500, letterSpacing: '0.02em' }}>{label}</label>
        {right}
      </div>
      {children}
    </div>
  );
}

// 본문 byte 길이 (한글=2, ASCII=1 단순 추정, NCP 기준과 동일)
function calcByteLength(s: string): number {
  let len = 0;
  for (let i = 0; i < s.length; i++) {
    len += s.charCodeAt(i) > 127 ? 2 : 1;
  }
  return len;
}

function AdminSendHistoryTable({ sendType }: { sendType: 'CUSTOM' | 'SIGNUP_ADMIN' }) {
  const [items, setItems] = useState<AdminMessageSendItem[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const size = 10;
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    setLoading(true);
    getAdminSendHistory({ sendType, page, size })
      .then((data: AdminSendHistoryResponse) => { setItems(data.items || []); setTotal(data.total || 0); })
      .catch(() => { setItems([]); setTotal(0); })
      .finally(() => setLoading(false));
  }, [sendType, page, reloadKey]);

  const totalPages = Math.max(1, Math.ceil(total / size));
  const isSignup = sendType === 'SIGNUP_ADMIN';

  return (
    <div style={{ marginTop: 28 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
        <h4 style={{ margin: 0, fontSize: 13, color: '#cdd6e0', fontWeight: 600, letterSpacing: '-0.01em' }}>
          발송 이력 <span style={{ color: '#666', fontWeight: 400, marginLeft: 6 }}>{total.toLocaleString()}건</span>
        </h4>
        <button onClick={() => setReloadKey(k => k + 1)} title="새로고침" style={{ padding: '5px 12px', fontSize: 11, borderRadius: 4, border: '1px solid #2a2a4a', background: 'transparent', color: '#aaa', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 4 }}>↻ 새로고침</button>
      </div>
      {loading ? (
        <div style={{ padding: 32, textAlign: 'center', color: '#888', fontSize: 13, background: '#0c0c16', border: '1px solid #1f1f33', borderRadius: 8 }}>로딩 중...</div>
      ) : items.length === 0 ? (
        <div style={{ padding: 32, textAlign: 'center', color: '#666', fontSize: 13, background: '#0c0c16', border: '1px solid #1f1f33', borderRadius: 8 }}>이력이 없습니다</div>
      ) : (
        <>
          <div style={{ background: '#0c0c16', border: '1px solid #1f1f33', borderRadius: 8, overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
              <thead>
                <tr style={{ background: '#13131f' }}>
                  <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500, color: '#888', borderBottom: '1px solid #1f1f33', whiteSpace: 'nowrap' }}>일시</th>
                  <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500, color: '#888', borderBottom: '1px solid #1f1f33' }}>수신자</th>
                  <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500, color: '#888', borderBottom: '1px solid #1f1f33', whiteSpace: 'nowrap' }}>발신</th>
                  <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500, color: '#888', borderBottom: '1px solid #1f1f33' }}>본문</th>
                  <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500, color: '#888', borderBottom: '1px solid #1f1f33' }}>결과</th>
                  {!isSignup && <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500, color: '#888', borderBottom: '1px solid #1f1f33' }}>발송자</th>}
                </tr>
              </thead>
              <tbody>
                {items.map((it, i) => (
                  <tr key={it.id} style={{ borderBottom: i < items.length - 1 ? '1px solid #16162a' : 'none' }}>
                    <td style={{ padding: '10px 12px', color: '#aaa', whiteSpace: 'nowrap' }}>{it.createdDate?.slice(0, 16).replace('T', ' ')}</td>
                    <td style={{ padding: '10px 12px', whiteSpace: 'nowrap' }}>
                      <div style={{ color: '#e0e0e0', fontWeight: 500 }}>{it.name || <span style={{ color: '#555' }}>—</span>}</div>
                      <div style={{ color: '#888', fontSize: 11 }}>{it.countryCode} {it.phone}</div>
                      {isSignup && (
                        <div style={{ color: '#666', fontSize: 11 }}>
                          {it.birthDay ? `생년 ${it.birthDay.slice(0, 4)}-${it.birthDay.slice(4, 6)}-${it.birthDay.slice(6, 8)}` : <span style={{ color: '#444' }}>생년월일 —</span>}
                        </div>
                      )}
                    </td>
                    <td style={{ padding: '10px 12px', whiteSpace: 'nowrap', color: '#888' }}>{it.sender}</td>
                    <td style={{ padding: '10px 12px', maxWidth: 280, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#cdd6e0' }} title={it.content}>{it.title ? <b style={{ color: '#aaa' }}>[{it.title}] </b> : null}{it.content}</td>
                    <td style={{ padding: '10px 12px', whiteSpace: 'nowrap' }}>
                      {it.success
                        ? <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 3, background: 'rgba(0, 204, 106, 0.12)', color: '#00cc6a', fontWeight: 500 }}>성공</span>
                        : <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 3, background: 'rgba(255, 85, 85, 0.12)', color: '#ff5555', fontWeight: 500 }} title={it.description || ''}>실패 {it.returnCode}</span>}
                    </td>
                    {!isSignup && <td style={{ padding: '10px 12px', color: '#888' }}>{it.sendUserId}</td>}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {totalPages > 1 && (
            <div style={{ display: 'flex', justifyContent: 'center', gap: 10, marginTop: 14, alignItems: 'center' }}>
              <button disabled={page <= 1} onClick={() => setPage(page - 1)} style={{ padding: '6px 14px', fontSize: 12, borderRadius: 4, border: '1px solid #2a2a4a', background: 'transparent', color: page <= 1 ? '#444' : '#aaa', cursor: page <= 1 ? 'not-allowed' : 'pointer' }}>이전</button>
              <span style={{ fontSize: 12, color: '#cdd6e0', minWidth: 60, textAlign: 'center' }}>{page} <span style={{ color: '#555' }}>/</span> {totalPages}</span>
              <button disabled={page >= totalPages} onClick={() => setPage(page + 1)} style={{ padding: '6px 14px', fontSize: 12, borderRadius: 4, border: '1px solid #2a2a4a', background: 'transparent', color: page >= totalPages ? '#444' : '#aaa', cursor: page >= totalPages ? 'not-allowed' : 'pointer' }}>다음</button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

function AdminSmsSendTab() {
  const [countryCode, setCountryCode] = useState('+82');
  const [phone, setPhone] = useState('');
  const [recipientName, setRecipientName] = useState('');
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState<AdminSmsSendResult | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [historyKey, setHistoryKey] = useState(0);

  const byteLen = calcByteLength(content);
  const isLms = byteLen >= 90 || !!title.trim();

  const send = async () => {
    setError(null);
    if (!phone.trim()) { setError('전화번호를 입력하세요'); return; }
    if (!content.trim()) { setError('본문을 입력하세요'); return; }
    if (!window.confirm(`${countryCode} ${phone} ${recipientName ? `(${recipientName})` : ''} 으로 ${isLms ? 'LMS' : 'SMS'} 발송할까요?`)) return;
    setSending(true);
    try {
      const r = await sendAdminSms({
        sendType: 'CUSTOM',
        title: title.trim() || undefined,
        content,
        recipients: [{ countryCode, phone, name: recipientName.trim() || undefined }],
      });
      setResult(r);
      setHistoryKey(k => k + 1);
    } catch (e: any) {
      setError(e.message || '발송 실패');
    } finally {
      setSending(false);
    }
  };

  return (
    <div>
      <div style={ADMIN_CARD_STYLE}>
        <div style={{ marginBottom: 16 }}>
          <h3 style={{ margin: '0 0 4px', fontSize: 15, color: '#e0e0e0', fontWeight: 600, letterSpacing: '-0.01em' }}>관리자 커스텀 문자 발송</h3>
          <div style={{ fontSize: 11, color: '#777', lineHeight: 1.5 }}>발신번호 <b style={{ color: '#aaa' }}>070</b> 고정 · 업체 과금 미포함 · 본문 90 byte 이상 또는 제목 입력 시 LMS</div>
        </div>

        <Field label="수신자">
          <div style={{ display: 'flex', gap: 8 }}>
            <select value={countryCode} onChange={e => setCountryCode(e.target.value)} style={{ ...ADMIN_INPUT_STYLE, width: 80, flex: 'none', padding: '8px' }}>
              <option value="+82">+82</option>
              <option value="+1">+1</option>
              <option value="+81">+81</option>
              <option value="+86">+86</option>
              <option value="+84">+84</option>
            </select>
            <input
              type="tel"
              placeholder="01012345678"
              value={phone}
              onChange={e => setPhone(e.target.value)}
              style={{ ...ADMIN_INPUT_STYLE, flex: 1 }}
            />
          </div>
        </Field>

        <Field label="이름 (선택)">
          <input
            type="text"
            placeholder="홍길동"
            value={recipientName}
            onChange={e => setRecipientName(e.target.value)}
            style={ADMIN_INPUT_STYLE}
          />
        </Field>

        <Field label="LMS 제목 (선택)">
          <input
            type="text"
            placeholder="[Linko] 안내"
            value={title}
            onChange={e => setTitle(e.target.value)}
            maxLength={60}
            style={ADMIN_INPUT_STYLE}
          />
        </Field>

        <Field label="본문" right={
          <span style={{ fontSize: 11, color: '#666' }}>
            {byteLen} byte · {content.length}자
            <span style={{ marginLeft: 8, padding: '1px 8px', borderRadius: 3, fontWeight: 600, fontSize: 10, letterSpacing: '0.03em', background: isLms ? '#2a2a4a' : '#1a3a5a', color: '#cdd6e0' }}>{isLms ? 'LMS' : 'SMS'}</span>
          </span>
        }>
          <textarea
            placeholder="본문을 입력하세요"
            value={content}
            onChange={e => setContent(e.target.value)}
            rows={6}
            style={{ ...ADMIN_INPUT_STYLE, resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.5 }}
          />
        </Field>

        {error && <div style={ADMIN_ERROR_STYLE}>{error}</div>}

        <button
          onClick={send}
          disabled={sending || !phone.trim() || !content.trim()}
          style={primaryButtonStyle(sending, !phone.trim() || !content.trim())}
        >{sending ? '발송 중...' : '문자 발송'}</button>

        {result && (
          <div style={{ marginTop: 16, padding: 14, borderRadius: 6, background: result.successCount > 0 ? 'linear-gradient(180deg, rgba(0,204,106,0.08), rgba(0,204,106,0.02))' : 'linear-gradient(180deg, rgba(255,85,85,0.08), rgba(255,85,85,0.02))', border: `1px solid ${result.successCount > 0 ? 'rgba(0,204,106,0.4)' : 'rgba(255,85,85,0.4)'}` }}>
            <div style={{ fontSize: 13, marginBottom: 8, color: result.successCount > 0 ? '#00cc6a' : '#ff5555', fontWeight: 600 }}>
              {result.successCount > 0 ? '발송 완료' : '발송 실패'}
              <span style={{ color: '#888', fontWeight: 400, marginLeft: 8, fontSize: 11 }}>{result.smsType} · 발신 {result.sender}</span>
            </div>
            {result.results.map((r, i) => (
              <div key={i} style={{ fontSize: 12, color: r.success ? '#aaa' : '#ff8888', padding: '3px 0' }}>
                <span style={{ display: 'inline-block', width: 14, color: r.success ? '#00cc6a' : '#ff5555' }}>{r.success ? '✓' : '✗'}</span>
                {r.countryCode} {r.phone} <span style={{ color: '#666' }}>— {r.success ? `성공 (${r.returnCode})` : `실패 (${r.returnCode}: ${r.description})`}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      <AdminSendHistoryTable key={historyKey} sendType="CUSTOM" />
    </div>
  );
}

// 백엔드가 실제 발송한 본문(content)이 내려오기 전까지의 폴백.
// Link_Dev_Back HubMessagingService 의 본문 템플릿과 동일 문구를 유지해야 한다.
function buildVerifiedCodeFallbackContent(authNumber: string, expirationDate: string, countryCode: string): string {
  const d = new Date(expirationDate);
  const valid = !isNaN(d.getTime());

  if (countryCode === '+82') {
    const label = valid ? `${d.getMonth() + 1}월 ${d.getDate()}일 ${String(d.getHours()).padStart(2, '0')}시` : '';
    return `링코 관리자 발급 본인확인 인증번호 [${authNumber}] (타인 노출 금지)\n\n위 번호는 일회성 인증번호로 ${label}까지 사용가능합니다.`;
  }

  const pad = (n: number) => String(n).padStart(2, '0');
  const label = valid
    ? `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())} (KST)`
    : '';
  return `[Linko]\nYour verification code is ${authNumber}\nDo not share this code with anyone.\n\nThis code is valid until ${label}.`;
}

function AdminVerifiedCodeSendTab() {
  const [name, setName] = useState('');
  const [birth, setBirth] = useState('');
  const [countryCode, setCountryCode] = useState('+82');
  const [countryIso, setCountryIso] = useState('KR');              // 같은 코드를 쓰는 국가 구분용 (+1 US/CA 등)
  const [sentCountryCode, setSentCountryCode] = useState('+82');  // 발급 시점 국가코드 고정 (입력칸 수정에 영향 안 받도록)
  const [phone, setPhone] = useState('');
  const [copied, setCopied] = useState(false);
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState<AdminVerifiedCodeSendResult | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [historyKey, setHistoryKey] = useState(0);
  // 가입 실패자 명단 상태
  const [failed, setFailed] = useState<RegistrationFailedMembersResponse | null>(null);
  const [failedLoading, setFailedLoading] = useState(false);
  const [failedError, setFailedError] = useState<string | null>(null);
  const [failedSearch, setFailedSearch] = useState('');
  const [failedValidOnly, setFailedValidOnly] = useState(false);
  const [failedPage, setFailedPage] = useState(1);
  const failedPageSize = 10;

  const loadFailed = useCallback(() => {
    setFailedLoading(true);
    setFailedError(null);
    getRegistrationFailedMembers()
      .then(setFailed)
      .catch((e: any) => setFailedError(e?.message || '명단 조회 실패'))
      .finally(() => setFailedLoading(false));
  }, []);

  useEffect(() => { loadFailed(); }, [loadFailed]);

  const validCount = failed ? failed.members.filter(m => !m.expired).length : 0;

  const filteredFailed: RegistrationFailedMember[] = (() => {
    if (!failed) return [];
    const q = failedSearch.trim();
    const norm = q.replace(/[-\s]/g, '').toLowerCase();
    return failed.members.filter(m => {
      if (failedValidOnly && m.expired) return false;
      if (!q) return true;
      const phoneNorm = (m.phone || '').replace(/[-\s]/g, '');
      const nameNorm = (m.name || '').toLowerCase();
      return phoneNorm.includes(norm) || nameNorm.includes(q);
    });
  })();

  useEffect(() => { setFailedPage(1); }, [failedSearch, failedValidOnly]);
  const failedTotalPages = Math.max(1, Math.ceil(filteredFailed.length / failedPageSize));
  const pagedFailed = filteredFailed.slice((failedPage - 1) * failedPageSize, failedPage * failedPageSize);

  const selectMember = (m: RegistrationFailedMember) => {
    setName(m.name || '');
    setBirth(m.birthDay || '');
    setCountryCode(m.countryCode || '+82');
    setCountryIso('');  // 명단에는 iso 가 없어 코드로만 매칭한다 (+1 처럼 중복 코드는 가중치 상위 국가로 선택됨)
    setPhone(m.phone || '');
    setResult(null);
    setError(null);
  };

  const send = async () => {
    setError(null);
    // 국가코드는 목록에서만 선택되므로 원문 그대로 쓴다 ('+1-340' 처럼 지역번호가 붙은 값 보존)
    const cc = countryCode.trim();
    const normalizedCc = cc.startsWith('+') ? cc : `+${cc}`;
    const digits = phone.replace(/[^\d]/g, '');

    if (!name.trim()) { setError('이름을 입력하세요'); return; }
    if (!/^\d{8}$/.test(birth)) { setError('생년월일을 YYYYMMDD 형식으로 입력하세요'); return; }
    if (!/^\+\d{1,4}(-\d{1,6})?$/.test(normalizedCc)) { setError('국가코드를 선택하세요'); return; }
    if (!/^\d{6,15}$/.test(digits)) { setError('전화번호를 숫자 6~15자리로 입력하세요'); return; }
    // 회원이 앱에서 입력하는 번호와 그대로 대조되므로, 국가코드를 뺀 현지 번호를 그대로 보낸다
    if (!window.confirm(`${name} (${normalizedCc} ${digits}) 에게 인증번호를 발급할까요?`)) return;
    setSending(true);
    setCopied(false);
    try {
      const r = await sendAdminVerifiedCode({ name, birth, countryCode: normalizedCc, phone: digits });
      setSentCountryCode(normalizedCc);
      setResult(r);
      setHistoryKey(k => k + 1);
    } catch (e: any) {
      setError(e.message || '발급 실패');
    } finally {
      setSending(false);
    }
  };

  const resultContent = result
    ? (result.content || buildVerifiedCodeFallbackContent(result.authNumber, result.expirationDate, result.countryCode || sentCountryCode))
    : '';

  const copyContent = async () => {
    try {
      await navigator.clipboard.writeText(resultContent);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setError('클립보드 복사에 실패했습니다. 본문을 직접 선택해 복사하세요');
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'flex-start' }}>
      <div style={{ ...ADMIN_CARD_STYLE, width: 400, flexShrink: 0 }}>
        <div style={{ marginBottom: 16 }}>
          <h3 style={{ margin: '0 0 4px', fontSize: 15, color: '#e0e0e0', fontWeight: 600, letterSpacing: '-0.01em' }}>관리자 발급 인증번호</h3>
          <div style={{ fontSize: 11, color: '#777', lineHeight: 1.5 }}>국내 발신번호 <b style={{ color: '#aaa' }}>010</b> · 해외 국제발신 · 12시간 유효 · 회원이 입력한 인증번호와 일치 시 본인확인 완료</div>
          <div style={{ fontSize: 11, color: '#777', lineHeight: 1.5, marginTop: 3 }}>문자 발송이 실패해도 인증번호는 발급됩니다 — 아래 본문을 복사해 직접 전달하세요</div>
        </div>

        <Field label="이름">
          <input
            type="text"
            placeholder="홍길동"
            value={name}
            onChange={e => setName(e.target.value)}
            style={ADMIN_INPUT_STYLE}
          />
        </Field>

        <Field label="생년월일">
          <input
            type="text"
            placeholder="YYYYMMDD"
            value={birth}
            onChange={e => setBirth(e.target.value.replace(/\D/g, '').slice(0, 8))}
            style={ADMIN_INPUT_STYLE}
          />
        </Field>

        <Field label="휴대폰">
          <div style={{ display: 'flex', gap: 8 }}>
            <CountryCodeSelect
              code={countryCode}
              iso={countryIso}
              width={110}
              onChange={c => { setCountryCode(c.countryCode); setCountryIso(c.countryIso); }}
            />
            <input
              type="tel"
              placeholder={countryCode === '+82' ? '010xxxxxxxx' : '국가코드 제외 번호'}
              value={phone}
              onChange={e => setPhone(e.target.value)}
              style={{ ...ADMIN_INPUT_STYLE, flex: 1 }}
            />
          </div>
          <div style={{ fontSize: 10, color: '#666', marginTop: 5, lineHeight: 1.5 }}>회원이 앱 가입 시 입력하는 번호와 똑같이 넣어야 인증이 됩니다 (국가코드 제외)</div>
        </Field>

        {error && <div style={ADMIN_ERROR_STYLE}>{error}</div>}

        <button
          onClick={send}
          disabled={sending || !name.trim() || !birth || !phone.trim()}
          style={primaryButtonStyle(sending, !name.trim() || !birth || !phone.trim())}
        >{sending ? '발급 중...' : '인증번호 발급'}</button>

        {result && (
          <div style={{ marginTop: 16, padding: 18, borderRadius: 8, background: result.smsResult.success ? 'linear-gradient(180deg, rgba(0,204,106,0.08), rgba(0,204,106,0.02))' : 'linear-gradient(180deg, rgba(255,85,85,0.08), rgba(255,85,85,0.02))', border: `1px solid ${result.smsResult.success ? 'rgba(0,204,106,0.4)' : 'rgba(255,85,85,0.4)'}` }}>
            <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 6 }}>인증번호</div>
            <div style={{ fontSize: 38, fontWeight: 700, fontFamily: 'SF Mono, Menlo, monospace', letterSpacing: '0.15em', color: '#fff', marginBottom: 14, lineHeight: 1 }}>{result.authNumber}</div>
            <div style={{ fontSize: 12, color: '#aaa', marginBottom: 4 }}>
              <span style={{ color: '#666' }}>만료</span> {result.expirationDate?.replace('T', ' ').slice(0, 16)}
            </div>
            <div style={{ fontSize: 13, fontWeight: 700, color: result.smsResult.success ? '#00cc6a' : '#ff5555', display: 'flex', alignItems: 'center', gap: 6 }}>
              <span>{result.smsResult.success ? '✓' : '✗'}</span>
              {result.smsResult.success ? '발송완료!' : '발송 실패'}
            </div>
            {!result.smsResult.success && (
              <div style={{ fontSize: 11, color: '#aaa', marginTop: 6, lineHeight: 1.5 }}>인증번호는 정상 발급되었습니다. 아래 본문을 복사해 직접 전달하세요</div>
            )}

            <div style={{ marginTop: 16, paddingTop: 14, borderTop: '1px solid rgba(255,255,255,0.07)' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: '0.08em' }}>발송 본문</div>
                <button
                  onClick={copyContent}
                  style={{ padding: '4px 12px', fontSize: 11, fontWeight: 600, borderRadius: 5, cursor: 'pointer', border: `1px solid ${copied ? '#00cc6a' : '#2a2a4a'}`, background: 'transparent', color: copied ? '#00cc6a' : '#aab', transition: 'all 120ms ease' }}
                >{copied ? '복사됨 ✓' : '복사'}</button>
              </div>
              <div style={{ padding: '12px 14px', borderRadius: 6, background: '#0a0a14', border: '1px solid #23233a', fontSize: 12, color: '#ccc', lineHeight: 1.6, whiteSpace: 'pre-wrap', wordBreak: 'break-word', userSelect: 'text' }}>{resultContent}</div>
            </div>
          </div>
        )}
      </div>

      {/* 회원 등록 후 앱 미가입자 */}
      <div style={{ ...ADMIN_CARD_STYLE, flex: 1, minWidth: 380, maxWidth: 560 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 4, gap: 8 }}>
          <h3 style={{ margin: 0, fontSize: 15, color: '#e0e0e0', fontWeight: 600, letterSpacing: '-0.01em' }}>회원 등록 후 앱 미가입자</h3>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, whiteSpace: 'nowrap', marginTop: 2 }}>
            {failed && (
              <span style={{ fontSize: 11, color: '#888' }}>
                <b style={{ color: '#ff8888' }}>{failed.failedCount.toLocaleString()}</b>
                <span style={{ color: '#555' }}> / {failed.distinctPhones.toLocaleString()}명</span>
              </span>
            )}
            <button
              onClick={loadFailed}
              disabled={failedLoading}
              title="명단 새로고침"
              style={{ background: 'none', border: '1px solid #2a2a4a', borderRadius: 4, color: failedLoading ? '#444' : '#aaa', cursor: failedLoading ? 'not-allowed' : 'pointer', fontSize: 13, lineHeight: 1, padding: '3px 7px' }}
            >↻</button>
          </div>
        </div>
        <div style={{ fontSize: 11, color: '#777', marginBottom: 12, lineHeight: 1.5 }}>최근 7일 매장 회원 등록(가입 안내 알림톡) 후 coach 앱 미가입 회원. 클릭 시 입력란 자동 채움.</div>

        <div style={{ position: 'relative', marginBottom: 10 }}>
          <input
            type="text"
            placeholder="이름 또는 전화번호 검색"
            value={failedSearch}
            onChange={e => setFailedSearch(e.target.value)}
            style={{ ...ADMIN_INPUT_STYLE, paddingRight: 32 }}
          />
          {failedSearch && (
            <button
              onClick={() => setFailedSearch('')}
              style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: '#666', cursor: 'pointer', fontSize: 18, padding: 0, lineHeight: 1 }}
              title="검색어 지우기"
            >×</button>
          )}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10, gap: 8 }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#aab', cursor: 'pointer', userSelect: 'none' }} title="만료된 인증번호를 빼고, 지금 바로 안내 가능한 대상만 봅니다">
            <input type="checkbox" checked={failedValidOnly} onChange={e => setFailedValidOnly(e.target.checked)} style={{ accentColor: '#00cc6a', cursor: 'pointer' }} />
            유효만 보기
          </label>
          <span style={{ fontSize: 11, color: '#666' }}>
            유효 <b style={{ color: '#33dd88' }}>{validCount.toLocaleString()}</b>
            {failed && <span style={{ color: '#555' }}> / 전체 {failed.members.length.toLocaleString()}</span>}
          </span>
        </div>

        <div style={{ background: '#0a0a14', border: '1px solid #1f1f33', borderRadius: 6, overflow: 'hidden' }}>
          {failedLoading ? (
            <div style={{ padding: 32, textAlign: 'center', color: '#888', fontSize: 12 }}>로딩 중...</div>
          ) : failedError ? (
            <div style={{ padding: 32, textAlign: 'center', color: '#ff5555', fontSize: 12 }}>{failedError}</div>
          ) : filteredFailed.length === 0 ? (
            <div style={{ padding: 32, textAlign: 'center', color: '#666', fontSize: 12 }}>
              {failedSearch ? '검색 결과 없음' : failedValidOnly ? '유효한 인증번호 대상 없음' : '미가입자 없음'}
            </div>
          ) : (
            pagedFailed.map((m, i) => {
              const isSelected = m.phone === phone && m.name === name;
              return (
                <div
                  key={`${m.phone}-${i}`}
                  onClick={() => selectMember(m)}
                  style={{
                    padding: '10px 14px',
                    borderBottom: i < pagedFailed.length - 1 ? '1px solid #15152a' : 'none',
                    borderLeft: `3px solid ${isSelected ? '#00cc6a' : 'transparent'}`,
                    cursor: 'pointer',
                    background: isSelected ? 'rgba(0,204,106,0.06)' : 'transparent',
                    transition: 'background 120ms ease',
                  }}
                  onMouseEnter={e => { if (!isSelected) (e.currentTarget as HTMLDivElement).style.background = '#13131f'; }}
                  onMouseLeave={e => { if (!isSelected) (e.currentTarget as HTMLDivElement).style.background = 'transparent'; }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 3, gap: 6 }}>
                    <span style={{ fontSize: 13, color: '#e8e8e8', fontWeight: 500 }}>{m.name || <span style={{ color: '#555' }}>(이름 없음)</span>}</span>
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap' }}>
                      {m.failCount > 1 && <span title={`인증번호 발급 ${m.failCount}회`} style={{ fontSize: 10, padding: '2px 7px', borderRadius: 10, background: 'rgba(255,85,85,0.12)', color: '#ff8888', fontWeight: 600 }}>{m.failCount}회</span>}
                      {m.expired
                        ? <span title="인증번호 만료 — 가입하려면 재발급 필요" style={{ fontSize: 10, padding: '2px 8px', borderRadius: 10, background: 'rgba(255,255,255,0.05)', color: '#8a8a99', fontWeight: 600, border: '1px solid #2a2a3a' }}>만료</span>
                        : <span title="인증번호 유효 — 지금 안내하면 바로 가입 가능" style={{ fontSize: 10, padding: '2px 8px', borderRadius: 10, background: 'rgba(0,204,106,0.14)', color: '#33dd88', fontWeight: 600 }}>유효</span>}
                    </span>
                  </div>
                  <div style={{ fontSize: 12, color: '#9aa', fontFamily: 'SF Mono, Menlo, monospace' }}>{m.countryCode} {m.phone}</div>
                  <div style={{ fontSize: 11, color: '#666', marginTop: 3 }}>
                    {m.birthDay ? <>생년 {m.birthDay.slice(0, 4)}-{m.birthDay.slice(4, 6)}-{m.birthDay.slice(6, 8)} <span style={{ color: '#444' }}> · </span></> : null}
                    {m.latestSendDate?.slice(0, 10)}
                  </div>
                </div>
              );
            })
          )}
        </div>

        {failedTotalPages > 1 && (
          <div style={{ display: 'flex', justifyContent: 'center', gap: 10, marginTop: 12, alignItems: 'center' }}>
            <button disabled={failedPage <= 1} onClick={() => setFailedPage(failedPage - 1)} style={{ padding: '5px 12px', fontSize: 12, borderRadius: 4, border: '1px solid #2a2a4a', background: 'transparent', color: failedPage <= 1 ? '#444' : '#aaa', cursor: failedPage <= 1 ? 'not-allowed' : 'pointer' }}>이전</button>
            <span style={{ fontSize: 12, color: '#cdd6e0', minWidth: 50, textAlign: 'center' }}>{failedPage} <span style={{ color: '#555' }}>/</span> {failedTotalPages}</span>
            <button disabled={failedPage >= failedTotalPages} onClick={() => setFailedPage(failedPage + 1)} style={{ padding: '5px 12px', fontSize: 12, borderRadius: 4, border: '1px solid #2a2a4a', background: 'transparent', color: failedPage >= failedTotalPages ? '#444' : '#aaa', cursor: failedPage >= failedTotalPages ? 'not-allowed' : 'pointer' }}>다음</button>
          </div>
        )}
      </div>
      </div>

      <AdminSendHistoryTable key={historyKey} sendType="SIGNUP_ADMIN" />
    </div>
  );
}

const MIGRATION_STAGE_LABEL: Record<string, string> = {
  // 크롤링 단계
  crawl_start: '수집 시작',
  crawl_member: '회원 수집',
  crawl_upload: 'S3 업로드',
  crawl_done: '수집 완료',
  crawl_error: '수집 에러',
  // 적재 단계
  membership: '회원권 상품',
  member: '회원',
  usage: '매출/이용내역',
  registration: 'Linko 등록 보완',
  extension: '회원권 연장',
  lesson: '수강',
  lesson_sync: '예약 수업 동기화',
  done: '완료',
};

const PLATFORM_LABEL: Record<string, string> = {
  peoplebox: 'PeopleBox',
  dagym: '다짐매니저',
  studiomate: '스튜디오메이트',
  assistfit: '어시스트핏',
  atbox: '앳박스',
  hifive: '하이파이브',
};

function MigrationProgress({ job }: { job: MigrationJob }) {
  const stage = job.progress_stage;
  const total = job.progress_total || 0;
  const current = job.progress_current || 0;
  if (!stage || total <= 0) {
    return <span style={{ color: '#00ff88', fontSize: 12 }}>준비 중...</span>;
  }
  const pct = Math.min(100, Math.round((current / total) * 100));
  const label = MIGRATION_STAGE_LABEL[stage] || stage;
  return (
    <div style={{ minWidth: 140 }}>
      <div style={{ fontSize: 11, color: '#aaa', marginBottom: 2 }}>{label} {current}/{total} ({pct}%)</div>
      <div style={{ height: 6, background: '#333', borderRadius: 3, overflow: 'hidden' }}>
        <div style={{ height: '100%', width: `${pct}%`, background: '#00ff88', transition: 'width 0.3s' }} />
      </div>
    </div>
  );
}

function MigrationPage() {
  const [jobs, setJobs] = useState<MigrationJob[]>([]);
  const [filter, setFilter] = useState('all');
  const [showForm, setShowForm] = useState(false);
  const [selectedJob, setSelectedJob] = useState<MigrationJob | null>(null);
  const [loading, setLoading] = useState(false);
  const [stores, setStores] = useState<{ id: number; name: string }[]>([]);
  const [storeSearch, setStoreSearch] = useState('');
  const [storeDropdownOpen, setStoreDropdownOpen] = useState(false);
  const storeDropdownRef = useRef<HTMLDivElement>(null);
  const [form, setForm] = useState({
    platform: 'peoplebox',
    store_id: '',
    user_id: '',
    password: '',
    member_filter: 'valid',
    gym_id: '',
  });

  const load = useCallback(() => {
    getMigrationJobs(filter !== 'all' ? filter : undefined).then(setJobs).catch(() => {});
  }, [filter]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => { getStores().then(setStores).catch(() => {}); }, []);
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (storeDropdownRef.current && !storeDropdownRef.current.contains(e.target as Node)) {
        setStoreDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  // 실행 중인 작업 자동 새로고침
  useEffect(() => {
    const hasRunning = jobs.some(j => ['collecting', 'inserting_dev', 'verifying', 'inserting_live'].includes(j.status));
    if (!hasRunning) return;
    const timer = setInterval(load, 5000);
    return () => clearInterval(timer);
  }, [jobs, load]);

  const selectedStore = stores.find(s => s.id === Number(form.store_id));

  const handleSubmit = async () => {
    if (!form.store_id || !form.user_id || !form.password) {
      alert('필수 항목을 모두 입력해주세요.');
      return;
    }
    if (form.platform === 'studiomate' && !form.gym_id.trim()) {
      alert('스튜디오메이트는 서브도메인(gym_id)이 필수입니다. 예: hadastudio');
      return;
    }
    if (form.platform === 'assistfit' && !form.gym_id.trim()) {
      alert('어시스트핏은 AssistFit CRM에 등록된 지점명이 필수입니다. (센터명과 다를 수 있음)');
      return;
    }
    if (form.platform === 'atbox' && !form.gym_id.trim()) {
      alert('앳박스는 박스(지점)를 입력해야 합니다. 예: 가경 또는 봉명');
      return;
    }
    setLoading(true);
    try {
      await createMigrationJob({
        platform: form.platform,
        center: selectedStore?.name || '',
        store_id: Number(form.store_id),
        user_id: form.user_id,
        password: form.password,
        member_filter: form.member_filter,
        gym_id: form.gym_id || undefined,
      });
      setShowForm(false);
      setForm({ platform: 'peoplebox', store_id: '', user_id: '', password: '', member_filter: 'all', gym_id: '' });
      load();
    } catch (e: any) {
      alert('요청 실패: ' + e.message);
    }
    setLoading(false);
  };

  const handleInsertDev = async (id: number, dryRun: boolean) => {
    try {
      await migrationInsertDev(id, dryRun);
      load();
    } catch (e: any) {
      alert('실패: ' + e.message);
    }
  };

  const handleRequestLive = async (id: number) => {
    if (!window.confirm('검증 보고서와 함께 Live DB 승인 요청을 슬랙에 전송합니다. 계속하시겠습니까?')) return;
    try {
      await migrationRequestLive(id);
      alert('승인 요청이 슬랙에 전송되었습니다.');
      load();
    } catch (e: any) {
      alert('실패: ' + e.message);
    }
  };

  const handleInsertLive = async (id: number) => {
    if (!window.confirm('⚠️ Live DB에 삽입합니다. 계속하시겠습니까?')) return;
    try {
      await migrationInsertLive(id);
      load();
    } catch (e: any) {
      alert('실패: ' + e.message);
    }
  };

  // 승인 버튼 — pending_approval → verified + Live insert 자동 트리거
  const handleApprove = async (id: number) => {
    if (!window.confirm('승인 시 Live DB 이전이 바로 시작됩니다. 진행할까요?')) return;
    try {
      await migrationApprove(id);
      load();
    } catch (e: any) {
      alert('승인 실패: ' + e.message);
    }
  };

  // 거부 버튼 — pending_approval → dev_done 롤백 + db_approvals rejected
  const handleReject = async (id: number) => {
    const reason = window.prompt('거부 사유 (선택사항)');
    if (reason === null) return;
    try {
      await migrationReject(id, reason || undefined);
      load();
    } catch (e: any) {
      alert('거부 실패: ' + e.message);
    }
  };

  const statusLabel: Record<string, string> = {
    pending: '대기', collecting: '수집 중', collected: '수집 완료',
    inserting_dev: '테스트 삽입 중', dev_done: '테스트 삽입 완료',
    pending_approval: '승인 대기', verified: '승인 완료',
    inserting_live: 'Live 삽입 중', completed: '완료', failed: '실패',
  };

  const formatTime = (t: string | null) => {
    if (!t) return '-';
    return new Date(t).toLocaleString('ko-KR', { timeZone: 'Asia/Seoul', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="task-section">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <h2>데이터 이전 <span>{jobs.length}건</span></h2>
        <button className="migration-new-btn" onClick={() => setShowForm(!showForm)}>
          {showForm ? '취소' : '+ 새 이전 요청'}
        </button>
      </div>

      {showForm && (
        <div className="migration-form">
          <div className="migration-form-grid">
            <div className="migration-field" ref={storeDropdownRef}>
              <label>업체 *</label>
              <div style={{ position: 'relative' }}>
                <input
                  type="text"
                  placeholder="업체명 또는 ID로 검색"
                  value={storeDropdownOpen ? storeSearch : (stores.find(s => s.id === Number(form.store_id))?.name ? `${stores.find(s => s.id === Number(form.store_id))!.name} (#${form.store_id})` : '')}
                  onChange={(e) => { setStoreSearch(e.target.value); setStoreDropdownOpen(true); }}
                  onFocus={() => { setStoreSearch(''); setStoreDropdownOpen(true); }}
                  style={{ width: '100%', boxSizing: 'border-box' }}
                />
                {storeDropdownOpen && (
                  <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, maxHeight: 200, overflowY: 'auto', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 6, zIndex: 100, marginTop: 2 }}>
                    {stores.filter(s => {
                      const q = storeSearch.toLowerCase();
                      return !q || s.name.toLowerCase().includes(q) || String(s.id).includes(q);
                    }).map(s => (
                      <div
                        key={s.id}
                        onClick={() => { setForm({ ...form, store_id: String(s.id) }); setStoreDropdownOpen(false); setStoreSearch(''); }}
                        style={{ padding: '8px 12px', cursor: 'pointer', fontSize: 13, color: '#e0e0e0', borderBottom: '1px solid #1f1f3a' }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = '#2a2a4a')}
                        onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
                      >
                        {s.name} <span style={{ color: '#666' }}>#{s.id}</span>
                      </div>
                    ))}
                    {stores.filter(s => { const q = storeSearch.toLowerCase(); return !q || s.name.toLowerCase().includes(q) || String(s.id).includes(q); }).length === 0 && (
                      <div style={{ padding: '8px 12px', fontSize: 13, color: '#666' }}>검색 결과 없음</div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="migration-field">
              <label>플랫폼 *</label>
              <select value={form.platform} onChange={(e) => setForm({ ...form, platform: e.target.value })}>
                <option value="peoplebox">PeopleBox</option>
                <option value="dagym">다짐매니저</option>
                <option value="studiomate">스튜디오메이트</option>
                <option value="assistfit">어시스트핏</option>
                <option value="atbox">앳박스</option>
                <option value="hifive">하이파이브</option>
              </select>
            </div>
            <div className="migration-field">
              <label>회원 필터</label>
              <select value={form.member_filter} onChange={(e) => setForm({ ...form, member_filter: e.target.value })}>
                <option value="all">전체</option>
                <option value="valid">유효 회원</option>
                <option value="expired">만료 회원</option>
              </select>
            </div>
            <div className="migration-field">
              <label>로그인 ID *</label>
              <input placeholder="타 플랫폼 로그인 ID" value={form.user_id} onChange={(e) => setForm({ ...form, user_id: e.target.value })} />
            </div>
            <div className="migration-field">
              <label>비밀번호 *</label>
              <input type="password" placeholder="타 플랫폼 비밀번호" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
            </div>
            {form.platform === 'dagym' && (
              <div className="migration-field">
                <label>다짐 매장 (선택)</label>
                <input placeholder="매장 이름 (예: 어라운드 평택점) 또는 UUID. 비우면 기본 매장" value={form.gym_id} onChange={(e) => setForm({ ...form, gym_id: e.target.value })} />
              </div>
            )}
            {form.platform === 'assistfit' && (
              <div className="migration-field">
                <label>AssistFit 지점명 *</label>
                <input placeholder="AssistFit CRM 에 등록된 지점명 (센터명과 다를 수 있음)" value={form.gym_id} onChange={(e) => setForm({ ...form, gym_id: e.target.value })} />
              </div>
            )}
            {form.platform === 'studiomate' && (
              <div className="migration-field">
                <label>서브도메인 *</label>
                <input placeholder="hadastudio (studiomate.kr 서브도메인)" value={form.gym_id} onChange={(e) => setForm({ ...form, gym_id: e.target.value })} />
              </div>
            )}
            {form.platform === 'atbox' && (
              <div className="migration-field">
                <label>앳박스 박스 *</label>
                <input placeholder="박스(지점) 이름. 예: 가경 또는 봉명. 한 계정에 여러 박스면 박스마다 따로 이전" value={form.gym_id} onChange={(e) => setForm({ ...form, gym_id: e.target.value })} />
              </div>
            )}
            {form.platform === 'hifive' && (
              <div className="migration-field">
                <label>하이파이브 센터 (선택)</label>
                <input placeholder="센터명 또는 campId. 계정에 센터가 하나면 비워두세요" value={form.gym_id} onChange={(e) => setForm({ ...form, gym_id: e.target.value })} />
              </div>
            )}
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 12 }}>
            <button className="migration-submit-btn" onClick={handleSubmit} disabled={loading || !form.store_id}>
              {loading ? '요청 중...' : '정보 이전 시작'}
            </button>
          </div>
        </div>
      )}

      <div className="filters">
        {['all', 'collecting', 'collected', 'dev_done', 'pending_approval', 'verified', 'completed', 'failed'].map((s) => (
          <button key={s} className={filter === s ? 'active' : ''} onClick={() => setFilter(s)}>
            {s === 'all' ? '전체' : statusLabel[s] || s}
          </button>
        ))}
      </div>

      {jobs.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>상태</th>
              <th>플랫폼</th>
              <th>센터</th>
              <th>Store ID</th>
              <th>요청일</th>
              <th>작업</th>
            </tr>
          </thead>
          <tbody>
            {jobs.map((j) => (
              <tr key={j.id} onClick={() => { getMigrationJob(j.id).then(setSelectedJob).catch(() => {}); }}>
                <td>#{j.id}</td>
                <td><span className={`status ${j.status}`}>{statusLabel[j.status] || j.status}</span></td>
                <td>{PLATFORM_LABEL[j.platform] || j.platform}</td>
                <td>{j.center}</td>
                <td>{j.store_id}{j.store_name ? ` (${j.store_name})` : ''}</td>
                <td>{formatTime(j.requested_at)}</td>
                <td onClick={(e) => e.stopPropagation()}>
                  {j.status === 'collected' && (
                    <div style={{ display: 'flex', gap: 4 }}>
                      <button className="migration-action-btn" onClick={() => handleInsertDev(j.id, true)}>Dry-run</button>
                      <button className="migration-action-btn primary" onClick={() => handleInsertDev(j.id, false)}>테스트 삽입</button>
                    </div>
                  )}
                  {j.status === 'dev_done' && (
                    <button className="migration-action-btn primary" onClick={() => handleRequestLive(j.id)}>승인 요청</button>
                  )}
                  {j.status === 'pending_approval' && (
                    <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                      <button className="migration-action-btn primary" onClick={() => handleApprove(j.id)}>승인</button>
                      <button className="migration-action-btn danger" onClick={() => handleReject(j.id)}>거부</button>
                    </div>
                  )}
                  {j.status === 'verified' && (
                    <button className="migration-action-btn danger" onClick={() => handleInsertLive(j.id)}>Live 삽입 (수동)</button>
                  )}
                  {['collecting', 'inserting_dev', 'inserting_live'].includes(j.status) && (
                    <MigrationProgress job={j} />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div style={{ textAlign: 'center', color: '#555', padding: 40, fontSize: 14 }}>이전 작업이 없습니다</div>
      )}

      {selectedJob && (
        <div className="modal-overlay" onClick={() => setSelectedJob(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>이전 작업 #{selectedJob.id}</h3>
              <button className="modal-close" onClick={() => setSelectedJob(null)}>×</button>
            </div>
            <div className="modal-body">
              <div className="detail-row"><div className="dl">상태</div><div className="dv"><span className={`status ${selectedJob.status}`}>{statusLabel[selectedJob.status] || selectedJob.status}</span></div></div>
              <div className="detail-row"><div className="dl">플랫폼</div><div className="dv">{PLATFORM_LABEL[selectedJob.platform] || selectedJob.platform}</div></div>
              <div className="detail-row"><div className="dl">센터</div><div className="dv">{selectedJob.center}</div></div>
              <div className="detail-row"><div className="dl">Store ID</div><div className="dv">{selectedJob.store_id}{selectedJob.store_name ? ` (${selectedJob.store_name})` : ''}</div></div>
              <div className="detail-row"><div className="dl">요청일</div><div className="dv">{formatTime(selectedJob.requested_at)}</div></div>
              <div className="detail-row"><div className="dl">완료일</div><div className="dv">{formatTime(selectedJob.completed_at)}</div></div>
              {selectedJob.error && (
                <div className="detail-row"><div className="dl">에러</div><div className="dv" style={{ color: '#ff4444' }}>{selectedJob.error}</div></div>
              )}
              {selectedJob.crawl_result && (
                <div style={{ marginTop: 12 }}>
                  <h4 style={{ color: '#00ff88', fontSize: 13, marginBottom: 8 }}>크롤링 결과</h4>
                  <pre className="migration-result-pre">{JSON.stringify(selectedJob.crawl_result, null, 2)}</pre>
                </div>
              )}
              {selectedJob.insert_dev_result && (
                <div style={{ marginTop: 12 }}>
                  <h4 style={{ color: '#00aaff', fontSize: 13, marginBottom: 8 }}>Dev DB 삽입 결과</h4>
                  <pre className="migration-result-pre">{JSON.stringify(selectedJob.insert_dev_result, null, 2)}</pre>
                </div>
              )}
              {selectedJob.insert_live_result && (
                <div style={{ marginTop: 12 }}>
                  <h4 style={{ color: '#ff8800', fontSize: 13, marginBottom: 8 }}>Live DB 삽입 결과</h4>
                  <pre className="migration-result-pre">{JSON.stringify(selectedJob.insert_live_result, null, 2)}</pre>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function MyPage({ user, onUpdate }: { user: User; onUpdate: (u: User) => void }) {
  const [name, setName] = useState(user.name);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const fileRef = React.useRef<HTMLInputElement>(null);
  const [tokenInput, setTokenInput] = useState('');
  const [tokenSaving, setTokenSaving] = useState(false);

  const handleSaveName = async () => {
    if (!name.trim() || name === user.name) return;
    setSaving(true);
    try {
      const updated = await updateMe({ name: name.trim() });
      onUpdate({ ...user, ...updated });
      setMsg('저장되었습니다.');
    } catch (e: any) {
      setMsg('저장 실패: ' + e.message);
    }
    setSaving(false);
    setTimeout(() => setMsg(''), 2000);
  };

  const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 350000) {
      setMsg('이미지가 너무 큽니다. (최대 350KB)');
      setTimeout(() => setMsg(''), 2000);
      return;
    }
    const reader = new FileReader();
    reader.onload = async () => {
      const base64 = reader.result as string;
      setSaving(true);
      try {
        const updated = await updateMe({ profile_image: base64 });
        onUpdate({ ...user, ...updated });
        setMsg('프로필 사진이 변경되었습니다.');
      } catch (e: any) {
        setMsg('업로드 실패: ' + e.message);
      }
      setSaving(false);
      setTimeout(() => setMsg(''), 2000);
    };
    reader.readAsDataURL(file);
  };

  const handleRemoveImage = async () => {
    setSaving(true);
    try {
      const updated = await updateMe({ profile_image: null });
      onUpdate({ ...user, ...updated });
      setMsg('프로필 사진이 삭제되었습니다.');
    } catch (e: any) {
      setMsg('삭제 실패: ' + e.message);
    }
    setSaving(false);
    setTimeout(() => setMsg(''), 2000);
  };

  const roleLabel: Record<string, string> = { owner: 'Owner', admin: 'Admin', engineer: 'Engineer', member: 'Member' };

  return (
    <div className="mypage">
      <h2>마이페이지</h2>
      <div className="mypage-card">
        <div className="mypage-avatar-section">
          <div className="mypage-avatar" onClick={() => fileRef.current?.click()}>
            {user.profile_image
              ? <img src={user.profile_image} alt="" />
              : <div className="mypage-avatar-placeholder">{user.name?.charAt(0).toUpperCase()}</div>
            }
            <div className="mypage-avatar-overlay">변경</div>
          </div>
          <input ref={fileRef} type="file" accept="image/*" hidden onChange={handleImageChange} />
          {user.profile_image && (
            <button className="mypage-remove-img" onClick={handleRemoveImage} disabled={saving}>삭제</button>
          )}
        </div>
        <div className="mypage-fields">
          <div className="mypage-field">
            <label>아이디</label>
            <div className="mypage-readonly">{user.login_id}</div>
          </div>
          <div className="mypage-field">
            <label>이름</label>
            <div style={{ display: 'flex', gap: 8 }}>
              <input value={name} onChange={(e) => setName(e.target.value)} />
              <button onClick={handleSaveName} disabled={saving || !name.trim() || name === user.name}>저장</button>
            </div>
          </div>
          <div className="mypage-field">
            <label>권한</label>
            <div className="mypage-readonly"><span className="mypage-role">{roleLabel[user.role] || user.role}</span></div>
          </div>
          <div className="mypage-field">
            <label>Slack ID</label>
            <div className="mypage-readonly">{user.slack_user_id || '-'}</div>
          </div>
        </div>
      </div>
      {/* Claude 토큰 설정 */}
      <div className="mypage-card" style={{ marginTop: 16 }}>
        <h3 style={{ margin: '0 0 12px', fontSize: 15, color: '#aaa' }}>Claude 토큰 설정</h3>
        {user.has_claude_token ? (
          <div className="mypage-fields">
            <div className="mypage-field">
              <label>상태</label>
              <div className="mypage-readonly" style={{ color: '#00ff88' }}>등록됨</div>
            </div>
            <div className="mypage-field">
              <label>등록일</label>
              <div className="mypage-readonly">{user.claude_token_set_at ? new Date(user.claude_token_set_at).toLocaleDateString('ko-KR') : '-'}</div>
            </div>
            <div className="mypage-field">
              <label>만료 예상</label>
              <div className="mypage-readonly">{user.claude_token_set_at ? new Date(new Date(user.claude_token_set_at).getTime() + 365 * 24 * 60 * 60 * 1000).toLocaleDateString('ko-KR') : '-'}</div>
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
              <button onClick={async () => {
                setTokenSaving(true);
                try { await deleteClaudeToken(); const u = await getMe(); onUpdate(u); setMsg('토큰이 삭제되었습니다.'); }
                catch (e: any) { setMsg('삭제 실패: ' + e.message); }
                setTokenSaving(false);
                setTimeout(() => setMsg(''), 2000);
              }} disabled={tokenSaving} style={{ background: '#ff4444', border: 'none', color: '#fff', padding: '6px 16px', borderRadius: 6, cursor: 'pointer' }}>토큰 삭제</button>
            </div>
          </div>
        ) : (
          <div className="mypage-fields">
            <div className="mypage-field">
              <label>상태</label>
              <div className="mypage-readonly" style={{ color: '#ff8800' }}>미등록 (작업 요청 불가)</div>
            </div>
            <div className="mypage-field">
              <label>토큰 입력</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <input
                  type="password"
                  value={tokenInput}
                  onChange={(e) => setTokenInput(e.target.value)}
                  placeholder="sk-ant-oat01-..."
                  style={{ flex: 1 }}
                />
                <button onClick={async () => {
                  if (!tokenInput.trim()) return;
                  setTokenSaving(true);
                  try { await updateClaudeToken(tokenInput.trim()); const u = await getMe(); onUpdate(u); setTokenInput(''); setMsg('토큰이 등록되었습니다.'); }
                  catch (e: any) { setMsg('등록 실패: ' + e.message); }
                  setTokenSaving(false);
                  setTimeout(() => setMsg(''), 2000);
                }} disabled={tokenSaving || !tokenInput.trim()}>등록</button>
              </div>
            </div>
            <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
              터미널에서 <code style={{ background: '#1a1a2e', padding: '2px 6px', borderRadius: 4 }}>claude setup-token</code> 실행하여 발급 (유효기간 1년)
            </div>
          </div>
        )}
      </div>
      {/* Passkey 설정 */}
      <div className="mypage-card" style={{ marginTop: 16 }}>
        <h3 style={{ margin: '0 0 12px', fontSize: 15, color: '#aaa' }}>Passkey 설정 (외부 접속 보안)</h3>
        <PasskeySection userId={user.id} setMsg={setMsg} />
      </div>
      {msg && <div className="mypage-msg">{msg}</div>}
    </div>
  );
}

function PasskeySection({ userId, setMsg }: { userId: number; setMsg: (s: string) => void }) {
  const [passkeys, setPasskeys] = useState<{ id: number; device_name: string; created_at: string }[]>([]);
  const [loading, setLoading] = useState(false);

  const loadPasskeys = () => { getPasskeys().then(setPasskeys).catch(() => {}); };
  useEffect(() => { loadPasskeys(); }, []); // eslint-disable-line

  const handleRegister = async () => {
    setLoading(true);
    try {
      const { startRegistration } = await import('@simplewebauthn/browser');
      const options = await getPasskeyRegisterOptions();
      const credential = await startRegistration({ optionsJSON: options });
      const deviceName = navigator.userAgent.includes('iPhone') ? 'iPhone'
        : navigator.userAgent.includes('Android') ? 'Android'
        : navigator.userAgent.includes('Mac') ? 'Mac' : 'Unknown';
      await verifyPasskeyRegister(credential, deviceName);
      setMsg('Passkey 등록 완료');
      loadPasskeys();
    } catch (e: any) {
      if (e.name === 'NotAllowedError') setMsg('등록이 취소되었습니다.');
      else setMsg('등록 실패: ' + (e.message || e));
    }
    setLoading(false);
    setTimeout(() => setMsg(''), 3000);
  };

  return (
    <div>
      {passkeys.length === 0 ? (
        <div style={{ fontSize: 13, color: '#888', marginBottom: 12 }}>등록된 Passkey가 없습니다. 외부에서 접속 시 추가 인증 없이 로그인됩니다.</div>
      ) : (
        <table style={{ width: '100%', marginBottom: 12 }}>
          <thead><tr><th style={{ textAlign: 'left', fontSize: 12, color: '#888' }}>기기</th><th style={{ textAlign: 'left', fontSize: 12, color: '#888' }}>등록일</th><th style={{ width: 60 }}></th></tr></thead>
          <tbody>
            {passkeys.map(p => (
              <tr key={p.id}>
                <td style={{ fontSize: 13 }}>{p.device_name || '알 수 없음'}</td>
                <td style={{ fontSize: 12, color: '#888' }}>{new Date(p.created_at).toLocaleDateString('ko-KR')}</td>
                <td><button onClick={async () => { await deletePasskey(p.id); loadPasskeys(); setMsg('삭제되었습니다.'); setTimeout(() => setMsg(''), 2000); }} style={{ fontSize: 11, padding: '2px 8px', background: 'none', border: '1px solid #ff4444', color: '#ff4444', borderRadius: 4, cursor: 'pointer' }}>삭제</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <button onClick={handleRegister} disabled={loading} style={{ padding: '8px 20px', fontSize: 13, borderRadius: 6, border: '1px solid #4dabf7', background: '#4dabf710', color: '#4dabf7', cursor: 'pointer' }}>
        {loading ? '등록 중...' : 'Passkey 등록'}
      </button>
      <div style={{ fontSize: 11, color: '#666', marginTop: 8 }}>Touch ID, Face ID, 지문 등 기기의 생체인증을 사용합니다.</div>
    </div>
  );
}

interface AdminUser extends User {
  is_active?: boolean;
  created_at?: string;
}

function AdminPage({ currentUser }: { currentUser: User }) {
  const [users, setUsers] = useState<AdminUser[]>([]);
  const [deleteTarget, setDeleteTarget] = useState<AdminUser | null>(null);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [adminTab, setAdminTab] = useState<'members' | 'usage' | 'kpi'>('members');
  const [actionMenu, setActionMenu] = useState<number | null>(null);
  useEffect(() => {
    if (!actionMenu) return;
    const close = (e: MouseEvent) => { if (!(e.target as HTMLElement).closest('[data-action-menu]')) setActionMenu(null); };
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, [actionMenu]);

  // 사용량 탭 상태
  const [usageMode, setUsageMode] = useState<'hourly' | 'daily' | 'weekly' | 'monthly' | 'lastWeek' | 'lastMonth' | 'last7' | 'last30'>('hourly');
  const [usageSyncing, setUsageSyncing] = useState(false);
  const [usageDate, setUsageDate] = useState(new Date().toISOString().slice(0, 10));
  const [usageFrom, setUsageFrom] = useState(new Date(Date.now() - 7 * 86400000).toISOString().slice(0, 10));
  const [usageTo, setUsageTo] = useState(new Date().toISOString().slice(0, 10));
  const [hourlyData, setHourlyData] = useState<TelemetryHourly[]>([]);
  const [dailyData, setDailyData] = useState<TelemetryDaily[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
  const [telemetry, setTelemetry] = useState<TelemetrySummary[]>([]);
  const [usageSort, setUsageSort] = useState<{ key: string; asc: boolean }>({ key: 'cost', asc: false });
  const [modelSort, setModelSort] = useState<{ key: string; asc: boolean }>({ key: 'cost', asc: false });
  const [modelDetail, setModelDetail] = useState<string | null>(null);

  const load = () => { getUsers().then(setUsers).catch(() => {}); };
  useEffect(() => { load(); }, []);

  // 사용량 기간 계산 (로컬/KST 기준, YYYY-MM-DD)
  const getUsageRange = (mode: typeof usageMode): { from: string; to: string } => {
    const fmt = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    switch (mode) {
      case 'weekly': { // 이번주 월요일 ~ 일요일
        const mon = new Date(today); mon.setDate(today.getDate() - ((today.getDay() + 6) % 7));
        const sun = new Date(mon); sun.setDate(mon.getDate() + 6);
        return { from: fmt(mon), to: fmt(sun) };
      }
      case 'lastWeek': { // 지난주 월요일 ~ 일요일
        const mon = new Date(today); mon.setDate(today.getDate() - ((today.getDay() + 6) % 7) - 7);
        const sun = new Date(mon); sun.setDate(mon.getDate() + 6);
        return { from: fmt(mon), to: fmt(sun) };
      }
      case 'monthly': { // 이번달 1일 ~ 말일
        const first = new Date(today.getFullYear(), today.getMonth(), 1);
        const last = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        return { from: fmt(first), to: fmt(last) };
      }
      case 'lastMonth': { // 지난달 1일 ~ 말일
        const first = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const last = new Date(today.getFullYear(), today.getMonth(), 0);
        return { from: fmt(first), to: fmt(last) };
      }
      case 'last7': { // 최근 7일 (오늘 포함)
        const from = new Date(today); from.setDate(today.getDate() - 6);
        return { from: fmt(from), to: fmt(today) };
      }
      case 'last30': { // 최근 30일 (오늘 포함)
        const from = new Date(today); from.setDate(today.getDate() - 29);
        return { from: fmt(from), to: fmt(today) };
      }
      default: // daily: 사용자 지정
        return { from: usageFrom, to: usageTo };
    }
  };

  // 사용량 데이터 로드
  useEffect(() => {
    if (adminTab !== 'usage') return;
    if (usageMode === 'hourly') {
      getTelemetryHourly(usageDate).then(setHourlyData).catch(() => {});
      getTelemetrySummary({ from: usageDate }).then(setTelemetry).catch(() => {});
    } else {
      const { from, to } = getUsageRange(usageMode);
      getTelemetryDaily(from, to).then(setDailyData).catch(() => {});
      getTelemetrySummary({ from, to }).then(setTelemetry).catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminTab, usageMode, usageDate, usageFrom, usageTo]);

  // 유저 목록 추출
  const allUserEmails = Array.from(new Set(telemetry.map(t => t.user_email)));
  const userColors: Record<string, string> = { '__total__': '#ffffff' };
  const colors = ['#00ff88', '#ff8800', '#8888ff', '#ff4488', '#44ddff', '#ffdd44'];
  allUserEmails.forEach((email, i) => { userColors[email] = colors[i % colors.length]; });

  // 새 유저 감지 시 자동 선택 (초기 로드)
  const allUserEmailsKey = allUserEmails.join(',');
  useEffect(() => {
    if (allUserEmails.length > 0 && selectedUsers.length === 0) {
      setSelectedUsers([...allUserEmails]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allUserEmailsKey]);

  // 차트에 표시할 유저 (전체 제외, 체크된 유저만)
  const visibleUsers = selectedUsers.filter(u => u !== '__total__');

  useEffect(() => {
    document.body.classList.toggle('modal-open', !!deleteTarget);
    return () => { document.body.classList.remove('modal-open'); };
  }, [deleteTarget]);

  const ROLES = ['owner', 'admin', 'engineer', 'member'];
  const roleLabel: Record<string, string> = { owner: 'Owner', admin: 'Admin', engineer: 'Engineer', member: 'Member' };

  const handleRoleChange = async (userId: number, role: string) => {
    try {
      await updateUserRole(userId, role);
      load();
    } catch (e: any) {
      alert(e.message);
    }
  };

  const handleDeactivate = async () => {
    if (!password) { setError('비밀번호를 입력해주세요.'); return; }
    setLoading(true);
    try {
      await deactivateUser(deleteTarget!.id, password);
      setDeleteTarget(null);
      setPassword('');
      setError('');
      load();
    } catch (e: any) {
      setError(e.message || '비활성화 실패');
    }
    setLoading(false);
  };

  const handleActivate = async (userId: number) => {
    try {
      await activateUser(userId);
      load();
    } catch (e: any) {
      alert(e.message);
    }
  };

  const canEditRole = (target: AdminUser) => {
    if (target.id === currentUser.id) return false;
    if (currentUser.role === 'owner') return true;
    if (currentUser.role === 'admin' && ['engineer', 'member'].includes(target.role)) return true;
    return false;
  };

  const canDeactivate = (target: AdminUser) => {
    if (target.id === currentUser.id) return false;
    if (target.role === 'owner') return false;
    if (currentUser.role === 'admin' && ['owner', 'admin'].includes(target.role)) return false;
    return target.is_active !== false;
  };

  // 차트 데이터 가공
  const showTotal = selectedUsers.includes('__total__');
  const chartData = usageMode === 'hourly'
    ? Array.from({ length: 24 }, (_, h) => {
        const row: any = { label: `${h}시` };
        // 개별 유저 라인 (체크된 것만)
        visibleUsers.forEach(email => {
          const d = hourlyData.find(d => d.user_email === email && parseInt(d.hour) === h);
          row[email] = d ? parseInt(d.input_tokens) + parseInt(d.output_tokens) : 0;
        });
        // 전체 합산은 항상 allUserEmails 기준
        if (showTotal) {
          let total = 0;
          allUserEmails.forEach(email => {
            const d = hourlyData.find(d => d.user_email === email && parseInt(d.hour) === h);
            total += d ? parseInt(d.input_tokens) + parseInt(d.output_tokens) : 0;
          });
          row['__total__'] = total;
        }
        return row;
      })
    : (() => {
        // 선택 기간 전체 날짜를 생성 → 데이터 없는 날/달은 0 처리
        const { from, to } = getUsageRange(usageMode);
        const dates: string[] = [];
        const end = new Date(`${to}T00:00:00`);
        for (let dt = new Date(`${from}T00:00:00`); dt <= end && dates.length < 750; dt.setDate(dt.getDate() + 1)) {
          dates.push(`${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`);
        }
        return dates.map(date => {
          const row: any = { label: date.slice(5) };
          // 개별 유저 라인 (체크된 것만)
          visibleUsers.forEach(email => {
            const d = dailyData.find(d => d.user_email === email && d.date.slice(0, 10) === date);
            row[email] = d ? parseInt(d.input_tokens) + parseInt(d.output_tokens) : 0;
          });
          // 전체 합산은 항상 allUserEmails 기준
          if (showTotal) {
            let total = 0;
            allUserEmails.forEach(email => {
              const d = dailyData.find(d => d.user_email === email && d.date.slice(0, 10) === date);
              total += d ? parseInt(d.input_tokens) + parseInt(d.output_tokens) : 0;
            });
            row['__total__'] = total;
          }
          return row;
        });
      })();

  // 유저별 비용 합계 (바 차트용)
  const costByUser = allUserEmails.map(email => {
    const total = telemetry.filter(t => t.user_email === email).reduce((s, t) => s + parseFloat(t.total_cost), 0);
    return { name: email.split('@')[0], cost: total, fill: userColors[email] };
  }).filter(d => d.cost > 0);

  return (
    <div className="admin-page">
      {/* 탭 */}
      <div className="admin-tabs">
        <button className={`admin-tab ${adminTab === 'members' ? 'active' : ''}`} onClick={() => setAdminTab('members')}>팀원 관리</button>
        <button className={`admin-tab ${adminTab === 'usage' ? 'active' : ''}`} onClick={() => setAdminTab('usage')}>AI 사용량</button>
        <button className={`admin-tab ${adminTab === 'kpi' ? 'active' : ''}`} onClick={() => setAdminTab('kpi')}>KPI</button>
      </div>

      {/* AI 사용량 탭 */}
      {adminTab === 'usage' && (
        <div>
          {/* 필터 바 */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 28 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4, alignItems: 'flex-start' }}>
              <div style={{ display: 'flex', gap: 4 }}>
                <button className={`admin-tab-sm ${usageMode === 'hourly' ? 'active' : ''}`} onClick={() => setUsageMode('hourly')}>시간별</button>
                <button className={`admin-tab-sm ${usageMode === 'daily' ? 'active' : ''}`} onClick={() => setUsageMode('daily')}>일별</button>
                <button className={`admin-tab-sm ${usageMode === 'weekly' ? 'active' : ''}`} onClick={() => setUsageMode('weekly')}>주간</button>
                <button className={`admin-tab-sm ${usageMode === 'monthly' ? 'active' : ''}`} onClick={() => setUsageMode('monthly')}>월간</button>
              </div>
              <div style={{ display: 'flex', gap: 4 }}>
                <button className={`admin-tab-sm ${usageMode === 'lastWeek' ? 'active' : ''}`} onClick={() => setUsageMode('lastWeek')}>지난주</button>
                <button className={`admin-tab-sm ${usageMode === 'lastMonth' ? 'active' : ''}`} onClick={() => setUsageMode('lastMonth')}>지난달</button>
                <button className={`admin-tab-sm ${usageMode === 'last7' ? 'active' : ''}`} onClick={() => setUsageMode('last7')}>최근7일</button>
                <button className={`admin-tab-sm ${usageMode === 'last30' ? 'active' : ''}`} onClick={() => setUsageMode('last30')}>최근30일</button>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
            {usageMode === 'hourly' ? (
              <input type="date" value={usageDate} onChange={(e) => setUsageDate(e.target.value)} style={{ padding: '4px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 4, color: '#e0e0e0', fontSize: 12 }} />
            ) : usageMode === 'daily' ? (
              <>
                <input type="date" value={usageFrom} onChange={(e) => setUsageFrom(e.target.value)} style={{ padding: '4px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 4, color: '#e0e0e0', fontSize: 12 }} />
                <span style={{ color: '#666' }}>~</span>
                <input type="date" value={usageTo} onChange={(e) => setUsageTo(e.target.value)} style={{ padding: '4px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 4, color: '#e0e0e0', fontSize: 12 }} />
              </>
            ) : (
              (() => { const r = getUsageRange(usageMode); return <span style={{ color: '#888', fontSize: 12 }}>{r.from} ~ {r.to}</span>; })()
            )}
            <button onClick={() => { const today = new Date().toISOString().slice(0, 10); setUsageDate(today); setUsageFrom(today); setUsageTo(today); setUsageMode('hourly'); }} style={{ padding: '4px 10px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, color: '#aaa', fontSize: 12, cursor: 'pointer' }}>오늘</button>
            <button
              onClick={async () => {
                setUsageSyncing(true);
                try {
                  if (usageMode === 'hourly') {
                    const [h, s] = await Promise.all([getTelemetryHourly(usageDate), getTelemetrySummary({ from: usageDate })]);
                    setHourlyData(h); setTelemetry(s);
                  } else {
                    const { from, to } = getUsageRange(usageMode);
                    const [d, s] = await Promise.all([getTelemetryDaily(from, to), getTelemetrySummary({ from, to })]);
                    setDailyData(d); setTelemetry(s);
                  }
                } catch {}
                setUsageSyncing(false);
              }}
              disabled={usageSyncing}
              style={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 6, color: usageSyncing ? '#555' : '#00ff88', padding: '4px 14px', fontSize: 12, cursor: usageSyncing ? 'default' : 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}
            >
              <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" style={usageSyncing ? { animation: 'spin 1s linear infinite' } : {}}>
                <path d="M2,8 a6,6 0 0,1 10.3,-4.2 M14,8 a6,6 0 0,1 -10.3,4.2" /><polyline points="2,3 2,8 7,8" /><polyline points="14,13 14,8 9,8" />
              </svg>
              {usageSyncing ? '로딩...' : '새로고침'}
            </button>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, color: '#ffffff', cursor: 'pointer' }}>
              <input type="checkbox" checked={selectedUsers.includes('__total__')} onChange={(e) => {
                if (e.target.checked) {
                  setSelectedUsers(prev => [...prev, '__total__']);
                } else {
                  setSelectedUsers(prev => prev.filter(u => u !== '__total__'));
                }
              }} />
              전체
            </label>
            {allUserEmails.map(email => (
              <label key={email} style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, color: userColors[email], cursor: 'pointer' }}>
                <input type="checkbox" checked={selectedUsers.includes(email)} onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedUsers(prev => [...prev, email]);
                  } else {
                    setSelectedUsers(prev => prev.filter(u => u !== email));
                  }
                }} />
                {email.split('@')[0]}
              </label>
            ))}
          </div>

          {/* 토큰 사용량 라인 차트 */}
          {(visibleUsers.length > 0 || showTotal) && chartData.length > 0 ? (
            <div style={{ marginBottom: 24 }}>
              <h3 style={{ fontSize: 14, color: '#aaa', marginBottom: 8 }}>토큰 사용량</h3>
              <ResponsiveContainer width="100%" height={280}>
                <LineChart data={chartData}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
                  <XAxis dataKey="label" stroke="#666" fontSize={11} />
                  <YAxis stroke="#666" fontSize={11} tickFormatter={(v: number) => v >= 1000 ? `${(v/1000).toFixed(0)}K` : String(v)} />
                  <Tooltip contentStyle={{ background: '#1a1a2e', border: '1px solid #333', borderRadius: 8, fontSize: 12, color: '#e0e0e0' }} labelStyle={{ color: '#aaa' }} itemStyle={{ color: '#e0e0e0' }} formatter={(v: any) => Number(v).toLocaleString()} />
                  <Legend />
                  {showTotal && <Line type="monotone" dataKey="__total__" stroke="#ffffff" strokeWidth={2} strokeDasharray="5 5" dot={false} name="전체" />}
                  {visibleUsers.filter(u => u !== '__total__').map(email => (
                    <Line key={email} type="monotone" dataKey={email} stroke={userColors[email]} strokeWidth={2} dot={false} name={email.split('@')[0]} />
                  ))}
                </LineChart>
              </ResponsiveContainer>
            </div>
          ) : (
            <div style={{ color: '#666', padding: 24, textAlign: 'center' }}>데이터가 없습니다</div>
          )}

          {/* 유저별 비용 바 차트 */}
          {costByUser.length > 0 && (
            <div style={{ marginBottom: 24 }}>
              <h3 style={{ fontSize: 14, color: '#aaa', marginBottom: 8 }}>유저별 비용 (USD)</h3>
              <ResponsiveContainer width="100%" height={200}>
                <BarChart data={costByUser}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
                  <XAxis dataKey="name" stroke="#666" fontSize={12} />
                  <YAxis stroke="#666" fontSize={11} tickFormatter={(v: number) => `$${v.toFixed(2)}`} />
                  <Tooltip cursor={{ fill: 'rgba(255,255,255,0.05)' }} contentStyle={{ background: '#1a1a2e', border: '1px solid #333', borderRadius: 8, fontSize: 12, color: '#e0e0e0' }} labelStyle={{ color: '#aaa' }} itemStyle={{ color: '#e0e0e0' }} formatter={(v: any) => `$${Number(v).toFixed(4)}`} />
                  <Bar dataKey="cost" radius={[4, 4, 0, 0]} maxBarSize={48}>
                    {costByUser.map((entry, i) => (
                      <Cell key={i} fill={entry.fill} />
                    ))}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          )}

          {/* 팀 총 사용량 */}
          {telemetry.length > 0 && (() => {
            const total = telemetry.reduce((acc, t) => {
              acc.requests += parseInt(t.request_count);
              acc.input += parseInt(t.total_input);
              acc.output += parseInt(t.total_output);
              acc.cost += parseFloat(t.total_cost);
              return acc;
            }, { requests: 0, input: 0, output: 0, cost: 0 });
            return (
              <div style={{ display: 'flex', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
                {[
                  { label: '총 요청수', value: total.requests.toLocaleString() },
                  { label: '총 입력 토큰', value: total.input.toLocaleString() },
                  { label: '총 출력 토큰', value: total.output.toLocaleString() },
                  { label: '총 비용', value: `$${total.cost.toFixed(4)}` },
                ].map(item => (
                  <div key={item.label} style={{ flex: 1, minWidth: 120, background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 8, padding: '12px 16px' }}>
                    <div style={{ fontSize: 11, color: '#666', marginBottom: 4 }}>{item.label}</div>
                    <div style={{ fontSize: 18, fontWeight: 700, color: '#e0e0e0' }}>{item.value}</div>
                  </div>
                ))}
              </div>
            );
          })()}

          {/* 유저별 합계 테이블 */}
          {telemetry.length > 0 && (() => {
            const toggleUsageSort = (key: string) => {
              setUsageSort(prev => {
                if (prev.key !== key) return { key, asc: false };
                if (!prev.asc) return { key, asc: true };
                return { key: '', asc: false };
              });
            };
            const uSortIcon = (key: string) => {
              const active = usageSort.key === key;
              const arrow = active ? (usageSort.asc ? ' ▲' : ' ▼') : ' ▲';
              return <span style={{ opacity: active ? 1 : 0 }}>{arrow}</span>;
            };
            const userSummary = Object.entries(telemetry.reduce((acc: Record<string, { requests: number; input: number; output: number; cost: number }>, t) => {
              const name = t.user_email.split('@')[0];
              if (!acc[name]) acc[name] = { requests: 0, input: 0, output: 0, cost: 0 };
              acc[name].requests += parseInt(t.request_count);
              acc[name].input += parseInt(t.total_input);
              acc[name].output += parseInt(t.total_output);
              acc[name].cost += parseFloat(t.total_cost);
              return acc;
            }, {})).sort((a, b) => {
              const key = usageSort.key;
              if (!key) return b[1].cost - a[1].cost;
              if (key === 'name') {
                const cmp = a[0].localeCompare(b[0]);
                return usageSort.asc ? cmp : -cmp;
              }
              const av = (a[1] as any)[key] || 0;
              const bv = (b[1] as any)[key] || 0;
              return usageSort.asc ? av - bv : bv - av;
            });
            return (
              <div className="admin-table-wrap">
                <h3 style={{ fontSize: 14, color: '#aaa', marginBottom: 8 }}>유저별 합계</h3>
                <table>
                  <thead>
                    <tr>
                      <th style={{ cursor: 'pointer' }} onClick={() => toggleUsageSort('name')}>유저{uSortIcon('name')}</th>
                      <th style={{ cursor: 'pointer' }} onClick={() => toggleUsageSort('requests')}>요청수{uSortIcon('requests')}</th>
                      <th style={{ cursor: 'pointer' }} onClick={() => toggleUsageSort('input')}>입력 토큰{uSortIcon('input')}</th>
                      <th style={{ cursor: 'pointer' }} onClick={() => toggleUsageSort('output')}>출력 토큰{uSortIcon('output')}</th>
                      <th style={{ cursor: 'pointer' }} onClick={() => toggleUsageSort('cost')}>비용 (USD){uSortIcon('cost')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userSummary.map(([name, d]) => (
                      <tr key={name}>
                        <td>{name}</td>
                        <td>{d.requests.toLocaleString()}</td>
                        <td>{d.input.toLocaleString()}</td>
                        <td>{d.output.toLocaleString()}</td>
                        <td>${d.cost.toFixed(4)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            );
          })()}

          {/* 모델별 사용량 테이블 */}
          {telemetry.length > 0 && (() => {
            const toggleModelSort = (key: string) => {
              setModelSort(prev => {
                if (prev.key !== key) return { key, asc: false };
                if (!prev.asc) return { key, asc: true };
                return { key: '', asc: false };
              });
            };
            const mSortIcon = (key: string) => {
              const active = modelSort.key === key;
              const arrow = active ? (modelSort.asc ? ' ▲' : ' ▼') : ' ▲';
              return <span style={{ opacity: active ? 1 : 0 }}>{arrow}</span>;
            };
            const modelData = Object.entries(telemetry.reduce((acc: Record<string, { requests: number; input: number; output: number; cost: number }>, t) => {
              const model = t.model || 'unknown';
              if (!acc[model]) acc[model] = { requests: 0, input: 0, output: 0, cost: 0 };
              acc[model].requests += parseInt(t.request_count);
              acc[model].input += parseInt(t.total_input);
              acc[model].output += parseInt(t.total_output);
              acc[model].cost += parseFloat(t.total_cost);
              return acc;
            }, {})).sort((a, b) => {
              const key = modelSort.key;
              if (!key) return b[1].cost - a[1].cost;
              if (key === 'model') {
                const cmp = a[0].localeCompare(b[0]);
                return modelSort.asc ? cmp : -cmp;
              }
              const av = (a[1] as any)[key] || 0;
              const bv = (b[1] as any)[key] || 0;
              return modelSort.asc ? av - bv : bv - av;
            });
            return (
              <div className="admin-table-wrap" style={{ marginTop: 16 }}>
                <h3 style={{ fontSize: 14, color: '#aaa', marginBottom: 8 }}>모델별 사용량</h3>
                <table>
                  <thead>
                    <tr>
                      <th style={{ cursor: 'pointer' }} onClick={() => toggleModelSort('model')}>모델{mSortIcon('model')}</th>
                      <th style={{ cursor: 'pointer' }} onClick={() => toggleModelSort('requests')}>요청수{mSortIcon('requests')}</th>
                      <th style={{ cursor: 'pointer' }} onClick={() => toggleModelSort('input')}>입력 토큰{mSortIcon('input')}</th>
                      <th style={{ cursor: 'pointer' }} onClick={() => toggleModelSort('output')}>출력 토큰{mSortIcon('output')}</th>
                      <th style={{ cursor: 'pointer' }} onClick={() => toggleModelSort('cost')}>비용 (USD){mSortIcon('cost')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modelData.map(([model, d]) => (
                      <tr key={model} style={{ cursor: 'pointer' }} onClick={() => setModelDetail(model)}>
                        <td>{model}</td>
                        <td>{d.requests.toLocaleString()}</td>
                        <td>{d.input.toLocaleString()}</td>
                        <td>{d.output.toLocaleString()}</td>
                        <td>${d.cost.toFixed(4)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            );
          })()}

          {/* 모델별 유저 상세 모달 */}
          {modelDetail && telemetry.length > 0 && (() => {
            const users = telemetry.filter(t => (t.model || 'unknown') === modelDetail).reduce((acc: Record<string, { requests: number; input: number; output: number; cost: number }>, t) => {
              const name = t.user_email.split('@')[0];
              if (!acc[name]) acc[name] = { requests: 0, input: 0, output: 0, cost: 0 };
              acc[name].requests += parseInt(t.request_count);
              acc[name].input += parseInt(t.total_input);
              acc[name].output += parseInt(t.total_output);
              acc[name].cost += parseFloat(t.total_cost);
              return acc;
            }, {});
            const totalReq = Object.values(users).reduce((s, d) => s + d.requests, 0);
            const totalInput = Object.values(users).reduce((s, d) => s + d.input, 0);
            const totalOutput = Object.values(users).reduce((s, d) => s + d.output, 0);
            const totalCost = Object.values(users).reduce((s, d) => s + d.cost, 0);
            const sorted = Object.entries(users).sort((a, b) => b[1].cost - a[1].cost);
            return (
              <div className="modal-overlay" onClick={() => setModelDetail(null)}>
                <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 720 }}>
                  <div className="modal-header">
                    <h2 style={{ fontSize: 16 }}>{modelDetail}</h2>
                    <button className="close" onClick={() => setModelDetail(null)}>&times;</button>
                  </div>
                  <div className="modal-body" style={{ padding: '16px 24px' }}>
                    <table>
                      <thead>
                        <tr><th>유저</th><th>요청수</th><th>입력 토큰</th><th>출력 토큰</th><th>비용 (USD)</th><th>비용 비중</th></tr>
                      </thead>
                      <tbody>
                        {sorted.map(([name, d]) => {
                          const costPct = totalCost ? (d.cost / totalCost * 100) : 0;
                          return (
                            <tr key={name}>
                              <td>{name}</td>
                              <td>{d.requests.toLocaleString()} <span style={{ color: '#666', fontSize: 11 }}>({totalReq ? (d.requests / totalReq * 100).toFixed(1) : 0}%)</span></td>
                              <td>{d.input.toLocaleString()} <span style={{ color: '#666', fontSize: 11 }}>({totalInput ? (d.input / totalInput * 100).toFixed(1) : 0}%)</span></td>
                              <td>{d.output.toLocaleString()} <span style={{ color: '#666', fontSize: 11 }}>({totalOutput ? (d.output / totalOutput * 100).toFixed(1) : 0}%)</span></td>
                              <td>${d.cost.toFixed(4)}</td>
                              <td style={{ minWidth: 100 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                  <div style={{ flex: 1, height: 6, background: '#1a1a2e', borderRadius: 3, overflow: 'hidden' }}>
                                    <div style={{ width: `${costPct}%`, height: '100%', background: '#00ff88', borderRadius: 3 }} />
                                  </div>
                                  <span style={{ color: '#aaa', fontSize: 11, whiteSpace: 'nowrap' }}>{costPct.toFixed(1)}%</span>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot>
                        <tr style={{ fontWeight: 600, borderTop: '1px solid #333' }}>
                          <td>합계</td>
                          <td>{totalReq.toLocaleString()}</td>
                          <td>{totalInput.toLocaleString()}</td>
                          <td>{totalOutput.toLocaleString()}</td>
                          <td>${totalCost.toFixed(4)}</td>
                          <td></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            );
          })()}
        </div>
      )}

      {/* KPI 탭 */}
      {adminTab === 'kpi' && <KpiPage />}

      {/* 팀원 관리 탭 */}
      {adminTab === 'members' && (<>
      <h2>팀 <span style={{ color: '#00ff88', fontWeight: 'normal', fontSize: 13 }}>{users.length}명</span></h2>
      <div className="admin-table-wrap">
        <table>
          <thead>
            <tr>
              <th>프로필</th>
              <th>아이디</th>
              <th>이름</th>
              <th>GitHub</th>
              <th>Claude 토큰</th>
              <th>권한</th>
              <th>상태</th>
              <th>가입일</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className={u.is_active === false ? 'deactivated' : ''}>
                <td>
                  {u.profile_image
                    ? <img src={u.profile_image} alt="" className="admin-avatar" />
                    : <div className="admin-avatar-ph">{u.name?.charAt(0).toUpperCase()}</div>
                  }
                </td>
                <td>{u.login_id}</td>
                <td>{u.name}</td>
                <td>
                  {currentUser.role === 'owner' ? (
                    <input
                      type="text"
                      defaultValue={u.github_username || ''}
                      placeholder="-"
                      style={{ width: 100, padding: '4px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 4, color: '#e0e0e0', fontSize: 12 }}
                      onBlur={(e) => {
                        const val = e.target.value.trim();
                        if (val !== (u.github_username || '')) {
                          updateGithubUsername(u.id, val || null).then(() => load());
                        }
                      }}
                      onKeyDown={(e) => { if (e.key === 'Enter') (e.target as HTMLInputElement).blur(); }}
                    />
                  ) : (
                    <span style={{ color: '#888', fontSize: 12 }}>{u.github_username || '-'}</span>
                  )}
                </td>
                <td>
                  <span style={{ color: u.has_claude_token ? '#00ff88' : '#ff8800', fontSize: 12 }}>
                    {u.has_claude_token ? '등록됨' : '미등록'}
                  </span>
                </td>
                <td>
                  {canEditRole(u) ? (
                    <select value={u.role} onChange={(e) => handleRoleChange(u.id, e.target.value)}>
                      {ROLES.filter(r => currentUser.role === 'owner' || ['engineer', 'member'].includes(r))
                        .map(r => <option key={r} value={r}>{roleLabel[r]}</option>)}
                    </select>
                  ) : (
                    <span className="mypage-role">{roleLabel[u.role] || u.role}</span>
                  )}
                </td>
                <td>
                  <span className={`admin-status ${u.is_active === false ? 'inactive' : 'active'}`}>
                    {u.is_active === false ? '비활성' : '활성'}
                  </span>
                </td>
                <td>{formatTime(u.created_at || null, true)}</td>
                <td style={{ position: 'relative' }}>
                  {u.id !== currentUser.id && (() => { const openUp = users.indexOf(u) >= users.length - 2; return (
                    <div data-action-menu style={{ position: 'relative', display: 'inline-block' }}>
                      <button
                        onClick={(e) => { e.stopPropagation(); setActionMenu(actionMenu === u.id ? null : u.id); }}
                        style={{ padding: '4px 8px', background: 'transparent', border: '1px solid #2a2a4a', borderRadius: 4, color: '#888', fontSize: 14, cursor: 'pointer', lineHeight: 1 }}
                      >⋯</button>
                      {actionMenu === u.id && (
                        <div style={{ position: 'absolute', right: 0, ...(openUp ? { bottom: '100%', marginBottom: 4 } : { top: '100%', marginTop: 4 }), background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 6, overflow: 'hidden', zIndex: 100, minWidth: 130, boxShadow: '0 4px 12px rgba(0,0,0,0.4)' }}>
                          {u.is_active === false ? (
                            <button onClick={() => { handleActivate(u.id); setActionMenu(null); }}
                              style={{ display: 'block', width: '100%', padding: '8px 14px', background: 'transparent', border: 'none', color: '#00ff88', fontSize: 12, cursor: 'pointer', textAlign: 'left' }}
                              onMouseEnter={e => (e.target as HTMLElement).style.background = '#2a2a4a'}
                              onMouseLeave={e => (e.target as HTMLElement).style.background = 'transparent'}
                            >복구</button>
                          ) : (<>
                            {currentUser.role === 'owner' && (
                              <button onClick={async () => {
                                  setActionMenu(null);
                                  try { const r = await requestPasswordReset(u.id); alert(r.message || '전송 완료'); } catch (e: any) { alert(e.message || '전송 실패'); }
                                }}
                                style={{ display: 'block', width: '100%', padding: '8px 14px', background: 'transparent', border: 'none', color: '#00aaff', fontSize: 12, cursor: 'pointer', textAlign: 'left' }}
                                onMouseEnter={e => (e.target as HTMLElement).style.background = '#2a2a4a'}
                                onMouseLeave={e => (e.target as HTMLElement).style.background = 'transparent'}
                              >PW 재설정</button>
                            )}
                            {canDeactivate(u) && (
                              <button onClick={() => { setActionMenu(null); setDeleteTarget(u); setPassword(''); setError(''); }}
                                style={{ display: 'block', width: '100%', padding: '8px 14px', background: 'transparent', border: 'none', borderTop: '1px solid #2a2a4a', color: '#ff4444', fontSize: 12, cursor: 'pointer', textAlign: 'left' }}
                                onMouseEnter={e => (e.target as HTMLElement).style.background = '#2a2a4a'}
                                onMouseLeave={e => (e.target as HTMLElement).style.background = 'transparent'}
                              >비활성화</button>
                            )}
                          </>)}
                        </div>
                      )}
                    </div>
                  ); })()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      </>)}

      {deleteTarget && (
        <div className="modal-overlay" onClick={() => setDeleteTarget(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 400 }}>
            <h2>
              회원 비활성화
              <button className="close" onClick={() => setDeleteTarget(null)}>&times;</button>
            </h2>
            <div style={{ fontSize: 13, color: '#ff8800', background: '#ff880012', padding: 12, borderRadius: 8, marginBottom: 16 }}>
              <strong>{deleteTarget.name}</strong> ({deleteTarget.login_id}) 계정을 비활성화합니다.<br />
              비활성화된 유저는 로그인할 수 없지만, 기존 데이터는 유지됩니다.
            </div>
            <div style={{ fontSize: 12, color: '#888', marginBottom: 8 }}>확인을 위해 본인 비밀번호를 입력하세요</div>
            <input
              type="password"
              placeholder="본인 비밀번호"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') handleDeactivate(); }}
              style={{ width: '100%', padding: '10px 12px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 8, color: '#e0e0e0', fontSize: 14, boxSizing: 'border-box', marginBottom: 8 }}
            />
            {error && <div style={{ color: '#ff4444', fontSize: 13, marginBottom: 8 }}>{error}</div>}
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setDeleteTarget(null)} style={{ padding: '8px 16px', background: 'transparent', border: '1px solid #2a2a4a', borderRadius: 6, color: '#888', cursor: 'pointer', fontSize: 13 }}>취소</button>
              <button onClick={handleDeactivate} disabled={loading || !password} style={{ padding: '8px 16px', background: '#ff4444', border: 'none', borderRadius: 6, color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 600, opacity: loading || !password ? 0.4 : 1 }}>비활성화</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const PROPOSAL_LABEL: Record<string, string> = {
  STATUS_DRIFT: '상태 불일치',
  DATE_DRIFT: '일정 불일치',
  MISSING_CARD: '미등록 작업',
  ORPHAN: '근거 없는 카드',
  UNMATCHED: '담당자 판정 불가',
};

function KpiPage() {
  const [summaries, setSummaries] = useState<KpiSummary[]>([]);
  const [scores, setScores] = useState<KpiScore[]>([]);
  const [tasks, setTasks] = useState<KpiTask[]>([]);
  const [reviews, setReviews] = useState<KpiReview[]>([]);
  const [selectedAssignee, setSelectedAssignee] = useState<string>('all');
  const [loading, setLoading] = useState(true);
  const [evaluating, setEvaluating] = useState(false);
  const [syncProposals, setSyncProposals] = useState<SyncProposal[]>([]);
  const [proposalBusy, setProposalBusy] = useState<number | null>(null);
  const [proposalMsg, setProposalMsg] = useState<string | null>(null);
  const loadProposals = () => { getSyncProposals().then(r => setSyncProposals(r.proposals || [])).catch(() => {}); };
  useEffect(() => { loadProposals(); }, []);
  const [evalResult, setEvalResult] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [taskPage, setTaskPage] = useState(0);
  const [reviewPage, setReviewPage] = useState(0);
  const [expandedReview, setExpandedReview] = useState<number | null>(null);
  const [taskSort, setTaskSort] = useState<{ key: string; asc: boolean }>({ key: 'progress', asc: true });
  const [reviewSort, setReviewSort] = useState<{ key: string; asc: boolean }>({ key: 'severity', asc: true });
  const PAGE_SIZE = 10;

  // 기간 선택
  const [kpiPeriod, setKpiPeriod] = useState<'week' | 'month' | '3month' | 'all' | 'custom'>('month');
  const [kpiFrom, setKpiFrom] = useState(() => new Date(Date.now() - 30 * 86400000).toISOString().slice(0, 10));
  const [kpiTo, setKpiTo] = useState(() => new Date().toISOString().slice(0, 10));

  const assignees = Array.from(new Set(summaries.map(s => s.assignee))).sort();

  // 기간 프리셋 적용
  const applyPeriod = useCallback((mode: 'week' | 'month' | '3month' | 'all' | 'custom') => {
    setKpiPeriod(mode);
    const today = new Date().toISOString().slice(0, 10);
    if (mode === 'week') {
      setKpiFrom(new Date(Date.now() - 7 * 86400000).toISOString().slice(0, 10));
      setKpiTo(today);
    } else if (mode === 'month') {
      setKpiFrom(new Date(Date.now() - 30 * 86400000).toISOString().slice(0, 10));
      setKpiTo(today);
    } else if (mode === '3month') {
      setKpiFrom(new Date(Date.now() - 90 * 86400000).toISOString().slice(0, 10));
      setKpiTo(today);
    } else if (mode === 'all') {
      setKpiFrom('2025-01-01');
      setKpiTo(today);
    }
  }, []);

  const fmtDate = (d: string | null) => d ? d.slice(0, 10) : '-';

  const loadData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const assigneeParam = selectedAssignee === 'all' ? undefined : selectedAssignee;
      const [sum, sc, tk, rv] = await Promise.all([
        getKpiSummary(),
        getKpiScores({ assignee: assigneeParam, period_start: kpiFrom, period_end: kpiTo }),
        getKpiTasks({ assignee: assigneeParam }),
        getKpiReviews({ assignee: assigneeParam }),
      ]);
      setSummaries(sum);
      setScores(sc);
      setTasks(tk);
      setReviews(rv);
    } catch (e: any) {
      setError(e.message || 'Failed to load KPI data');
    } finally {
      setLoading(false);
    }
  }, [selectedAssignee, kpiFrom, kpiTo]);

  useEffect(() => { loadData(); }, [loadData]);

  const gradeColor = (grade: string | null) => {
    if (!grade) return '#888';
    const map: Record<string, string> = { S: '#00ff88', A: '#00aaff', B: '#ffaa00', C: '#ff8844', D: '#ff4444', F: '#ff0000' };
    return map[grade.toUpperCase()] || '#888';
  };

  const progressColor = (p: number) => {
    if (p >= 80) return '#00ff88';
    if (p >= 60) return '#00aaff';
    if (p >= 40) return '#ffaa00';
    if (p >= 20) return '#ff8844';
    return '#ff4444';
  };

  const severityStyle = (sev: string | null): React.CSSProperties => {
    const base: React.CSSProperties = { display: 'inline-block', padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 600 };
    if (sev === 'critical') return { ...base, background: 'rgba(255,68,68,0.2)', color: '#ff4444' };
    if (sev === 'major') return { ...base, background: 'rgba(255,170,0,0.2)', color: '#ffaa00' };
    return { ...base, background: 'rgba(136,136,136,0.2)', color: '#888' };
  };

  // 현재 담당자의 최신 점수
  const currentScore = selectedAssignee === 'all'
    ? (scores.length > 0 ? {
        ...scores[0],
        total_score: (scores.reduce((s, c) => s + Number(c.total_score || 0), 0) / scores.length).toFixed(1),
        grade: (() => { const avg = scores.reduce((s, c) => s + Number(c.total_score || 0), 0) / scores.length; return avg >= 90 ? 'S' : avg >= 80 ? 'A' : avg >= 70 ? 'B' : avg >= 60 ? 'C' : avg >= 50 ? 'D' : 'F'; })(),
        code_quality_score: (scores.reduce((s, c) => s + Number(c.code_quality_score || 0), 0) / scores.length).toFixed(1),
        deadline_score: (scores.reduce((s, c) => s + Number(c.deadline_score || 0), 0) / scores.length).toFixed(1),
      } : null)
    : scores.find(s => s.assignee === selectedAssignee) || scores[0];

  // 태스크 통계
  const totalTasks = tasks.length;
  const completedTasks = tasks.filter(t => t.status === 'done' || t.status === 'completed').length;
  const completionRate = totalTasks > 0 ? Math.round((completedTasks / totalTasks) * 100) : 0;

  // 프로젝트별 진행률 (완료 후 3일 지난 프로젝트는 숨김)
  const threeDaysAgo = new Date(Date.now() - 3 * 86400000).toISOString().slice(0, 10);
  const projectProgress = Array.from(
    tasks.reduce((map, t) => {
      const p = t.project;
      if (!map.has(p)) map.set(p, { total: 0, sum: 0, hasActive: false, latestDate: '' });
      const entry = map.get(p)!;
      entry.total++;
      entry.sum += t.progress;
      const isDone = t.status === 'done' || t.status === 'completed';
      if (!isDone) entry.hasActive = true;
      const taskDate = t.completed_at || t.due_date || t.started_at || '';
      if (taskDate > entry.latestDate) entry.latestDate = taskDate.slice(0, 10);
      return map;
    }, new Map<string, { total: number; sum: number; hasActive: boolean; latestDate: string }>())
  ).map(([project, { total, sum, hasActive, latestDate }]) => ({ project, avg: Math.round(sum / total), hasActive, latestDate }))
   .filter(p => p.hasActive || p.latestDate >= threeDaysAgo)
   .sort((a, b) => a.avg === 100 && b.avg !== 100 ? 1 : a.avg !== 100 && b.avg === 100 ? -1 : b.avg - a.avg);

  const cardStyle: React.CSSProperties = { background: '#16213e', borderRadius: 8, padding: 16 };
  const labelStyle: React.CSSProperties = { color: '#888', fontSize: 12, marginBottom: 4 };
  const thStyle: React.CSSProperties = { textAlign: 'left', padding: '8px 12px', color: '#888', fontWeight: 500, fontSize: 12, borderBottom: '1px solid #2a2a4a' };
  const tdStyle: React.CSSProperties = { padding: '8px 12px', borderBottom: '1px solid rgba(42,42,74,0.5)', fontSize: 13 };

  return (
    <div style={{ padding: '0 8px' }}>
      {/* 기간 선택 + 새로고침 */}
      <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap', marginBottom: 16 }}>
        <div style={{ display: 'flex', gap: 4 }}>
          <button className={`admin-tab-sm ${kpiPeriod === 'week' ? 'active' : ''}`} onClick={() => applyPeriod('week')}>주간</button>
          <button className={`admin-tab-sm ${kpiPeriod === 'month' ? 'active' : ''}`} onClick={() => applyPeriod('month')}>월간</button>
          <button className={`admin-tab-sm ${kpiPeriod === '3month' ? 'active' : ''}`} onClick={() => applyPeriod('3month')}>3개월</button>
          <button className={`admin-tab-sm ${kpiPeriod === 'all' ? 'active' : ''}`} onClick={() => applyPeriod('all')}>전체</button>
          <button className={`admin-tab-sm ${kpiPeriod === 'custom' ? 'active' : ''}`} onClick={() => setKpiPeriod('custom')}>직접 선택</button>
        </div>
        <input type="date" value={kpiFrom} onChange={(e) => { setKpiFrom(e.target.value); setKpiPeriod('custom'); }} style={{ padding: '4px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 4, color: '#e0e0e0', fontSize: 12 }} />
        <span style={{ color: '#666' }}>~</span>
        <input type="date" value={kpiTo} onChange={(e) => { setKpiTo(e.target.value); setKpiPeriod('custom'); }} style={{ padding: '4px 8px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 4, color: '#e0e0e0', fontSize: 12 }} />
        <button onClick={() => { const today = new Date().toISOString().slice(0, 10); setKpiFrom(today); setKpiTo(today); setKpiPeriod('custom'); }} style={{ padding: '4px 10px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, color: '#aaa', fontSize: 12, cursor: 'pointer' }}>오늘</button>
        <button
          onClick={async () => {
            setEvaluating(true); setEvalResult(null);
            try {
              const r = await evaluateKpi();
              const opusStatus = r.opus_analysis ? ' (심화 분석 백그라운드 진행 중)' : '';
              setEvalResult(`평가 완료 (${r.report_types?.join(', ')}) — ${r.reports?.length || 0}건 보고서 생성${opusStatus}`);
              await loadData();
            } catch (e: any) { setEvalResult(`오류: ${e.message}`); } finally { setEvaluating(false); }
          }}
          disabled={evaluating}
          style={{ padding: '4px 10px', background: evaluating ? '#2a2a4a' : '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, color: evaluating ? '#555' : '#ffaa00', fontSize: 12, cursor: evaluating ? 'default' : 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}
        >
          <svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" style={evaluating ? { animation: 'spin 1s linear infinite' } : {}}>
            <path d="M8,1 v6 l4,2"/><circle cx="8" cy="8" r="7"/>
          </svg>
          {evaluating ? '평가 산정 중...' : '평가 산정'}
        </button>
      </div>
      {evalResult && (
        <div style={{ marginBottom: 12, padding: '8px 12px', background: evalResult.startsWith('오류') ? 'rgba(255,68,68,0.1)' : 'rgba(0,255,136,0.1)', borderRadius: 6, fontSize: 12, color: evalResult.startsWith('오류') ? '#ff4444' : '#00ff88' }}>
          {evalResult}
        </div>
      )}

      {/* 담당자 선택 탭 */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 24, flexWrap: 'wrap' }}>
        <button className={`admin-tab-sm ${selectedAssignee === 'all' ? 'active' : ''}`} onClick={() => { setSelectedAssignee('all'); setTaskPage(0); setReviewPage(0); }}>전체</button>
        {assignees.map(a => (
          <button key={a} className={`admin-tab-sm ${selectedAssignee === a ? 'active' : ''}`} onClick={() => { setSelectedAssignee(a); setTaskPage(0); setReviewPage(0); }}>{a}</button>
        ))}
      </div>

      {error && <div style={{ color: '#ff4444', fontSize: 13, marginBottom: 16 }}>{error}</div>}
      {loading && <div style={{ color: '#888', fontSize: 13, marginBottom: 16 }}>로딩 중...</div>}

      {/* 요약 카드 4개 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12, marginBottom: 24 }}>
        <div style={cardStyle}>
          <div style={labelStyle}>종합 점수 (등급)</div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
            <span style={{ color: gradeColor(currentScore?.grade || null), fontSize: 28, fontWeight: 700 }}>
              {currentScore?.total_score ? Number(currentScore.total_score).toFixed(1) : '-'}
            </span>
            {currentScore?.grade && (
              <span style={{ color: gradeColor(currentScore.grade), fontSize: 16, fontWeight: 600 }}>{currentScore.grade}</span>
            )}
          </div>
        </div>
        <div style={cardStyle}>
          <div style={labelStyle}>태스크 완료율</div>
          <div style={{ color: progressColor(completionRate), fontSize: 28, fontWeight: 700 }}>
            {totalTasks > 0 ? `${completionRate}%` : '-'}
          </div>
          <div style={{ color: '#666', fontSize: 11, marginTop: 2 }}>{completedTasks}/{totalTasks}</div>
        </div>
        <div style={cardStyle}>
          <div style={labelStyle}>PR Cycle</div>
          <div style={{ color: currentScore?.deadline_score ? progressColor(Number(currentScore.deadline_score)) : '#888', fontSize: 28, fontWeight: 700 }}>
            {currentScore?.deadline_score ? Number(currentScore.deadline_score).toFixed(1) : '-'}
          </div>
        </div>
        <div style={cardStyle}>
          <div style={labelStyle}>생산성</div>
          <div style={{ color: currentScore?.productivity_score ? progressColor(Number(currentScore.productivity_score)) : '#888', fontSize: 28, fontWeight: 700 }}>
            {currentScore?.productivity_score ? Number(currentScore.productivity_score).toFixed(1) : '-'}
          </div>
        </div>
      </div>

      {/* KPI 점수 추이 차트 */}
      {scores.length > 0 && (() => {
        // 담당자별 점수 추이 데이터 구성
        const allDates = Array.from(new Set(scores.map(s => fmtDate(s.period_end)))).sort();
        const scoreAssignees = selectedAssignee === 'all' ? assignees : [selectedAssignee];
        const chartData = allDates.map(date => {
          const row: any = { date };
          scoreAssignees.forEach(a => {
            const s = scores.find(sc => fmtDate(sc.period_end) === date && sc.assignee === a);
            if (s) {
              row[a] = Number(s.total_score);
              row[`${a}_task`] = Number(s.task_completion_score);
              row[`${a}_quality`] = Number(s.code_quality_score);
            }
          });
          return row;
        });
        const colors = ['#00ff88', '#00aaff', '#ffaa00', '#ff8844', '#cc66ff'];
        // 이전 대비 변화량 계산
        const changes = scoreAssignees.map(a => {
          const personScores = scores.filter(s => s.assignee === a).sort((x, y) => (x.period_end || '').localeCompare(y.period_end || ''));
          if (personScores.length < 2) return { assignee: a, diff: null, prev: null, curr: Number(personScores[0]?.total_score || 0) };
          const prev = Number(personScores[personScores.length - 2].total_score);
          const curr = Number(personScores[personScores.length - 1].total_score);
          return { assignee: a, diff: curr - prev, prev, curr };
        });

        return (
          <>
            <h3 style={{ fontSize: 14, color: '#aaa', marginBottom: 8 }}>점수 추이</h3>
            {/* 변화량 카드 */}
            <div style={{ display: 'flex', gap: 12, marginBottom: 12, flexWrap: 'wrap' }}>
              {changes.map((c, i) => (
                <div key={c.assignee} style={{ ...cardStyle, display: 'flex', alignItems: 'center', gap: 12, minWidth: 200 }}>
                  <div>
                    <div style={{ color: colors[i % colors.length], fontSize: 13, fontWeight: 600 }}>{c.assignee}</div>
                    <div style={{ color: '#e0e0e0', fontSize: 20, fontWeight: 700 }}>{c.curr.toFixed(1)}</div>
                  </div>
                  {c.diff !== null && (
                    <div style={{ color: c.diff > 0 ? '#00ff88' : c.diff < 0 ? '#ff4444' : '#888', fontSize: 14, fontWeight: 600 }}>
                      {c.diff > 0 ? '+' : ''}{c.diff.toFixed(1)}
                      <div style={{ fontSize: 10, color: '#666', fontWeight: 400 }}>이전 {c.prev?.toFixed(1)}</div>
                    </div>
                  )}
                </div>
              ))}
            </div>
            {/* 종합 점수 추이 — 라인 차트 (토큰 사용량 스타일) */}
            {chartData.length > 0 && (
              <ResponsiveContainer width="100%" height={280}>
                <LineChart data={chartData}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
                  <XAxis dataKey="date" stroke="#666" fontSize={11} />
                  <YAxis domain={[0, 100]} stroke="#666" fontSize={11} />
                  <Tooltip contentStyle={{ background: '#1a1a2e', border: '1px solid #333', borderRadius: 8, fontSize: 12, color: '#e0e0e0' }} labelStyle={{ color: '#aaa' }} formatter={(v: any) => Number(v).toFixed(1)} />
                  <Legend />
                  {scoreAssignees.map((a, i) => (
                    <Line key={a} type="monotone" dataKey={a} stroke={colors[i % colors.length]} strokeWidth={2} dot={false} name={`${a} 종합`} />
                  ))}
                </LineChart>
              </ResponsiveContainer>
            )}
            {/* 항목별 점수 추이 — 개인 선택 시 */}
            {selectedAssignee !== 'all' && (() => {
              const detailData = scores
                .filter(s => s.assignee === selectedAssignee)
                .sort((a, b) => (a.period_end || '').localeCompare(b.period_end || ''))
                .map(s => ({
                  date: fmtDate(s.period_end),
                  '태스크(30%)': Number(s.task_completion_score || 0),
                  'PR Cycle(20%)': Number(s.deadline_score || 0),
                  '생산성(15%)': Number(s.productivity_score || 0),
                  '일관성(10%)': Number(s.consistency_score || 0),
                  '코드품질(10%)': Number(s.code_quality_score || 0),
                  '프로젝트(10%)': Number(s.project_engagement_score || 0),
                  '커밋크기(5%)': Number(s.commit_size_score || 0),
                }));
              if (detailData.length === 0) return null;
              return (
                <ResponsiveContainer width="100%" height={300}>
                  <LineChart data={detailData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
                    <XAxis dataKey="date" stroke="#666" fontSize={11} />
                    <YAxis domain={[0, 100]} stroke="#666" fontSize={11} />
                    <Tooltip contentStyle={{ background: '#1a1a2e', border: '1px solid #333', borderRadius: 8, fontSize: 12, color: '#e0e0e0' }} labelStyle={{ color: '#aaa' }} formatter={(v: any) => Number(v).toFixed(1)} />
                    <Legend wrapperStyle={{ fontSize: 11 }} />
                    <Line type="monotone" dataKey="태스크(30%)" stroke="#00ff88" strokeWidth={2} dot={false} />
                    <Line type="monotone" dataKey="PR Cycle(20%)" stroke="#ffaa00" strokeWidth={2} dot={false} />
                    <Line type="monotone" dataKey="생산성(15%)" stroke="#ff6b6b" strokeWidth={2} dot={false} />
                    <Line type="monotone" dataKey="일관성(10%)" stroke="#4ecdc4" strokeWidth={2} dot={false} />
                    <Line type="monotone" dataKey="코드품질(10%)" stroke="#00aaff" strokeWidth={2} dot={false} />
                    <Line type="monotone" dataKey="프로젝트(10%)" stroke="#ff8844" strokeWidth={2} dot={false} />
                    <Line type="monotone" dataKey="커밋크기(5%)" stroke="#cc66ff" strokeWidth={2} dot={false} />
                  </LineChart>
                </ResponsiveContainer>
              );
            })()}
          </>
        );
      })()}

      {/* 담당자별 요약 (전체 선택 시) */}
      {selectedAssignee === 'all' && summaries.length > 0 && (
        <>
          <h3 style={{ fontSize: 14, color: '#aaa', marginBottom: 8 }}>담당자별 요약</h3>
          <div style={{ overflowX: 'auto', marginBottom: 24 }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={thStyle}>담당자</th>
                  <th style={thStyle}>평균 진행률</th>
                  <th style={{ ...thStyle, textAlign: 'center' }}>리뷰 이슈</th>
                  <th style={{ ...thStyle, textAlign: 'center' }}>최근 KPI 점수</th>
                </tr>
              </thead>
              <tbody>
                {summaries.map(s => {
                  const avgProg = Number(s.avg_progress);
                  return (
                    <tr key={s.assignee} style={{ cursor: 'pointer' }} onClick={() => { setSelectedAssignee(s.assignee); setTaskPage(0); setReviewPage(0); }}>
                      <td style={{ ...tdStyle, color: '#e0e0e0', fontWeight: 500 }}>{s.assignee}</td>
                      <td style={tdStyle}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <div style={{ width: 80, height: 8, background: '#2a2a4a', borderRadius: 4, overflow: 'hidden' }}>
                            <div style={{ width: `${avgProg}%`, height: '100%', background: progressColor(avgProg), borderRadius: 4, transition: 'width 0.3s' }} />
                          </div>
                          <span style={{ color: progressColor(avgProg), fontSize: 12 }}>{avgProg}%</span>
                        </div>
                      </td>
                      <td style={{ ...tdStyle, textAlign: 'center', color: Number(s.review_issue_count) > 0 ? '#ffaa00' : '#888' }}>{s.review_issue_count}</td>
                      <td style={{ ...tdStyle, textAlign: 'center', color: s.latest_kpi_score ? '#00aaff' : '#666' }}>{s.latest_kpi_score ? Number(s.latest_kpi_score).toFixed(1) : '-'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* KPI 점수 이력 (개인 선택 시) */}
      {selectedAssignee !== 'all' && scores.length > 0 && (
        <>
          <h3 style={{ fontSize: 14, color: '#aaa', marginBottom: 8 }}>KPI 점수 이력</h3>
          <div style={{ overflowX: 'auto', marginBottom: 24 }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={thStyle}>기간</th>
                  <th style={{ ...thStyle, textAlign: 'center' }}>종합</th>
                  <th style={{ ...thStyle, textAlign: 'center' }}>등급</th>
                  <th style={{ ...thStyle, textAlign: 'center' }}>태스크</th>
                  <th style={{ ...thStyle, textAlign: 'center' }}>코드 품질</th>
                  <th style={{ ...thStyle, textAlign: 'center' }}>작업 효율</th>
                  <th style={{ ...thStyle, textAlign: 'center' }}>커밋 품질</th>
                </tr>
              </thead>
              <tbody>
                {scores.map(s => (
                  <tr key={s.id}>
                    <td style={{ ...tdStyle, color: '#e0e0e0', fontSize: 12 }}>{fmtDate(s.period_start)} ~ {fmtDate(s.period_end)}</td>
                    <td style={{ ...tdStyle, textAlign: 'center', color: '#e0e0e0', fontWeight: 600 }}>{s.total_score ? Number(s.total_score).toFixed(1) : '-'}</td>
                    <td style={{ ...tdStyle, textAlign: 'center', color: gradeColor(s.grade), fontWeight: 700, fontSize: 14 }}>{s.grade || '-'}</td>
                    <td style={{ ...tdStyle, textAlign: 'center', color: '#888' }}>{s.task_completion_score ? Number(s.task_completion_score).toFixed(1) : '-'}</td>
                    <td style={{ ...tdStyle, textAlign: 'center', color: '#888' }}>{s.code_quality_score ? Number(s.code_quality_score).toFixed(1) : '-'}</td>
                    <td style={{ ...tdStyle, textAlign: 'center', color: '#888' }}>{s.deadline_score ? Number(s.deadline_score).toFixed(1) : '-'}</td>
                    <td style={{ ...tdStyle, textAlign: 'center', color: '#888' }}>{s.commit_quality_score ? Number(s.commit_quality_score).toFixed(1) : '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* AI 활용 효율 (개인 선택 시) */}
      {selectedAssignee !== 'all' && currentScore && currentScore.ai_total_cost && (
        <>
          <h3 style={{ fontSize: 14, color: '#aaa', marginBottom: 8 }}>AI 활용 효율 <span style={{ color: '#555', fontSize: 11, fontWeight: 400 }}>참고 지표</span></h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 12, marginBottom: 24 }}>
            <div style={cardStyle}>
              <div style={labelStyle}>총 비용</div>
              <div style={{ color: '#ffaa00', fontSize: 20, fontWeight: 700 }}>${Number(currentScore.ai_total_cost).toFixed(2)}</div>
            </div>
            <div style={cardStyle}>
              <div style={labelStyle}>총 토큰</div>
              <div style={{ color: '#00aaff', fontSize: 20, fontWeight: 700 }}>
                {currentScore.ai_total_tokens ? (Number(currentScore.ai_total_tokens) >= 1000000 ? `${(Number(currentScore.ai_total_tokens) / 1000000).toFixed(1)}M` : Number(currentScore.ai_total_tokens).toLocaleString()) : '-'}
              </div>
            </div>
            <div style={cardStyle}>
              <div style={labelStyle}>세션 / 요청</div>
              <div style={{ color: '#e0e0e0', fontSize: 20, fontWeight: 700 }}>
                {currentScore.ai_sessions ?? '-'}<span style={{ color: '#555', fontSize: 13 }}> / </span>{currentScore.ai_requests ?? '-'}
              </div>
            </div>
            <div style={cardStyle}>
              <div style={labelStyle}>진행률 1%당 비용</div>
              <div style={{ color: currentScore.ai_cost_per_progress ? '#00ff88' : '#888', fontSize: 20, fontWeight: 700 }}>
                {currentScore.ai_cost_per_progress ? `$${Number(currentScore.ai_cost_per_progress).toFixed(4)}` : '-'}
              </div>
              {currentScore.ai_cost_per_progress && (
                <div style={{ color: '#555', fontSize: 11, marginTop: 2 }}>
                  {Number(currentScore.ai_cost_per_progress) < 0.1 ? '효율 좋음' : Number(currentScore.ai_cost_per_progress) < 0.3 ? '보통' : '개선 필요'}
                </div>
              )}
            </div>
          </div>
        </>
      )}

      {/* Git 지표 */}
      {scores.length > 0 && scores.some(s => s.commit_count) && (() => {
        const gitScores = selectedAssignee === 'all' ? scores.filter(s => s.commit_count) : scores.filter(s => s.assignee === selectedAssignee && s.commit_count);
        // 담당자별 최신 git 지표만 추출
        const gitByAssignee = new Map<string, KpiScore>();
        gitScores.forEach(s => { if (!gitByAssignee.has(s.assignee)) gitByAssignee.set(s.assignee, s); });
        const gitData = Array.from(gitByAssignee.values());
        if (gitData.length === 0) return null;
        return (
          <>
            <h3 style={{ fontSize: 14, color: '#aaa', marginBottom: 8 }}>
              Git 활동
              {gitData[0]?.last_sync_at && <span style={{ color: '#555', fontSize: 11, fontWeight: 400, marginLeft: 8 }}>마지막 동기화: {fmtDate(gitData[0].last_sync_at)}</span>}
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: `repeat(${selectedAssignee === 'all' ? gitData.length : 1}, minmax(200px, 1fr))`, gap: 12, marginBottom: 24 }}>
              {gitData.map(s => (
                <div key={s.assignee} style={{ ...cardStyle, padding: 16 }}>
                  {selectedAssignee === 'all' && <div style={{ color: '#00aaff', fontSize: 13, fontWeight: 600, marginBottom: 8 }}>{s.assignee}</div>}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 12 }}>
                    <div>
                      <div style={labelStyle}>커밋</div>
                      <div style={{ color: '#e0e0e0', fontSize: 20, fontWeight: 700 }}>{s.commit_count?.toLocaleString() ?? '-'}</div>
                    </div>
                    <div>
                      <div style={labelStyle}>추가</div>
                      <div style={{ color: '#00ff88', fontSize: 20, fontWeight: 700 }}>
                        {s.lines_added ? (s.lines_added >= 10000 ? `${(s.lines_added / 1000).toFixed(1)}K` : s.lines_added.toLocaleString()) : '-'}
                      </div>
                    </div>
                    <div>
                      <div style={labelStyle}>삭제</div>
                      <div style={{ color: '#ff4444', fontSize: 20, fontWeight: 700 }}>
                        {s.lines_deleted ? (s.lines_deleted >= 10000 ? `${(s.lines_deleted / 1000).toFixed(1)}K` : s.lines_deleted.toLocaleString()) : '-'}
                      </div>
                    </div>
                    <div>
                      <div style={labelStyle}>문서</div>
                      <div style={{ color: '#ffaa00', fontSize: 20, fontWeight: 700 }}>{s.doc_count ?? '-'}</div>
                    </div>
                  </div>
                  {/* 비계획 기여 */}
                  {s.unplanned_commits != null && s.unplanned_commits > 0 && (
                    <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px solid #2a2a4a' }}>
                      <div style={{ color: '#cc66ff', fontSize: 11, fontWeight: 600, marginBottom: 6 }}>계획 외 기여</div>
                      <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
                        <span style={{ color: '#cc66ff', fontSize: 14, fontWeight: 700 }}>{s.unplanned_commits} 커밋</span>
                        <span style={{ color: '#888', fontSize: 12 }}>+{s.unplanned_lines_added?.toLocaleString()} 라인</span>
                      </div>
                      {s.unplanned_detail && (
                        <div style={{ marginTop: 4, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                          {Object.entries(s.unplanned_detail).map(([proj, cnt]) => (
                            <span key={proj} style={{ fontSize: 11, color: '#888', background: 'rgba(204,102,255,0.1)', padding: '2px 6px', borderRadius: 3 }}>
                              {proj}: {cnt}
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </>
        );
      })()}

      {/* 프로젝트별 진행률 */}
      {projectProgress.length > 0 && (
        <>
          <h3 style={{ fontSize: 14, color: '#aaa', marginBottom: 8 }}>프로젝트별 진행률</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
            {projectProgress.map(({ project, avg }) => (
              <div key={project} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ color: '#ccc', fontSize: 12, width: 180, flexShrink: 0 }}>{project}</span>
                <div style={{ flex: 1, height: 8, background: '#2a2a4a', borderRadius: 4, overflow: 'hidden' }}>
                  <div style={{ width: `${avg}%`, height: '100%', background: progressColor(avg), borderRadius: 4, transition: 'width 0.3s' }} />
                </div>
                <span style={{ color: progressColor(avg), fontSize: 12, width: 40, textAlign: 'right' }}>{avg}%</span>
              </div>
            ))}
          </div>
        </>
      )}

      {/* 세부 태스크 테이블 (소팅 + 페이지네이션) */}
      {tasks.length > 0 && (() => {
        const sortedTasks = [...tasks].sort((a, b) => {
          const dir = taskSort.asc ? 1 : -1;
          const k = taskSort.key;
          if (k === 'progress') return (a.progress - b.progress) * dir;
          if (k === 'status') return (a.status || '').localeCompare(b.status || '') * dir;
          if (k === 'project') return (a.project || '').localeCompare(b.project || '') * dir;
          if (k === 'assignee') return (a.assignee || '').localeCompare(b.assignee || '') * dir;
          if (k === 'task_title') return (a.task_title || '').localeCompare(b.task_title || '') * dir;
          return 0;
        });
        const totalTaskPages = Math.ceil(sortedTasks.length / PAGE_SIZE);
        const pagedTasks = sortedTasks.slice(taskPage * PAGE_SIZE, (taskPage + 1) * PAGE_SIZE);
        const thSort = (key: string, label: string, center?: boolean) => (
          <th style={{ ...thStyle, ...(center ? { textAlign: 'center' as const } : {}), cursor: 'pointer', userSelect: 'none' as const }} onClick={() => { setTaskSort(s => ({ key, asc: s.key === key ? !s.asc : true })); setTaskPage(0); }}>
            {label}{taskSort.key === key ? (taskSort.asc ? ' \u25B2' : ' \u25BC') : ''}
          </th>
        );
        return (
          <>
            <h3 style={{ fontSize: 14, color: '#aaa', marginBottom: 8 }}>세부 태스크 <span style={{ color: '#555', fontSize: 11, fontWeight: 400 }}>{tasks.length}건</span></h3>
            <div style={{ overflowX: 'auto', marginBottom: 8 }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    {selectedAssignee === 'all' && thSort('assignee', '담당자')}
                    {thSort('project', '프로젝트')}
                    {thSort('task_title', '태스크')}
                    <th style={thStyle}>서브 태스크</th>
                    {thSort('progress', '진행률', true)}
                    {thSort('status', '상태', true)}
                    <th style={{ ...thStyle, textAlign: 'center' }}>난이도</th>
                  </tr>
                </thead>
                <tbody>
                  {pagedTasks.map(t => {
                    const statusColor = t.status === 'done' || t.status === 'completed' ? '#00ff88' : t.status === 'in_progress' ? '#00aaff' : t.status === 'todo' ? '#888' : '#ffaa00';
                    return (
                      <tr key={t.id}>
                        {selectedAssignee === 'all' && <td style={{ ...tdStyle, color: '#e0e0e0', fontWeight: 500 }}>{t.assignee}</td>}
                        <td style={{ ...tdStyle, color: '#aaa', fontSize: 12 }}>{t.project}</td>
                        <td style={{ ...tdStyle, color: '#e0e0e0' }}>{t.task_title}</td>
                        <td style={{ ...tdStyle, color: '#ccc', fontSize: 12 }}>{t.sub_task}</td>
                        <td style={{ ...tdStyle, textAlign: 'center' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center' }}>
                            <div style={{ width: 80, height: 8, background: '#2a2a4a', borderRadius: 4, overflow: 'hidden' }}>
                              <div style={{ width: `${t.progress}%`, height: '100%', background: progressColor(t.progress), borderRadius: 4, transition: 'width 0.3s' }} />
                            </div>
                            <span style={{ color: progressColor(t.progress), fontSize: 12, minWidth: 32 }}>{t.progress}%</span>
                          </div>
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'center', color: statusColor, fontSize: 12 }}>{t.status}</td>
                        <td style={{ ...tdStyle, textAlign: 'center', padding: '4px 8px' }}>
                          <select
                            value={t.complexity || 'medium'}
                            onChange={async (e) => {
                              try { await updateTaskComplexity(t.id, e.target.value); loadData(); } catch {}
                            }}
                            style={{
                              background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 4, fontSize: 11, cursor: 'pointer', padding: '2px 4px',
                              color: (t.complexity || 'medium') === 'critical' ? '#ff4444' : (t.complexity || 'medium') === 'high' ? '#ffaa00' : (t.complexity || 'medium') === 'low' ? '#888' : '#00aaff',
                            }}
                          >
                            <option value="low">low</option>
                            <option value="medium">medium</option>
                            <option value="high">high</option>
                            <option value="critical">critical</option>
                          </select>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {totalTaskPages > 1 && (
              <div style={{ display: 'flex', gap: 4, justifyContent: 'center', marginBottom: 24 }}>
                <button onClick={() => setTaskPage(p => Math.max(0, p - 1))} disabled={taskPage === 0} style={{ padding: '4px 10px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, color: taskPage === 0 ? '#444' : '#aaa', fontSize: 12, cursor: taskPage === 0 ? 'default' : 'pointer' }}>&lt;</button>
                {Array.from({ length: totalTaskPages }, (_, i) => (
                  <button key={i} onClick={() => setTaskPage(i)} style={{ padding: '4px 10px', background: taskPage === i ? '#2a2a4a' : '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, color: taskPage === i ? '#00ff88' : '#888', fontSize: 12, cursor: 'pointer' }}>{i + 1}</button>
                ))}
                <button onClick={() => setTaskPage(p => Math.min(totalTaskPages - 1, p + 1))} disabled={taskPage >= totalTaskPages - 1} style={{ padding: '4px 10px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, color: taskPage >= totalTaskPages - 1 ? '#444' : '#aaa', fontSize: 12, cursor: taskPage >= totalTaskPages - 1 ? 'default' : 'pointer' }}>&gt;</button>
              </div>
            )}
          </>
        );
      })()}

      {/* 코드 품질 이슈 목록 (소팅 + 페이지네이션) */}
      {reviews.length > 0 && (() => {
        const sevOrder: Record<string, number> = { critical: 0, major: 1, minor: 2 };
        const sortedReviews = [...reviews].sort((a, b) => {
          const dir = reviewSort.asc ? 1 : -1;
          const k = reviewSort.key;
          if (k === 'severity') return ((sevOrder[a.severity || ''] ?? 3) - (sevOrder[b.severity || ''] ?? 3)) * dir;
          if (k === 'category') return (a.category || '').localeCompare(b.category || '') * dir;
          if (k === 'assignee') return (a.assignee || '').localeCompare(b.assignee || '') * dir;
          if (k === 'resolved') return ((a.resolved ? 1 : 0) - (b.resolved ? 1 : 0)) * dir;
          if (k === 'task_title') return (a.task_title || '').localeCompare(b.task_title || '') * dir;
          return 0;
        });
        const totalReviewPages = Math.ceil(sortedReviews.length / PAGE_SIZE);
        const pagedReviews = sortedReviews.slice(reviewPage * PAGE_SIZE, (reviewPage + 1) * PAGE_SIZE);
        const rhSort = (key: string, label: string, center?: boolean) => (
          <th style={{ ...thStyle, ...(center ? { textAlign: 'center' as const } : {}), cursor: 'pointer', userSelect: 'none' as const }} onClick={() => { setReviewSort(s => ({ key, asc: s.key === key ? !s.asc : true })); setReviewPage(0); }}>
            {label}{reviewSort.key === key ? (reviewSort.asc ? ' \u25B2' : ' \u25BC') : ''}
          </th>
        );
        return (
          <>
            <h3 style={{ fontSize: 14, color: '#aaa', marginBottom: 8 }}>코드 품질 이슈 <span style={{ color: '#555', fontSize: 11, fontWeight: 400 }}>{reviews.length}건</span></h3>
            <div style={{ overflowX: 'auto', marginBottom: 8 }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    {selectedAssignee === 'all' && rhSort('assignee', '담당자')}
                    {rhSort('severity', '심각도')}
                    {rhSort('category', '카테고리')}
                    <th style={thStyle}>설명</th>
                    {rhSort('task_title', '태스크')}
                    {rhSort('resolved', '해결', true)}
                  </tr>
                </thead>
                <tbody>
                  {pagedReviews.map(r => {
                    const isExpanded = expandedReview === r.id;
                    const filePart = r.description?.split('—')[0]?.trim() || '';
                    const issuePart = r.description?.split('—').slice(1).join('—').trim() || r.description || '';
                    const colSpan = selectedAssignee === 'all' ? 6 : 5;
                    return (<React.Fragment key={r.id}>
                    <tr onClick={() => setExpandedReview(isExpanded ? null : r.id)} style={{ cursor: 'pointer' }}>
                      {selectedAssignee === 'all' && <td style={{ ...tdStyle, color: '#e0e0e0', fontWeight: 500 }}>{r.assignee}</td>}
                      <td style={tdStyle}><span style={severityStyle(r.severity)}>{r.severity || '-'}</span></td>
                      <td style={{ ...tdStyle, color: '#aaa', fontSize: 12 }}>{r.category || '-'}</td>
                      <td style={{ ...tdStyle, color: '#e0e0e0', fontSize: 12, maxWidth: 400 }}>{r.description || '-'}</td>
                      <td style={{ ...tdStyle, color: '#888', fontSize: 12 }}>{r.task_title}</td>
                      <td style={{ ...tdStyle, textAlign: 'center', color: r.resolved ? '#00ff88' : '#ff4444', fontSize: 14 }}>{r.resolved ? '\u2713' : '\u2717'}</td>
                    </tr>
                    {isExpanded && (
                      <tr>
                        <td colSpan={colSpan} style={{ padding: '12px 16px', background: '#0f0f1a', borderBottom: '1px solid #2a2a4a' }}>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                            <div style={{ display: 'flex', gap: 12 }}>
                              <span style={{ color: '#555', fontSize: 11, width: 60, flexShrink: 0 }}>파일</span>
                              <span style={{ color: '#00aaff', fontSize: 12, fontFamily: 'monospace' }}>{filePart || '-'}</span>
                            </div>
                            <div style={{ display: 'flex', gap: 12 }}>
                              <span style={{ color: '#555', fontSize: 11, width: 60, flexShrink: 0 }}>문제</span>
                              <span style={{ color: '#e0e0e0', fontSize: 12 }}>{issuePart || '-'}</span>
                            </div>
                            <div style={{ display: 'flex', gap: 12 }}>
                              <span style={{ color: '#555', fontSize: 11, width: 60, flexShrink: 0 }}>프로젝트</span>
                              <span style={{ color: '#00aaff', fontSize: 12, fontFamily: 'monospace' }}>{r.project || '-'}</span>
                            </div>
                            <div style={{ display: 'flex', gap: 12 }}>
                              <span style={{ color: '#555', fontSize: 11, width: 60, flexShrink: 0 }}>태스크</span>
                              <span style={{ color: '#888', fontSize: 12 }}>{r.task_title} ({r.assignee})</span>
                            </div>
                            <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                              <span style={{ color: '#555', fontSize: 11, width: 60, flexShrink: 0 }}>상태</span>
                              <button
                                onClick={async (e) => {
                                  e.stopPropagation();
                                  try { await toggleReviewResolved(r.id, !r.resolved); loadData(); } catch {}
                                }}
                                style={{ padding: '2px 10px', background: r.resolved ? 'rgba(0,255,136,0.1)' : 'rgba(255,68,68,0.1)', border: `1px solid ${r.resolved ? '#00ff88' : '#ff4444'}`, borderRadius: 4, color: r.resolved ? '#00ff88' : '#ff4444', fontSize: 11, cursor: 'pointer' }}
                              >{r.resolved ? '해결됨 (미해결로 변경)' : '미해결 (해결로 변경)'}</button>
                            </div>
                            <div style={{ display: 'flex', gap: 12 }}>
                              <span style={{ color: '#555', fontSize: 11, width: 60, flexShrink: 0 }}>등록일</span>
                              <span style={{ color: '#666', fontSize: 11 }}>{r.created_at ? r.created_at.slice(0, 16).replace('T', ' ') : '-'}</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                    </React.Fragment>);
                  })}
                </tbody>
              </table>
            </div>
            {totalReviewPages > 1 && (
              <div style={{ display: 'flex', gap: 4, justifyContent: 'center', marginBottom: 24 }}>
                <button onClick={() => setReviewPage(p => Math.max(0, p - 1))} disabled={reviewPage === 0} style={{ padding: '4px 10px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, color: reviewPage === 0 ? '#444' : '#aaa', fontSize: 12, cursor: reviewPage === 0 ? 'default' : 'pointer' }}>&lt;</button>
                {Array.from({ length: totalReviewPages }, (_, i) => (
                  <button key={i} onClick={() => setReviewPage(i)} style={{ padding: '4px 10px', background: reviewPage === i ? '#2a2a4a' : '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, color: reviewPage === i ? '#00ff88' : '#888', fontSize: 12, cursor: 'pointer' }}>{i + 1}</button>
                ))}
                <button onClick={() => setReviewPage(p => Math.min(totalReviewPages - 1, p + 1))} disabled={reviewPage >= totalReviewPages - 1} style={{ padding: '4px 10px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, color: reviewPage >= totalReviewPages - 1 ? '#444' : '#aaa', fontSize: 12, cursor: reviewPage >= totalReviewPages - 1 ? 'default' : 'pointer' }}>&gt;</button>
              </div>
            )}
          </>
        );
      })()}

      {/* 데이터 없음 안내 */}
      {!loading && tasks.length === 0 && summaries.length === 0 && (
        <div style={{ marginTop: 32, padding: 16, background: '#1a1a2e', borderRadius: 8, border: '1px solid #2a2a4a' }}>
          <p style={{ color: '#888', fontSize: 13, margin: 0 }}>
            KPI 데이터가 없습니다. KPI 산정이 완료되면 여기에 표시됩니다.
          </p>
        </div>
      )}

      {/* 노션 동기화 제안 —— 대사 결과 중 자동 반영하기엔 근거가 약한 건 */}
      {syncProposals.length > 0 && (
        <div style={{ marginTop: 24, border: '1px solid #3a3a2a', borderRadius: 6, background: '#16160e', padding: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
            <span style={{ color: '#ffaa00', fontSize: 13, fontWeight: 600 }}>노션 동기화 제안</span>
            <span style={{ color: '#888', fontSize: 12 }}>컨펌 대기 {syncProposals.length}건</span>
            <button onClick={loadProposals} style={{ marginLeft: 'auto', padding: '2px 8px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 4, color: '#aaa', fontSize: 11, cursor: 'pointer' }}>새로고침</button>
          </div>
          {proposalMsg && <div style={{ color: '#8fd', fontSize: 12, marginBottom: 8 }}>{proposalMsg}</div>}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {syncProposals.map(p => (
              <div key={p.id} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: 8, background: '#0e0e16', borderRadius: 4 }}>
                <span style={{ flexShrink: 0, padding: '2px 6px', borderRadius: 3, fontSize: 11, background: '#2a2a4a', color: '#ffaa00' }}>
                  {PROPOSAL_LABEL[p.kind] || p.kind}
                </span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ color: '#ddd', fontSize: 13 }}>
                    {p.assignee ? <span style={{ color: '#7af', marginRight: 6 }}>{p.assignee}</span> : null}
                    {p.title}
                  </div>
                  <div style={{ color: '#aaa', fontSize: 12, marginTop: 2 }}>
                    {p.proposal?.before ? <span><code>{p.proposal.before}</code> → </span> : null}
                    {p.proposal?.after ? <code style={{ color: '#8fd' }}>{p.proposal.after}</code> : <code>{JSON.stringify(p.proposal?.fields || {})}</code>}
                  </div>
                  {p.evidence && <div style={{ color: '#666', fontSize: 11, marginTop: 2 }}>근거: {p.evidence}</div>}
                </div>
                <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
                  <button
                    disabled={proposalBusy === p.id}
                    onClick={async () => {
                      setProposalBusy(p.id); setProposalMsg(null);
                      try { const r = await approveSyncProposal(p.id); setProposalMsg(r.message || '반영했습니다'); loadProposals(); }
                      catch (e: any) { setProposalMsg(`오류: ${e.message}`); }
                      finally { setProposalBusy(null); }
                    }}
                    style={{ padding: '3px 10px', background: '#1a2e1a', border: '1px solid #2a4a2a', borderRadius: 4, color: '#8f8', fontSize: 12, cursor: 'pointer' }}
                  >{proposalBusy === p.id ? '반영 중...' : '승인'}</button>
                  <button
                    disabled={proposalBusy === p.id}
                    onClick={async () => {
                      setProposalBusy(p.id); setProposalMsg(null);
                      try { const r = await rejectSyncProposal(p.id); setProposalMsg(r.message || '거절했습니다'); loadProposals(); }
                      catch (e: any) { setProposalMsg(`오류: ${e.message}`); }
                      finally { setProposalBusy(null); }
                    }}
                    style={{ padding: '3px 10px', background: '#2e1a1a', border: '1px solid #4a2a2a', borderRadius: 4, color: '#f88', fontSize: 12, cursor: 'pointer' }}
                  >거절</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function ResetPasswordPage() {
  const [pw, setPw] = useState('');
  const [pwConfirm, setPwConfirm] = useState('');
  const [msg, setMsg] = useState('');
  const [done, setDone] = useState(false);
  const token = new URLSearchParams(window.location.search).get('token') || '';

  if (!token) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#0f0f1a', color: '#ff4444' }}>유효하지 않은 링크입니다.</div>;

  const handleSubmit = async () => {
    if (!pw || !pwConfirm) { setMsg('비밀번호를 입력해주세요.'); return; }
    if (pw !== pwConfirm) { setMsg('비밀번호가 일치하지 않습니다.'); return; }
    try {
      await confirmPasswordReset(token, pw);
      setDone(true); setMsg('');
    } catch (e: any) { setMsg(e.message || '변경 실패'); }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#0f0f1a' }}>
      <div style={{ width: 360, padding: 32, background: '#16213e', borderRadius: 12, border: '1px solid #2a2a4a' }}>
        <h2 style={{ color: '#e0e0e0', fontSize: 18, marginBottom: 24, textAlign: 'center' }}>비밀번호 재설정</h2>
        {done ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ color: '#00ff88', fontSize: 14, marginBottom: 16 }}>비밀번호가 변경되었습니다.</div>
            <button onClick={() => { window.location.href = '/'; }} style={{ padding: '8px 24px', background: '#00ff88', border: 'none', borderRadius: 6, color: '#0f0f1a', fontWeight: 600, cursor: 'pointer' }}>로그인하기</button>
          </div>
        ) : (
          <>
            <input type="password" placeholder="새 비밀번호" value={pw} onChange={e => setPw(e.target.value)}
              style={{ width: '100%', padding: '10px 12px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13, marginBottom: 12, boxSizing: 'border-box' }} />
            <input type="password" placeholder="비밀번호 확인" value={pwConfirm} onChange={e => setPwConfirm(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') handleSubmit(); }}
              style={{ width: '100%', padding: '10px 12px', background: '#0f0f1a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#e0e0e0', fontSize: 13, marginBottom: 8, boxSizing: 'border-box' }} />
            <div style={{ color: '#666', fontSize: 11, marginBottom: 16 }}>8자 이상, 영문+숫자+특수문자 포함</div>
            {msg && <div style={{ color: '#ff4444', fontSize: 12, marginBottom: 12 }}>{msg}</div>}
            <button onClick={handleSubmit} style={{ width: '100%', padding: '10px', background: '#00ff88', border: 'none', borderRadius: 6, color: '#0f0f1a', fontWeight: 600, fontSize: 14, cursor: 'pointer' }}>변경하기</button>
          </>
        )}
      </div>
    </div>
  );
}

export default App;
